var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741, _path2742, _path2743, _path2744, _path2745, _path2746, _path2747, _path2748, _path2749, _path2750, _path2751, _path2752, _path2753, _path2754, _path2755, _path2756, _path2757, _path2758, _path2759, _path2760, _path2761, _path2762, _path2763, _path2764, _path2765, _path2766, _path2767, _path2768, _path2769, _path2770, _path2771, _path2772, _path2773, _path2774, _path2775, _path2776, _path2777, _path2778, _path2779, _path2780, _path2781, _path2782, _path2783, _path2784, _path2785, _path2786, _path2787, _path2788, _path2789, _path2790, _path2791, _path2792, _path2793, _path2794, _path2795, _path2796, _path2797, _path2798, _path2799, _path2800, _path2801, _path2802, _path2803, _path2804, _path2805, _path2806, _path2807, _path2808, _path2809, _path2810, _path2811, _path2812, _path2813, _path2814, _path2815, _path2816, _path2817, _path2818, _path2819, _path2820, _path2821, _path2822, _path2823, _path2824, _path2825, _path2826, _path2827, _path2828, _path2829, _path2830, _path2831, _path2832, _path2833, _path2834, _path2835, _path2836, _path2837, _path2838, _path2839, _path2840, _path2841, _path2842, _path2843, _path2844, _path2845, _path2846, _path2847, _path2848, _path2849, _path2850, _path2851, _path2852, _path2853, _path2854, _path2855, _path2856, _path2857, _path2858, _path2859, _path2860, _path2861, _path2862, _path2863, _path2864, _path2865, _path2866, _path2867, _path2868, _path2869, _path2870, _path2871, _path2872, _path2873, _path2874, _path2875, _path2876, _path2877, _path2878, _path2879, _path2880, _path2881, _path2882, _path2883, _path2884, _path2885, _path2886, _path2887, _path2888, _path2889, _path2890, _path2891, _path2892, _path2893, _path2894, _path2895, _path2896, _path2897, _path2898, _path2899, _path2900, _path2901, _path2902, _path2903, _path2904, _path2905, _path2906, _path2907, _path2908, _path2909, _path2910, _path2911, _path2912, _path2913, _path2914, _path2915, _path2916, _path2917, _path2918, _path2919, _path2920, _path2921, _path2922, _path2923, _path2924, _path2925, _path2926, _path2927, _path2928, _path2929, _path2930, _path2931, _path2932, _path2933, _path2934, _path2935, _path2936, _path2937, _path2938, _path2939, _path2940, _path2941, _path2942, _path2943, _path2944, _path2945, _path2946, _path2947, _path2948, _path2949, _path2950, _path2951, _path2952, _path2953, _path2954, _path2955, _path2956, _path2957, _path2958, _path2959, _path2960, _path2961, _path2962, _path2963, _path2964, _path2965, _path2966, _path2967, _path2968, _path2969, _path2970, _path2971, _path2972, _path2973, _path2974, _path2975, _path2976, _path2977, _path2978, _path2979, _path2980, _path2981, _path2982, _path2983, _path2984, _path2985, _path2986, _path2987, _path2988, _path2989, _path2990, _path2991, _path2992, _path2993, _path2994, _path2995, _path2996, _path2997, _path2998, _path2999, _path3000, _path3001, _path3002, _path3003, _path3004, _path3005, _path3006, _path3007, _path3008, _path3009, _path3010, _path3011, _path3012, _path3013, _path3014, _path3015, _path3016, _path3017, _path3018, _path3019, _path3020, _path3021, _path3022, _path3023, _path3024, _path3025, _path3026, _path3027, _path3028, _path3029, _path3030, _path3031, _path3032, _path3033, _path3034, _path3035, _path3036, _path3037, _path3038, _path3039, _path3040, _path3041, _path3042, _path3043, _path3044, _path3045, _path3046, _path3047, _path3048, _path3049, _path3050, _path3051, _path3052, _path3053, _path3054, _path3055, _path3056, _path3057, _path3058, _path3059, _path3060, _path3061, _path3062, _path3063, _path3064, _path3065, _path3066, _path3067, _path3068, _path3069, _path3070, _path3071, _path3072, _path3073, _path3074, _path3075, _path3076, _path3077, _path3078, _path3079, _path3080, _path3081, _path3082, _path3083, _path3084, _path3085, _path3086, _path3087, _path3088, _path3089, _path3090, _path3091, _path3092, _path3093, _path3094, _path3095, _path3096, _path3097, _path3098, _path3099, _path3100, _path3101, _path3102, _path3103, _path3104, _path3105, _path3106, _path3107, _path3108, _path3109, _path3110, _path3111, _path3112, _path3113, _path3114, _path3115, _path3116, _path3117, _path3118, _path3119, _path3120, _path3121, _path3122, _path3123, _path3124, _path3125, _path3126, _path3127, _path3128, _path3129, _path3130, _path3131, _path3132, _path3133, _path3134, _path3135, _path3136, _path3137, _path3138, _path3139, _path3140, _path3141, _path3142, _path3143, _path3144, _path3145, _path3146, _path3147, _path3148, _path3149, _path3150, _path3151, _path3152, _path3153, _path3154, _path3155, _path3156, _path3157, _path3158, _path3159, _path3160, _path3161, _path3162, _path3163, _path3164, _path3165, _path3166, _path3167, _path3168, _path3169, _path3170, _path3171, _path3172, _path3173, _path3174, _path3175, _path3176, _path3177, _path3178, _path3179, _path3180, _path3181, _path3182, _path3183, _path3184, _path3185, _path3186, _path3187, _path3188, _path3189, _path3190, _path3191, _path3192, _path3193, _path3194, _path3195, _path3196, _path3197, _path3198, _path3199, _path3200, _path3201, _path3202, _path3203, _path3204, _path3205, _path3206, _path3207, _path3208, _path3209, _path3210, _path3211, _path3212, _path3213, _path3214, _path3215, _path3216, _path3217, _path3218, _path3219, _path3220, _path3221, _path3222, _path3223, _path3224, _path3225, _path3226, _path3227, _path3228, _path3229, _path3230, _path3231, _path3232, _path3233, _path3234, _path3235, _path3236, _path3237, _path3238, _path3239, _path3240, _path3241, _path3242, _path3243, _path3244, _path3245, _path3246, _path3247, _path3248, _path3249, _path3250, _path3251, _path3252, _path3253, _path3254, _path3255, _path3256, _path3257, _path3258, _path3259, _path3260, _path3261, _path3262, _path3263, _path3264, _path3265, _path3266, _path3267, _path3268, _path3269, _path3270, _path3271, _path3272, _path3273, _path3274, _path3275, _path3276, _path3277, _path3278, _path3279, _path3280, _path3281, _path3282, _path3283, _path3284, _path3285, _path3286, _path3287, _path3288, _path3289, _path3290, _path3291, _path3292, _path3293, _path3294, _path3295, _path3296, _path3297, _path3298, _path3299, _path3300, _path3301, _path3302, _path3303, _path3304, _path3305, _path3306, _path3307, _path3308, _path3309, _path3310, _path3311, _path3312, _path3313, _path3314, _path3315, _path3316, _path3317, _path3318, _path3319, _path3320, _path3321, _path3322, _path3323, _path3324, _path3325, _path3326, _path3327, _path3328, _path3329, _path3330, _path3331, _path3332, _path3333, _path3334, _path3335, _path3336, _path3337, _path3338, _path3339, _path3340, _path3341, _path3342, _path3343, _path3344, _path3345, _path3346, _path3347, _path3348, _path3349, _path3350, _path3351, _path3352, _path3353, _path3354, _path3355, _path3356, _path3357, _path3358, _path3359, _path3360, _path3361, _path3362, _path3363, _path3364, _path3365, _path3366, _path3367, _path3368, _path3369, _path3370, _path3371, _path3372, _path3373, _path3374, _path3375, _path3376, _path3377, _path3378, _path3379, _path3380, _path3381, _path3382, _path3383, _path3384, _path3385, _path3386, _path3387, _path3388, _path3389, _path3390, _path3391, _path3392, _path3393, _path3394, _path3395, _path3396, _path3397, _path3398, _path3399, _path3400, _path3401, _path3402, _path3403, _path3404, _path3405, _path3406, _path3407, _path3408, _path3409, _path3410, _path3411, _path3412, _path3413, _path3414, _path3415, _path3416, _path3417, _path3418, _path3419, _path3420, _path3421, _path3422, _path3423, _path3424, _path3425, _path3426, _path3427, _path3428, _path3429, _path3430, _path3431, _path3432, _path3433, _path3434, _path3435, _path3436, _path3437, _path3438, _path3439, _path3440, _path3441, _path3442, _path3443, _path3444, _path3445, _path3446, _path3447, _path3448, _path3449, _path3450, _path3451, _path3452, _path3453, _path3454, _path3455, _path3456, _path3457, _path3458, _path3459, _path3460, _path3461, _path3462, _path3463, _path3464, _path3465, _path3466, _path3467, _path3468, _path3469, _path3470, _path3471, _path3472, _path3473, _path3474, _path3475, _path3476, _path3477, _path3478, _path3479, _path3480, _path3481, _path3482, _path3483, _path3484, _path3485, _path3486, _path3487, _path3488, _path3489, _path3490, _path3491, _path3492, _path3493, _path3494, _path3495, _path3496, _path3497, _path3498, _path3499, _path3500, _path3501, _path3502, _path3503, _path3504, _path3505, _path3506, _path3507, _path3508, _path3509, _path3510, _path3511, _path3512, _path3513, _path3514, _path3515, _path3516, _path3517, _path3518, _path3519, _path3520, _path3521, _path3522, _path3523, _path3524, _path3525, _path3526, _path3527, _path3528, _path3529, _path3530, _path3531, _path3532, _path3533, _path3534, _path3535, _path3536, _path3537, _path3538, _path3539, _path3540, _path3541, _path3542, _path3543, _path3544, _path3545, _path3546, _path3547, _path3548, _path3549, _path3550, _path3551, _path3552, _path3553, _path3554, _path3555, _path3556, _path3557, _path3558, _path3559, _path3560, _path3561, _path3562, _path3563, _path3564, _path3565, _path3566, _path3567, _path3568, _path3569, _path3570, _path3571, _path3572, _path3573, _path3574, _path3575, _path3576, _path3577, _path3578, _path3579, _path3580, _path3581, _path3582, _path3583, _path3584, _path3585, _path3586, _path3587, _path3588, _path3589, _path3590, _path3591, _path3592, _path3593, _path3594, _path3595, _path3596, _path3597, _path3598, _path3599, _path3600, _path3601, _path3602, _path3603, _path3604, _path3605, _path3606, _path3607, _path3608, _path3609, _path3610, _path3611, _path3612, _path3613, _path3614, _path3615, _path3616, _path3617, _path3618, _path3619, _path3620, _path3621, _path3622, _path3623, _path3624, _path3625, _path3626, _path3627, _path3628, _path3629, _path3630, _path3631, _path3632, _path3633, _path3634, _path3635, _path3636, _path3637, _path3638, _path3639, _path3640, _path3641, _path3642, _path3643, _path3644, _path3645, _path3646, _path3647, _path3648, _path3649, _path3650, _path3651, _path3652, _path3653, _path3654, _path3655, _path3656, _path3657, _path3658, _path3659, _path3660, _path3661, _path3662, _path3663, _path3664, _path3665, _path3666, _path3667, _path3668, _path3669, _path3670, _path3671, _path3672, _path3673, _path3674, _path3675, _path3676, _path3677, _path3678, _path3679, _path3680, _path3681, _path3682, _path3683, _path3684, _path3685, _path3686, _path3687, _path3688, _path3689, _path3690, _path3691, _path3692, _path3693, _path3694, _path3695, _path3696, _path3697, _path3698, _path3699, _path3700, _path3701, _path3702, _path3703, _path3704, _path3705, _path3706, _path3707, _path3708, _path3709, _path3710, _path3711, _path3712, _path3713, _path3714, _path3715, _path3716, _path3717, _path3718, _path3719, _path3720, _path3721, _path3722, _path3723, _path3724, _path3725, _path3726, _path3727, _path3728, _path3729, _path3730, _path3731, _path3732, _path3733, _path3734, _path3735, _path3736, _path3737, _path3738, _path3739, _path3740, _path3741, _path3742, _path3743, _path3744, _path3745, _path3746, _path3747, _path3748, _path3749, _path3750, _path3751, _path3752, _path3753, _path3754, _path3755, _path3756, _path3757, _path3758, _path3759, _path3760, _path3761, _path3762, _path3763, _path3764, _path3765, _path3766, _path3767, _path3768, _path3769, _path3770, _path3771, _path3772, _path3773, _path3774, _path3775, _path3776, _path3777, _path3778, _path3779, _path3780, _path3781, _path3782, _path3783, _path3784, _path3785, _path3786, _path3787, _path3788, _path3789, _path3790, _path3791, _path3792, _path3793, _path3794, _path3795, _path3796, _path3797, _path3798, _path3799, _path3800, _path3801, _path3802, _path3803, _path3804, _path3805, _path3806, _path3807, _path3808, _path3809, _path3810, _path3811, _path3812, _path3813, _path3814, _path3815, _path3816, _path3817, _path3818, _path3819, _path3820, _path3821, _path3822, _path3823, _path3824, _path3825, _path3826, _path3827, _path3828, _path3829, _path3830, _path3831, _path3832, _path3833, _path3834, _path3835, _path3836, _path3837, _path3838, _path3839, _path3840, _path3841, _path3842, _path3843, _path3844, _path3845, _path3846, _path3847, _path3848, _path3849, _path3850, _path3851, _path3852, _path3853, _path3854, _path3855, _path3856, _path3857, _path3858, _path3859, _path3860, _path3861, _path3862, _path3863, _path3864, _path3865, _path3866, _path3867, _path3868, _path3869, _path3870, _path3871, _path3872, _path3873, _path3874, _path3875, _path3876, _path3877, _path3878, _path3879, _path3880, _path3881, _path3882, _path3883, _path3884, _path3885, _path3886, _path3887, _path3888, _path3889, _path3890, _path3891, _path3892, _path3893, _path3894, _path3895, _path3896, _path3897, _path3898, _path3899, _path3900, _path3901, _path3902, _path3903, _path3904, _path3905, _path3906, _path3907, _path3908, _path3909, _path3910, _path3911, _path3912, _path3913, _path3914, _path3915, _path3916, _path3917, _path3918, _path3919, _path3920, _path3921, _path3922, _path3923, _path3924, _path3925, _path3926, _path3927, _path3928, _path3929, _path3930, _path3931, _path3932, _path3933, _path3934, _path3935, _path3936, _path3937, _path3938, _path3939, _path3940, _path3941, _path3942, _path3943, _path3944, _path3945, _path3946, _path3947, _path3948, _path3949, _path3950, _path3951, _path3952, _path3953, _path3954, _path3955, _path3956, _path3957, _path3958, _path3959, _path3960, _path3961, _path3962, _path3963, _path3964, _path3965, _path3966, _path3967, _path3968, _path3969, _path3970, _path3971, _path3972, _path3973, _path3974, _path3975, _path3976, _path3977, _path3978, _path3979, _path3980, _path3981, _path3982, _path3983, _path3984, _path3985, _path3986, _path3987, _path3988, _path3989, _path3990, _path3991, _path3992, _path3993, _path3994, _path3995, _path3996, _path3997, _path3998, _path3999, _path4000, _path4001, _path4002, _path4003, _path4004, _path4005, _path4006, _path4007, _path4008, _path4009, _path4010, _path4011, _path4012, _path4013, _path4014, _path4015, _path4016, _path4017, _path4018, _path4019, _path4020, _path4021, _path4022, _path4023, _path4024, _path4025, _path4026, _path4027, _path4028, _path4029, _path4030, _path4031, _path4032, _path4033, _path4034, _path4035, _path4036, _path4037, _path4038, _path4039, _path4040, _path4041, _path4042, _path4043, _path4044, _path4045, _path4046, _path4047, _path4048, _path4049, _path4050, _path4051, _path4052, _path4053, _path4054, _path4055, _path4056, _path4057, _path4058, _path4059, _path4060, _path4061, _path4062, _path4063, _path4064, _path4065, _path4066, _path4067, _path4068, _path4069, _path4070, _path4071, _path4072, _path4073, _path4074, _path4075, _path4076, _path4077, _path4078, _path4079, _path4080, _path4081, _path4082, _path4083, _path4084, _path4085, _path4086, _path4087, _path4088, _path4089, _path4090, _path4091, _path4092, _path4093, _path4094, _path4095, _path4096, _path4097, _path4098, _path4099, _path4100, _path4101, _path4102, _path4103, _path4104, _path4105, _path4106, _path4107, _path4108, _path4109, _path4110, _path4111, _path4112, _path4113, _path4114, _path4115, _path4116, _path4117, _path4118, _path4119, _path4120, _path4121, _path4122, _path4123, _path4124, _path4125, _path4126, _path4127, _path4128, _path4129, _path4130, _path4131, _path4132, _path4133, _path4134, _path4135, _path4136, _path4137, _path4138, _path4139, _path4140, _path4141, _path4142, _path4143, _path4144, _path4145, _path4146, _path4147, _path4148, _path4149, _path4150, _path4151, _path4152, _path4153, _path4154, _path4155, _path4156, _path4157, _path4158, _path4159, _path4160, _path4161, _path4162, _path4163, _path4164, _path4165, _path4166, _path4167, _path4168, _path4169, _path4170, _path4171, _path4172, _path4173, _path4174, _path4175, _path4176, _path4177, _path4178, _path4179, _path4180, _path4181, _path4182, _path4183, _path4184, _path4185, _path4186, _path4187, _path4188, _path4189, _path4190, _path4191, _path4192, _path4193, _path4194, _path4195, _path4196, _path4197, _path4198, _path4199, _path4200, _path4201, _path4202, _path4203, _path4204, _path4205, _path4206, _path4207, _path4208, _path4209, _path4210, _path4211, _path4212, _path4213, _path4214, _path4215, _path4216, _path4217, _path4218, _path4219, _path4220, _path4221, _path4222, _path4223, _path4224, _path4225, _path4226, _path4227, _path4228, _path4229, _path4230, _path4231, _path4232, _path4233, _path4234, _path4235, _path4236, _path4237, _path4238, _path4239, _path4240, _path4241, _path4242, _path4243, _path4244, _path4245, _path4246, _path4247, _path4248, _path4249, _path4250, _path4251, _path4252, _path4253, _path4254, _path4255, _path4256, _path4257, _path4258, _path4259, _path4260, _path4261, _path4262, _path4263, _path4264, _path4265, _path4266, _path4267, _path4268, _path4269, _path4270, _path4271, _path4272, _path4273, _path4274, _path4275, _path4276, _path4277, _path4278, _path4279, _path4280, _path4281, _path4282, _path4283, _path4284, _path4285, _path4286, _path4287, _path4288, _path4289, _path4290, _path4291, _path4292, _path4293, _path4294, _path4295, _path4296, _path4297, _path4298, _path4299, _path4300, _path4301, _path4302, _path4303, _path4304, _path4305, _path4306, _path4307, _path4308, _path4309, _path4310, _path4311, _path4312, _path4313, _path4314, _path4315, _path4316, _path4317, _path4318, _path4319, _path4320, _path4321, _path4322, _path4323, _path4324, _path4325, _path4326, _path4327, _path4328, _path4329, _path4330, _path4331, _path4332, _path4333, _path4334, _path4335, _path4336, _path4337, _path4338, _path4339, _path4340, _path4341, _path4342, _path4343, _path4344, _path4345, _path4346, _path4347, _path4348, _path4349, _path4350, _path4351, _path4352, _path4353, _path4354, _path4355, _path4356, _path4357, _path4358, _path4359, _path4360, _path4361, _path4362, _path4363, _path4364, _path4365, _path4366, _path4367, _path4368, _path4369, _path4370, _path4371, _path4372, _path4373, _path4374, _path4375, _path4376, _path4377, _path4378, _path4379, _path4380, _path4381, _path4382, _path4383, _path4384, _path4385, _path4386, _path4387, _path4388, _path4389, _path4390, _path4391, _path4392, _path4393, _path4394, _path4395, _path4396, _path4397, _path4398, _path4399, _path4400, _path4401, _path4402, _path4403, _path4404, _path4405, _path4406, _path4407, _path4408, _path4409, _path4410, _path4411, _path4412, _path4413, _path4414, _path4415, _path4416, _path4417, _path4418, _path4419, _path4420, _path4421, _path4422, _path4423, _path4424, _path4425, _path4426, _path4427, _path4428, _path4429, _path4430, _path4431, _path4432, _path4433, _path4434, _path4435, _path4436, _path4437, _path4438, _path4439, _path4440, _path4441, _path4442, _path4443, _path4444, _path4445, _path4446, _path4447, _path4448, _path4449, _path4450, _path4451, _path4452, _path4453, _path4454, _path4455, _path4456, _path4457, _path4458, _path4459, _path4460, _path4461, _path4462, _path4463, _path4464, _path4465, _path4466, _path4467, _path4468, _path4469, _path4470, _path4471, _path4472, _path4473, _path4474, _path4475, _path4476, _path4477, _path4478, _path4479, _path4480, _path4481, _path4482, _path4483, _path4484, _path4485, _path4486, _path4487, _path4488, _path4489, _path4490, _path4491, _path4492, _path4493, _path4494, _path4495, _path4496, _path4497, _path4498, _path4499, _path4500, _path4501, _path4502, _path4503, _path4504, _path4505, _path4506, _path4507, _path4508, _path4509, _path4510, _path4511, _path4512, _path4513, _path4514, _path4515, _path4516, _path4517, _path4518, _path4519, _path4520, _path4521, _path4522, _path4523, _path4524, _path4525, _path4526, _path4527, _path4528, _path4529, _path4530, _path4531, _path4532, _path4533, _path4534, _path4535, _path4536, _path4537, _path4538, _path4539, _path4540, _path4541, _path4542, _path4543, _path4544, _path4545, _path4546, _path4547, _path4548, _path4549, _path4550, _path4551, _path4552, _path4553, _path4554, _path4555, _path4556, _path4557, _path4558, _path4559, _path4560, _path4561, _path4562, _path4563, _path4564, _path4565, _path4566, _path4567, _path4568, _path4569, _path4570;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaves(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 85,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 16v-1h1v1zM17 42h-1v-1h1zm57 33v-1h1v1zm16 3h-1v-1h1zm-20 1h-1v-1h1zm-7 1v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13v1h-1v-1zm45 19h1v1h-1zm17 27v-1h1v1z",
    fillOpacity: 0.004
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 18v1h-1v-1zm68 24v-1h1v1z",
    fill: "#9f9f5f",
    fillOpacity: 0.031
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20h-1v-1h1zm0 40h-1v-1h1z",
    fill: "#a3673f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23v1h-1v-1zm10 39v-1h1v1z",
    fill: "#90562c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23v1h-1v-1zm-8 31v-1h1v1z",
    fill: "#421f14"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100 26v1h-1v-1zm25 32h-1v-1h1z",
    fill: "#ff0",
    fillOpacity: 0.004
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55 29h-1v-1h1zm6 15h1v1h-1z",
    fill: "#d3b597"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76 29h1v1h-1zm2 34v1h-1v-1z",
    fill: "#905b37"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M112 33v1h-1v-1zm9 14v-1h1v1z",
    fill: "#bfbf7f",
    fillOpacity: 0.016
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M41 36h-1v-1h1zm69 13h-1v-1h1z",
    fill: "#88572d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 37v-1h1v1zm46 11v1h-1v-1z",
    fill: "#733a1a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36h1v1h-1zm15 22v1h-1v-1z",
    fill: "#3f190d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33 37v-1h1v1zm62 25h1v1h-1z",
    fill: "#512519"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37v1h-1v-1zm58 17h1v1h-1z",
    fill: "#1d0807"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38h-1v-1h1zm-7 6v1h-1v-1z",
    fill: "#421e11"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v1h-1v-1zm5 2h-1v-1h1z",
    fill: "#693e21"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44 39v1h-1v-1zm16 23v1h-1v-1z",
    fill: "#673416"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103 40v1h-1v-1zm-67 2v1h-1v-1z",
    fill: "#25140d"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v1h-1v-1zm60 8v-1h1v1z",
    fill: "#2b1206"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45h-1v-1h1zm40 8h-1v-1h1z",
    fill: "#331e13"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M104 44v1h-1v-1zm-37 8h-1v-1h1z",
    fill: "#784b29"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21 46v-1h1v1zm26 16h-1v-1h1z",
    fill: "#9c5f28"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45h1v1h-1zm33 12h-1v-1h1z",
    fill: "#412012"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37 46v1h-1v-1zm-23 6h-1v-1h1z",
    fill: "#462f21"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18 50h1v1h-1zm56 3v-1h1v1z",
    fill: "#774b3a"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19 51v-1h1v1zm3 1h1v1h-1z",
    fill: "#3e2314"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34 51h-1v-1h1zm57 14v-1h1v1z",
    fill: "#281005"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16 51v1h-1v-1zm80 6v1h-1v-1z",
    fill: "#482b21"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52h-1v-1h1zm39 20h-1v-1h1z",
    fill: "#210e05"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M42 54v1h-1v-1zm29 12h-1v-1h1z",
    fill: "#110903"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M97 56v1h-1v-1zM62 68v1h-1v-1z",
    fill: "#3a190a"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v-1h1v1zm23 7h1v1h-1z",
    fill: "#5d3a28"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v-1h1v1zm37 11v1h-1v-1z",
    fill: "#5c3523"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M120 58v-1h1v2h-1z",
    fill: "#7f7f00",
    fillOpacity: 0.008
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M119 61h-1v-1h1zM58 78h1v1h-1z",
    fill: "#999",
    fillOpacity: 0.02
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M92 63v-1h1v1zm-3 2h1v1h-1z",
    fill: "#673f33"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M116 64v1h-1v-1zm-13 6v-1h1v1z",
    fillOpacity: 0.02
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M112 68v-1h1v1zm-2 0h1v1h-1z",
    fillOpacity: 0.024
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M72 14v-1h1v1z",
    fill: "#7fff7f",
    fillOpacity: 0.008
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M74 13v1h-1v-1z",
    fill: "#dac8a3",
    fillOpacity: 0.055
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M59 14v1h-1v-1z",
    fill: "#e3da7a",
    fillOpacity: 0.22
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M59 15v-1h1v1z",
    fill: "#f0e797",
    fillOpacity: 0.686
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14h1v1h-1z",
    fill: "#e2d997",
    fillOpacity: 0.455
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M62 15h-1v-1h1z",
    fill: "#eee7a3",
    fillOpacity: 0.714
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M62 14h1v1h-1z",
    fill: "#eae0a8",
    fillOpacity: 0.196
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h-1v-1h1z",
    fill: "#e5e5b2",
    fillOpacity: 0.039
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15v-1h1v1z",
    fill: "#f1edc6",
    fillOpacity: 0.69
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M75 15h-1v-1h1z",
    fill: "#f1eacc",
    fillOpacity: 0.588
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M75 14h1v1h-1z",
    fill: "#b6b691",
    fillOpacity: 0.027
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h1v1h-1z",
    fill: "#cdb953",
    fillOpacity: 0.502
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M60 15v1h-1v-1z",
    fill: "#ffe880"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M60 16v-1h1v1z",
    fill: "#f8de8e"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M62 16h-1v-1h1z",
    fill: "#f7dc96"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M63 16h-1v-1h1z",
    fill: "#f6e596",
    fillOpacity: 0.596
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M63 15h1v1h-1z",
    fill: "#e7cf69",
    fillOpacity: 0.294
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M65 16h-1v-1h1z",
    fill: "#e7d767",
    fillOpacity: 0.125
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v-1h1v1z",
    fill: "#d6cc47",
    fillOpacity: 0.098
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M69 16h-1v-1h1z",
    fill: "#d2b142",
    fillOpacity: 0.09
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h1v1h-1z",
    fill: "#dfefc9",
    fillOpacity: 0.188
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16h-1v-1h1z",
    fill: "#f6f1ca",
    fillOpacity: 0.929
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16v-1h1v1z",
    fill: "#f6f1cc",
    fillOpacity: 0.667
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M76 16v-1h1v1z",
    fill: "#d7d7bd",
    fillOpacity: 0.153
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17v-1h1v1z",
    fill: "#ccbe53",
    fillOpacity: 0.216
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M55 16h1v1h-1z",
    fill: "#c5c551",
    fillOpacity: 0.086
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M57 17v-1h1v1z",
    fill: "#bdb158",
    fillOpacity: 0.169
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v-1h1v1z",
    fill: "#ddaf42",
    fillOpacity: 0.898
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M60 17h-1v-1h1z",
    fill: "#f1be43"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17h-1v-1h1z",
    fill: "#d09a30"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17v-1h1v1z",
    fill: "#dfb35c"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M62 17v-1h1v1z",
    fill: "#efc669"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M64 16v1h-1v-1z",
    fill: "#d09730"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17v-1h1v1z",
    fill: "#d5ab45",
    fillOpacity: 0.918
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M66 17h-1v-1h1z",
    fill: "#c3a643",
    fillOpacity: 0.667
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v1h-1v-1z",
    fill: "#ad8326",
    fillOpacity: 0.518
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16h1v1h-1z",
    fill: "#e6be2e",
    fillOpacity: 0.843
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M68 16h1v1h-1z",
    fill: "#ecc932",
    fillOpacity: 0.749
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M69 16h1v1h-1z",
    fill: "#c8aa30",
    fillOpacity: 0.165
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M71 17h-1v-1h1z",
    fill: "#c7ac37",
    fillOpacity: 0.145
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M72 17h-1v-1h1z",
    fill: "#dfbe42",
    fillOpacity: 0.514
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M72 16h1v1h-1z",
    fill: "#dbba4b",
    fillOpacity: 0.675
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16v1h-1v-1z",
    fill: "#e2c47d",
    fillOpacity: 0.533
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16v1h-1v-1z",
    fill: "#e5d38a",
    fillOpacity: 0.808
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M76 16v1h-1v-1z",
    fill: "#f9ecb8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M77 17h-1v-1h1z",
    fill: "#f8efd1",
    fillOpacity: 0.925
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M77 16h1v1h-1z",
    fill: "#faedd9",
    fillOpacity: 0.4
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M51 17h1v1h-1z",
    fill: "#ae7828",
    fillOpacity: 0.075
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M53 17v1h-1v-1z",
    fill: "#cf8e2d",
    fillOpacity: 0.42
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M53 17h1v1h-1z",
    fill: "#be8d3c",
    fillOpacity: 0.247
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18h-1v-1h1z",
    fill: "#d1b73a",
    fillOpacity: 0.545
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18v-1h1v1z",
    fill: "#eecc45",
    fillOpacity: 0.847
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18v-1h1v1z",
    fill: "#e8d99e",
    fillOpacity: 0.718
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v1h-1v-1z",
    fill: "#caad5d",
    fillOpacity: 0.859
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18v-1h1v1z",
    fill: "#db9d28"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M59 17h1v1h-1z",
    fill: "#e5ae2d"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v-1h1v1z",
    fill: "#dca937"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M62 18h-1v-1h1z",
    fill: "#eac787"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M63 17v1h-1v-1z",
    fill: "#e3c291"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18v-1h1v1z",
    fill: "#d39d5d"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17h1v1h-1z",
    fill: "#bb7d4d"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M65 18v-1h1v1z",
    fill: "#a36441"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h-1v-1h1z",
    fill: "#c8892c"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M68 17v1h-1v-1z",
    fill: "#fbd133"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18h-1v-1h1z",
    fill: "#fad433"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M70 17v1h-1v-1z",
    fill: "#e7ae2f",
    fillOpacity: 0.941
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M70 18v-1h1v1z",
    fill: "#e7a72b",
    fillOpacity: 0.937
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M71 18v-1h1v1z",
    fill: "#eba82c"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M72 18v-1h1v1z",
    fill: "#daa33f"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18h-1v-1h1z",
    fill: "#eace8f"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M75 18h-1v-1h1z",
    fill: "#f7e5c2"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M75 18v-1h1v1z",
    fill: "#f0e2c2"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M77 17v1h-1v-1z",
    fill: "#f7eccd"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M78 17v1h-1v-1z",
    fill: "#fcf0d8",
    fillOpacity: 0.976
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M78 18v-1h1v1z",
    fill: "#fbe8d2",
    fillOpacity: 0.271
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M45 19h-1v-1h1z",
    fill: "#dec343",
    fillOpacity: 0.4
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M45 19v-1h1v1z",
    fill: "#e6d349",
    fillOpacity: 0.369
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M47 18v1h-1v-1z",
    fill: "#e9e9aa",
    fillOpacity: 0.047
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M47 19v-1h1v1z",
    fill: "#7faa55",
    fillOpacity: 0.024
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M48 19v-1h1v1z",
    fill: "#a95",
    fillOpacity: 0.059
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M51 19h-1v-1h1z",
    fill: "#896213",
    fillOpacity: 0.051
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M52 19h-1v-1h1z",
    fill: "#dca730",
    fillOpacity: 0.757
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M52 19v-1h1v1z",
    fill: "#eea32a"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M53 18h1v1h-1z",
    fill: "#d99d42",
    fillOpacity: 0.929
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M54 18h1v1h-1z",
    fill: "#ca9937",
    fillOpacity: 0.878
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18h1v1h-1z",
    fill: "#f2b427"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18h1v1h-1z",
    fill: "#f1c45c"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18v1h-1v-1z",
    fill: "#e6bd72"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M59 19h-1v-1h1z",
    fill: "#e6b333"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v1h-1v-1z",
    fill: "#e9c01c"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M60 19v-1h1v1z",
    fill: "#e3bc20"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M61 18h1v1h-1z",
    fill: "#e6c976"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M63 19h-1v-1h1z",
    fill: "#b59783"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18h1v1h-1z",
    fill: "#ca9977"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v-1h1v1z",
    fill: "#b67f5a"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M66 18v1h-1v-1z",
    fill: "#bf8764"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18v1h-1v-1z",
    fill: "#b57435"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h1v1h-1z",
    fill: "#bf912d"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18v1h-1v-1z",
    fill: "#c39c30"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18h1v1h-1z",
    fill: "#da9635"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M70 18h1v1h-1z",
    fill: "#d27f13"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M72 19h-1v-1h1z",
    fill: "#d99920"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M73 19h-1v-1h1z",
    fill: "#f7d153"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18v1h-1v-1z",
    fill: "#fbdc94"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M74 19v-1h1v1z",
    fill: "#f8e0b6"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M75 19v-1h1v1z",
    fill: "#faeec9"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M76 19v-1h1v1z",
    fill: "#f2ead0"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M78 19h-1v-1h1z",
    fill: "#faf0d9"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M79 18v1h-1v-1z",
    fill: "#f4e2be",
    fillOpacity: 0.667
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M43 20h-1v-1h1z",
    fill: "#dcc966",
    fillOpacity: 0.204
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M44 19v1h-1v-1z",
    fill: "#e8c64f",
    fillOpacity: 0.702
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M44 19h1v1h-1z",
    fill: "#f0cf53",
    fillOpacity: 0.957
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M45 20v-1h1v1z",
    fill: "#ead63f",
    fillOpacity: 0.965
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M47 19v1h-1v-1z",
    fill: "#bca147",
    fillOpacity: 0.408
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M48 20h-1v-1h1z",
    fill: "#caa443",
    fillOpacity: 0.651
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M49 19v1h-1v-1z",
    fill: "#dcaa4a",
    fillOpacity: 0.851
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20v-1h1v1z",
    fill: "#d9a849",
    fillOpacity: 0.694
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M50 20v-1h1v1z",
    fill: "#d6ab37",
    fillOpacity: 0.733
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M51 20v-1h1v1z",
    fill: "#dcab27"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M52 20v-1h1v1z",
    fill: "#d59f35"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M54 19v1h-1v-1z",
    fill: "#d18f4a"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M54 19h1v1h-1z",
    fill: "#d49242"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M56 19v1h-1v-1z",
    fill: "#e1a222"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M57 20h-1v-1h1z",
    fill: "#e8ac29"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M58 20h-1v-1h1z",
    fill: "#dca656"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M59 20h-1v-1h1z",
    fill: "#dfa32c"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h-1v-1h1z",
    fill: "#dda619"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19v1h-1v-1z",
    fill: "#e3ae2b"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19h1v1h-1z",
    fill: "#c28639"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M62 19h1v1h-1z",
    fill: "#682106"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v1h-1v-1z",
    fill: "#a15122"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19h1v1h-1z",
    fill: "#cf8248"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M66 20h-1v-1h1z",
    fill: "#bd7c5a"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19h1v1h-1z",
    fill: "#b78151"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20v-1h1v1z",
    fill: "#d4a787"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M70 19v1h-1v-1z",
    fill: "#ecc79f"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M71 19v1h-1v-1z",
    fill: "#d09f54"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M72 20h-1v-1h1z",
    fill: "#e4bf68"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20h-1v-1h1z",
    fill: "#f5ce57"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20v-1h1v1z",
    fill: "#d69427"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M75 20h-1v-1h1z",
    fill: "#aa783b"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M76 20h-1v-1h1z",
    fill: "#d6bb8f"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M77 20h-1v-1h1z",
    fill: "#efe19e"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M78 20h-1v-1h1z",
    fill: "#f3e57b"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M78 20v-1h1v1z",
    fill: "#f7ec80",
    fillOpacity: 0.929
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M80 19v1h-1v-1z",
    fill: "#e5dd79",
    fillOpacity: 0.239
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20v-1h1v1z",
    fill: "#7f6231",
    fillOpacity: 0.102
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M84 20h-1v-1h1z",
    fill: "#917a48",
    fillOpacity: 0.22
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M41 20v1h-1v-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.008
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M42 20v1h-1v-1z",
    fill: "#e4cd8e",
    fillOpacity: 0.408
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M43 20v1h-1v-1z",
    fill: "#e6d180",
    fillOpacity: 0.843
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M44 20v1h-1v-1z",
    fill: "#e9c138"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M45 21h-1v-1h1z",
    fill: "#d6ae2b"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20v1h-1v-1z",
    fill: "#dcbe3e"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20h1v1h-1z",
    fill: "#e3b83c",
    fillOpacity: 0.969
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M47 20h1v1h-1z",
    fill: "#e5b22a"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20v1h-1v-1z",
    fill: "#efbe3e"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20h1v1h-1z",
    fill: "#f4d27a"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M50 20h1v1h-1z",
    fill: "#ffeaa4"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21h-1v-1h1z",
    fill: "#e6ce7e"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M53 20v1h-1v-1z",
    fill: "#dbbd70"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M53 21v-1h1v1z",
    fill: "#eac375"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20v1h-1v-1z",
    fill: "#e6b640"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20h1v1h-1z",
    fill: "#dea11d"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21h-1v-1h1z",
    fill: "#d59311"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21v-1h1v1z",
    fill: "#d9992e"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M59 21h-1v-1h1z",
    fill: "#cc8421"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20v1h-1v-1z",
    fill: "#ca9025"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h1v1h-1z",
    fill: "#cd9530"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M62 21h-1v-1h1z",
    fill: "#ba7231"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M63 20v1h-1v-1z",
    fill: "#a2531c"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21v-1h1v1z",
    fill: "#ab5411"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h-1v-1h1z",
    fill: "#b65814"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21v-1h1v1z",
    fill: "#bd7a46"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20v1h-1v-1z",
    fill: "#8d674a"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v-1h1v1z",
    fill: "#b58451"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20h1v1h-1z",
    fill: "#cd965b"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h-1v-1h1z",
    fill: "#e1bd90"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21v-1h1v1z",
    fill: "#e3c9a1"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M71 20h1v1h-1z",
    fill: "#e6b981"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M72 20h1v1h-1z",
    fill: "#d38c38"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20h1v1h-1z",
    fill: "#7f370b"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M75 21h-1v-1h1z",
    fill: "#300b01"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M76 21h-1v-1h1z",
    fill: "#755127"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M77 21h-1v-1h1z",
    fill: "#eac85a"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M78 21h-1v-1h1z",
    fill: "#f2d53d"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M79 20v1h-1v-1z",
    fill: "#eccc42"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M79 20h1v1h-1z",
    fill: "#d4b541",
    fillOpacity: 0.898
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M81 20v1h-1v-1z",
    fill: "#d1ba66",
    fillOpacity: 0.569
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21v-1h1v1z",
    fill: "#b9b95c",
    fillOpacity: 0.043
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20h1v1h-1z",
    fill: "#634014",
    fillOpacity: 0.341
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M83 20h1v1h-1z",
    fill: "#84592c",
    fillOpacity: 0.773
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M85 21h-1v-1h1z",
    fill: "#666",
    fillOpacity: 0.02
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M40 22v-1h1v1z",
    fill: "#aa8d55",
    fillOpacity: 0.035
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M41 21h1v1h-1z",
    fill: "#d6b766",
    fillOpacity: 0.769
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M42 21h1v1h-1z",
    fill: "#dab95b"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M43 22v-1h1v1z",
    fill: "#d5ae3c"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M44 21h1v1h-1z",
    fill: "#cfa146"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22v-1h1v1z",
    fill: "#c6a43a"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M47 21v1h-1v-1z",
    fill: "#e4be3f"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M47 22v-1h1v1z",
    fill: "#efc54d"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M49 21v1h-1v-1z",
    fill: "#efc665"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M50 21v1h-1v-1z",
    fill: "#f1cd90"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M51 21v1h-1v-1z",
    fill: "#eacb9a"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21v1h-1v-1z",
    fill: "#f0d393"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21h1v1h-1z",
    fill: "#eaca78"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M54 22h-1v-1h1z",
    fill: "#edbf67"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21v1h-1v-1z",
    fill: "#e7b433"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21h1v1h-1z",
    fill: "#eeb126"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M57 22h-1v-1h1z",
    fill: "#eaac1e"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22h-1v-1h1z",
    fill: "#dd9b22"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M58 21h1v1h-1z",
    fill: "#ba6c1a"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M59 22v-1h1v1z",
    fill: "#ce8f34"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M61 22h-1v-1h1z",
    fill: "#d6962d"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22h-1v-1h1z",
    fill: "#b76d14"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22v-1h1v1z",
    fill: "#ae6117"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21h1v1h-1z",
    fill: "#be6c1b"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22h-1v-1h1z",
    fill: "#cd7824"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h1v1h-1z",
    fill: "#985a2b"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v1h-1v-1z",
    fill: "#602f12"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M67 22v-1h1v1z",
    fill: "#c27e38"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M69 21v1h-1v-1z",
    fill: "#c8802b"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M69 22v-1h1v1z",
    fill: "#ce9f5c"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h1v1h-1z",
    fill: "#e3c58a"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M71 21h1v1h-1z",
    fill: "#debd82"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21v1h-1v-1z",
    fill: "#d4a653"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21h1v1h-1z",
    fill: "#ba8a48"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M74 22v-1h1v1z",
    fill: "#9e7c60"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M76 21v1h-1v-1z",
    fill: "#be9f7c"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M77 22h-1v-1h1z",
    fill: "#ddb36a"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M78 22h-1v-1h1z",
    fill: "#d38a2a"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M78 21h1v1h-1z",
    fill: "#cf7d26"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M79 21h1v1h-1z",
    fill: "#dda33d"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21v1h-1v-1z",
    fill: "#fadf99"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21h1v1h-1z",
    fill: "#f1edac",
    fillOpacity: 0.671
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M82 21h1v1h-1z",
    fill: "#ac7c4a",
    fillOpacity: 0.78
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M84 21v1h-1v-1z",
    fill: "#934217"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M85 21v1h-1v-1z",
    fill: "#b3852c",
    fillOpacity: 0.541
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M85 22v-1h1v1z",
    fill: "#e4e157",
    fillOpacity: 0.341
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M86 21h1v1h-1z",
    fill: "#c9ba53",
    fillOpacity: 0.337
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h-1v-1h1z",
    fill: "#4c321a",
    fillOpacity: 0.416
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M89 22h-1v-1h1z",
    fill: "#4a3220",
    fillOpacity: 0.553
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M90 21v1h-1v-1z",
    fill: "#5e463b",
    fillOpacity: 0.553
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M91 22h-1v-1h1z",
    fill: "#5a453b",
    fillOpacity: 0.518
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M91 21h1v1h-1z",
    fill: "#807264",
    fillOpacity: 0.349
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M92 21h1v1h-1z",
    fill: "#918579",
    fillOpacity: 0.082
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M42 22v1h-1v-1z",
    fill: "#c6a73d",
    fillOpacity: 0.388
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M42 23v-1h1v1z",
    fill: "#d2a73c",
    fillOpacity: 0.996
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M43 23v-1h1v1z",
    fill: "#c0882e"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23h-1v-1h1z",
    fill: "#b87a33"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22h1v1h-1z",
    fill: "#dab145"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M46 22h1v1h-1z",
    fill: "#ecc84e"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23h-1v-1h1z",
    fill: "#e8c259"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v-1h1v1z",
    fill: "#ce9c38"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M50 23h-1v-1h1z",
    fill: "#b46c1f"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M50 22h1v1h-1z",
    fill: "#c97421"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22v1h-1v-1z",
    fill: "#d88b1e"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22h1v1h-1z",
    fill: "#e2a237"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M53 23v-1h1v1z",
    fill: "#edb162"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h-1v-1h1z",
    fill: "#e0a84b"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M56 22v1h-1v-1z",
    fill: "#d9a128"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M57 23h-1v-1h1z",
    fill: "#dfa721"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22v1h-1v-1z",
    fill: "#ca861f"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v-1h1v1z",
    fill: "#b9691f"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23v-1h1v1z",
    fill: "#954c1d"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M60 22h1v1h-1z",
    fill: "#a6581b"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v-1h1v1z",
    fill: "#ba6817"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23h-1v-1h1z",
    fill: "#bf7420"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23v-1h1v1z",
    fill: "#a15e1a"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22v1h-1v-1z",
    fill: "#a15d20"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23v-1h1v1z",
    fill: "#863e14"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23h-1v-1h1z",
    fill: "#995827"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M68 22v1h-1v-1z",
    fill: "#c68130"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M69 23h-1v-1h1z",
    fill: "#bb6c19"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M70 22v1h-1v-1z",
    fill: "#cf8130"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M71 22v1h-1v-1z",
    fill: "#e1a751"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h-1v-1h1z",
    fill: "#ab824a"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23v-1h1v1z",
    fill: "#c39652"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M74 22v1h-1v-1z",
    fill: "#ab7431"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M75 23h-1v-1h1z",
    fill: "#8d5229"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M75 23v-1h1v1z",
    fill: "#955630"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M77 22v1h-1v-1z",
    fill: "#b57239"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M77 23v-1h1v1z",
    fill: "#ce8642"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M79 23h-1v-1h1z",
    fill: "#de9948"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M80 22v1h-1v-1z",
    fill: "#d5a962"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M81 23h-1v-1h1z",
    fill: "#e0c186"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23h-1v-1h1z",
    fill: "#e6be90"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23v-1h1v1z",
    fill: "#ba794c"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M83 23v-1h1v1z",
    fill: "#a45217"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M84 23v-1h1v1z",
    fill: "#efc642"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M85 22h1v1h-1z",
    fill: "#ffea37"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M87 23h-1v-1h1z",
    fill: "#e9cc4b"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M88 23h-1v-1h1z",
    fill: "#5c351a"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h1v1h-1z",
    fill: "#391809"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M90 22v1h-1v-1z",
    fill: "#3a1c18"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23h-1v-1h1z",
    fill: "#4b2f26"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23v-1h1v1z",
    fill: "#5c4239"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M93 22v1h-1v-1z",
    fill: "#715f5a",
    fillOpacity: 0.871
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23v-1h1v1z",
    fill: "#908878",
    fillOpacity: 0.498
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M94 23v-1h1v1z",
    fill: "#8b8b73",
    fillOpacity: 0.043
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M34 24h-1v-1h1z",
    fill: "#dfdf7f",
    fillOpacity: 0.031
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M35 24h-1v-1h1z",
    fill: "#f2e1a4",
    fillOpacity: 0.408
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23v1h-1v-1z",
    fill: "#e4bc66",
    fillOpacity: 0.557
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M36 24v-1h1v1z",
    fill: "#dab53b",
    fillOpacity: 0.651
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24h-1v-1h1z",
    fill: "#cbac37",
    fillOpacity: 0.29
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v-1h1v1z",
    fill: "#9c9",
    fillOpacity: 0.02
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24h-1v-1h1z",
    fill: "#cfbc55",
    fillOpacity: 0.106
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23v1h-1v-1z",
    fill: "#91b648",
    fillOpacity: 0.027
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23h1v1h-1z",
    fill: "#c9b56b",
    fillOpacity: 0.204
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M42 23h1v1h-1z",
    fill: "#cb9d51",
    fillOpacity: 0.953
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24h-1v-1h1z",
    fill: "#c58d49"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23v1h-1v-1z",
    fill: "#d8a059"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24v-1h1v1z",
    fill: "#efc74a"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M46 23h1v1h-1z",
    fill: "#e8c24b"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v1h-1v-1z",
    fill: "#d6ac4f"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M48 24v-1h1v1z",
    fill: "#946242"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M49 23h1v1h-1z",
    fill: "#944a31"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24v-1h1v1z",
    fill: "#c86a27"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h-1v-1h1z",
    fill: "#db8014"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24v-1h1v1z",
    fill: "#d68618"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M53 24v-1h1v1z",
    fill: "#cc8f48"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M54 23h1v1h-1z",
    fill: "#c6954e"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h1v1h-1z",
    fill: "#c99227"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M56 23h1v1h-1z",
    fill: "#e0a321"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v1h-1v-1z",
    fill: "#ca8421"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M59 24h-1v-1h1z",
    fill: "#a45c17"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23h1v1h-1z",
    fill: "#985418"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v1h-1v-1z",
    fill: "#b46a26"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M62 23v1h-1v-1z",
    fill: "#c57e29"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v-1h1v1z",
    fill: "#cd8a32"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v-1h1v1z",
    fill: "#783b12"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M64 23h1v1h-1z",
    fill: "#6b321b"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23h1v1h-1z",
    fill: "#80401a"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M67 24v-1h1v1z",
    fill: "#9d6532"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h-1v-1h1z",
    fill: "#a45316"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M70 23v1h-1v-1z",
    fill: "#b55712"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24h-1v-1h1z",
    fill: "#b1672e"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v-1h1v1z",
    fill: "#8c461e"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h1v1h-1z",
    fill: "#93522a"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h-1v-1h1z",
    fill: "#a66e4d"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24v-1h1v1z",
    fill: "#d0a27f"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M76 23v1h-1v-1z",
    fill: "#c68d5f"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24h-1v-1h1z",
    fill: "#c88758"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v-1h1v1z",
    fill: "#bc8460"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M78 23h1v1h-1z",
    fill: "#d5b08c"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M79 24v-1h1v1z",
    fill: "#c3a281"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24h-1v-1h1z",
    fill: "#a3714d"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24v-1h1v1z",
    fill: "#914523"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23h1v1h-1z",
    fill: "#984a2f"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M84 23v1h-1v-1z",
    fill: "#a25b36"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M84 24v-1h1v1z",
    fill: "#ba7c2a"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M85 23h1v1h-1z",
    fill: "#d7a126"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M86 24v-1h1v1z",
    fill: "#ae8b39"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M87 23h1v1h-1z",
    fill: "#47190d"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M89 23v1h-1v-1z",
    fill: "#431714"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M90 24h-1v-1h1z",
    fill: "#441d1b"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M91 24v-1h1v1z",
    fill: "#472717",
    fillOpacity: 0.988
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23v1h-1v-1z",
    fill: "#46352a",
    fillOpacity: 0.784
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23h1v1h-1z",
    fill: "#65604a",
    fillOpacity: 0.58
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M94 23h1v1h-1z",
    fill: "#939a78",
    fillOpacity: 0.149
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M34 25h-1v-1h1z",
    fill: "#aa9b55",
    fillOpacity: 0.071
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M34 25v-1h1v1z",
    fill: "#da9f3d",
    fillOpacity: 0.882
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25h-1v-1h1z",
    fill: "#eeac26"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M37 25h-1v-1h1z",
    fill: "#f0b51e"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v1h-1v-1z",
    fill: "#e7b534",
    fillOpacity: 0.98
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v-1h1v1z",
    fill: "#daaf3b",
    fillOpacity: 0.745
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24v1h-1v-1z",
    fill: "#d8bc40",
    fillOpacity: 0.851
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M41 25h-1v-1h1z",
    fill: "#ead540",
    fillOpacity: 0.812
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M41 24h1v1h-1z",
    fill: "#dbbb54",
    fillOpacity: 0.839
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h-1v-1h1z",
    fill: "#dcb65b",
    fillOpacity: 0.996
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24v1h-1v-1z",
    fill: "#f1d389"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25v-1h1v1z",
    fill: "#eed580"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24h1v1h-1z",
    fill: "#e3cc6d"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24v1h-1v-1z",
    fill: "#e9ce79"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24h1v1h-1z",
    fill: "#c7a359"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h-1v-1h1z",
    fill: "#6a3f1c"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25h-1v-1h1z",
    fill: "#763f24"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M51 25h-1v-1h1z",
    fill: "#a05d2e"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M51 24h1v1h-1z",
    fill: "#be6d24"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h1v1h-1z",
    fill: "#bb6617"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M54 24v1h-1v-1z",
    fill: "#a85d22"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25v-1h1v1z",
    fill: "#ab6732"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M55 25v-1h1v1z",
    fill: "#c47c21"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M56 25v-1h1v1z",
    fill: "#cf8614"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M58 25h-1v-1h1z",
    fill: "#c0731e"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h-1v-1h1z",
    fill: "#974c14"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25v-1h1v1z",
    fill: "#aa611e"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M61 24v1h-1v-1z",
    fill: "#ac5f19"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v1h-1v-1z",
    fill: "#af621c"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v1h-1v-1z",
    fill: "#a7611e"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25h-1v-1h1z",
    fill: "#803510"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M64 24h1v1h-1z",
    fill: "#782b0f"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v-1h1v1z",
    fill: "#874a2e"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25v-1h1v1z",
    fill: "#713c2e"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h-1v-1h1z",
    fill: "#6c3420"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24v1h-1v-1z",
    fill: "#813413"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h1v1h-1z",
    fill: "#9d4b1e"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v1h-1v-1z",
    fill: "#a86752"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M72 25h-1v-1h1z",
    fill: "#854333"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M73 25h-1v-1h1z",
    fill: "#a47552"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M74 25h-1v-1h1z",
    fill: "#dcb788"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h1v1h-1z",
    fill: "#bc8d5d"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M76 25h-1v-1h1z",
    fill: "#dac3ac"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v1h-1v-1z",
    fill: "#e3c5b6"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v-1h1v1z",
    fill: "#a45e40"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25v-1h1v1z",
    fill: "#dbad8d"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M80 24v1h-1v-1z",
    fill: "#dfb890"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M81 25h-1v-1h1z",
    fill: "#d3a179"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M82 24v1h-1v-1z",
    fill: "#bf8450"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M83 25h-1v-1h1z",
    fill: "#ad7853"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M84 25h-1v-1h1z",
    fill: "#a96635"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M85 24v1h-1v-1z",
    fill: "#a24f19"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M86 25h-1v-1h1z",
    fill: "#ac6a2c"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M87 25h-1v-1h1z",
    fill: "#5a3623"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M87 25v-1h1v1z",
    fill: "#653d30"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25h-1v-1h1z",
    fill: "#582b1c"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M90 24v1h-1v-1z",
    fill: "#3e0d01"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M91 25h-1v-1h1z",
    fill: "#461207"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M92 25h-1v-1h1z",
    fill: "#55321f",
    fillOpacity: 0.847
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M92 24h1v1h-1z",
    fill: "#4e6b4e",
    fillOpacity: 0.102
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M95 24v1h-1v-1z",
    fill: "#8f967c",
    fillOpacity: 0.153
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25h1v1h-1z",
    fill: "#afa",
    fillOpacity: 0.012
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M35 25v1h-1v-1z",
    fill: "#db9922",
    fillOpacity: 0.647
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25v1h-1v-1z",
    fill: "#e79c11"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25h1v1h-1z",
    fill: "#e49f12"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v1h-1v-1z",
    fill: "#d69421"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26h-1v-1h1z",
    fill: "#cf961a"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M39 25h1v1h-1z",
    fill: "#f8d531"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M40 25h1v1h-1z",
    fill: "#f9d221"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26v-1h1v1z",
    fill: "#ecbb49"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25v1h-1v-1z",
    fill: "#deb552"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h1v1h-1z",
    fill: "#e7cb5a"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25h1v1h-1z",
    fill: "#f3d888"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M45 25h1v1h-1z",
    fill: "#f5da93"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M47 26h-1v-1h1z",
    fill: "#e6c767"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M48 26h-1v-1h1z",
    fill: "#e1b848"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M48 25h1v1h-1z",
    fill: "#c99131"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h1v1h-1z",
    fill: "#ce9636"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M51 26h-1v-1h1z",
    fill: "#a67429"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26h-1v-1h1z",
    fill: "#9e6733"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25v1h-1v-1z",
    fill: "#ae6834"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25h1v1h-1z",
    fill: "#924819"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25h1v1h-1z",
    fill: "#b86d32"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M56 26h-1v-1h1z",
    fill: "#ba6b2b"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M57 25v1h-1v-1z",
    fill: "#8f4217"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v-1h1v1z",
    fill: "#ad642b"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M59 26h-1v-1h1z",
    fill: "#bc782f"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h1v1h-1z",
    fill: "#b5722d"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M60 26v-1h1v1z",
    fill: "#b77121"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M62 25v1h-1v-1z",
    fill: "#b1651a"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M62 26v-1h1v1z",
    fill: "#934b11"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25v1h-1v-1z",
    fill: "#a14c1c"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v1h-1v-1z",
    fill: "#a94c1e"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M65 26v-1h1v1z",
    fill: "#773a23"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25h1v1h-1z",
    fill: "#694036"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M67 25h1v1h-1z",
    fill: "#663723"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h1v1h-1z",
    fill: "#6e2a0d"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h-1v-1h1z",
    fill: "#b87546"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h-1v-1h1z",
    fill: "#b67d5f"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M72 26h-1v-1h1z",
    fill: "#884e3e"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M72 25h1v1h-1z",
    fill: "#603621"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M73 25h1v1h-1z",
    fill: "#bd967d"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M75 25v1h-1v-1z",
    fill: "#c8987f"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M75 26v-1h1v1z",
    fill: "#b68f7c"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v1h-1v-1z",
    fill: "#84553d"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25v1h-1v-1z",
    fill: "#843d18"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25h1v1h-1z",
    fill: "#b57f52"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25v1h-1v-1z",
    fill: "#dbaf82"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25h1v1h-1z",
    fill: "#e1b493"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M82 25v1h-1v-1z",
    fill: "#cea17a"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26v-1h1v1z",
    fill: "#d6bb9e"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M84 25v1h-1v-1z",
    fill: "#af713e"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M84 26v-1h1v1z",
    fill: "#ae5a30"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M85 25h1v1h-1z",
    fill: "#773a1a"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M86 25h1v1h-1z",
    fill: "#81645b"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M88 26h-1v-1h1z",
    fill: "#d4b8a0"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25v1h-1v-1z",
    fill: "#4e271c"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M89 26v-1h1v1z",
    fill: "#663422"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M90 25h1v1h-1z",
    fill: "#7e3f1d"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26v-1h1v1z",
    fill: "#894e31",
    fillOpacity: 0.969
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M93 25v1h-1v-1z",
    fill: "#8b5337",
    fillOpacity: 0.647
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M94 26h-1v-1h1z",
    fill: "#a97545",
    fillOpacity: 0.443
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M95 26h-1v-1h1z",
    fill: "#c9c187",
    fillOpacity: 0.243
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M96 25v1h-1v-1z",
    fill: "#7b5c45",
    fillOpacity: 0.129
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M32 27h-1v-1h1z",
    fill: "#bf9f3f",
    fillOpacity: 0.031
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27h-1v-1h1z",
    fill: "#e7c122",
    fillOpacity: 0.667
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27v-1h1v1z",
    fill: "#e8ba26",
    fillOpacity: 0.624
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27h-1v-1h1z",
    fill: "#d08d1e",
    fillOpacity: 0.8
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27v-1h1v1z",
    fill: "#cc8113"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M36 27v-1h1v1z",
    fill: "#e0a024"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M38 26v1h-1v-1z",
    fill: "#daa230"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26v1h-1v-1z",
    fill: "#e0b03e"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M39 27v-1h1v1z",
    fill: "#ecc142"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M41 27h-1v-1h1z",
    fill: "#dab036"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26h1v1h-1z",
    fill: "#ca9c38"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M42 26h1v1h-1z",
    fill: "#c49158"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27h-1v-1h1z",
    fill: "#d3a94f"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M45 26v1h-1v-1z",
    fill: "#f1d46b"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27v-1h1v1z",
    fill: "#f0d175"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M46 26h1v1h-1z",
    fill: "#e1bd59"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27h-1v-1h1z",
    fill: "#eac65e"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M49 27h-1v-1h1z",
    fill: "#e7c053"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M49 26h1v1h-1z",
    fill: "#e2b641"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M50 27v-1h1v1z",
    fill: "#cfa73b"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26v1h-1v-1z",
    fill: "#916d41"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27h-1v-1h1z",
    fill: "#a16c57"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M54 27h-1v-1h1z",
    fill: "#8d5236"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M54 26h1v1h-1z",
    fill: "#af7157"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M55 26h1v1h-1z",
    fill: "#8e532c"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v1h-1v-1z",
    fill: "#996344"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27h-1v-1h1z",
    fill: "#b88353"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M59 27h-1v-1h1z",
    fill: "#d2a061"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27h-1v-1h1z",
    fill: "#dbad75"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M61 27h-1v-1h1z",
    fill: "#daae5d"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h-1v-1h1z",
    fill: "#ca9342"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27v-1h1v1z",
    fill: "#b27236"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M64 26v1h-1v-1z",
    fill: "#974a15"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h-1v-1h1z",
    fill: "#9b4d20"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M66 26v1h-1v-1z",
    fill: "#885641"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M66 27v-1h1v1z",
    fill: "#442825"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M68 27h-1v-1h1z",
    fill: "#613c37"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M69 26v1h-1v-1z",
    fill: "#66251a"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M70 27h-1v-1h1z",
    fill: "#814121"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h1v1h-1z",
    fill: "#93562e"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h1v1h-1z",
    fill: "#7b3a20"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h-1v-1h1z",
    fill: "#511d0e"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27v-1h1v1z",
    fill: "#612b1c"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M74 27v-1h1v1z",
    fill: "#c0936b"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M76 26v1h-1v-1z",
    fill: "#8e6d43"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27h-1v-1h1z",
    fill: "#74522e"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M78 26v1h-1v-1z",
    fill: "#744825"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27v-1h1v1z",
    fill: "#824d2f"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M80 27h-1v-1h1z",
    fill: "#8a5b3c"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M81 26v1h-1v-1z",
    fill: "#af806a"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M81 26h1v1h-1z",
    fill: "#ca997b"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26h1v1h-1z",
    fill: "#d7b18d"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M83 27v-1h1v1z",
    fill: "#c38953"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M84 26h1v1h-1z",
    fill: "#b87239"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M86 26v1h-1v-1z",
    fill: "#af7e4e"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M86 26h1v1h-1z",
    fill: "#f5e3c6"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M87 26h1v1h-1z",
    fill: "#d1bf9d"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27h-1v-1h1z",
    fill: "#633f35"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M89 26h1v1h-1z",
    fill: "#90643d"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M90 27v-1h1v1z",
    fill: "#bc8851"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26h1v1h-1z",
    fill: "#7d3c1b"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M92 26h1v1h-1z",
    fill: "#76290c"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M93 26h1v1h-1z",
    fill: "#944d20"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M95 26v1h-1v-1z",
    fill: "#bc9060",
    fillOpacity: 0.89
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M96 27h-1v-1h1z",
    fill: "#d3a786",
    fillOpacity: 0.757
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M96 26h1v1h-1z",
    fill: "#8b6754",
    fillOpacity: 0.416
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M98 27h-1v-1h1z",
    fill: "#9d887d",
    fillOpacity: 0.565
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M98 26h1v1h-1z",
    fill: "#efd6b5",
    fillOpacity: 0.392
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27h1v1h-1z",
    fill: "#ffbf7f",
    fillOpacity: 0.016
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M28 27h1v1h-1z",
    fill: "#a37f36",
    fillOpacity: 0.055
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M29 28v-1h1v1z",
    fill: "#deba28",
    fillOpacity: 0.247
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28h-1v-1h1z",
    fill: "#eccb3b",
    fillOpacity: 0.271
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M31 27h1v1h-1z",
    fill: "#d5c029",
    fillOpacity: 0.239
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27v1h-1v-1z",
    fill: "#e7bc19",
    fillOpacity: 0.973
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27h1v1h-1z",
    fill: "#efbb24"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28v-1h1v1z",
    fill: "#ce8b18"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27h1v1h-1z",
    fill: "#ce9138"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v-1h1v1z",
    fill: "#f3c142"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M37 28v-1h1v1z",
    fill: "#c88226"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M38 27h1v1h-1z",
    fill: "#9c5722"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27v1h-1v-1z",
    fill: "#63240c"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27h1v1h-1z",
    fill: "#7d441c"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27v1h-1v-1z",
    fill: "#c18f4c"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27h1v1h-1z",
    fill: "#824f32"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27v1h-1v-1z",
    fill: "#8c632d"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M45 28h-1v-1h1z",
    fill: "#deb437"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27h1v1h-1z",
    fill: "#e2b63b"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28h-1v-1h1z",
    fill: "#deba4b"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27v1h-1v-1z",
    fill: "#e3bf61"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M48 28v-1h1v1z",
    fill: "#eecd6d"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M49 28v-1h1v1z",
    fill: "#e0c36e"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M51 27v1h-1v-1z",
    fill: "#a28452"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M51 28v-1h1v1z",
    fill: "#7f5c4c"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27v1h-1v-1z",
    fill: "#a27c71"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M53 28v-1h1v1z",
    fill: "#d3b29d"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27v1h-1v-1z",
    fill: "#e6c6b6"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27h1v1h-1z",
    fill: "#af815e"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M57 28h-1v-1h1z",
    fill: "#b98655"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27v1h-1v-1z",
    fill: "#e4ba98"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28v-1h1v1z",
    fill: "#e2b99d"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27v1h-1v-1z",
    fill: "#dcbc99"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28v-1h1v1z",
    fill: "#d8be82"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h-1v-1h1z",
    fill: "#dabe7e"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h1v1h-1z",
    fill: "#d6b287"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M63 27h1v1h-1z",
    fill: "#ba8f70"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27v1h-1v-1z",
    fill: "#7d4f3d"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h1v1h-1z",
    fill: "#80564c"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28h-1v-1h1z",
    fill: "#906663"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v-1h1v1z",
    fill: "#856466"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27v1h-1v-1z",
    fill: "#5e3230"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27h1v1h-1z",
    fill: "#561710"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M71 27v1h-1v-1z",
    fill: "#864927"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M72 27v1h-1v-1z",
    fill: "#965c29"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v-1h1v1z",
    fill: "#501b11"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h1v1h-1z",
    fill: "#733b1e"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M75 27v1h-1v-1z",
    fill: "#b67634"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v-1h1v1z",
    fill: "#a56c29"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27v1h-1v-1z",
    fill: "#98643d"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M77 28v-1h1v1z",
    fill: "#97624b"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27h1v1h-1z",
    fill: "#592216"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M80 28h-1v-1h1z",
    fill: "#8e655b"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M80 27h1v1h-1z",
    fill: "#834f3c"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28h-1v-1h1z",
    fill: "#8c3e18"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28v-1h1v1z",
    fill: "#9b521e"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M83 27h1v1h-1z",
    fill: "#be7b35"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M85 28h-1v-1h1z",
    fill: "#c4882e"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28h-1v-1h1z",
    fill: "#dcb772"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M87 28h-1v-1h1z",
    fill: "#f2deb5"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M88 28h-1v-1h1z",
    fill: "#88714f"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27v1h-1v-1z",
    fill: "#4f2a25"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v-1h1v1z",
    fill: "#926e42"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M91 27v1h-1v-1z",
    fill: "#c19b74"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28v-1h1v1z",
    fill: "#97634b"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M92 28v-1h1v1z",
    fill: "#69260d"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M94 28h-1v-1h1z",
    fill: "#772907"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M94 28v-1h1v1z",
    fill: "#b97743"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M95 27h1v1h-1z",
    fill: "#d0a17d"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M96 28v-1h1v1z",
    fill: "#aa8672"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M97 27h1v1h-1z",
    fill: "#543126"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M99 27v1h-1v-1z",
    fill: "#bda08a",
    fillOpacity: 0.969
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M99 28v-1h1v1z",
    fill: "#f0e1ba",
    fillOpacity: 0.204
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M28 28v1h-1v-1z",
    fill: "#d5b73c",
    fillOpacity: 0.267
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M28 29v-1h1v1z",
    fill: "#deb02e",
    fillOpacity: 0.839
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28v1h-1v-1z",
    fill: "#efc323",
    fillOpacity: 0.965
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29h-1v-1h1z",
    fill: "#ecc424",
    fillOpacity: 0.996
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28h1v1h-1z",
    fill: "#dfc525",
    fillOpacity: 0.933
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M33 28v1h-1v-1z",
    fill: "#eabf2f"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28v1h-1v-1z",
    fill: "#fde445"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28h1v1h-1z",
    fill: "#f9df5a"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v1h-1v-1z",
    fill: "#d0ae5d"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v-1h1v1z",
    fill: "#ddb443"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M38 28v1h-1v-1z",
    fill: "#ba7420"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M38 29v-1h1v1z",
    fill: "#913c15"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M39 28h1v1h-1z",
    fill: "#8c3a1d"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28v1h-1v-1z",
    fill: "#9a4f1e"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28h1v1h-1z",
    fill: "#a96a2d"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M43 28v1h-1v-1z",
    fill: "#7e452d"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M44 28v1h-1v-1z",
    fill: "#84531c"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29h-1v-1h1z",
    fill: "#cd9613"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M46 28v1h-1v-1z",
    fill: "#d19426"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28v1h-1v-1z",
    fill: "#dba72b"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M47 29v-1h1v1z",
    fill: "#cb9117"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M49 29h-1v-1h1z",
    fill: "#be8a1a"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M50 28v1h-1v-1z",
    fill: "#a1762d"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v-1h1v1z",
    fill: "#623826"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M51 29v-1h1v1z",
    fill: "#5a332f"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v-1h1v1z",
    fill: "#6e5249"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M53 29v-1h1v1z",
    fill: "#e2ccaf"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M55 28h1v1h-1z",
    fill: "#c28b62"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M56 28h1v1h-1z",
    fill: "#b37440"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29v-1h1v1z",
    fill: "#c28e68"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28h1v1h-1z",
    fill: "#b88b73"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M59 28h1v1h-1z",
    fill: "#947348"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M61 29h-1v-1h1z",
    fill: "#a4842f"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M61 28h1v1h-1z",
    fill: "#dcc182"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h1v1h-1z",
    fill: "#efe3c4"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M63 29v-1h1v1z",
    fill: "#ecdfc6"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29h-1v-1h1z",
    fill: "#87695f"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29v-1h1v1z",
    fill: "#784e4b"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v1h-1v-1z",
    fill: "#81514b"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29v-1h1v1z",
    fill: "#ac7d78"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M68 28h1v1h-1z",
    fill: "#7e504c"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M70 28v1h-1v-1z",
    fill: "#4c1e0f"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29v-1h1v1z",
    fill: "#915d26"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v1h-1v-1z",
    fill: "#c5903f"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M73 29h-1v-1h1z",
    fill: "#946141"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M74 28v1h-1v-1z",
    fill: "#925b30"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v1h-1v-1z",
    fill: "#ae7534"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M76 28v1h-1v-1z",
    fill: "#be843d"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M77 29h-1v-1h1z",
    fill: "#b97d4f"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29h-1v-1h1z",
    fill: "#9c6545"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M79 28v1h-1v-1z",
    fill: "#783d25"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M79 29v-1h1v1z",
    fill: "#9c7269"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28v1h-1v-1z",
    fill: "#c79d95"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28h1v1h-1z",
    fill: "#864631"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28h1v1h-1z",
    fill: "#8c4318"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M83 28h1v1h-1z",
    fill: "#b47126"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M84 29v-1h1v1z",
    fill: "#d2962a"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28v1h-1v-1z",
    fill: "#e2b75e"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28h1v1h-1z",
    fill: "#ccab70"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M87 28h1v1h-1z",
    fill: "#3c2010"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v1h-1v-1z",
    fill: "#7e5e31"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29h-1v-1h1z",
    fill: "#be8f51"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28v1h-1v-1z",
    fill: "#a6793e"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28h1v1h-1z",
    fill: "#b58b57"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M92 29v-1h1v1z",
    fill: "#81412e"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M93 29v-1h1v1z",
    fill: "#893412"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M95 29h-1v-1h1z",
    fill: "#a94f1b"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M95 28h1v1h-1z",
    fill: "#ac571f"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M96 28h1v1h-1z",
    fill: "#a75d33"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M98 28v1h-1v-1z",
    fill: "#682e13"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M99 28v1h-1v-1z",
    fill: "#734b38"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M99 29v-1h1v1z",
    fill: "#998066",
    fillOpacity: 0.529
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M27 29h1v1h-1z",
    fill: "#bf9433",
    fillOpacity: 0.235
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M28 29h1v1h-1z",
    fill: "#cf9423"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M30 29v1h-1v-1z",
    fill: "#e4b329"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30h-1v-1h1z",
    fill: "#dfae28"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29h1v1h-1z",
    fill: "#e5a522"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M32 29h1v1h-1z",
    fill: "#d58211"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30h-1v-1h1z",
    fill: "#c58c1c"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M35 30h-1v-1h1z",
    fill: "#dfb63c"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v1h-1v-1z",
    fill: "#bd9d4d"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M37 29v1h-1v-1z",
    fill: "#bc8d40"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30h-1v-1h1z",
    fill: "#94541b"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30h-1v-1h1z",
    fill: "#a55320"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30v-1h1v1z",
    fill: "#a75311"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30v-1h1v1z",
    fill: "#a45605"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30h-1v-1h1z",
    fill: "#ad6a18"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30v-1h1v1z",
    fill: "#8e5123"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h-1v-1h1z",
    fill: "#8e581c"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29v1h-1v-1z",
    fill: "#cb9418"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30v-1h1v1z",
    fill: "#bf8215"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M47 30h-1v-1h1z",
    fill: "#d6a126"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h-1v-1h1z",
    fill: "#e6bf51"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M48 29h1v1h-1z",
    fill: "#e4be60"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v1h-1v-1z",
    fill: "#b98e4e"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M51 30h-1v-1h1z",
    fill: "#956446"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v1h-1v-1z",
    fill: "#7a4a27"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29h1v1h-1z",
    fill: "#714120"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v-1h1v1z",
    fill: "#b17d5e"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30v-1h1v1z",
    fill: "#c48f69"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M55 30v-1h1v1z",
    fill: "#c1844f"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M57 30h-1v-1h1z",
    fill: "#b7713a"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29h1v1h-1z",
    fill: "#ab6a3f"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M58 30v-1h1v1z",
    fill: "#804325"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v-1h1v1z",
    fill: "#5d2a12"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30v-1h1v1z",
    fill: "#97632f"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h-1v-1h1z",
    fill: "#c89e53"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30h-1v-1h1z",
    fill: "#b49666"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30v-1h1v1z",
    fill: "#b29376"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h-1v-1h1z",
    fill: "#dabba2"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M66 29v1h-1v-1z",
    fill: "#bc9f88"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M67 30h-1v-1h1z",
    fill: "#a88772"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29h1v1h-1z",
    fill: "#824a3b"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v-1h1v1z",
    fill: "#975d5e"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M69 29h1v1h-1z",
    fill: "#793f39"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29h1v1h-1z",
    fill: "#834a21"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M71 30v-1h1v1z",
    fill: "#c79348"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h-1v-1h1z",
    fill: "#d5ab6a"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30v-1h1v1z",
    fill: "#cb9d52"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29v1h-1v-1z",
    fill: "#bc8c51"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29h1v1h-1z",
    fill: "#bf8c55"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29v1h-1v-1z",
    fill: "#6d3a1d"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M79 30h-1v-1h1z",
    fill: "#7a462c"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M79 29h1v1h-1z",
    fill: "#754130"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30v-1h1v1z",
    fill: "#a96b54"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29v1h-1v-1z",
    fill: "#a45b35"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29h1v1h-1z",
    fill: "#ac733c"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M84 29v1h-1v-1z",
    fill: "#d19a43"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M85 29v1h-1v-1z",
    fill: "#ca9125"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M86 30h-1v-1h1z",
    fill: "#d6ac5d"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M86 29h1v1h-1z",
    fill: "#7f603f"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M88 29v1h-1v-1z",
    fill: "#280e10"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M88 30v-1h1v1z",
    fill: "#957b3b"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29v1h-1v-1z",
    fill: "#edc685"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M91 30h-1v-1h1z",
    fill: "#e7c68e"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M92 30h-1v-1h1z",
    fill: "#c19961"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M92 30v-1h1v1z",
    fill: "#74290f"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M93 29h1v1h-1z",
    fill: "#872f09"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M95 29v1h-1v-1z",
    fill: "#89340b"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M96 30h-1v-1h1z",
    fill: "#c36023"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M96 29h1v1h-1z",
    fill: "#b34a10"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30h-1v-1h1z",
    fill: "#953e15"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M99 30h-1v-1h1z",
    fill: "#58220f"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M100 29v1h-1v-1z",
    fill: "#704938",
    fillOpacity: 0.937
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M101 30h-1v-1h1z",
    fill: "#957962",
    fillOpacity: 0.255
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31v-1h1v1z",
    fill: "#e2d97a",
    fillOpacity: 0.106
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31v-1h1v1z",
    fill: "#e4d676",
    fillOpacity: 0.573
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M27 31h-1v-1h1z",
    fill: "#d6d06b",
    fillOpacity: 0.149
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30h1v1h-1z",
    fill: "#8c5028",
    fillOpacity: 0.149
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30h1v1h-1z",
    fill: "#c27e1f",
    fillOpacity: 0.953
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M29 30h1v1h-1z",
    fill: "#d59e2d"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30v1h-1v-1z",
    fill: "#c78d28"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31h-1v-1h1z",
    fill: "#d2963c"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M33 30v1h-1v-1z",
    fill: "#9d4d0f"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M33 31v-1h1v1z",
    fill: "#a36219"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30h1v1h-1z",
    fill: "#af752a"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31h-1v-1h1z",
    fill: "#8b6645"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31v-1h1v1z",
    fill: "#ae825b"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30v1h-1v-1z",
    fill: "#b18a75"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31h-1v-1h1z",
    fill: "#925c40"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31h-1v-1h1z",
    fill: "#9b5810"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30h1v1h-1z",
    fill: "#b47112"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M41 31v-1h1v1z",
    fill: "#c08325"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M43 30v1h-1v-1z",
    fill: "#ad7735"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M43 31v-1h1v1z",
    fill: "#753f15"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h1v1h-1z",
    fill: "#996723"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31h-1v-1h1z",
    fill: "#dfb147"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31v-1h1v1z",
    fill: "#d8ac3c"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30v1h-1v-1z",
    fill: "#ba953b"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h1v1h-1z",
    fill: "#ccae84"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31h-1v-1h1z",
    fill: "#ab8f82"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M51 31h-1v-1h1z",
    fill: "#876b66"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M52 30v1h-1v-1z",
    fill: "#7b522a"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v1h-1v-1z",
    fill: "#a96527"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v-1h1v1z",
    fill: "#934414"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30h1v1h-1z",
    fill: "#a56732"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M55 31v-1h1v1z",
    fill: "#c5894a"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31h-1v-1h1z",
    fill: "#b16a35"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M58 31h-1v-1h1z",
    fill: "#8d4621"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v1h-1v-1z",
    fill: "#783413"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30h1v1h-1z",
    fill: "#9a7058"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M61 31h-1v-1h1z",
    fill: "#967353"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30v1h-1v-1z",
    fill: "#c2996a"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h1v1h-1z",
    fill: "#e1bfa1"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M64 30v1h-1v-1z",
    fill: "#d4b7a7"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31v-1h1v1z",
    fill: "#e2c7b6"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h1v1h-1z",
    fill: "#f4dcc9"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M67 31h-1v-1h1z",
    fill: "#e3c0aa"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v1h-1v-1z",
    fill: "#9c684f"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30v1h-1v-1z",
    fill: "#725353"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30h1v1h-1z",
    fill: "#614141"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31h-1v-1h1z",
    fill: "#7f4e2e"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M72 30v1h-1v-1z",
    fill: "#d5a666"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M72 31v-1h1v1z",
    fill: "#d1ae69"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h1v1h-1z",
    fill: "#d2a968"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31h-1v-1h1z",
    fill: "#c29669"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31v-1h1v1z",
    fill: "#936640"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M77 30v1h-1v-1z",
    fill: "#683b29"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M78 31h-1v-1h1z",
    fill: "#5a3122"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h-1v-1h1z",
    fill: "#7e4a32"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30v1h-1v-1z",
    fill: "#753723"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M81 31h-1v-1h1z",
    fill: "#813d1e"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M82 30v1h-1v-1z",
    fill: "#995722"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31v-1h1v1z",
    fill: "#ddb35b"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M84 30v1h-1v-1z",
    fill: "#e6be53"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M84 31v-1h1v1z",
    fill: "#d9ab48"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M86 30v1h-1v-1z",
    fill: "#6f4c2a"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M86 31v-1h1v1z",
    fill: "#361a19"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M87 30h1v1h-1z",
    fill: "#6e482c"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31h-1v-1h1z",
    fill: "#a77d40"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31v-1h1v1z",
    fill: "#e5c07d"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31h-1v-1h1z",
    fill: "#efcea9"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31v-1h1v1z",
    fill: "#d1a07a"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M93 30v1h-1v-1z",
    fill: "#a06141"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M94 30v1h-1v-1z",
    fill: "#ae755d"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M94 30h1v1h-1z",
    fill: "#cea085"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M95 30h1v1h-1z",
    fill: "#db9974"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M96 31v-1h1v1z",
    fill: "#9b390d"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30v1h-1v-1z",
    fill: "#a43b11"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30h1v1h-1z",
    fill: "#64260a"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M100 31h-1v-1h1z",
    fill: "#65331b"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M101 31h-1v-1h1z",
    fill: "#8f6041",
    fillOpacity: 0.796
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M102 31h-1v-1h1z",
    fill: "#d4bf94",
    fillOpacity: 0.047
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31h1v1h-1z",
    fill: "#d8cf63",
    fillOpacity: 0.333
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31h1v1h-1z",
    fill: "#f6de62"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M26 31h1v1h-1z",
    fill: "#dfc859",
    fillOpacity: 0.737
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M28 31v1h-1v-1z",
    fill: "#b99447",
    fillOpacity: 0.686
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M29 32h-1v-1h1z",
    fill: "#af8531",
    fillOpacity: 0.992
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31v1h-1v-1z",
    fill: "#a7662e"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M31 32h-1v-1h1z",
    fill: "#8a441a"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31v1h-1v-1z",
    fill: "#8f5e2c"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31h1v1h-1z",
    fill: "#8e4f21"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32v-1h1v1z",
    fill: "#c48a2c"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M34 31h1v1h-1z",
    fill: "#dab070"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32v-1h1v1z",
    fill: "#e8d3c2"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M37 32h-1v-1h1z",
    fill: "#ebd7c9"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M38 31v1h-1v-1z",
    fill: "#d7b99c"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31v1h-1v-1z",
    fill: "#c1924b"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31v1h-1v-1z",
    fill: "#c28d1f"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32h-1v-1h1z",
    fill: "#d1971e"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32h-1v-1h1z",
    fill: "#ca972b"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M42 31h1v1h-1z",
    fill: "#77421a"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M44 31v1h-1v-1z",
    fill: "#722d17"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M45 31v1h-1v-1z",
    fill: "#6d3f29"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h-1v-1h1z",
    fill: "#9d7d4e"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M47 31v1h-1v-1z",
    fill: "#ceab6a"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32h-1v-1h1z",
    fill: "#8a6842"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M49 31v1h-1v-1z",
    fill: "#8c685d"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31v1h-1v-1z",
    fill: "#947972"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32h-1v-1h1z",
    fill: "#635451"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32v-1h1v1z",
    fill: "#26110f"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v1h-1v-1z",
    fill: "#6c371f"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31h1v1h-1z",
    fill: "#833e13"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M54 31h1v1h-1z",
    fill: "#a46534"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M56 32h-1v-1h1z",
    fill: "#c18745"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31v1h-1v-1z",
    fill: "#a05e27"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32h-1v-1h1z",
    fill: "#7b3f18"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M59 32h-1v-1h1z",
    fill: "#794e2b"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M59 31h1v1h-1z",
    fill: "#ab9365"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M60 31h1v1h-1z",
    fill: "#845b2f"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31v1h-1v-1z",
    fill: "#a1734c"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31h1v1h-1z",
    fill: "#d3b697"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v-1h1v1z",
    fill: "#dec9bb"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31h1v1h-1z",
    fill: "#e1cebb"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v-1h1v1z",
    fill: "#e1c2ad"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M66 32v-1h1v1z",
    fill: "#c79c86"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32h-1v-1h1z",
    fill: "#b38669"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31v1h-1v-1z",
    fill: "#896055"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31h1v1h-1z",
    fill: "#654238"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31v1h-1v-1z",
    fill: "#9c7351"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32v-1h1v1z",
    fill: "#d5ab75"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M73 31v1h-1v-1z",
    fill: "#dcb776"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v-1h1v1z",
    fill: "#dcb573"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M74 31h1v1h-1z",
    fill: "#d9b271"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M76 32h-1v-1h1z",
    fill: "#cfa66f"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M77 32h-1v-1h1z",
    fill: "#b07e57"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h-1v-1h1z",
    fill: "#7b4b34"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31v1h-1v-1z",
    fill: "#965e41"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h1v1h-1z",
    fill: "#662a17"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32v-1h1v1z",
    fill: "#6f341c"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M81 31h1v1h-1z",
    fill: "#a87243"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31h1v1h-1z",
    fill: "#cda34a"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M83 32v-1h1v1z",
    fill: "#e9bd44"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M85 32h-1v-1h1z",
    fill: "#c99d3e"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M86 32h-1v-1h1z",
    fill: "#7a543a"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M87 32h-1v-1h1z",
    fill: "#5a382c"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M88 31v1h-1v-1z",
    fill: "#92622f"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M88 32v-1h1v1z",
    fill: "#c99255"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M90 32h-1v-1h1z",
    fill: "#dfad6f"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M91 32h-1v-1h1z",
    fill: "#d9b072"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M92 31v1h-1v-1z",
    fill: "#e3c5a0"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M92 31h1v1h-1z",
    fill: "#eed5b5"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M93 32v-1h1v1z",
    fill: "#e4cca8"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M95 31v1h-1v-1z",
    fill: "#e3c094"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M96 32h-1v-1h1z",
    fill: "#af734f"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32h-1v-1h1z",
    fill: "#732308"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32v-1h1v1z",
    fill: "#95310f"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M99 31v1h-1v-1z",
    fill: "#963d0f"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M100 31v1h-1v-1z",
    fill: "#a24514"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M100 32v-1h1v1z",
    fill: "#91461d",
    fillOpacity: 0.827
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M102 31v1h-1v-1z",
    fill: "#005",
    fillOpacity: 0.012
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32h1v1h-1z",
    fill: "#b8a760",
    fillOpacity: 0.114
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33v-1h1v1z",
    fill: "#d5b964",
    fillOpacity: 0.745
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M26 32v1h-1v-1z",
    fill: "#f5ce5f"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33v-1h1v1z",
    fill: "#e8c34f"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M27 32h1v1h-1z",
    fill: "#9d7020"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32h1v1h-1z",
    fill: "#5f2f18"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M30 33h-1v-1h1z",
    fill: "#541a11"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M31 32v1h-1v-1z",
    fill: "#b87927"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32v1h-1v-1z",
    fill: "#e2ac42"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32v1h-1v-1z",
    fill: "#b4722b"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32h1v1h-1z",
    fill: "#d29142"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M34 33v-1h1v1z",
    fill: "#b5824e"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32h1v1h-1z",
    fill: "#c2a695"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h-1v-1h1z",
    fill: "#b3948f"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33v-1h1v1z",
    fill: "#a77f43"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M38 32h1v1h-1z",
    fill: "#d39f2a"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M40 33h-1v-1h1z",
    fill: "#dbac2c"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32v1h-1v-1z",
    fill: "#dfb22e"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32v1h-1v-1z",
    fill: "#b48b33"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M43 32v1h-1v-1z",
    fill: "#41160a"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M44 32v1h-1v-1z",
    fill: "#5c2a13"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33v-1h1v1z",
    fill: "#623519"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32v1h-1v-1z",
    fill: "#957051"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h1v1h-1z",
    fill: "#c3a580"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32v1h-1v-1z",
    fill: "#d3b38e"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v-1h1v1z",
    fill: "#7e583d"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33h-1v-1h1z",
    fill: "#795330"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33h-1v-1h1z",
    fill: "#765b40"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33v-1h1v1z",
    fill: "#160b09"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M53 32v1h-1v-1z",
    fill: "#2f1913"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33v-1h1v1z",
    fill: "#804d2b"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M55 32v1h-1v-1z",
    fill: "#98572e"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M56 33h-1v-1h1z",
    fill: "#94562c"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33h-1v-1h1z",
    fill: "#995b2a"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32v1h-1v-1z",
    fill: "#4b2214"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M58 33v-1h1v1z",
    fill: "#290d07"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32v1h-1v-1z",
    fill: "#916229"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32h1v1h-1z",
    fill: "#d5ab47"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33h-1v-1h1z",
    fill: "#c49c4f"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v1h-1v-1z",
    fill: "#cda271"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32h1v1h-1z",
    fill: "#d2b493"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v1h-1v-1z",
    fill: "#c3a790"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M65 33v-1h1v1z",
    fill: "#b6937e"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M66 33v-1h1v1z",
    fill: "#b5896b"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32v1h-1v-1z",
    fill: "#a87850"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h-1v-1h1z",
    fill: "#86513b"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33h-1v-1h1z",
    fill: "#875445"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33v-1h1v1z",
    fill: "#5a2f22"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32h1v1h-1z",
    fill: "#754d35"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v1h-1v-1z",
    fill: "#9e7648"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M74 32v1h-1v-1z",
    fill: "#cea569"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M75 32v1h-1v-1z",
    fill: "#d4a859"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M75 33v-1h1v1z",
    fill: "#ddac62"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33h-1v-1h1z",
    fill: "#d2a26e"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33v-1h1v1z",
    fill: "#d1a783"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h1v1h-1z",
    fill: "#c09669"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32v1h-1v-1z",
    fill: "#b1805b"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33h-1v-1h1z",
    fill: "#733c17"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M81 32h1v1h-1z",
    fill: "#a66f40"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M82 33v-1h1v1z",
    fill: "#e0ba7c"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M83 32h1v1h-1z",
    fill: "#dbb35e"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M85 32v1h-1v-1z",
    fill: "#b58749"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33h-1v-1h1z",
    fill: "#d3a68e"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33h-1v-1h1z",
    fill: "#b59074"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33v-1h1v1z",
    fill: "#b88965"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33h-1v-1h1z",
    fill: "#ce9b6e"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33v-1h1v1z",
    fill: "#daac75"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M90 32h1v1h-1z",
    fill: "#dbb576"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M92 32v1h-1v-1z",
    fill: "#d5b17f"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M93 33h-1v-1h1z",
    fill: "#d7bd92"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M93 32h1v1h-1z",
    fill: "#e1c9a4"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M94 33v-1h1v1z",
    fill: "#c99e78"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M96 32v1h-1v-1z",
    fill: "#8d5730"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33v-1h1v1z",
    fill: "#753920"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M98 33h-1v-1h1z",
    fill: "#7b280d"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M98 32h1v1h-1z",
    fill: "#933510"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M99 33v-1h1v1z",
    fill: "#a1360d"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M101 33h-1v-1h1z",
    fill: "#a24f18",
    fillOpacity: 0.949
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M102 33h-1v-1h1z",
    fill: "#c69c44",
    fillOpacity: 0.498
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M103 32v1h-1v-1z",
    fill: "#d5bb3d",
    fillOpacity: 0.31
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M103 32h1v1h-1z",
    fill: "#dbd558",
    fillOpacity: 0.169
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M106 32v1h-1v-1z",
    fill: "#afaf8f",
    fillOpacity: 0.063
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M106 33v-1h1v1z",
    fill: "#aaaa7a",
    fillOpacity: 0.106
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M23 34h-1v-1h1z",
    fill: "#b2855b",
    fillOpacity: 0.263
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M24 34h-1v-1h1z",
    fill: "#d1a086",
    fillOpacity: 0.769
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33h1v1h-1z",
    fill: "#dbb375"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M25 33h1v1h-1z",
    fill: "#cea03f"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33h1v1h-1z",
    fill: "#b78643"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34h-1v-1h1z",
    fill: "#af7d36"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34v-1h1v1z",
    fill: "#945e29"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M29 33h1v1h-1z",
    fill: "#4b180d"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M31 33v1h-1v-1z",
    fill: "#a06528"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h-1v-1h1z",
    fill: "#ac6920"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33v1h-1v-1z",
    fill: "#803a18"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34v-1h1v1z",
    fill: "#8f4f27"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M35 33v1h-1v-1z",
    fill: "#89512b"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M35 34v-1h1v1z",
    fill: "#a47e6e"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33h1v1h-1z",
    fill: "#a6816a"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h1v1h-1z",
    fill: "#b98d63"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33h1v1h-1z",
    fill: "#e0b44a"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M39 33h1v1h-1z",
    fill: "#dfb340"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34v-1h1v1z",
    fill: "#cea63b"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34h-1v-1h1z",
    fill: "#6c4517"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M43 34h-1v-1h1z",
    fill: "#3f1911"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M43 33h1v1h-1z",
    fill: "#522d20"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33h1v1h-1z",
    fill: "#b0895a"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M45 33h1v1h-1z",
    fill: "#e4c380"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M47 34h-1v-1h1z",
    fill: "#efd699"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v1h-1v-1z",
    fill: "#ead6af"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M49 33v1h-1v-1z",
    fill: "#d4be9c"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33v1h-1v-1z",
    fill: "#9a7f54"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34v-1h1v1z",
    fill: "#917151"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M52 33v1h-1v-1z",
    fill: "#5d3f2c"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v-1h1v1z",
    fill: "#431d0c"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33h1v1h-1z",
    fill: "#8b4923"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M54 33h1v1h-1z",
    fill: "#a85a1f"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M56 34h-1v-1h1z",
    fill: "#8e471f"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33v1h-1v-1z",
    fill: "#74321d"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M58 34h-1v-1h1z",
    fill: "#6c421f"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M59 34h-1v-1h1z",
    fill: "#8c5f29"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M59 33h1v1h-1z",
    fill: "#b87124"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M60 33h1v1h-1z",
    fill: "#daaa41"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33v1h-1v-1z",
    fill: "#e7c378"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M62 34v-1h1v1z",
    fill: "#cca376"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M64 33v1h-1v-1z",
    fill: "#ceae87"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M64 34v-1h1v1z",
    fill: "#dcbaa2"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M66 33v1h-1v-1z",
    fill: "#dab996"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33v1h-1v-1z",
    fill: "#ccaa80"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33h1v1h-1z",
    fill: "#a57f54"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34h-1v-1h1z",
    fill: "#9c7059"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h1v1h-1z",
    fill: "#673d36"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M71 34h-1v-1h1z",
    fill: "#795240"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h-1v-1h1z",
    fill: "#542d1a"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M73 34h-1v-1h1z",
    fill: "#562e1c"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33v1h-1v-1z",
    fill: "#552c18"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33h1v1h-1z",
    fill: "#794522"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34v-1h1v1z",
    fill: "#985527"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M77 34h-1v-1h1z",
    fill: "#a0714e"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M78 33v1h-1v-1z",
    fill: "#d7b28a"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M79 33v1h-1v-1z",
    fill: "#e2c189"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M80 34h-1v-1h1z",
    fill: "#dfb880"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33v1h-1v-1z",
    fill: "#af7d47"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33h1v1h-1z",
    fill: "#b7824b"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M82 34v-1h1v1z",
    fill: "#e1c38b"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M84 33v1h-1v-1z",
    fill: "#eed1b2"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M84 33h1v1h-1z",
    fill: "#eacfb8"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33v1h-1v-1z",
    fill: "#d6bd9b"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33h1v1h-1z",
    fill: "#dcbf9c"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33h1v1h-1z",
    fill: "#d8b89c"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33v1h-1v-1z",
    fill: "#b58c6b"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M90 34h-1v-1h1z",
    fill: "#c29872"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M91 33v1h-1v-1z",
    fill: "#a2805b"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M91 33h1v1h-1z",
    fill: "#8c643c"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M93 34h-1v-1h1z",
    fill: "#bd9466"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M93 33h1v1h-1z",
    fill: "#d2b182"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M95 33v1h-1v-1z",
    fill: "#d7b97a"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33v1h-1v-1z",
    fill: "#d8b061"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33h1v1h-1z",
    fill: "#c89058"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M98 33v1h-1v-1z",
    fill: "#8d3f19"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M98 34v-1h1v1z",
    fill: "#882805"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M99 33h1v1h-1z",
    fill: "#a83a12"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M100 34v-1h1v1z",
    fill: "#a34c16"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M102 34h-1v-1h1z",
    fill: "#c57f33"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M103 33v1h-1v-1z",
    fill: "#eaad2e"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M103 33h1v1h-1z",
    fill: "#ebc53b",
    fillOpacity: 0.906
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M105 33v1h-1v-1z",
    fill: "#c9b764",
    fillOpacity: 0.408
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M106 33v1h-1v-1z",
    fill: "#c5b88c",
    fillOpacity: 0.761
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M106 33h1v1h-1z",
    fill: "#c6ad8b",
    fillOpacity: 0.906
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M108 33v1h-1v-1z",
    fill: "#c19a7a",
    fillOpacity: 0.745
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M109 34h-1v-1h1z",
    fill: "#bb9060",
    fillOpacity: 0.651
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M110 34h-1v-1h1z",
    fill: "#b78a61",
    fillOpacity: 0.584
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M110 33h1v1h-1z",
    fill: "#9a8451",
    fillOpacity: 0.22
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M15 35v-1h1v1z",
    fill: "#63551c",
    fillOpacity: 0.071
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M17 35h-1v-1h1z",
    fill: "#705225",
    fillOpacity: 0.133
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M18 35h-1v-1h1z",
    fill: "#7f7f3f",
    fillOpacity: 0.016
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35h-1v-1h1z",
    fill: "#dbc943",
    fillOpacity: 0.224
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M23 34v1h-1v-1z",
    fill: "#d5a740",
    fillOpacity: 0.882
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35h-1v-1h1z",
    fill: "#8d552b"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M25 35h-1v-1h1z",
    fill: "#a1775b"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M25 34h1v1h-1z",
    fill: "#96663e"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M26 34h1v1h-1z",
    fill: "#49190b"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M27 34h1v1h-1z",
    fill: "#703d14"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34h1v1h-1z",
    fill: "#c58624"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M29 35v-1h1v1z",
    fill: "#d7a437"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M31 35h-1v-1h1z",
    fill: "#cf9844"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34v1h-1v-1z",
    fill: "#884113"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h1v1h-1z",
    fill: "#703217"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34h1v1h-1z",
    fill: "#501a02"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35v-1h1v1z",
    fill: "#521d06"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M36 35h-1v-1h1z",
    fill: "#531d0a"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M37 34v1h-1v-1z",
    fill: "#622b0d"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35h-1v-1h1z",
    fill: "#d8a658"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M39 34v1h-1v-1z",
    fill: "#e7bd48"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35v-1h1v1z",
    fill: "#9f6c1e"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M41 35h-1v-1h1z",
    fill: "#8e5e26"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34v1h-1v-1z",
    fill: "#60301f"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M42 35v-1h1v1z",
    fill: "#66381b"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M44 34v1h-1v-1z",
    fill: "#a07648"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M45 35h-1v-1h1z",
    fill: "#e5c78c"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M45 34h1v1h-1z",
    fill: "#dabd83"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v-1h1v1z",
    fill: "#e8c991"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M48 35h-1v-1h1z",
    fill: "#e5d09f"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h-1v-1h1z",
    fill: "#ecd9af"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35v-1h1v1z",
    fill: "#f5dcb3"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34h1v1h-1z",
    fill: "#74523f"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v1h-1v-1z",
    fill: "#5f3118"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M53 34v1h-1v-1z",
    fill: "#8d4015"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v-1h1v1z",
    fill: "#9d4516"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M55 34v1h-1v-1z",
    fill: "#a95c20"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v-1h1v1z",
    fill: "#9b6337"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M56 35v-1h1v1z",
    fill: "#a87e4f"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M57 34h1v1h-1z",
    fill: "#d7ac56"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35v-1h1v1z",
    fill: "#fcd16f"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34v1h-1v-1z",
    fill: "#eed184"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34h1v1h-1z",
    fill: "#dcb67b"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35v-1h1v1z",
    fill: "#ae8147"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M63 35h-1v-1h1z",
    fill: "#cca66f"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M64 35h-1v-1h1z",
    fill: "#ba8f5b"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34v1h-1v-1z",
    fill: "#b07f4a"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34h1v1h-1z",
    fill: "#ddb059"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35h-1v-1h1z",
    fill: "#d5b35a"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M67 34h1v1h-1z",
    fill: "#e2c275"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35h-1v-1h1z",
    fill: "#be9b65"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34h1v1h-1z",
    fill: "#75563a"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35h-1v-1h1z",
    fill: "#542f1c"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35v-1h1v1z",
    fill: "#572e21"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h1v1h-1z",
    fill: "#674135"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M73 35v-1h1v1z",
    fill: "#492917"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v-1h1v1z",
    fill: "#663a17"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34h1v1h-1z",
    fill: "#8b4516"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M77 34v1h-1v-1z",
    fill: "#68351a"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M78 34v1h-1v-1z",
    fill: "#b38766"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35v-1h1v1z",
    fill: "#d5b27d"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M79 34h1v1h-1z",
    fill: "#d5b073"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M80 34h1v1h-1z",
    fill: "#deae72"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M81 34h1v1h-1z",
    fill: "#c89056"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M83 34v1h-1v-1z",
    fill: "#9f652a"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M84 35h-1v-1h1z",
    fill: "#c69954"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M85 34v1h-1v-1z",
    fill: "#e6c788"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M85 35v-1h1v1z",
    fill: "#f4dcb1"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M87 35h-1v-1h1z",
    fill: "#f5e4c3"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M87 35v-1h1v1z",
    fill: "#fcedcb"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M88 34h1v1h-1z",
    fill: "#d7ba99"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M90 35h-1v-1h1z",
    fill: "#9a7051"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M90 34h1v1h-1z",
    fill: "#d4b396"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M92 35h-1v-1h1z",
    fill: "#af8e70"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M92 35v-1h1v1z",
    fill: "#ab7c47"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M93 34h1v1h-1z",
    fill: "#b77c30"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M95 35h-1v-1h1z",
    fill: "#c48726"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M96 35h-1v-1h1z",
    fill: "#d39837"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M97 35h-1v-1h1z",
    fill: "#894413"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35h-1v-1h1z",
    fill: "#6c2008"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M99 34v1h-1v-1z",
    fill: "#802c0a"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M99 35v-1h1v1z",
    fill: "#973b15"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M101 34v1h-1v-1z",
    fill: "#611b06"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M101 35v-1h1v1z",
    fill: "#6f361b"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M102 34h1v1h-1z",
    fill: "#a86a1d"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M104 35h-1v-1h1z",
    fill: "#d39628"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M104 35v-1h1v1z",
    fill: "#e3bd4f"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M106 35h-1v-1h1z",
    fill: "#dbca89"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M106 35v-1h1v1z",
    fill: "#dccaad"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M108 34v1h-1v-1z",
    fill: "#cfb598"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M109 34v1h-1v-1z",
    fill: "#b7a16f",
    fillOpacity: 0.835
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M109 35v-1h1v1z",
    fill: "#b59f5c",
    fillOpacity: 0.835
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M110 34h1v1h-1z",
    fill: "#a79350",
    fillOpacity: 0.557
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M112 34v1h-1v-1z",
    fill: "#b6b67f",
    fillOpacity: 0.055
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M15 35h1v1h-1z",
    fill: "#6c4c1d",
    fillOpacity: 0.341
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M16 35h1v1h-1z",
    fill: "#7f4c23",
    fillOpacity: 0.933
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M17 36v-1h1v1z",
    fill: "#7a4a21",
    fillOpacity: 0.749
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M19 35v1h-1v-1z",
    fill: "#7d592f",
    fillOpacity: 0.627
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M19 36v-1h1v1z",
    fill: "#754924",
    fillOpacity: 0.545
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36v-1h1v1z",
    fill: "#a5965a",
    fillOpacity: 0.133
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M22 36h-1v-1h1z",
    fill: "#dfc249",
    fillOpacity: 0.788
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35h1v1h-1z",
    fill: "#e1ac30"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35v1h-1v-1z",
    fill: "#7f4e13"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M25 36h-1v-1h1z",
    fill: "#89592b"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M26 35v1h-1v-1z",
    fill: "#7c4b1e"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M26 36v-1h1v1z",
    fill: "#50220d"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36h-1v-1h1z",
    fill: "#743d19"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36h-1v-1h1z",
    fill: "#cd9023"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36v-1h1v1z",
    fill: "#f2b522"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M30 35h1v1h-1z",
    fill: "#af6716"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v-1h1v1z",
    fill: "#8d4418"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M32 35h1v1h-1z",
    fill: "#703617"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M33 35h1v1h-1z",
    fill: "#64260c"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35h1v1h-1z",
    fill: "#642d10"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M35 35h1v1h-1z",
    fill: "#89532d"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M37 36h-1v-1h1z",
    fill: "#7a4124"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35v1h-1v-1z",
    fill: "#b17723"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v-1h1v1z",
    fill: "#af7822"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35h1v1h-1z",
    fill: "#a0642a"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M42 36h-1v-1h1z",
    fill: "#603425"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M43 35v1h-1v-1z",
    fill: "#8c4f23"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h-1v-1h1z",
    fill: "#c28b3c"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M44 35h1v1h-1z",
    fill: "#ebce93"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v1h-1v-1z",
    fill: "#f7e3bf"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36h-1v-1h1z",
    fill: "#c5ac87"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v-1h1v1z",
    fill: "#b89c7a"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36v-1h1v1z",
    fill: "#c09e78"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h1v1h-1z",
    fill: "#a77657"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M50 35h1v1h-1z",
    fill: "#935b47"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M51 35h1v1h-1z",
    fill: "#823a1d"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v1h-1v-1z",
    fill: "#a94715"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35h1v1h-1z",
    fill: "#873a10"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v1h-1v-1z",
    fill: "#88572f"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M55 36v-1h1v1z",
    fill: "#c4a47d"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M57 36h-1v-1h1z",
    fill: "#bd9b6e"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M58 36h-1v-1h1z",
    fill: "#9b733f"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35h1v1h-1z",
    fill: "#896b41"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M59 35h1v1h-1z",
    fill: "#81644b"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M60 35h1v1h-1z",
    fill: "#704430"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35h1v1h-1z",
    fill: "#66300c"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v-1h1v1z",
    fill: "#b48444"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M63 36v-1h1v1z",
    fill: "#d2a755"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M65 35v1h-1v-1z",
    fill: "#daaf4b"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M65 36v-1h1v1z",
    fill: "#ddb33b"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35v1h-1v-1z",
    fill: "#e2be49"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36v-1h1v1z",
    fill: "#f3cf71"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35v1h-1v-1z",
    fill: "#eecd7b"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M70 35v1h-1v-1z",
    fill: "#83663a"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v-1h1v1z",
    fill: "#3f2006"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36h-1v-1h1z",
    fill: "#5b340c"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M72 35h1v1h-1z",
    fill: "#724621"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v1h-1v-1z",
    fill: "#633d29"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h-1v-1h1z",
    fill: "#61402b"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36v-1h1v1z",
    fill: "#774724"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M77 36h-1v-1h1z",
    fill: "#7b4f30"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M77 35h1v1h-1z",
    fill: "#7d5234"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35h1v1h-1z",
    fill: "#b79167"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M80 36h-1v-1h1z",
    fill: "#b69469"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M80 35h1v1h-1z",
    fill: "#bc8352"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M81 35h1v1h-1z",
    fill: "#ac692e"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36v-1h1v1z",
    fill: "#652407"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M83 35h1v1h-1z",
    fill: "#a26624"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M84 35h1v1h-1z",
    fill: "#d09d46"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M86 35v1h-1v-1z",
    fill: "#cea554"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v-1h1v1z",
    fill: "#e0c384"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M87 36v-1h1v1z",
    fill: "#eedeb2"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M89 36h-1v-1h1z",
    fill: "#f9e7c0"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M89 36v-1h1v1z",
    fill: "#dfbf90"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M91 35v1h-1v-1z",
    fill: "#cfa774"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M91 36v-1h1v1z",
    fill: "#d3ab74"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M92 36v-1h1v1z",
    fill: "#e0b783"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M94 36h-1v-1h1z",
    fill: "#d4a16f"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M94 36v-1h1v1z",
    fill: "#843b0f"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M96 35v1h-1v-1z",
    fill: "#915023"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M96 36v-1h1v1z",
    fill: "#874425"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35v1h-1v-1z",
    fill: "#6f220e"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35h1v1h-1z",
    fill: "#7a2b0a"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M99 36v-1h1v1z",
    fill: "#98491b"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M101 35v1h-1v-1z",
    fill: "#8d4c2b"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M101 36v-1h1v1z",
    fill: "#a57d56"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M102 35h1v1h-1z",
    fill: "#b08651"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M103 36v-1h1v1z",
    fill: "#c49353"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M105 36h-1v-1h1z",
    fill: "#e5c781"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M106 36h-1v-1h1z",
    fill: "#e4d19d"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M106 36v-1h1v1z",
    fill: "#e0cda8"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M108 35v1h-1v-1z",
    fill: "#e5daaf",
    fillOpacity: 0.976
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M108 36v-1h1v1z",
    fill: "#b3b37f",
    fillOpacity: 0.251
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M109 36v-1h1v1z",
    fill: "#71aa38",
    fillOpacity: 0.035
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M110 36v-1h1v1z",
    fill: "#550",
    fillOpacity: 0.012
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M16 36v1h-1v-1z",
    fill: "#55310d",
    fillOpacity: 0.361
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M17 36h1v1h-1z",
    fill: "#733a1d"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M18 37v-1h1v1z",
    fill: "#6e3819"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M19 36h1v1h-1z",
    fill: "#793a17",
    fillOpacity: 0.996
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M20 37v-1h1v1z",
    fill: "#834e21",
    fillOpacity: 0.867
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37h-1v-1h1z",
    fill: "#a66d28",
    fillOpacity: 0.992
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37v-1h1v1z",
    fill: "#97631d"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37h-1v-1h1z",
    fill: "#9f8156"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M24 36h1v1h-1z",
    fill: "#e6ca7a"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M25 36h1v1h-1z",
    fill: "#eeca4e"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M27 37h-1v-1h1z",
    fill: "#cf9e36"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36v1h-1v-1z",
    fill: "#a36623"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37h-1v-1h1z",
    fill: "#b36f1b"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M30 37h-1v-1h1z",
    fill: "#c27621"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v1h-1v-1z",
    fill: "#80340c"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36h1v1h-1z",
    fill: "#501909"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M35 36v1h-1v-1z",
    fill: "#501b05"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M36 37h-1v-1h1z",
    fill: "#a66b34"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37h-1v-1h1z",
    fill: "#c09375"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v1h-1v-1z",
    fill: "#996a43"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36h1v1h-1z",
    fill: "#a36d44"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37h-1v-1h1z",
    fill: "#a86d47"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37v-1h1v1z",
    fill: "#5e391d"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M41 37v-1h1v1z",
    fill: "#351c16"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M43 37h-1v-1h1z",
    fill: "#6f3d1a"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M43 36h1v1h-1z",
    fill: "#bd8334"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h1v1h-1z",
    fill: "#b99560"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M46 36v1h-1v-1z",
    fill: "#6b5644"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v1h-1v-1z",
    fill: "#483627"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37h-1v-1h1z",
    fill: "#4e3124"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36h1v1h-1z",
    fill: "#6e4531"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M50 36v1h-1v-1z",
    fill: "#6f3018"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36v1h-1v-1z",
    fill: "#7a2e15"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36h1v1h-1z",
    fill: "#7e3110"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M53 37h-1v-1h1z",
    fill: "#702d12"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h-1v-1h1z",
    fill: "#4b2213"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37v-1h1v1z",
    fill: "#39180a"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h-1v-1h1z",
    fill: "#32180d"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M57 37h-1v-1h1z",
    fill: "#371a0c"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h-1v-1h1z",
    fill: "#3d1b09"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M59 37h-1v-1h1z",
    fill: "#391c0a"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M59 36h1v1h-1z",
    fill: "#4d2813"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M61 37h-1v-1h1z",
    fill: "#885931"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v1h-1v-1z",
    fill: "#b17b2a"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36h1v1h-1z",
    fill: "#d8a532"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h-1v-1h1z",
    fill: "#e2b638"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M65 37h-1v-1h1z",
    fill: "#e0b838"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M66 36v1h-1v-1z",
    fill: "#e0b937"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M67 37h-1v-1h1z",
    fill: "#dbb235"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36h1v1h-1z",
    fill: "#c99b26"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M68 37v-1h1v1z",
    fill: "#c08c18"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v1h-1v-1z",
    fill: "#c79128"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36h1v1h-1z",
    fill: "#b8882a"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36v1h-1v-1z",
    fill: "#be9030"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M73 36v1h-1v-1z",
    fill: "#9f722e"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v-1h1v1z",
    fill: "#6b4431"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M75 37h-1v-1h1z",
    fill: "#46261d"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h1v1h-1z",
    fill: "#5b351e"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h-1v-1h1z",
    fill: "#371505"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M78 36v1h-1v-1z",
    fill: "#5a331b"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37h-1v-1h1z",
    fill: "#603416"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M79 36h1v1h-1z",
    fill: "#4b2315"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M81 36v1h-1v-1z",
    fill: "#906026"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M81 36h1v1h-1z",
    fill: "#b47e44"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36h1v1h-1z",
    fill: "#ac7953"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M84 36v1h-1v-1z",
    fill: "#ca9d69"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M85 36v1h-1v-1z",
    fill: "#f4d298"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v1h-1v-1z",
    fill: "#ebd095"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36h1v1h-1z",
    fill: "#e0c783"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M87 36h1v1h-1z",
    fill: "#d7c38c"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M88 37v-1h1v1z",
    fill: "#e9d5a8"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M90 36v1h-1v-1z",
    fill: "#f2ddb2"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M90 37v-1h1v1z",
    fill: "#e5cb9f"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M92 37h-1v-1h1z",
    fill: "#92663f"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M93 36v1h-1v-1z",
    fill: "#975e3b"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M93 37v-1h1v1z",
    fill: "#975e40"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M95 36v1h-1v-1z",
    fill: "#834328"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M96 37h-1v-1h1z",
    fill: "#6f3016"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M97 36v1h-1v-1z",
    fill: "#72341c"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M97 37v-1h1v1z",
    fill: "#954e34"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M98 36h1v1h-1z",
    fill: "#9c5535"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M99 36h1v1h-1z",
    fill: "#985a39"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M101 37h-1v-1h1z",
    fill: "#dab085"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M102 36v1h-1v-1z",
    fill: "#eece9f"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M102 37v-1h1v1z",
    fill: "#ecc88a"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M104 37h-1v-1h1z",
    fill: "#f0cc85"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M105 36v1h-1v-1z",
    fill: "#efd5a1"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M105 36h1v1h-1z",
    fill: "#c4a882"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M107 37h-1v-1h1z",
    fill: "#a07b45"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M107 37v-1h1v1z",
    fill: "#967f38",
    fillOpacity: 0.871
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M109 37h-1v-1h1z",
    fill: "#63712a",
    fillOpacity: 0.071
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M16 37v1h-1v-1z",
    fill: "#4e300e",
    fillOpacity: 0.494
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M17 38h-1v-1h1z",
    fill: "#5c2b15"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M17 38v-1h1v1z",
    fill: "#512213"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M19 37v1h-1v-1z",
    fill: "#622d15"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M19 38v-1h1v1z",
    fill: "#883d1e"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M21 37v1h-1v-1z",
    fill: "#7e3212"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M22 38h-1v-1h1z",
    fill: "#763513"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M23 37v1h-1v-1z",
    fill: "#c49f6d"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37v1h-1v-1z",
    fill: "#f0dfa5"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M25 37v1h-1v-1z",
    fill: "#f0df9c"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M25 38v-1h1v1z",
    fill: "#ebd37b"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M27 38h-1v-1h1z",
    fill: "#f1d061"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M27 38v-1h1v1z",
    fill: "#dfb14c"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37v1h-1v-1z",
    fill: "#c6882a"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38v-1h1v1z",
    fill: "#b06c23"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M31 37v1h-1v-1z",
    fill: "#6b3017"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M31 38v-1h1v1z",
    fill: "#34100a"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M32 37h1v1h-1z",
    fill: "#220c06"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37h1v1h-1z",
    fill: "#602a15"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37h1v1h-1z",
    fill: "#9b5224"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37v1h-1v-1z",
    fill: "#6f3b21"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v-1h1v1z",
    fill: "#926448"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M39 37v1h-1v-1z",
    fill: "#af8362"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M39 38v-1h1v1z",
    fill: "#875943"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M41 38h-1v-1h1z",
    fill: "#8b5d3c"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38h-1v-1h1z",
    fill: "#502915"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38v-1h1v1z",
    fill: "#7b4c24"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h-1v-1h1z",
    fill: "#885622"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38v-1h1v1z",
    fill: "#a37951"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M46 37v1h-1v-1z",
    fill: "#46271b"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v-1h1v1z",
    fill: "#251108"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37v1h-1v-1z",
    fill: "#200f04"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v-1h1v1z",
    fill: "#341c10"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v-1h1v1z",
    fill: "#5b3625"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h-1v-1h1z",
    fill: "#5e2f1d"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M51 37h1v1h-1z",
    fill: "#542412"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38v-1h1v1z",
    fill: "#3f2217"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h1v1h-1z",
    fill: "#3a170a"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38h-1v-1h1z",
    fill: "#200a05"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h1v1h-1z",
    fill: "#30150f"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37v1h-1v-1z",
    fill: "#401f15"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h1v1h-1z",
    fill: "#351c10"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37v1h-1v-1z",
    fill: "#30120c"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37h1v1h-1z",
    fill: "#5d2f1e"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h-1v-1h1z",
    fill: "#b17f23"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M62 37h1v1h-1z",
    fill: "#cf9e14"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M63 38v-1h1v1z",
    fill: "#d4a31f"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h1v1h-1z",
    fill: "#d4a426"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v-1h1v1z",
    fill: "#cb9b23"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M66 37h1v1h-1z",
    fill: "#d2a532"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M68 38h-1v-1h1z",
    fill: "#e4ba46"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M69 38h-1v-1h1z",
    fill: "#d9ac40"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M70 37v1h-1v-1z",
    fill: "#d5a42f"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M70 38v-1h1v1z",
    fill: "#d0a324"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M72 37v1h-1v-1z",
    fill: "#ad7f30"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37h1v1h-1z",
    fill: "#63402f"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M74 37h1v1h-1z",
    fill: "#46210f"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M75 38v-1h1v1z",
    fill: "#6e4327"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37v1h-1v-1z",
    fill: "#784e2e"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h1v1h-1z",
    fill: "#814c20"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37v1h-1v-1z",
    fill: "#6d3b0e"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M80 37v1h-1v-1z",
    fill: "#532b0d"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M80 37h1v1h-1z",
    fill: "#ab8447"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38v-1h1v1z",
    fill: "#edce97"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M82 38v-1h1v1z",
    fill: "#eacfa6"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M83 37h1v1h-1z",
    fill: "#f1daae"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M84 37h1v1h-1z",
    fill: "#e8d2a7"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M85 37h1v1h-1z",
    fill: "#e2c9a3"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M87 37v1h-1v-1z",
    fill: "#eccfa6"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M87 38v-1h1v1z",
    fill: "#f0cf99"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M88 38v-1h1v1z",
    fill: "#e6c990"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M90 37v1h-1v-1z",
    fill: "#dcc796"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M91 38h-1v-1h1z",
    fill: "#e8cea5"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M92 37v1h-1v-1z",
    fill: "#854f31"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M93 38h-1v-1h1z",
    fill: "#682410"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38h-1v-1h1z",
    fill: "#692e17"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38v-1h1v1z",
    fill: "#84492c"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M95 37h1v1h-1z",
    fill: "#7f4024"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M96 38v-1h1v1z",
    fill: "#824526"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M97 37h1v1h-1z",
    fill: "#aa6a48"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M98 38v-1h1v1z",
    fill: "#b98260"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M99 38v-1h1v1z",
    fill: "#b6856a"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M101 37v1h-1v-1z",
    fill: "#d9b394"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M101 38v-1h1v1z",
    fill: "#e1ba8f"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M103 37v1h-1v-1z",
    fill: "#e1bc7e"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M104 37v1h-1v-1z",
    fill: "#f0d38f"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M104 38v-1h1v1z",
    fill: "#edce9b"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M106 37v1h-1v-1z",
    fill: "#ebcba3"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M107 37v1h-1v-1z",
    fill: "#e7c791",
    fillOpacity: 0.894
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M107 37h1v1h-1z",
    fill: "#bca45c",
    fillOpacity: 0.694
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M109 37v1h-1v-1z",
    fill: "#6a7f2a",
    fillOpacity: 0.047
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M16 38v1h-1v-1z",
    fill: "#492e0f",
    fillOpacity: 0.725
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M16 39v-1h1v1z",
    fill: "#3d190a"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M17 38h1v1h-1z",
    fill: "#32130b",
    fillOpacity: 0.988
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M19 38v1h-1v-1z",
    fill: "#4f2712"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39v-1h1v1z",
    fill: "#a15f31"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M21 39h-1v-1h1z",
    fill: "#964f19"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39h-1v-1h1z",
    fill: "#7b4b29"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39v-1h1v1z",
    fill: "#7a593b"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M24 38v1h-1v-1z",
    fill: "#a68144"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M25 39h-1v-1h1z",
    fill: "#e7ca84"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M26 38v1h-1v-1z",
    fill: "#f2dd99"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M26 39v-1h1v1z",
    fill: "#f5de9d"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M28 38v1h-1v-1z",
    fill: "#e3bf63"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39v-1h1v1z",
    fill: "#d39f39"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38h1v1h-1z",
    fill: "#ac7c30"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M30 38h1v1h-1z",
    fill: "#704829"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M31 38h1v1h-1z",
    fill: "#482115"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M33 38v1h-1v-1z",
    fill: "#2a1107"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v-1h1v1z",
    fill: "#1b0b08"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M34 38h1v1h-1z",
    fill: "#6c3618"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M36 38v1h-1v-1z",
    fill: "#9c4d18"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v1h-1v-1z",
    fill: "#995324"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38v1h-1v-1z",
    fill: "#bb7d58"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38h1v1h-1z",
    fill: "#d6af8d"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39h-1v-1h1z",
    fill: "#cea989"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v-1h1v1z",
    fill: "#b2732b"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M42 39h-1v-1h1z",
    fill: "#c07f2c"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M43 39h-1v-1h1z",
    fill: "#aa722b"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M43 38h1v1h-1z",
    fill: "#4f2710"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h1v1h-1z",
    fill: "#532c15"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v1h-1v-1z",
    fill: "#543223"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M47 38v1h-1v-1z",
    fill: "#503728"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v1h-1v-1z",
    fill: "#322011"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v1h-1v-1z",
    fill: "#23150a"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M50 38v1h-1v-1z",
    fill: "#2b1c16"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v-1h1v1z",
    fill: "#3a2520"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h1v1h-1z",
    fill: "#533224"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M52 39v-1h1v1z",
    fill: "#442614"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M54 39h-1v-1h1z",
    fill: "#351e14"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M54 38h1v1h-1z",
    fill: "#391a0d"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38v1h-1v-1z",
    fill: "#451f0e"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M57 38v1h-1v-1z",
    fill: "#4e2919"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M58 39h-1v-1h1z",
    fill: "#452216"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38v1h-1v-1z",
    fill: "#381b0d"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38h1v1h-1z",
    fill: "#704e2b"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M60 38h1v1h-1z",
    fill: "#ac7d32"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38v1h-1v-1z",
    fill: "#d39a24"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h1v1h-1z",
    fill: "#c69110"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M64 38v1h-1v-1z",
    fill: "#c49116"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v1h-1v-1z",
    fill: "#c18b13"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M66 39h-1v-1h1z",
    fill: "#ca9319"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38v1h-1v-1z",
    fill: "#bd8711"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38h1v1h-1z",
    fill: "#c2951c"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39v-1h1v1z",
    fill: "#e2bc5c"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M69 39v-1h1v1z",
    fill: "#debf5e"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39h-1v-1h1z",
    fill: "#cda642"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M71 38h1v1h-1z",
    fill: "#a7782e"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M72 39v-1h1v1z",
    fill: "#9a6c38"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M73 38h1v1h-1z",
    fill: "#71452c"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39v-1h1v1z",
    fill: "#2d1614"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M76 38v1h-1v-1z",
    fill: "#3c2827"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M77 39h-1v-1h1z",
    fill: "#462f22"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M79 38v1h-1v-1z",
    fill: "#6e3d1b"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M80 39h-1v-1h1z",
    fill: "#502708"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38v1h-1v-1z",
    fill: "#4b2513"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38h1v1h-1z",
    fill: "#aa917b"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M82 38h1v1h-1z",
    fill: "#dfc4a3"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M84 38v1h-1v-1z",
    fill: "#d1af8c"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M84 38h1v1h-1z",
    fill: "#b88e6a"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39v-1h1v1z",
    fill: "#ae8058"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M86 39v-1h1v1z",
    fill: "#c39859"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M87 38h1v1h-1z",
    fill: "#c38d3f"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39v-1h1v1z",
    fill: "#cc9b50"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M89 39v-1h1v1z",
    fill: "#ceac6a"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M91 39h-1v-1h1z",
    fill: "#c9a466"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M91 38h1v1h-1z",
    fill: "#b77e4d"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M92 38h1v1h-1z",
    fill: "#7e3f1c"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M93 38h1v1h-1z",
    fill: "#7c4729"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38h1v1h-1z",
    fill: "#9f6641"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M96 39h-1v-1h1z",
    fill: "#9b5b41"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M96 38h1v1h-1z",
    fill: "#a26448"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M97 39v-1h1v1z",
    fill: "#b57a55"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M98 39v-1h1v1z",
    fill: "#cc9a73"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M100 39h-1v-1h1z",
    fill: "#af8063"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M100 38h1v1h-1z",
    fill: "#af7868"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M102 38v1h-1v-1z",
    fill: "#a66c51"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M102 39v-1h1v1z",
    fill: "#a27a54"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M104 38v1h-1v-1z",
    fill: "#c1a37b"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M104 38h1v1h-1z",
    fill: "#c59d72"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M105 39v-1h1v1z",
    fill: "#c3a27a",
    fillOpacity: 0.733
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M106 38h1v1h-1z",
    fill: "#947b4a",
    fillOpacity: 0.122
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M107 39v-1h1v1z",
    fill: "#8d8d38",
    fillOpacity: 0.035
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M15 40v-1h1v1z",
    fill: "#452d10",
    fillOpacity: 0.243
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M17 40h-1v-1h1z",
    fill: "#240f03",
    fillOpacity: 0.325
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M18 39v1h-1v-1z",
    fill: "#261108",
    fillOpacity: 0.235
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M18 40v-1h1v1z",
    fill: "#321103",
    fillOpacity: 0.278
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39h1v1h-1z",
    fill: "#723f15",
    fillOpacity: 0.667
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40v-1h1v1z",
    fill: "#9c5a25"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39v1h-1v-1z",
    fill: "#80522d"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39h1v1h-1z",
    fill: "#6a452a"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M23 39h1v1h-1z",
    fill: "#c9a57c"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40h-1v-1h1z",
    fill: "#f8e1ba"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40v-1h1v1z",
    fill: "#e4d49c"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M27 39v1h-1v-1z",
    fill: "#d1b382"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39v1h-1v-1z",
    fill: "#c39348"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40h-1v-1h1z",
    fill: "#af6f2f"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M30 39v1h-1v-1z",
    fill: "#8d532b"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40h-1v-1h1z",
    fill: "#6a2d15"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40v-1h1v1z",
    fill: "#82412c"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v1h-1v-1z",
    fill: "#ad877a"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39h1v1h-1z",
    fill: "#694c41"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v-1h1v1z",
    fill: "#6a3319"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39v1h-1v-1z",
    fill: "#894014"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39h1v1h-1z",
    fill: "#873c10"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M37 40v-1h1v1z",
    fill: "#955326"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M39 40h-1v-1h1z",
    fill: "#ba8556"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v1h-1v-1z",
    fill: "#b68248"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39v1h-1v-1z",
    fill: "#b5711b"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39h1v1h-1z",
    fill: "#c17f1d"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40h-1v-1h1z",
    fill: "#a46119"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M44 40v-1h1v1z",
    fill: "#36150d"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h-1v-1h1z",
    fill: "#331f1a"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M47 40h-1v-1h1z",
    fill: "#221009"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M47 39h1v1h-1z",
    fill: "#22120d"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h-1v-1h1z",
    fill: "#241512"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v1h-1v-1z",
    fill: "#180d0a"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39v1h-1v-1z",
    fill: "#120704"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39h1v1h-1z",
    fill: "#270f08"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M53 39v1h-1v-1z",
    fill: "#562c1a"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M53 40v-1h1v1z",
    fill: "#4e2312"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M54 40v-1h1v1z",
    fill: "#592c12"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40h-1v-1h1z",
    fill: "#924616"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40v-1h1v1z",
    fill: "#8a4920"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M57 39h1v1h-1z",
    fill: "#4a2512"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M59 39v1h-1v-1z",
    fill: "#886039"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M59 40v-1h1v1z",
    fill: "#bc904c"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v-1h1v1z",
    fill: "#c58f31"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M61 40v-1h1v1z",
    fill: "#c88e1d"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M63 40h-1v-1h1z",
    fill: "#cd981d"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M63 39h1v1h-1z",
    fill: "#bb8411"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39v1h-1v-1z",
    fill: "#bc8012"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39h1v1h-1z",
    fill: "#cf9818"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40h-1v-1h1z",
    fill: "#cf9a21"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h-1v-1h1z",
    fill: "#b88613"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39h1v1h-1z",
    fill: "#9c671f"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M70 40h-1v-1h1z",
    fill: "#674528"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39v1h-1v-1z",
    fill: "#5c422a"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40v-1h1v1z",
    fill: "#653712"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M72 40v-1h1v1z",
    fill: "#9d6722"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40h-1v-1h1z",
    fill: "#a27641"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39h1v1h-1z",
    fill: "#694b31"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M75 40v-1h1v1z",
    fill: "#472c24"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M76 39h1v1h-1z",
    fill: "#3e251a"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M77 40v-1h1v1z",
    fill: "#2f160c"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h1v1h-1z",
    fill: "#331914"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40h-1v-1h1z",
    fill: "#583724"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M81 40h-1v-1h1z",
    fill: "#250b02"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M82 39v1h-1v-1z",
    fill: "#472a1c"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M83 40h-1v-1h1z",
    fill: "#845939"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M84 39v1h-1v-1z",
    fill: "#a7724e"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39v1h-1v-1z",
    fill: "#b07b5a"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39h1v1h-1z",
    fill: "#ba8d72"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M87 39v1h-1v-1z",
    fill: "#cfae8d"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39v1h-1v-1z",
    fill: "#ddb380"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39h1v1h-1z",
    fill: "#e9c181"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M90 40h-1v-1h1z",
    fill: "#e3c37d"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M90 39h1v1h-1z",
    fill: "#d7b375"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M91 39h1v1h-1z",
    fill: "#d2a667"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M92 40v-1h1v1z",
    fill: "#955f26"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M93 40v-1h1v1z",
    fill: "#a0652e"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M95 39v1h-1v-1z",
    fill: "#dea852"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M96 40h-1v-1h1z",
    fill: "#b87f44"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M97 39v1h-1v-1z",
    fill: "#a66a43"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M98 40h-1v-1h1z",
    fill: "#a06236"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M99 39v1h-1v-1z",
    fill: "#c07f52"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M100 40h-1v-1h1z",
    fill: "#c68e70"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M101 40h-1v-1h1z",
    fill: "#b3795f"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M101 40v-1h1v1z",
    fill: "#7e462e"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M103 40h-1v-1h1z",
    fill: "#36231a"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M104 39v1h-1v-1z",
    fill: "#2c1c12"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M104 40v-1h1v1z",
    fill: "#6f4b31",
    fillOpacity: 0.965
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M106 40h-1v-1h1z",
    fill: "#a47f5f",
    fillOpacity: 0.188
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M19 41h-1v-1h1z",
    fill: "#b9a273",
    fillOpacity: 0.043
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M20 41h-1v-1h1z",
    fill: "#8d663f",
    fillOpacity: 0.439
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40h1v1h-1z",
    fill: "#925b33"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41h-1v-1h1z",
    fill: "#6f3819"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M23 41h-1v-1h1z",
    fill: "#8a6042"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M23 41v-1h1v1z",
    fill: "#ad8d5a"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M24 41v-1h1v1z",
    fill: "#debc94"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40h1v1h-1z",
    fill: "#af865b"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M27 41h-1v-1h1z",
    fill: "#996437"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M27 40h1v1h-1z",
    fill: "#c79462"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40v1h-1v-1z",
    fill: "#b17c49"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40h1v1h-1z",
    fill: "#913a12"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40v1h-1v-1z",
    fill: "#6d1f0e"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M31 41v-1h1v1z",
    fill: "#8e5947"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M32 40h1v1h-1z",
    fill: "#c29886"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v1h-1v-1z",
    fill: "#9a6f60"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v-1h1v1z",
    fill: "#834a36"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M36 40v1h-1v-1z",
    fill: "#6d2e11"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h-1v-1h1z",
    fill: "#6b2c0c"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M38 41h-1v-1h1z",
    fill: "#733513"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h-1v-1h1z",
    fill: "#7d421e"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M40 41h-1v-1h1z",
    fill: "#ad6a22"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M41 40v1h-1v-1z",
    fill: "#c4761a"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h-1v-1h1z",
    fill: "#b9751a"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40v1h-1v-1z",
    fill: "#9a5b1a"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M43 41v-1h1v1z",
    fill: "#623213"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M45 40v1h-1v-1z",
    fill: "#391510"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v-1h1v1z",
    fill: "#3f211f"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h1v1h-1z",
    fill: "#624532"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40v1h-1v-1z",
    fill: "#402a19"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40h1v1h-1z",
    fill: "#1a070b"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h1v1h-1z",
    fill: "#110205"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M50 41v-1h1v1z",
    fill: "#281107"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41h-1v-1h1z",
    fill: "#5f3116"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v-1h1v1z",
    fill: "#7d401b"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M53 41v-1h1v1z",
    fill: "#783711"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M55 41h-1v-1h1z",
    fill: "#6b3110"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M55 40h1v1h-1z",
    fill: "#73330d"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h-1v-1h1z",
    fill: "#9b5c2a"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M58 40v1h-1v-1z",
    fill: "#9e6c33"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M59 41h-1v-1h1z",
    fill: "#af7f3e"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v1h-1v-1z",
    fill: "#ae8335"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M60 41v-1h1v1z",
    fill: "#a57327"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M62 40v1h-1v-1z",
    fill: "#975c0f"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41v-1h1v1z",
    fill: "#c68c1c"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M63 41v-1h1v1z",
    fill: "#c98d15"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M64 41v-1h1v1z",
    fill: "#c28410"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M65 40h1v1h-1z",
    fill: "#ce9617"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40v1h-1v-1z",
    fill: "#d8a720"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41v-1h1v1z",
    fill: "#d29e2e"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h1v1h-1z",
    fill: "#c28721"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41v-1h1v1z",
    fill: "#9c712c"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41v-1h1v1z",
    fill: "#8d7049"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40h1v1h-1z",
    fill: "#b48e60"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M73 40v1h-1v-1z",
    fill: "#a27438"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40v1h-1v-1z",
    fill: "#b68b4b"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v-1h1v1z",
    fill: "#c4944f"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M76 40v1h-1v-1z",
    fill: "#9d6526"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v-1h1v1z",
    fill: "#734321"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40v1h-1v-1z",
    fill: "#3d2420"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40h1v1h-1z",
    fill: "#372625"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40v1h-1v-1z",
    fill: "#644a36"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40h1v1h-1z",
    fill: "#3c2317"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M81 40h1v1h-1z",
    fill: "#462613"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h-1v-1h1z",
    fill: "#814d27"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M84 40v1h-1v-1z",
    fill: "#9e633a"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M84 40h1v1h-1z",
    fill: "#a26238"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M85 40h1v1h-1z",
    fill: "#ac6c44"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M86 41v-1h1v1z",
    fill: "#c08c5f"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M87 41v-1h1v1z",
    fill: "#dfb573"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M88 40h1v1h-1z",
    fill: "#d1a758"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41v-1h1v1z",
    fill: "#deb368"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M91 40v1h-1v-1z",
    fill: "#debc73"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M92 40v1h-1v-1z",
    fill: "#d5ae51"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v-1h1v1z",
    fill: "#daa953"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M94 40v1h-1v-1z",
    fill: "#c4883c"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41v-1h1v1z",
    fill: "#c7851d"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M96 40v1h-1v-1z",
    fill: "#cf9229"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M96 41v-1h1v1z",
    fill: "#b27238"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M97 40h1v1h-1z",
    fill: "#7f4727"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M98 40h1v1h-1z",
    fill: "#8c4c21"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M99 40h1v1h-1z",
    fill: "#844012"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M100 41v-1h1v1z",
    fill: "#693416"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M102 41h-1v-1h1z",
    fill: "#694632"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M103 40h1v1h-1z",
    fill: "#413024"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M105 41h-1v-1h1z",
    fill: "#a5926b",
    fillOpacity: 0.992
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M106 40v1h-1v-1z",
    fill: "#c3b081",
    fillOpacity: 0.471
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M106 40h1v1h-1z",
    fill: "#553838",
    fillOpacity: 0.035
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M108 41h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.043
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M18 41v1h-1v-1z",
    fill: "#744526",
    fillOpacity: 0.549
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M18 42v-1h1v1z",
    fill: "#9d6645",
    fillOpacity: 0.882
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M20 41v1h-1v-1z",
    fill: "#af8056",
    fillOpacity: 0.973
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M21 41v1h-1v-1z",
    fill: "#9f7548"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M21 42v-1h1v1z",
    fill: "#875b32"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41h1v1h-1z",
    fill: "#774b2d"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42h-1v-1h1z",
    fill: "#64351c"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42h-1v-1h1z",
    fill: "#8a5221"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42v-1h1v1z",
    fill: "#a67529"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M26 41h1v1h-1z",
    fill: "#c39779"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M27 42v-1h1v1z",
    fill: "#d9b899"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42h-1v-1h1z",
    fill: "#cda473"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M30 41v1h-1v-1z",
    fill: "#b07244"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M31 42h-1v-1h1z",
    fill: "#6c3922"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M32 41v1h-1v-1z",
    fill: "#755141"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M33 41v1h-1v-1z",
    fill: "#9a6e5a"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v1h-1v-1z",
    fill: "#572815"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M35 41v1h-1v-1z",
    fill: "#5f3529"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42h-1v-1h1z",
    fill: "#5a3427"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M36 41h1v1h-1z",
    fill: "#431b09"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h1v1h-1z",
    fill: "#54240c"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41v1h-1v-1z",
    fill: "#62290f"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h1v1h-1z",
    fill: "#944c23"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M41 42h-1v-1h1z",
    fill: "#a25112"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M42 42h-1v-1h1z",
    fill: "#9d5d17"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h1v1h-1z",
    fill: "#7a4514"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M44 42h-1v-1h1z",
    fill: "#3f220d"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42h-1v-1h1z",
    fill: "#442111"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M47 41v1h-1v-1z",
    fill: "#a17451"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M47 42v-1h1v1z",
    fill: "#b89a65"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h-1v-1h1z",
    fill: "#998361"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M49 41h1v1h-1z",
    fill: "#5c402c"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M51 41v1h-1v-1z",
    fill: "#855533"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v1h-1v-1z",
    fill: "#9a541f"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M53 42h-1v-1h1z",
    fill: "#874213"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h-1v-1h1z",
    fill: "#763913"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42v-1h1v1z",
    fill: "#723c1a"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M55 42v-1h1v1z",
    fill: "#672d10"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41v1h-1v-1z",
    fill: "#985e32"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h1v1h-1z",
    fill: "#aa7235"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h-1v-1h1z",
    fill: "#a06e35"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42v-1h1v1z",
    fill: "#a7803c"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M61 41v1h-1v-1z",
    fill: "#bf995f"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M62 42h-1v-1h1z",
    fill: "#c29149"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41h1v1h-1z",
    fill: "#cf9822"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M64 42h-1v-1h1z",
    fill: "#d29820"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42h-1v-1h1z",
    fill: "#bf831e"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42h-1v-1h1z",
    fill: "#9e6714"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42v-1h1v1z",
    fill: "#bf8c27"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41h1v1h-1z",
    fill: "#d5a22c"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v-1h1v1z",
    fill: "#c98e25"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41h1v1h-1z",
    fill: "#be8e54"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41h1v1h-1z",
    fill: "#c4a37e"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M72 42h-1v-1h1z",
    fill: "#a28062"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M73 41v1h-1v-1z",
    fill: "#4c2218"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v1h-1v-1z",
    fill: "#74422a"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41h1v1h-1z",
    fill: "#ce9841"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v1h-1v-1z",
    fill: "#d29a2f"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M77 41v1h-1v-1z",
    fill: "#af7c39"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42h-1v-1h1z",
    fill: "#7b582e"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42v-1h1v1z",
    fill: "#5e3f1a"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M79 41h1v1h-1z",
    fill: "#885f2e"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h-1v-1h1z",
    fill: "#633c22"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M82 42h-1v-1h1z",
    fill: "#6c3e28"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M82 41h1v1h-1z",
    fill: "#884f26"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h1v1h-1z",
    fill: "#874a20"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M84 41h1v1h-1z",
    fill: "#944c1c"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M86 42h-1v-1h1z",
    fill: "#a14d12"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42h-1v-1h1z",
    fill: "#bd6816"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42v-1h1v1z",
    fill: "#c38127"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M88 42v-1h1v1z",
    fill: "#d5a74c"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41h1v1h-1z",
    fill: "#d7b35f"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M91 42h-1v-1h1z",
    fill: "#d3ad53"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v1h-1v-1z",
    fill: "#d4a748"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42h-1v-1h1z",
    fill: "#dda54d"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M93 41h1v1h-1z",
    fill: "#cb8d2f"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41h1v1h-1z",
    fill: "#d69734"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M95 42v-1h1v1z",
    fill: "#af782b"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M97 41v1h-1v-1z",
    fill: "#602c0d"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M97 42v-1h1v1z",
    fill: "#512715"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M99 42h-1v-1h1z",
    fill: "#652d0a"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M100 41v1h-1v-1z",
    fill: "#955421"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M100 42v-1h1v1z",
    fill: "#82543c"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M102 41v1h-1v-1z",
    fill: "#44271f"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M102 42v-1h1v1z",
    fill: "#744e29"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M104 41v1h-1v-1z",
    fill: "#c39b6f"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M105 41v1h-1v-1z",
    fill: "#e1ca97"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M105 41h1v1h-1z",
    fill: "#d7c087",
    fillOpacity: 0.984
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M107 41v1h-1v-1z",
    fill: "#ac8d61",
    fillOpacity: 0.792
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M108 42h-1v-1h1z",
    fill: "#b8987a",
    fillOpacity: 0.827
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M109 42h-1v-1h1z",
    fill: "#cfb297",
    fillOpacity: 0.627
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M109 42v-1h1v1z",
    fill: "#d8c4a7",
    fillOpacity: 0.447
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M110 41h1v1h-1z",
    fill: "#ecd8bc",
    fillOpacity: 0.388
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M112 42h-1v-1h1z",
    fill: "#f1e4bb",
    fillOpacity: 0.149
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42v1h-1v-1z",
    fill: "#6b5533",
    fillOpacity: 0.176
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42h1v1h-1z",
    fill: "#784d30",
    fillOpacity: 0.937
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M18 42h1v1h-1z",
    fill: "#703d20"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M20 42v1h-1v-1z",
    fill: "#804e27"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M21 43h-1v-1h1z",
    fill: "#a68455"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M21 42h1v1h-1z",
    fill: "#d4c081"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43h-1v-1h1z",
    fill: "#a4823d"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42v1h-1v-1z",
    fill: "#937536"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M24 43v-1h1v1z",
    fill: "#a8845d"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M25 43v-1h1v1z",
    fill: "#e2ba94"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M26 43v-1h1v1z",
    fill: "#ebccb2"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M27 42h1v1h-1z",
    fill: "#cfaf7f"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42v1h-1v-1z",
    fill: "#a87343"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M29 43v-1h1v1z",
    fill: "#9b734b"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M30 42h1v1h-1z",
    fill: "#543522"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43v-1h1v1z",
    fill: "#331912"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42h1v1h-1z",
    fill: "#401e10"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42v1h-1v-1z",
    fill: "#3e1a0a"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42h1v1h-1z",
    fill: "#27120a"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M36 43v-1h1v1z",
    fill: "#2f1b0f"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43h-1v-1h1z",
    fill: "#42210f"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M38 42h1v1h-1z",
    fill: "#63361d"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43h-1v-1h1z",
    fill: "#572d12"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42h1v1h-1z",
    fill: "#5f320d"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h-1v-1h1z",
    fill: "#4f2b0b"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M43 42v1h-1v-1z",
    fill: "#432211"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43v-1h1v1z",
    fill: "#31180a"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43h-1v-1h1z",
    fill: "#4f2d14"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42v1h-1v-1z",
    fill: "#662b10"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M46 43v-1h1v1z",
    fill: "#5a1c07"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M48 42v1h-1v-1z",
    fill: "#997557"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v-1h1v1z",
    fill: "#bea176"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h1v1h-1z",
    fill: "#c39a6a"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M51 42v1h-1v-1z",
    fill: "#8a5429"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M51 43v-1h1v1z",
    fill: "#814921"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h-1v-1h1z",
    fill: "#8e5329"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43v-1h1v1z",
    fill: "#854a23"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h1v1h-1z",
    fill: "#793e15"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M56 42v1h-1v-1z",
    fill: "#6c3413"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M56 43v-1h1v1z",
    fill: "#703c19"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v-1h1v1z",
    fill: "#936135"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43v-1h1v1z",
    fill: "#a67b4e"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h1v1h-1z",
    fill: "#c8a967"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M60 42h1v1h-1z",
    fill: "#d5ba83"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h-1v-1h1z",
    fill: "#c6a05d"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M63 42v1h-1v-1z",
    fill: "#b8851c"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43v-1h1v1z",
    fill: "#d0952b"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42v1h-1v-1z",
    fill: "#995f18"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M65 43v-1h1v1z",
    fill: "#67310d"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h-1v-1h1z",
    fill: "#76431b"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v1h-1v-1z",
    fill: "#a67623"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h-1v-1h1z",
    fill: "#9c651d"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M70 42v1h-1v-1z",
    fill: "#6d442d"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43v-1h1v1z",
    fill: "#a68879"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43v-1h1v1z",
    fill: "#856c52"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M72 43v-1h1v1z",
    fill: "#482411"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M74 43h-1v-1h1z",
    fill: "#b88a42"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43h-1v-1h1z",
    fill: "#dba837"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43v-1h1v1z",
    fill: "#d5af2e"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M77 42v1h-1v-1z",
    fill: "#e2c050"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M77 43v-1h1v1z",
    fill: "#dbb246"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M79 42v1h-1v-1z",
    fill: "#ba8a1f"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M79 43v-1h1v1z",
    fill: "#b97e12"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M80 42h1v1h-1z",
    fill: "#b37b28"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h1v1h-1z",
    fill: "#945a21"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M83 43h-1v-1h1z",
    fill: "#783d16"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M83 42h1v1h-1z",
    fill: "#763c14"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M85 43h-1v-1h1z",
    fill: "#843b0d"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h-1v-1h1z",
    fill: "#a1470c"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v-1h1v1z",
    fill: "#aa5110"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M88 43h-1v-1h1z",
    fill: "#b56115"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M88 42h1v1h-1z",
    fill: "#d79643"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M89 42h1v1h-1z",
    fill: "#d2a449"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M90 42h1v1h-1z",
    fill: "#cea039"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M91 42h1v1h-1z",
    fill: "#ad7221"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42v1h-1v-1z",
    fill: "#a35f1d"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M93 43v-1h1v1z",
    fill: "#bc7a1b"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43h-1v-1h1z",
    fill: "#b47621"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h-1v-1h1z",
    fill: "#7e4922"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M97 43h-1v-1h1z",
    fill: "#704028"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M97 42h1v1h-1z",
    fill: "#4c230f"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43h-1v-1h1z",
    fill: "#5b2b0b"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43v-1h1v1z",
    fill: "#5e2b0d"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M101 42v1h-1v-1z",
    fill: "#603b32"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M101 43v-1h1v1z",
    fill: "#795d57"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M102 42h1v1h-1z",
    fill: "#8e6239"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M104 43h-1v-1h1z",
    fill: "#c59651"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M104 43v-1h1v1z",
    fill: "#b0905e"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M106 42v1h-1v-1z",
    fill: "#d0b26e"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M106 43v-1h1v1z",
    fill: "#aa854a"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M108 43h-1v-1h1z",
    fill: "#6c4523"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M109 42v1h-1v-1z",
    fill: "#6c4b31"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M109 43v-1h1v1z",
    fill: "#6b4e2f"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M111 42v1h-1v-1z",
    fill: "#6d5032"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M112 43h-1v-1h1z",
    fill: "#93744b",
    fillOpacity: 0.945
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M113 43h-1v-1h1z",
    fill: "#ae8e55",
    fillOpacity: 0.78
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M113 42h1v1h-1z",
    fill: "#c0af86",
    fillOpacity: 0.416
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M114 42h1v1h-1z",
    fill: "#e0d4b0",
    fillOpacity: 0.165
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M115 42h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.016
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M16 43v1h-1v-1z",
    fill: "#4a3e37",
    fillOpacity: 0.161
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44v-1h1v1z",
    fill: "#533d2a",
    fillOpacity: 0.843
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M18 43v1h-1v-1z",
    fill: "#806353"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M19 44h-1v-1h1z",
    fill: "#5b4033"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44h-1v-1h1z",
    fill: "#54290d"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44h-1v-1h1z",
    fill: "#af895b"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44v-1h1v1z",
    fill: "#bea87d"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43v1h-1v-1z",
    fill: "#b48d4c"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44h-1v-1h1z",
    fill: "#cf9f41"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M25 44h-1v-1h1z",
    fill: "#c5965d"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44h-1v-1h1z",
    fill: "#a87957"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44h-1v-1h1z",
    fill: "#b08053"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44v-1h1v1z",
    fill: "#b58036"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M28 44v-1h1v1z",
    fill: "#a77030"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h-1v-1h1z",
    fill: "#714020"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44v-1h1v1z",
    fill: "#471f13"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43h1v1h-1z",
    fill: "#1f0c09"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v-1h1v1z",
    fill: "#160601"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M33 44v-1h1v1z",
    fill: "#1a0702"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M35 43v1h-1v-1z",
    fill: "#150704"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M36 44h-1v-1h1z",
    fill: "#150a04"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M37 44h-1v-1h1z",
    fill: "#1b0e08"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43v1h-1v-1z",
    fill: "#261008"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44v-1h1v1z",
    fill: "#3c1f12"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43v1h-1v-1z",
    fill: "#27190c"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M41 43v1h-1v-1z",
    fill: "#261d12"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43v1h-1v-1z",
    fill: "#20120a"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h1v1h-1z",
    fill: "#331d0e"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43h1v1h-1z",
    fill: "#422409"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43v1h-1v-1z",
    fill: "#592b0d"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M45 44v-1h1v1z",
    fill: "#692613"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M47 43v1h-1v-1z",
    fill: "#3e1205"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v1h-1v-1z",
    fill: "#2a0e03"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43h1v1h-1z",
    fill: "#351204"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M49 43h1v1h-1z",
    fill: "#4e240f"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44v-1h1v1z",
    fill: "#4d1e09"
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M52 43v1h-1v-1z",
    fill: "#58280d"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M53 44h-1v-1h1z",
    fill: "#663715"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h1v1h-1z",
    fill: "#6d3718"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h-1v-1h1z",
    fill: "#824c21"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M55 43h1v1h-1z",
    fill: "#8b582e"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v1h-1v-1z",
    fill: "#79492a"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44h-1v-1h1z",
    fill: "#8b603b"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43h1v1h-1z",
    fill: "#b3905c"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M59 44v-1h1v1z",
    fill: "#bc9f65"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43h1v1h-1z",
    fill: "#bd9f6a"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43v1h-1v-1z",
    fill: "#caa978"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h1v1h-1z",
    fill: "#b48851"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43h1v1h-1z",
    fill: "#9d6922"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44h-1v-1h1z",
    fill: "#895622"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M66 43v1h-1v-1z",
    fill: "#6f4225"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43v1h-1v-1z",
    fill: "#4a2610"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h1v1h-1z",
    fill: "#5d341a"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43v1h-1v-1z",
    fill: "#7e491f"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h1v1h-1z",
    fill: "#5c3517"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43h1v1h-1z",
    fill: "#3d1e0c"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43h1v1h-1z",
    fill: "#53381d"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M73 43v1h-1v-1z",
    fill: "#7e502e"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44v-1h1v1z",
    fill: "#bc892c"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M74 44v-1h1v1z",
    fill: "#d6a727"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M76 43v1h-1v-1z",
    fill: "#dab950"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M77 44h-1v-1h1z",
    fill: "#cfb757"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44h-1v-1h1z",
    fill: "#e5c355"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44v-1h1v1z",
    fill: "#ba8a1d"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44h-1v-1h1z",
    fill: "#be8212"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43v1h-1v-1z",
    fill: "#cb8c1c"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43h1v1h-1z",
    fill: "#aa6e1f"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h-1v-1h1z",
    fill: "#783c10"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M84 43v1h-1v-1z",
    fill: "#77441c"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44h-1v-1h1z",
    fill: "#743714"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v1h-1v-1z",
    fill: "#94470f"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h1v1h-1z",
    fill: "#a65114"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M87 43h1v1h-1z",
    fill: "#ab6117"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M89 44h-1v-1h1z",
    fill: "#ce8e3b"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M89 43h1v1h-1z",
    fill: "#c68f2d"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v-1h1v1z",
    fill: "#cc962b"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M91 44v-1h1v1z",
    fill: "#b8731a"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M92 43h1v1h-1z",
    fill: "#b97324"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M94 43v1h-1v-1z",
    fill: "#c1871e"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43v1h-1v-1z",
    fill: "#d4a64f"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43v1h-1v-1z",
    fill: "#d2b474"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h1v1h-1z",
    fill: "#e4c379"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M98 43v1h-1v-1z",
    fill: "#946e3d"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43v1h-1v-1z",
    fill: "#572f15"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43h1v1h-1z",
    fill: "#6b472d"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M100 44v-1h1v1z",
    fill: "#4d3329"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M101 43h1v1h-1z",
    fill: "#573b3b"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M102 44v-1h1v1z",
    fill: "#664233"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M103 44v-1h1v1z",
    fill: "#90632d"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M105 44h-1v-1h1z",
    fill: "#88562f"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M105 43h1v1h-1z",
    fill: "#845217"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M106 43h1v1h-1z",
    fill: "#a5742d"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M107 44v-1h1v1z",
    fill: "#996a2c"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M109 44h-1v-1h1z",
    fill: "#74421f"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M110 44h-1v-1h1z",
    fill: "#461d07"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M111 44h-1v-1h1z",
    fill: "#341803"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M111 43h1v1h-1z",
    fill: "#3c1502"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M112 44v-1h1v1z",
    fill: "#5f3310"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M113 44v-1h1v1z",
    fill: "#8b693d"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M115 44h-1v-1h1z",
    fill: "#8a5c32",
    fillOpacity: 0.918
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M115 44v-1h1v1z",
    fill: "#ad8a63",
    fillOpacity: 0.616
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M117 43v1h-1v-1z",
    fill: "#e7dcc5",
    fillOpacity: 0.086
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M15 44v1h-1v-1z",
    fill: "#8a7f6a",
    fillOpacity: 0.094
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44v1h-1v-1z",
    fill: "#6c6356",
    fillOpacity: 0.808
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M17 45h-1v-1h1z",
    fill: "#504337"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M18 44v1h-1v-1z",
    fill: "#73625a"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M18 44h1v1h-1z",
    fill: "#695244"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45v-1h1v1z",
    fill: "#845022"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44h1v1h-1z",
    fill: "#bb8225"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M22 44v1h-1v-1z",
    fill: "#aa7a2e"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M23 45h-1v-1h1z",
    fill: "#b98531"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M23 44h1v1h-1z",
    fill: "#ae722e"
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45h-1v-1h1z",
    fill: "#8a4f1f"
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44v1h-1v-1z",
    fill: "#9f633c"
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45h-1v-1h1z",
    fill: "#ac6d38"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45v-1h1v1z",
    fill: "#c0833e"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h-1v-1h1z",
    fill: "#b68751"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45h-1v-1h1z",
    fill: "#532f17"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h1v1h-1z",
    fill: "#401910"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v1h-1v-1z",
    fill: "#200a07"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45v-1h1v1z",
    fill: "#1a0803"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M34 44v1h-1v-1z",
    fill: "#2a140c"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v-1h1v1z",
    fill: "#210d06"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M35 44h1v1h-1z",
    fill: "#170801"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45h-1v-1h1z",
    fill: "#100602"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45v-1h1v1z",
    fill: "#120c08"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44h1v1h-1z",
    fill: "#1e150d"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M40 45h-1v-1h1z",
    fill: "#251810"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M41 44v1h-1v-1z",
    fill: "#2a1c14"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45v-1h1v1z",
    fill: "#361606"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v-1h1v1z",
    fill: "#4c240d"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M45 45h-1v-1h1z",
    fill: "#502812"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M47 45h-1v-1h1z",
    fill: "#291008"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M47 44h1v1h-1z",
    fill: "#240c03"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M48 45v-1h1v1z",
    fill: "#2c0f04"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45h-1v-1h1z",
    fill: "#381508"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44h1v1h-1z",
    fill: "#461b0c"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M51 45v-1h1v1z",
    fill: "#603018"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45h-1v-1h1z",
    fill: "#5a2e16"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45v-1h1v1z",
    fill: "#5f2c13"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44v1h-1v-1z",
    fill: "#7c4419"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h1v1h-1z",
    fill: "#743e15"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45h-1v-1h1z",
    fill: "#7c4c2f"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44v1h-1v-1z",
    fill: "#976b45"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45v-1h1v1z",
    fill: "#a37946"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45v-1h1v1z",
    fill: "#c09663"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h-1v-1h1z",
    fill: "#cea97d"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M63 45h-1v-1h1z",
    fill: "#cbb090"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M64 45h-1v-1h1z",
    fill: "#bd9d70"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44v1h-1v-1z",
    fill: "#8b6840"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M66 44v1h-1v-1z",
    fill: "#563321"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M66 45v-1h1v1z",
    fill: "#2c150d"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M68 44v1h-1v-1z",
    fill: "#2c170e"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M69 45h-1v-1h1z",
    fill: "#592d14"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M69 44h1v1h-1z",
    fill: "#834c29"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M71 44v1h-1v-1z",
    fill: "#7f461b"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M72 44v1h-1v-1z",
    fill: "#6e3d28"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v-1h1v1z",
    fill: "#7e4b23"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44h1v1h-1z",
    fill: "#a36e30"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45h-1v-1h1z",
    fill: "#ad8839"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M76 45h-1v-1h1z",
    fill: "#b49942"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M76 44h1v1h-1z",
    fill: "#c0a53f"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M77 45v-1h1v1z",
    fill: "#f0d054"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v-1h1v1z",
    fill: "#e1b94c"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44v1h-1v-1z",
    fill: "#c59537"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h-1v-1h1z",
    fill: "#bb8521"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M82 44v1h-1v-1z",
    fill: "#a2641f"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45v-1h1v1z",
    fill: "#a26324"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h1v1h-1z",
    fill: "#86501e"
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44v1h-1v-1z",
    fill: "#915d36"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h-1v-1h1z",
    fill: "#8f5922"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M87 45h-1v-1h1z",
    fill: "#a2601f"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44v1h-1v-1z",
    fill: "#c27e26"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44h1v1h-1z",
    fill: "#b56e1b"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v1h-1v-1z",
    fill: "#c18122"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44h1v1h-1z",
    fill: "#c7862d"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45h-1v-1h1z",
    fill: "#bd7a1d"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M93 45h-1v-1h1z",
    fill: "#d39719"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M94 45h-1v-1h1z",
    fill: "#ecc132"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44v1h-1v-1z",
    fill: "#f5db74"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44h1v1h-1z",
    fill: "#f5e399"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45v-1h1v1z",
    fill: "#f4e087"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M98 45h-1v-1h1z",
    fill: "#dec561"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M98 44h1v1h-1z",
    fill: "#93712f"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M100 44v1h-1v-1z",
    fill: "#7c5a39"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M101 45h-1v-1h1z",
    fill: "#724f39"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M102 45h-1v-1h1z",
    fill: "#5e3723"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M103 45h-1v-1h1z",
    fill: "#754f38"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M104 45v-1h1v1z",
    fill: "#845033"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M106 45h-1v-1h1z",
    fill: "#915522"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M106 45v-1h1v1z",
    fill: "#b77a38"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M107 45v-1h1v1z",
    fill: "#d2984a"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M108 44h1v1h-1z",
    fill: "#d2914d"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M109 45v-1h1v1z",
    fill: "#99613a"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M111 44v1h-1v-1z",
    fill: "#482b14"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M112 44v1h-1v-1z",
    fill: "#412416"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M112 45v-1h1v1z",
    fill: "#562b17"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M113 44h1v1h-1z",
    fill: "#945122"
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M114 45v-1h1v1z",
    fill: "#9a3c0f"
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M116 44v1h-1v-1z",
    fill: "#824220",
    fillOpacity: 0.914
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M117 45h-1v-1h1z",
    fill: "#876d58",
    fillOpacity: 0.192
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M14 46h-1v-1h1z",
    fill: "#5a3c1e",
    fillOpacity: 0.067
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M15 45v1h-1v-1z",
    fill: "#4f4028",
    fillOpacity: 0.639
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M16 46h-1v-1h1z",
    fill: "#4f4739"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M16 45h1v1h-1z",
    fill: "#332c20"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M17 45h1v1h-1z",
    fill: "#231910"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45v1h-1v-1z",
    fill: "#442c13"
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46v-1h1v1z",
    fill: "#ad763e"
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M20 45h1v1h-1z",
    fill: "#9b591a"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v-1h1v1z",
    fill: "#774319"
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M24 45v1h-1v-1z",
    fill: "#693b1e"
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M25 46h-1v-1h1z",
    fill: "#673b23"
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45h1v1h-1z",
    fill: "#6e3f29"
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46h-1v-1h1z",
    fill: "#915b3b"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46h-1v-1h1z",
    fill: "#9e6837"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46v-1h1v1z",
    fill: "#6e3f1a"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h1v1h-1z",
    fill: "#411c0d"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M31 45v1h-1v-1z",
    fill: "#2f110a"
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46v-1h1v1z",
    fill: "#1c0a04"
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M33 45v1h-1v-1z",
    fill: "#251005"
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v1h-1v-1z",
    fill: "#3e2413"
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45h1v1h-1z",
    fill: "#3c2414"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M36 45v1h-1v-1z",
    fill: "#331f12"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M36 46v-1h1v1z",
    fill: "#2b1c13"
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M38 45v1h-1v-1z",
    fill: "#31211a"
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M39 46h-1v-1h1z",
    fill: "#3c261b"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M40 46h-1v-1h1z",
    fill: "#533324"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M41 46h-1v-1h1z",
    fill: "#5a3d32"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M42 46h-1v-1h1z",
    fill: "#46281e"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v1h-1v-1z",
    fill: "#654336"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45v1h-1v-1z",
    fill: "#59382b"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45h1v1h-1z",
    fill: "#3b1f14"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h-1v-1h1z",
    fill: "#1d1107"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M46 45h1v1h-1z",
    fill: "#2b160f"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h-1v-1h1z",
    fill: "#34180b"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M49 46h-1v-1h1z",
    fill: "#381a0c"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45v1h-1v-1z",
    fill: "#3e1c10"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v-1h1v1z",
    fill: "#3f1809"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45v1h-1v-1z",
    fill: "#5c341e"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M54 46h-1v-1h1z",
    fill: "#532914"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M54 45h1v1h-1z",
    fill: "#835128"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M56 45v1h-1v-1z",
    fill: "#7b4c30"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45v1h-1v-1z",
    fill: "#724835"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M58 46h-1v-1h1z",
    fill: "#956943"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45h1v1h-1z",
    fill: "#91632a"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45h1v1h-1z",
    fill: "#845116"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46h-1v-1h1z",
    fill: "#a5733d"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h1v1h-1z",
    fill: "#bd9870"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v-1h1v1z",
    fill: "#c4aa87"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46v-1h1v1z",
    fill: "#dec19b"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46v-1h1v1z",
    fill: "#a5875b"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46h-1v-1h1z",
    fill: "#41220f"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45v1h-1v-1z",
    fill: "#37221a"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45h1v1h-1z",
    fill: "#190c08"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M68 45h1v1h-1z",
    fill: "#451a0e"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M69 46v-1h1v1z",
    fill: "#914225"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M70 46v-1h1v1z",
    fill: "#93461b"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v1h-1v-1z",
    fill: "#ae7a68"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45h1v1h-1z",
    fill: "#b58c7d"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M73 45h1v1h-1z",
    fill: "#a77e6f"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45v1h-1v-1z",
    fill: "#674240"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M75 46v-1h1v1z",
    fill: "#997640"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46v-1h1v1z",
    fill: "#eac95b"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v1h-1v-1z",
    fill: "#dec04d"
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M79 45v1h-1v-1z",
    fill: "#dec263"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M80 46h-1v-1h1z",
    fill: "#c3a560"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45v1h-1v-1z",
    fill: "#e5c262"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h1v1h-1z",
    fill: "#925c1e"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45h1v1h-1z",
    fill: "#a76c33"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M83 45h1v1h-1z",
    fill: "#bd833e"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M84 46v-1h1v1z",
    fill: "#8b5325"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v-1h1v1z",
    fill: "#794722"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h1v1h-1z",
    fill: "#875424"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h-1v-1h1z",
    fill: "#bc8029"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M89 45v1h-1v-1z",
    fill: "#9d5917"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M90 46h-1v-1h1z",
    fill: "#c1812a"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M90 45h1v1h-1z",
    fill: "#aa6713"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45v1h-1v-1z",
    fill: "#cc9320"
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46v-1h1v1z",
    fill: "#e6b926"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M93 46v-1h1v1z",
    fill: "#f4ce55"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M95 46h-1v-1h1z",
    fill: "#f1d87d"
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M96 46h-1v-1h1z",
    fill: "#e8d287"
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45h1v1h-1z",
    fill: "#f3da8b"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M97 45h1v1h-1z",
    fill: "#f3d259"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M99 45v1h-1v-1z",
    fill: "#eec746"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M100 46h-1v-1h1z",
    fill: "#734d2c"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M101 45v1h-1v-1z",
    fill: "#71442d"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M102 46h-1v-1h1z",
    fill: "#9d642b"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M103 45v1h-1v-1z",
    fill: "#c99659"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M104 45v1h-1v-1z",
    fill: "#a97d42"
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M104 45h1v1h-1z",
    fill: "#95653b"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M106 45v1h-1v-1z",
    fill: "#bf8e36"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M106 46v-1h1v1z",
    fill: "#d4a84f"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M107 46v-1h1v1z",
    fill: "#ddb85e"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M109 46h-1v-1h1z",
    fill: "#e8bc58"
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M110 45v1h-1v-1z",
    fill: "#ad7e3d"
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M110 45h1v1h-1z",
    fill: "#5a3210"
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M111 45h1v1h-1z",
    fill: "#633017"
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M112 46v-1h1v1z",
    fill: "#8b542e"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M113 46v-1h1v1z",
    fill: "#a35721"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M114 46v-1h1v1z",
    fill: "#8d2e0d"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M116 45v1h-1v-1z",
    fill: "#7e4222"
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M116 45h1v1h-1z",
    fill: "#796739",
    fillOpacity: 0.435
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M12 46h1v1h-1z",
    fill: "#c59668",
    fillOpacity: 0.086
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M13 47v-1h1v1z",
    fill: "#8e7046",
    fillOpacity: 0.71
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M15 47h-1v-1h1z",
    fill: "#302413"
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M16 46v1h-1v-1z",
    fill: "#1c1710"
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M17 47h-1v-1h1z",
    fill: "#251d18"
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M18 46v1h-1v-1z",
    fill: "#453a34"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M19 47h-1v-1h1z",
    fill: "#5d412a"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46h1v1h-1z",
    fill: "#a16e3c"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M20 46h1v1h-1z",
    fill: "#864820"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v1h-1v-1z",
    fill: "#6e3915"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h-1v-1h1z",
    fill: "#4f2713"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47v-1h1v1z",
    fill: "#532d14"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47h-1v-1h1z",
    fill: "#6b4229"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M26 47h-1v-1h1z",
    fill: "#6d3d24"
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46v1h-1v-1z",
    fill: "#916043"
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M28 47h-1v-1h1z",
    fill: "#b0805c"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47h-1v-1h1z",
    fill: "#8e562e"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M29 46h1v1h-1z",
    fill: "#622909"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M31 47h-1v-1h1z",
    fill: "#582c11"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46h1v1h-1z",
    fill: "#351b0b"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M33 46v1h-1v-1z",
    fill: "#2b1406"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47h-1v-1h1z",
    fill: "#311809"
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M35 47h-1v-1h1z",
    fill: "#341d0f"
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47h-1v-1h1z",
    fill: "#352014"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v-1h1v1z",
    fill: "#4f3022"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M38 47v-1h1v1z",
    fill: "#674535"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M39 47v-1h1v1z",
    fill: "#816153"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47h-1v-1h1z",
    fill: "#795c57"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47h-1v-1h1z",
    fill: "#644d4e"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47v-1h1v1z",
    fill: "#574444"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h-1v-1h1z",
    fill: "#4d3a36"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47v-1h1v1z",
    fill: "#2e1c19"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47h-1v-1h1z",
    fill: "#2c221b"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h1v1h-1z",
    fill: "#341c15"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M47 46h1v1h-1z",
    fill: "#402211"
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h1v1h-1z",
    fill: "#3c1908"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v1h-1v-1z",
    fill: "#421b0c"
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M51 46v1h-1v-1z",
    fill: "#3e1807"
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47h-1v-1h1z",
    fill: "#411f0a"
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M52 46h1v1h-1z",
    fill: "#4a2f1f"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v-1h1v1z",
    fill: "#4f2d1b"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M54 47v-1h1v1z",
    fill: "#885e40"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46v1h-1v-1z",
    fill: "#865c3f"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46h1v1h-1z",
    fill: "#80573a"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M57 46h1v1h-1z",
    fill: "#85552b"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h-1v-1h1z",
    fill: "#a3713b"
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47v-1h1v1z",
    fill: "#915d23"
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46v1h-1v-1z",
    fill: "#7a4010"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v1h-1v-1z",
    fill: "#8a562e"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M63 47h-1v-1h1z",
    fill: "#c9a070"
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46h1v1h-1z",
    fill: "#e5c394"
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46h1v1h-1z",
    fill: "#c9a96d"
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46v1h-1v-1z",
    fill: "#634122"
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47v-1h1v1z",
    fill: "#411f19"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M68 46v1h-1v-1z",
    fill: "#32150f"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47v-1h1v1z",
    fill: "#5e2813"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M69 47v-1h1v1z",
    fill: "#a44817"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M71 46v1h-1v-1z",
    fill: "#9f4c16"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M71 47v-1h1v1z",
    fill: "#936443"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M73 46v1h-1v-1z",
    fill: "#9d7e79"
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47v-1h1v1z",
    fill: "#8e706c"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M74 46h1v1h-1z",
    fill: "#947a74"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M76 47h-1v-1h1z",
    fill: "#a07b69"
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46h1v1h-1z",
    fill: "#a77d5b"
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M78 46v1h-1v-1z",
    fill: "#c8a67a"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M79 47h-1v-1h1z",
    fill: "#ddc09b"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47h-1v-1h1z",
    fill: "#aa8a63"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47h-1v-1h1z",
    fill: "#a17b32"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47v-1h1v1z",
    fill: "#875418"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M83 46v1h-1v-1z",
    fill: "#5d2c08"
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v-1h1v1z",
    fill: "#9f6d3b"
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v1h-1v-1z",
    fill: "#784318"
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46h1v1h-1z",
    fill: "#5f2915"
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "M86 46h1v1h-1z",
    fill: "#52230f"
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46v1h-1v-1z",
    fill: "#925e25"
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h1v1h-1z",
    fill: "#935223"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "M90 47h-1v-1h1z",
    fill: "#c3892a"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h-1v-1h1z",
    fill: "#d39b1c"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "M91 46h1v1h-1z",
    fill: "#edbb29"
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46h1v1h-1z",
    fill: "#edc53e"
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "M94 46v1h-1v-1z",
    fill: "#fbd86c"
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47h-1v-1h1z",
    fill: "#f4d371"
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47v-1h1v1z",
    fill: "#edd072"
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47h-1v-1h1z",
    fill: "#f8d97d"
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47v-1h1v1z",
    fill: "#f6d463"
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "M99 47h-1v-1h1z",
    fill: "#ebca47"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "M100 46v1h-1v-1z",
    fill: "#a18032"
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "M100 47v-1h1v1z",
    fill: "#674129"
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "M101 47v-1h1v1z",
    fill: "#6a361a"
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "M103 47h-1v-1h1z",
    fill: "#8d5a1f"
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "M103 46h1v1h-1z",
    fill: "#b78e4e"
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "M105 46v1h-1v-1z",
    fill: "#d4a668"
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "M105 46h1v1h-1z",
    fill: "#dfab55"
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "M107 46v1h-1v-1z",
    fill: "#deae53"
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "M107 47v-1h1v1z",
    fill: "#dab153"
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "M108 46h1v1h-1z",
    fill: "#e7be64"
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "M110 47h-1v-1h1z",
    fill: "#d2ab53"
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "M111 46v1h-1v-1z",
    fill: "#b77f4b"
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "M112 46v1h-1v-1z",
    fill: "#893b11"
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "M113 47h-1v-1h1z",
    fill: "#be7a3b"
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "M114 46v1h-1v-1z",
    fill: "#b3713c"
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "M115 47h-1v-1h1z",
    fill: "#914b31"
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "M116 46v1h-1v-1z",
    fill: "#8b5836"
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "M116 47v-1h1v1z",
    fill: "#ad8948",
    fillOpacity: 0.875
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "M118 47h-1v-1h1z",
    fill: "#aa7c42",
    fillOpacity: 0.329
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "M119 46v1h-1v-1z",
    fill: "#b7935b",
    fillOpacity: 0.196
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "M119 46h1v1h-1z",
    fill: "#5f5f1f",
    fillOpacity: 0.031
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "M12 47v1h-1v-1z",
    fill: "#7f7f4c",
    fillOpacity: 0.039
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "M12 48v-1h1v1z",
    fill: "#b89146",
    fillOpacity: 0.569
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "M14 47v1h-1v-1z",
    fill: "#ad884d"
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "M14 48v-1h1v1z",
    fill: "#3e3420"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "M15 48v-1h1v1z",
    fill: "#1b110a"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "M16 47h1v1h-1z",
    fill: "#2f2219"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "M17 47h1v1h-1z",
    fill: "#735031"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "M19 47v1h-1v-1z",
    fill: "#a87650"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "M19 48v-1h1v1z",
    fill: "#834d2b"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "M21 48h-1v-1h1z",
    fill: "#9c623c"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "M21 47h1v1h-1z",
    fill: "#714227"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "M23 48h-1v-1h1z",
    fill: "#4f2410"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h1v1h-1z",
    fill: "#714123"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47v1h-1v-1z",
    fill: "#8a5939"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48v-1h1v1z",
    fill: "#7c4629"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48h-1v-1h1z",
    fill: "#603724"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48v-1h1v1z",
    fill: "#37140c"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "M29 48h-1v-1h1z",
    fill: "#653117"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47h1v1h-1z",
    fill: "#72330f"
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h-1v-1h1z",
    fill: "#632707"
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48h-1v-1h1z",
    fill: "#562810"
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48v-1h1v1z",
    fill: "#311204"
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47v1h-1v-1z",
    fill: "#1c0904"
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "M35 48h-1v-1h1z",
    fill: "#1c0f0d"
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47v1h-1v-1z",
    fill: "#23160f"
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v1h-1v-1z",
    fill: "#2e1a0e"
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47h1v1h-1z",
    fill: "#4a3325"
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "M39 48h-1v-1h1z",
    fill: "#432e21"
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "M40 48h-1v-1h1z",
    fill: "#513d33"
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47v1h-1v-1z",
    fill: "#6b5251"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "M41 48v-1h1v1z",
    fill: "#4f363b"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47v1h-1v-1z",
    fill: "#2d1b1c"
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47h1v1h-1z",
    fill: "#2f221f"
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h1v1h-1z",
    fill: "#362825"
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "M45 47h1v1h-1z",
    fill: "#31211f"
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48v-1h1v1z",
    fill: "#33221c"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "M47 47h1v1h-1z",
    fill: "#392111"
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "M48 47h1v1h-1z",
    fill: "#4c2818"
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "M50 48h-1v-1h1z",
    fill: "#5c321e"
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "M51 48h-1v-1h1z",
    fill: "#4f2915"
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47v1h-1v-1z",
    fill: "#381b09"
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v1h-1v-1z",
    fill: "#3d2110"
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48v-1h1v1z",
    fill: "#3e221a"
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48v-1h1v1z",
    fill: "#492516"
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48v-1h1v1z",
    fill: "#94673a"
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "M56 47h1v1h-1z",
    fill: "#a06f38"
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "M58 47v1h-1v-1z",
    fill: "#8c561d"
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "M59 48h-1v-1h1z",
    fill: "#8c561e"
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h1v1h-1z",
    fill: "#9f6d32"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "M61 47v1h-1v-1z",
    fill: "#7b441d"
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "M61 48v-1h1v1z",
    fill: "#6e3310"
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v-1h1v1z",
    fill: "#8f5b27"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48h-1v-1h1z",
    fill: "#c7a471"
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "M65 47v1h-1v-1z",
    fill: "#d2ae6a"
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "M66 48h-1v-1h1z",
    fill: "#805327"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47h1v1h-1z",
    fill: "#4b2314"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h-1v-1h1z",
    fill: "#451f0f"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47h1v1h-1z",
    fill: "#663117"
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48h-1v-1h1z",
    fill: "#974a1d"
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48v-1h1v1z",
    fill: "#a5531a"
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47v1h-1v-1z",
    fill: "#884f2d"
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47h1v1h-1z",
    fill: "#543026"
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47h1v1h-1z",
    fill: "#664237"
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "M75 47v1h-1v-1z",
    fill: "#684535"
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "M75 48v-1h1v1z",
    fill: "#794e3e"
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48v-1h1v1z",
    fill: "#774938"
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47v1h-1v-1z",
    fill: "#59311f"
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47h1v1h-1z",
    fill: "#7f592c"
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47v1h-1v-1z",
    fill: "#d5a756"
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "M81 48h-1v-1h1z",
    fill: "#b47e20"
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "M82 47v1h-1v-1z",
    fill: "#c08a20"
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v1h-1v-1z",
    fill: "#976116"
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "M84 47v1h-1v-1z",
    fill: "#975f28"
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48v-1h1v1z",
    fill: "#a56920"
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "M85 47h1v1h-1z",
    fill: "#8d4d16"
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "M86 48v-1h1v1z",
    fill: "#52250f"
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "M88 48h-1v-1h1z",
    fill: "#805629"
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "M89 48h-1v-1h1z",
    fill: "#8f551a"
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "M90 48h-1v-1h1z",
    fill: "#d7a430"
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47v1h-1v-1z",
    fill: "#efc133"
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h1v1h-1z",
    fill: "#af7a29"
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "M93 47v1h-1v-1z",
    fill: "#9d6b27"
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "M94 47v1h-1v-1z",
    fill: "#e1ba3d"
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v-1h1v1z",
    fill: "#e3bc39"
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47h1v1h-1z",
    fill: "#eac84a"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "M96 48v-1h1v1z",
    fill: "#efcb5e"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47h1v1h-1z",
    fill: "#e4c05c"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48v-1h1v1z",
    fill: "#edc645"
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "M100 48h-1v-1h1z",
    fill: "#ae761f"
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "M101 47v1h-1v-1z",
    fill: "#94613e"
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "M101 48v-1h1v1z",
    fill: "#4c291d"
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "M102 47h1v1h-1z",
    fill: "#4c271b"
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "M103 48v-1h1v1z",
    fill: "#4e2b1e"
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "M104 48v-1h1v1z",
    fill: "#542b14"
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "M106 47v1h-1v-1z",
    fill: "#8f6231"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "M107 48h-1v-1h1z",
    fill: "#b08352"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "M107 47h1v1h-1z",
    fill: "#9a6a39"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "M109 47v1h-1v-1z",
    fill: "#a67834"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "M109 48v-1h1v1z",
    fill: "#d3a743"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "M110 48v-1h1v1z",
    fill: "#ab672f"
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "M112 48h-1v-1h1z",
    fill: "#a65720"
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "M113 47v1h-1v-1z",
    fill: "#c9874a"
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "M114 48h-1v-1h1z",
    fill: "#c48863"
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "M115 48h-1v-1h1z",
    fill: "#a2644b"
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "M116 47v1h-1v-1z",
    fill: "#84401d"
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "M116 47h1v1h-1z",
    fill: "#9d5119"
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "M118 47v1h-1v-1z",
    fill: "#9e5515",
    fillOpacity: 0.988
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "M118 48v-1h1v1z",
    fill: "#ba8b39",
    fillOpacity: 0.973
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "M119 48v-1h1v1z",
    fill: "#d2c06e",
    fillOpacity: 0.769
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "M120 47h1v1h-1z",
    fill: "#c6b988",
    fillOpacity: 0.565
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "M122 47v1h-1v-1z",
    fill: "#9e9e83",
    fillOpacity: 0.114
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "M10 49H9v-1h1z",
    fill: "#d8a870",
    fillOpacity: 0.231
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "M11 49h-1v-1h1z",
    fill: "#be8d4d",
    fillOpacity: 0.686
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "M12 49h-1v-1h1z",
    fill: "#bc913c",
    fillOpacity: 0.812
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "M13 49h-1v-1h1z",
    fill: "#d2a843",
    fillOpacity: 0.984
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "M14 49h-1v-1h1z",
    fill: "#92692b"
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "M15 49h-1v-1h1z",
    fill: "#3a2011"
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "M15 49v-1h1v1z",
    fill: "#3c1b12"
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "M16 49v-1h1v1z",
    fill: "#7f4c30"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "M17 48h1v1h-1z",
    fill: "#a35c26"
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "M18 48h1v1h-1z",
    fill: "#975626"
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "M19 49v-1h1v1z",
    fill: "#55250b"
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "M21 48v1h-1v-1z",
    fill: "#7c4c32"
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "M22 49h-1v-1h1z",
    fill: "#56250f"
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "M23 48v1h-1v-1z",
    fill: "#623119"
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "M24 49h-1v-1h1z",
    fill: "#8c5f41"
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "M25 49h-1v-1h1z",
    fill: "#4b230e"
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48h1v1h-1z",
    fill: "#6c3b23"
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h-1v-1h1z",
    fill: "#4b1d0f"
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "M28 48v1h-1v-1z",
    fill: "#4d1d0d"
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "M29 49h-1v-1h1z",
    fill: "#662508"
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49h-1v-1h1z",
    fill: "#742c08"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "M31 49h-1v-1h1z",
    fill: "#702d0c"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h1v1h-1z",
    fill: "#592308"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v-1h1v1z",
    fill: "#421b09"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "M33 49v-1h1v1z",
    fill: "#27130a"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "M34 48h1v1h-1z",
    fill: "#140a04"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49v-1h1v1z",
    fill: "#150a02"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "M36 48h1v1h-1z",
    fill: "#1f1309"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48v1h-1v-1z",
    fill: "#32261c"
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48h1v1h-1z",
    fill: "#2a1f15"
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h-1v-1h1z",
    fill: "#291d19"
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "M41 49h-1v-1h1z",
    fill: "#4e3a39"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "M42 48v1h-1v-1z",
    fill: "#563d3c"
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h-1v-1h1z",
    fill: "#3d2624"
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "M43 48h1v1h-1z",
    fill: "#342522"
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "M45 48v1h-1v-1z",
    fill: "#2e201d"
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "M45 49v-1h1v1z",
    fill: "#2f2420"
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49h-1v-1h1z",
    fill: "#2c211c"
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v-1h1v1z",
    fill: "#2b1c0f"
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48h1v1h-1z",
    fill: "#341c09"
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49v-1h1v1z",
    fill: "#523014"
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49v-1h1v1z",
    fill: "#684323"
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "M52 48v1h-1v-1z",
    fill: "#5e3d22"
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49h-1v-1h1z",
    fill: "#4d2b19"
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48h1v1h-1z",
    fill: "#4f2c21"
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48h1v1h-1z",
    fill: "#5b321e"
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48h1v1h-1z",
    fill: "#936537"
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "M57 48v1h-1v-1z",
    fill: "#835419"
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49v-1h1v1z",
    fill: "#9e6a2c"
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "M59 49h-1v-1h1z",
    fill: "#814e13"
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "M60 49h-1v-1h1z",
    fill: "#804e1b"
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "M60 48h1v1h-1z",
    fill: "#75401a"
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h-1v-1h1z",
    fill: "#4f1e04"
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49v-1h1v1z",
    fill: "#653e1c"
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "M64 49v-1h1v1z",
    fill: "#a77747"
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v-1h1v1z",
    fill: "#6e3412"
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "M67 48v1h-1v-1z",
    fill: "#8a5a40"
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49h-1v-1h1z",
    fill: "#835435"
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h1v1h-1z",
    fill: "#78401b"
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "M69 48h1v1h-1z",
    fill: "#944e1f"
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49v-1h1v1z",
    fill: "#9e521d"
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49v-1h1v1z",
    fill: "#6b3413"
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "M73 48v1h-1v-1z",
    fill: "#532f1e"
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48v1h-1v-1z",
    fill: "#775141"
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48h1v1h-1z",
    fill: "#734630"
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "M76 49h-1v-1h1z",
    fill: "#4a2514"
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48h1v1h-1z",
    fill: "#381e13"
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h-1v-1h1z",
    fill: "#2b1208"
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49v-1h1v1z",
    fill: "#693d1c"
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "M80 48v1h-1v-1z",
    fill: "#9d6c31"
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49v-1h1v1z",
    fill: "#ae792c"
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49v-1h1v1z",
    fill: "#c18c26"
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "M82 48h1v1h-1z",
    fill: "#d0a136"
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v-1h1v1z",
    fill: "#c49632"
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48h1v1h-1z",
    fill: "#c5922f"
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "M85 48h1v1h-1z",
    fill: "#bb842a"
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "M86 49v-1h1v1z",
    fill: "#754d20"
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "M87 48h1v1h-1z",
    fill: "#a27e48"
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "M88 49v-1h1v1z",
    fill: "#b3863c"
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "M90 48v1h-1v-1z",
    fill: "#95632c"
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "M91 49h-1v-1h1z",
    fill: "#86551f"
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "M92 48v1h-1v-1z",
    fill: "#3f130b"
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "M93 48v1h-1v-1z",
    fill: "#805225"
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v1h-1v-1z",
    fill: "#dfae3b"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "M95 49h-1v-1h1z",
    fill: "#e3b52a"
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "M95 48h1v1h-1z",
    fill: "#e9bc32"
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "M97 48v1h-1v-1z",
    fill: "#c28d3f"
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "M97 49v-1h1v1z",
    fill: "#90581d"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48h1v1h-1z",
    fill: "#bb7d2e"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "M100 48v1h-1v-1z",
    fill: "#833a0d"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "M100 49v-1h1v1z",
    fill: "#8a472b"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "M101 48h1v1h-1z",
    fill: "#744931"
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49h-1v-1h1z",
    fill: "#8a6b42"
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49v-1h1v1z",
    fill: "#5e4629"
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "M105 48v1h-1v-1z",
    fill: "#45281d"
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "M107 48v1h-1v-1z",
    fill: "#342218"
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "M107 48h1v1h-1z",
    fill: "#543b35"
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "M109 49h-1v-1h1z",
    fill: "#765342"
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "M110 48h1v1h-1z",
    fill: "#a9693f"
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "M112 48v1h-1v-1z",
    fill: "#a76237"
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "M112 48h1v1h-1z",
    fill: "#b67955"
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "M114 48v1h-1v-1z",
    fill: "#a66c57"
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "M115 48v1h-1v-1z",
    fill: "#904f3d"
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "M116 49h-1v-1h1z",
    fill: "#87381b"
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "M117 48v1h-1v-1z",
    fill: "#9a3c0c"
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "M117 49v-1h1v1z",
    fill: "#a95410"
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "M119 48v1h-1v-1z",
    fill: "#d7a64b"
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "M120 49h-1v-1h1z",
    fill: "#dcc073",
    fillOpacity: 0.875
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "M120 49v-1h1v1z",
    fill: "#b8a57a",
    fillOpacity: 0.212
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "M10 49v1H9v-1z",
    fill: "#d39e57",
    fillOpacity: 0.765
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "M10 50v-1h1v1z",
    fill: "#e4aa51"
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "M11 49h1v1h-1z",
    fill: "#cb943d"
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "M13 49v1h-1v-1z",
    fill: "#ad712a"
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "M13 49h1v1h-1z",
    fill: "#9a5e2a"
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "M15 50h-1v-1h1z",
    fill: "#9b5622"
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "M16 49v1h-1v-1z",
    fill: "#964f1b"
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "M17 49v1h-1v-1z",
    fill: "#884420"
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "M17 50v-1h1v1z",
    fill: "#8e4928"
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "M19 50h-1v-1h1z",
    fill: "#69341b"
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "M20 50h-1v-1h1z",
    fill: "#412113"
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "M20 50v-1h1v1z",
    fill: "#4f281b"
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "M21 49h1v1h-1z",
    fill: "#6a3723"
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "M23 50h-1v-1h1z",
    fill: "#824824"
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50h-1v-1h1z",
    fill: "#6c3d17"
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50v-1h1v1z",
    fill: "#4e2a0d"
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "M26 49v1h-1v-1z",
    fill: "#724122"
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49v1h-1v-1z",
    fill: "#652c15"
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h1v1h-1z",
    fill: "#642d18"
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "M28 49h1v1h-1z",
    fill: "#6c2b0b"
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49v1h-1v-1z",
    fill: "#752d08"
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49h1v1h-1z",
    fill: "#6b2a09"
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v1h-1v-1z",
    fill: "#5a2509"
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v-1h1v1z",
    fill: "#451d09"
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "M34 49v1h-1v-1z",
    fill: "#2e1308"
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50v-1h1v1z",
    fill: "#27140a"
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49h1v1h-1z",
    fill: "#291910"
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "M37 49v1h-1v-1z",
    fill: "#2d231e"
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v-1h1v1z",
    fill: "#2a2320"
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "M39 49v1h-1v-1z",
    fill: "#1f1713"
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "M40 50h-1v-1h1z",
    fill: "#221816"
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h1v1h-1z",
    fill: "#4c3a34"
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "M42 49v1h-1v-1z",
    fill: "#543d3a"
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "M42 50v-1h1v1z",
    fill: "#3e2a29"
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h1v1h-1z",
    fill: "#42302e"
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "M44 49h1v1h-1z",
    fill: "#302320"
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "M46 49v1h-1v-1z",
    fill: "#342d27"
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v1h-1v-1z",
    fill: "#25211b"
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "M48 49v1h-1v-1z",
    fill: "#1a1410"
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v-1h1v1z",
    fill: "#261908"
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49h1v1h-1z",
    fill: "#4d3214"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49h1v1h-1z",
    fill: "#714a24"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50h-1v-1h1z",
    fill: "#7b512d"
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49v1h-1v-1z",
    fill: "#714730"
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "M53 50v-1h1v1z",
    fill: "#491e0e"
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "M55 49v1h-1v-1z",
    fill: "#582714"
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "M56 49v1h-1v-1z",
    fill: "#925b39"
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v-1h1v1z",
    fill: "#916033"
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49h1v1h-1z",
    fill: "#895a2e"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "M58 49h1v1h-1z",
    fill: "#6c4016"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50v-1h1v1z",
    fill: "#5b3010"
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "M61 49v1h-1v-1z",
    fill: "#653716"
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h-1v-1h1z",
    fill: "#613110"
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "M63 50h-1v-1h1z",
    fill: "#491b10"
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h1v1h-1z",
    fill: "#3f1603"
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v1h-1v-1z",
    fill: "#60290d"
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "M66 49v1h-1v-1z",
    fill: "#571b08"
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "M67 50h-1v-1h1z",
    fill: "#92623d"
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49v1h-1v-1z",
    fill: "#ce9a68"
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50v-1h1v1z",
    fill: "#bf8150"
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "M69 49h1v1h-1z",
    fill: "#9c5627"
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49h1v1h-1z",
    fill: "#864620"
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49h1v1h-1z",
    fill: "#5b3017"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "M73 49v1h-1v-1z",
    fill: "#543420"
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50v-1h1v1z",
    fill: "#582f1a"
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "M74 49h1v1h-1z",
    fill: "#441d0e"
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "M76 50h-1v-1h1z",
    fill: "#1d0b05"
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "M77 49v1h-1v-1z",
    fill: "#0c0502"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50v-1h1v1z",
    fill: "#25150e"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h1v1h-1z",
    fill: "#6a4438"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "M80 50h-1v-1h1z",
    fill: "#815b4a"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49h1v1h-1z",
    fill: "#502611"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49h1v1h-1z",
    fill: "#92642e"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v1h-1v-1z",
    fill: "#d09f4d"
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "M84 50h-1v-1h1z",
    fill: "#d5ae56"
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "M85 49v1h-1v-1z",
    fill: "#a37d3c"
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h-1v-1h1z",
    fill: "#bd944a"
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "M87 49v1h-1v-1z",
    fill: "#976e31"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "M87 50v-1h1v1z",
    fill: "#a07c49"
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "M89 49v1h-1v-1z",
    fill: "#b18848"
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "M89 50v-1h1v1z",
    fill: "#a4793e"
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "M90 49h1v1h-1z",
    fill: "#6c3f18"
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "M92 49v1h-1v-1z",
    fill: "#391207"
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50h-1v-1h1z",
    fill: "#451e14"
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50h-1v-1h1z",
    fill: "#8d5e31"
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50v-1h1v1z",
    fill: "#d1a127"
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "M95 50v-1h1v1z",
    fill: "#d0a12c"
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50v-1h1v1z",
    fill: "#b1804c"
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "M97 50v-1h1v1z",
    fill: "#9e7052"
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "M99 49v1h-1v-1z",
    fill: "#915f4a"
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "M100 50h-1v-1h1z",
    fill: "#895247"
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "M100 50v-1h1v1z",
    fill: "#8e5e59"
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "M102 49v1h-1v-1z",
    fill: "#99776f"
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "M102 49h1v1h-1z",
    fill: "#ac8b6b"
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49h1v1h-1z",
    fill: "#543018"
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "M104 50v-1h1v1z",
    fill: "#602f1b"
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "M106 49v1h-1v-1z",
    fill: "#58321f"
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "M106 50v-1h1v1z",
    fill: "#2d1c16"
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "M108 49v1h-1v-1z",
    fill: "#2d2321"
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "M109 50h-1v-1h1z",
    fill: "#5d4b44"
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "M109 50v-1h1v1z",
    fill: "#6a493d"
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "M110 50v-1h1v1z",
    fill: "#996958"
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "M111 50v-1h1v1z",
    fill: "#a96e5b"
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "M113 50h-1v-1h1z",
    fill: "#a96e53"
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "M113 49h1v1h-1z",
    fill: "#9a5f48"
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "M114 49h1v1h-1z",
    fill: "#9b5b43"
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "M116 49v1h-1v-1z",
    fill: "#ac5f38"
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "M116 50v-1h1v1z",
    fill: "#b0561c"
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "M118 50h-1v-1h1z",
    fill: "#b67118"
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "M119 50h-1v-1h1z",
    fill: "#ceb135"
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "M119 49h1v1h-1z",
    fill: "#c8a734",
    fillOpacity: 0.925
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "M121 49v1h-1v-1z",
    fill: "#c4ac4c",
    fillOpacity: 0.494
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "M122 49v1h-1v-1z",
    fill: "#050",
    fillOpacity: 0.012
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "M7 51v-1h1v1z",
    fill: "#fc9",
    fillOpacity: 0.078
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "M8 50h1v1H8z",
    fill: "#deb073",
    fillOpacity: 0.494
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "M9 50h1v1H9z",
    fill: "#daa04a",
    fillOpacity: 0.976
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "M10 50h1v1h-1z",
    fill: "#d7a44b"
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "M12 50v1h-1v-1z",
    fill: "#9b7f44"
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "M12 51v-1h1v1z",
    fill: "#584124"
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "M14 50v1h-1v-1z",
    fill: "#412318"
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "M15 51h-1v-1h1z",
    fill: "#522110"
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "M16 51h-1v-1h1z",
    fill: "#784423"
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "M17 50v1h-1v-1z",
    fill: "#77472f"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "M17 50h1v1h-1z",
    fill: "#754433"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "M21 51h-1v-1h1z",
    fill: "#3d211a"
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "M22 51h-1v-1h1z",
    fill: "#5e3221"
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "M22 50h1v1h-1z",
    fill: "#633112"
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "M24 51h-1v-1h1z",
    fill: "#7c461c"
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50h1v1h-1z",
    fill: "#814f23"
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "M26 50v1h-1v-1z",
    fill: "#5f3413"
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51h-1v-1h1z",
    fill: "#391507"
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51v-1h1v1z",
    fill: "#39170d"
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "M29 50v1h-1v-1z",
    fill: "#532109"
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51h-1v-1h1z",
    fill: "#67280c"
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51v-1h1v1z",
    fill: "#5d250e"
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v1h-1v-1z",
    fill: "#582a10"
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51h-1v-1h1z",
    fill: "#3b1805"
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50h1v1h-1z",
    fill: "#240f06"
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "M36 51h-1v-1h1z",
    fill: "#24150f"
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v1h-1v-1z",
    fill: "#2c221d"
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50h1v1h-1z",
    fill: "#31292a"
  })), _path2742 || (_path2742 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50h1v1h-1z",
    fill: "#2c2224"
  })), _path2743 || (_path2743 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h-1v-1h1z",
    fill: "#3f2c28"
  })), _path2744 || (_path2744 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50v1h-1v-1z",
    fill: "#2a1a12"
  })), _path2745 || (_path2745 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50h1v1h-1z",
    fill: "#2e1d18"
  })), _path2746 || (_path2746 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50v1h-1v-1z",
    fill: "#402e2c"
  })), _path2747 || (_path2747 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50h1v1h-1z",
    fill: "#3b2e29"
  })), _path2748 || (_path2748 = /*#__PURE__*/React.createElement("path", {
    d: "M44 50h1v1h-1z",
    fill: "#342c27"
  })), _path2749 || (_path2749 = /*#__PURE__*/React.createElement("path", {
    d: "M45 51v-1h1v1z",
    fill: "#25211c"
  })), _path2750 || (_path2750 = /*#__PURE__*/React.createElement("path", {
    d: "M46 50h1v1h-1z",
    fill: "#15110e"
  })), _path2751 || (_path2751 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v1h-1v-1z",
    fill: "#1f1917"
  })), _path2752 || (_path2752 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50v1h-1v-1z",
    fill: "#2e2214"
  })), _path2753 || (_path2753 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50h1v1h-1z",
    fill: "#493015"
  })), _path2754 || (_path2754 = /*#__PURE__*/React.createElement("path", {
    d: "M50 51v-1h1v1z",
    fill: "#5c3916"
  })), _path2755 || (_path2755 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50v1h-1v-1z",
    fill: "#593518"
  })), _path2756 || (_path2756 = /*#__PURE__*/React.createElement("path", {
    d: "M53 51h-1v-1h1z",
    fill: "#391a0b"
  })), _path2757 || (_path2757 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h-1v-1h1z",
    fill: "#431909"
  })), _path2758 || (_path2758 = /*#__PURE__*/React.createElement("path", {
    d: "M54 50h1v1h-1z",
    fill: "#662910"
  })), _path2759 || (_path2759 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v1h-1v-1z",
    fill: "#884121"
  })), _path2760 || (_path2760 = /*#__PURE__*/React.createElement("path", {
    d: "M57 50v1h-1v-1z",
    fill: "#7d4024"
  })), _path2761 || (_path2761 = /*#__PURE__*/React.createElement("path", {
    d: "M58 51h-1v-1h1z",
    fill: "#6a3d26"
  })), _path2762 || (_path2762 = /*#__PURE__*/React.createElement("path", {
    d: "M59 51h-1v-1h1z",
    fill: "#583016"
  })), _path2763 || (_path2763 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50h1v1h-1z",
    fill: "#5e3117"
  })), _path2764 || (_path2764 = /*#__PURE__*/React.createElement("path", {
    d: "M61 51h-1v-1h1z",
    fill: "#51280b"
  })), _path2765 || (_path2765 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50v1h-1v-1z",
    fill: "#50290b"
  })), _path2766 || (_path2766 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h1v1h-1z",
    fill: "#4c2315"
  })), _path2767 || (_path2767 = /*#__PURE__*/React.createElement("path", {
    d: "M64 50v1h-1v-1z",
    fill: "#491a04"
  })), _path2768 || (_path2768 = /*#__PURE__*/React.createElement("path", {
    d: "M64 51v-1h1v1z",
    fill: "#683013"
  })), _path2769 || (_path2769 = /*#__PURE__*/React.createElement("path", {
    d: "M65 50h1v1h-1z",
    fill: "#67341b"
  })), _path2770 || (_path2770 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50h1v1h-1z",
    fill: "#ab8152"
  })), _path2771 || (_path2771 = /*#__PURE__*/React.createElement("path", {
    d: "M67 51v-1h1v1z",
    fill: "#bd844d"
  })), _path2772 || (_path2772 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50h1v1h-1z",
    fill: "#ac6c36"
  })), _path2773 || (_path2773 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51v-1h1v1z",
    fill: "#984d20"
  })), _path2774 || (_path2774 = /*#__PURE__*/React.createElement("path", {
    d: "M71 51h-1v-1h1z",
    fill: "#5d2b11"
  })), _path2775 || (_path2775 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50v1h-1v-1z",
    fill: "#64422e"
  })), _path2776 || (_path2776 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50h1v1h-1z",
    fill: "#80614b"
  })), _path2777 || (_path2777 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50h1v1h-1z",
    fill: "#795039"
  })), _path2778 || (_path2778 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51h-1v-1h1z",
    fill: "#462316"
  })), _path2779 || (_path2779 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51v-1h1v1z",
    fill: "#0d0506"
  })), _path2780 || (_path2780 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h-1v-1h1z",
    fill: "#040507"
  })), _path2781 || (_path2781 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50h1v1h-1z",
    fill: "#2d1d14"
  })), _path2782 || (_path2782 = /*#__PURE__*/React.createElement("path", {
    d: "M79 50v1h-1v-1z",
    fill: "#856855"
  })), _path2783 || (_path2783 = /*#__PURE__*/React.createElement("path", {
    d: "M80 51h-1v-1h1z",
    fill: "#654c40"
  })), _path2784 || (_path2784 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50v1h-1v-1z",
    fill: "#250c03"
  })), _path2785 || (_path2785 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50h1v1h-1z",
    fill: "#634022"
  })), _path2786 || (_path2786 = /*#__PURE__*/React.createElement("path", {
    d: "M82 51v-1h1v1z",
    fill: "#a56b2b"
  })), _path2787 || (_path2787 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v-1h1v1z",
    fill: "#ab7941"
  })), _path2788 || (_path2788 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51v-1h1v1z",
    fill: "#caa27d"
  })), _path2789 || (_path2789 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50v1h-1v-1z",
    fill: "#b18c63"
  })), _path2790 || (_path2790 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h1v1h-1z",
    fill: "#9e6d41"
  })), _path2791 || (_path2791 = /*#__PURE__*/React.createElement("path", {
    d: "M87 50h1v1h-1z",
    fill: "#9d743a"
  })), _path2792 || (_path2792 = /*#__PURE__*/React.createElement("path", {
    d: "M88 51v-1h1v1z",
    fill: "#b89144"
  })), _path2793 || (_path2793 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51h-1v-1h1z",
    fill: "#c7a44b"
  })), _path2794 || (_path2794 = /*#__PURE__*/React.createElement("path", {
    d: "M91 50v1h-1v-1z",
    fill: "#7a4e23"
  })), _path2795 || (_path2795 = /*#__PURE__*/React.createElement("path", {
    d: "M91 50h1v1h-1z",
    fill: "#5a2d26"
  })), _path2796 || (_path2796 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50v1h-1v-1z",
    fill: "#351312"
  })), _path2797 || (_path2797 = /*#__PURE__*/React.createElement("path", {
    d: "M94 51h-1v-1h1z",
    fill: "#56301d"
  })), _path2798 || (_path2798 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51h-1v-1h1z",
    fill: "#a74"
  })), _path2799 || (_path2799 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50v1h-1v-1z",
    fill: "#bb906d"
  })), _path2800 || (_path2800 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50h1v1h-1z",
    fill: "#ad837f"
  })), _path2801 || (_path2801 = /*#__PURE__*/React.createElement("path", {
    d: "M97 50h1v1h-1z",
    fill: "#a27f79"
  })), _path2802 || (_path2802 = /*#__PURE__*/React.createElement("path", {
    d: "M98 51v-1h1v1z",
    fill: "#c8a6a3"
  })), _path2803 || (_path2803 = /*#__PURE__*/React.createElement("path", {
    d: "M100 51h-1v-1h1z",
    fill: "#c2a29d"
  })), _path2804 || (_path2804 = /*#__PURE__*/React.createElement("path", {
    d: "M101 50v1h-1v-1z",
    fill: "#987977"
  })), _path2805 || (_path2805 = /*#__PURE__*/React.createElement("path", {
    d: "M102 51h-1v-1h1z",
    fill: "#7f5f5d"
  })), _path2806 || (_path2806 = /*#__PURE__*/React.createElement("path", {
    d: "M103 50v1h-1v-1z",
    fill: "#6a493c"
  })), _path2807 || (_path2807 = /*#__PURE__*/React.createElement("path", {
    d: "M103 50h1v1h-1z",
    fill: "#572b1d"
  })), _path2808 || (_path2808 = /*#__PURE__*/React.createElement("path", {
    d: "M105 51h-1v-1h1z",
    fill: "#783418"
  })), _path2809 || (_path2809 = /*#__PURE__*/React.createElement("path", {
    d: "M105 51v-1h1v1z",
    fill: "#773c22"
  })), _path2810 || (_path2810 = /*#__PURE__*/React.createElement("path", {
    d: "M107 51h-1v-1h1z",
    fill: "#27130d"
  })), _path2811 || (_path2811 = /*#__PURE__*/React.createElement("path", {
    d: "M108 51h-1v-1h1z",
    fill: "#281e1c"
  })), _path2812 || (_path2812 = /*#__PURE__*/React.createElement("path", {
    d: "M109 50v1h-1v-1z",
    fill: "#4e3b34"
  })), _path2813 || (_path2813 = /*#__PURE__*/React.createElement("path", {
    d: "M110 51h-1v-1h1z",
    fill: "#382618"
  })), _path2814 || (_path2814 = /*#__PURE__*/React.createElement("path", {
    d: "M111 51h-1v-1h1z",
    fill: "#937861"
  })), _path2815 || (_path2815 = /*#__PURE__*/React.createElement("path", {
    d: "M111 50h1v1h-1z",
    fill: "#cd9a89"
  })), _path2816 || (_path2816 = /*#__PURE__*/React.createElement("path", {
    d: "M112 51v-1h1v1z",
    fill: "#cb8a5c"
  })), _path2817 || (_path2817 = /*#__PURE__*/React.createElement("path", {
    d: "M114 50v1h-1v-1z",
    fill: "#b97b51"
  })), _path2818 || (_path2818 = /*#__PURE__*/React.createElement("path", {
    d: "M114 50h1v1h-1z",
    fill: "#af6841"
  })), _path2819 || (_path2819 = /*#__PURE__*/React.createElement("path", {
    d: "M115 51v-1h1v1z",
    fill: "#a55524"
  })), _path2820 || (_path2820 = /*#__PURE__*/React.createElement("path", {
    d: "M117 51h-1v-1h1z",
    fill: "#a14f14"
  })), _path2821 || (_path2821 = /*#__PURE__*/React.createElement("path", {
    d: "M117 51v-1h1v1z",
    fill: "#c38133"
  })), _path2822 || (_path2822 = /*#__PURE__*/React.createElement("path", {
    d: "M119 50v1h-1v-1z",
    fill: "#dbb447"
  })), _path2823 || (_path2823 = /*#__PURE__*/React.createElement("path", {
    d: "M119 50h1v1h-1z",
    fill: "#e2bf4e"
  })), _path2824 || (_path2824 = /*#__PURE__*/React.createElement("path", {
    d: "M121 51h-1v-1h1z",
    fill: "#dbc15c"
  })), _path2825 || (_path2825 = /*#__PURE__*/React.createElement("path", {
    d: "M122 50v1h-1v-1z",
    fill: "#c7b772",
    fillOpacity: 0.631
  })), _path2826 || (_path2826 = /*#__PURE__*/React.createElement("path", {
    d: "M122 51v-1h1v1z",
    fill: "#aaa27b",
    fillOpacity: 0.129
  })), _path2827 || (_path2827 = /*#__PURE__*/React.createElement("path", {
    d: "M124 51h-1v-1h1z",
    fill: "#75624e",
    fillOpacity: 0.051
  })), _path2828 || (_path2828 = /*#__PURE__*/React.createElement("path", {
    d: "M125 50v1h-1v-1z",
    fill: "#948b6a",
    fillOpacity: 0.122
  })), _path2829 || (_path2829 = /*#__PURE__*/React.createElement("path", {
    d: "M125 51v-1h1v1z",
    fill: "#858563",
    fillOpacity: 0.09
  })), _path2830 || (_path2830 = /*#__PURE__*/React.createElement("path", {
    d: "M127 50v1h-1v-1z",
    fill: "#8b8b5c",
    fillOpacity: 0.043
  })), _path2831 || (_path2831 = /*#__PURE__*/React.createElement("path", {
    d: "M6 51h1v1H6z",
    fill: "#7f3f3f",
    fillOpacity: 0.016
  })), _path2832 || (_path2832 = /*#__PURE__*/React.createElement("path", {
    d: "M7 51h1v1H7z",
    fill: "#b88742",
    fillOpacity: 0.663
  })), _path2833 || (_path2833 = /*#__PURE__*/React.createElement("path", {
    d: "M9 51v1H8v-1z",
    fill: "#e8bb6e"
  })), _path2834 || (_path2834 = /*#__PURE__*/React.createElement("path", {
    d: "M10 51v1H9v-1z",
    fill: "#eab664"
  })), _path2835 || (_path2835 = /*#__PURE__*/React.createElement("path", {
    d: "M11 51v1h-1v-1z",
    fill: "#ac793e"
  })), _path2836 || (_path2836 = /*#__PURE__*/React.createElement("path", {
    d: "M12 52h-1v-1h1z",
    fill: "#4e2c1a"
  })), _path2837 || (_path2837 = /*#__PURE__*/React.createElement("path", {
    d: "M13 51v1h-1v-1z",
    fill: "#4e3027"
  })), _path2838 || (_path2838 = /*#__PURE__*/React.createElement("path", {
    d: "M14 51h1v1h-1z",
    fill: "#2f190e"
  })), _path2839 || (_path2839 = /*#__PURE__*/React.createElement("path", {
    d: "M17 52h-1v-1h1z",
    fill: "#3d1c0e"
  })), _path2840 || (_path2840 = /*#__PURE__*/React.createElement("path", {
    d: "M18 51v1h-1v-1z",
    fill: "#442212"
  })), _path2841 || (_path2841 = /*#__PURE__*/React.createElement("path", {
    d: "M19 52h-1v-1h1z",
    fill: "#3e2215"
  })), _path2842 || (_path2842 = /*#__PURE__*/React.createElement("path", {
    d: "M20 51v1h-1v-1z",
    fill: "#2f1c0f"
  })), _path2843 || (_path2843 = /*#__PURE__*/React.createElement("path", {
    d: "M21 51v1h-1v-1z",
    fill: "#321d17"
  })), _path2844 || (_path2844 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52v-1h1v1z",
    fill: "#442619"
  })), _path2845 || (_path2845 = /*#__PURE__*/React.createElement("path", {
    d: "M23 51v1h-1v-1z",
    fill: "#472511"
  })), _path2846 || (_path2846 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h-1v-1h1z",
    fill: "#40200f"
  })), _path2847 || (_path2847 = /*#__PURE__*/React.createElement("path", {
    d: "M24 51h1v1h-1z",
    fill: "#4d2c17"
  })), _path2848 || (_path2848 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52h-1v-1h1z",
    fill: "#4d2b18"
  })), _path2849 || (_path2849 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51v1h-1v-1z",
    fill: "#311309"
  })), _path2850 || (_path2850 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52h-1v-1h1z",
    fill: "#37160c"
  })), _path2851 || (_path2851 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52v-1h1v1z",
    fill: "#4e1f07"
  })), _path2852 || (_path2852 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v-1h1v1z",
    fill: "#5b210b"
  })), _path2853 || (_path2853 = /*#__PURE__*/React.createElement("path", {
    d: "M30 52v-1h1v1z",
    fill: "#4c1b06"
  })), _path2854 || (_path2854 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h-1v-1h1z",
    fill: "#401903"
  })), _path2855 || (_path2855 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51v1h-1v-1z",
    fill: "#2f1001"
  })), _path2856 || (_path2856 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52h-1v-1h1z",
    fill: "#271207"
  })), _path2857 || (_path2857 = /*#__PURE__*/React.createElement("path", {
    d: "M35 51h1v1h-1z",
    fill: "#150502"
  })), _path2858 || (_path2858 = /*#__PURE__*/React.createElement("path", {
    d: "M37 52h-1v-1h1z",
    fill: "#2b1613"
  })), _path2859 || (_path2859 = /*#__PURE__*/React.createElement("path", {
    d: "M38 51v1h-1v-1z",
    fill: "#534124"
  })), _path2860 || (_path2860 = /*#__PURE__*/React.createElement("path", {
    d: "M39 51v1h-1v-1z",
    fill: "#3d2a23"
  })), _path2861 || (_path2861 = /*#__PURE__*/React.createElement("path", {
    d: "M39 52v-1h1v1z",
    fill: "#3e2922"
  })), _path2862 || (_path2862 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h1v1h-1z",
    fill: "#1f1408"
  })), _path2863 || (_path2863 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52h-1v-1h1z",
    fill: "#2a1d12"
  })), _path2864 || (_path2864 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52v-1h1v1z",
    fill: "#3b2720"
  })), _path2865 || (_path2865 = /*#__PURE__*/React.createElement("path", {
    d: "M44 51v1h-1v-1z",
    fill: "#2e211a"
  })), _path2866 || (_path2866 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52v-1h1v1z",
    fill: "#2b261f"
  })), _path2867 || (_path2867 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52h-1v-1h1z",
    fill: "#161511"
  })), _path2868 || (_path2868 = /*#__PURE__*/React.createElement("path", {
    d: "M47 51v1h-1v-1z",
    fill: "#16110f"
  })), _path2869 || (_path2869 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h-1v-1h1z",
    fill: "#322b23"
  })), _path2870 || (_path2870 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h-1v-1h1z",
    fill: "#3f352a"
  })), _path2871 || (_path2871 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52v-1h1v1z",
    fill: "#231609"
  })), _path2872 || (_path2872 = /*#__PURE__*/React.createElement("path", {
    d: "M51 51v1h-1v-1z",
    fill: "#3f2b1d"
  })), _path2873 || (_path2873 = /*#__PURE__*/React.createElement("path", {
    d: "M52 52h-1v-1h1z",
    fill: "#573528"
  })), _path2874 || (_path2874 = /*#__PURE__*/React.createElement("path", {
    d: "M52 51h1v1h-1z",
    fill: "#4c1c09"
  })), _path2875 || (_path2875 = /*#__PURE__*/React.createElement("path", {
    d: "M54 52h-1v-1h1z",
    fill: "#783111"
  })), _path2876 || (_path2876 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h1v1h-1z",
    fill: "#8a3b16"
  })), _path2877 || (_path2877 = /*#__PURE__*/React.createElement("path", {
    d: "M56 52h-1v-1h1z",
    fill: "#8a3e1a"
  })), _path2878 || (_path2878 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h-1v-1h1z",
    fill: "#803616"
  })), _path2879 || (_path2879 = /*#__PURE__*/React.createElement("path", {
    d: "M57 51h1v1h-1z",
    fill: "#502011"
  })), _path2880 || (_path2880 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52v-1h1v1z",
    fill: "#3d180d"
  })), _path2881 || (_path2881 = /*#__PURE__*/React.createElement("path", {
    d: "M60 51v1h-1v-1z",
    fill: "#582b1d"
  })), _path2882 || (_path2882 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v-1h1v1z",
    fill: "#3e1d0f"
  })), _path2883 || (_path2883 = /*#__PURE__*/React.createElement("path", {
    d: "M62 52h-1v-1h1z",
    fill: "#2d1206"
  })), _path2884 || (_path2884 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51v1h-1v-1z",
    fill: "#2d1005"
  })), _path2885 || (_path2885 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51h1v1h-1z",
    fill: "#52270f"
  })), _path2886 || (_path2886 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51v1h-1v-1z",
    fill: "#5f2f15"
  })), _path2887 || (_path2887 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51h1v1h-1z",
    fill: "#603b21"
  })), _path2888 || (_path2888 = /*#__PURE__*/React.createElement("path", {
    d: "M68 51v1h-1v-1z",
    fill: "#a76432"
  })), _path2889 || (_path2889 = /*#__PURE__*/React.createElement("path", {
    d: "M68 52v-1h1v1z",
    fill: "#9a5b1f"
  })), _path2890 || (_path2890 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51h1v1h-1z",
    fill: "#92471f"
  })), _path2891 || (_path2891 = /*#__PURE__*/React.createElement("path", {
    d: "M70 51h1v1h-1z",
    fill: "#4b1e08"
  })), _path2892 || (_path2892 = /*#__PURE__*/React.createElement("path", {
    d: "M71 52v-1h1v1z",
    fill: "#6a4530"
  })), _path2893 || (_path2893 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h-1v-1h1z",
    fill: "#865f4b"
  })), _path2894 || (_path2894 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52v-1h1v1z",
    fill: "#4e2311"
  })), _path2895 || (_path2895 = /*#__PURE__*/React.createElement("path", {
    d: "M75 52h-1v-1h1z",
    fill: "#623926"
  })), _path2896 || (_path2896 = /*#__PURE__*/React.createElement("path", {
    d: "M76 52h-1v-1h1z",
    fill: "#170807"
  })), _path2897 || (_path2897 = /*#__PURE__*/React.createElement("path", {
    d: "M76 51h1v1h-1z",
    fill: "#060508"
  })), _path2898 || (_path2898 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h1v1h-1z",
    fill: "#20130d"
  })), _path2899 || (_path2899 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52v-1h1v1z",
    fill: "#392620"
  })), _path2900 || (_path2900 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52h-1v-1h1z",
    fill: "#3e312d"
  })), _path2901 || (_path2901 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52v-1h1v1z",
    fill: "#180b04"
  })), _path2902 || (_path2902 = /*#__PURE__*/React.createElement("path", {
    d: "M82 52h-1v-1h1z",
    fill: "#2b1303"
  })), _path2903 || (_path2903 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v1h-1v-1z",
    fill: "#78491c"
  })), _path2904 || (_path2904 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51h1v1h-1z",
    fill: "#643c21"
  })), _path2905 || (_path2905 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51h1v1h-1z",
    fill: "#583424"
  })), _path2906 || (_path2906 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52v-1h1v1z",
    fill: "#552d1a"
  })), _path2907 || (_path2907 = /*#__PURE__*/React.createElement("path", {
    d: "M86 51h1v1h-1z",
    fill: "#6c4225"
  })), _path2908 || (_path2908 = /*#__PURE__*/React.createElement("path", {
    d: "M88 52h-1v-1h1z",
    fill: "#896030"
  })), _path2909 || (_path2909 = /*#__PURE__*/React.createElement("path", {
    d: "M88 51h1v1h-1z",
    fill: "#b28b48"
  })), _path2910 || (_path2910 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51v1h-1v-1z",
    fill: "#c29c51"
  })), _path2911 || (_path2911 = /*#__PURE__*/React.createElement("path", {
    d: "M90 52v-1h1v1z",
    fill: "#664021"
  })), _path2912 || (_path2912 = /*#__PURE__*/React.createElement("path", {
    d: "M92 51v1h-1v-1z",
    fill: "#4d2b28"
  })), _path2913 || (_path2913 = /*#__PURE__*/React.createElement("path", {
    d: "M92 52v-1h1v1z",
    fill: "#43201d"
  })), _path2914 || (_path2914 = /*#__PURE__*/React.createElement("path", {
    d: "M94 52h-1v-1h1z",
    fill: "#663719"
  })), _path2915 || (_path2915 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51v1h-1v-1z",
    fill: "#875133"
  })), _path2916 || (_path2916 = /*#__PURE__*/React.createElement("path", {
    d: "M96 52h-1v-1h1z",
    fill: "#7d5751"
  })), _path2917 || (_path2917 = /*#__PURE__*/React.createElement("path", {
    d: "M97 52h-1v-1h1z",
    fill: "#8a6a69"
  })), _path2918 || (_path2918 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52h-1v-1h1z",
    fill: "#91756d"
  })), _path2919 || (_path2919 = /*#__PURE__*/React.createElement("path", {
    d: "M98 51h1v1h-1z",
    fill: "#927670"
  })), _path2920 || (_path2920 = /*#__PURE__*/React.createElement("path", {
    d: "M100 51v1h-1v-1z",
    fill: "#6f5752"
  })), _path2921 || (_path2921 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52h-1v-1h1z",
    fill: "#60453e"
  })), _path2922 || (_path2922 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52v-1h1v1z",
    fill: "#513127"
  })), _path2923 || (_path2923 = /*#__PURE__*/React.createElement("path", {
    d: "M102 51h1v1h-1z",
    fill: "#41271f"
  })), _path2924 || (_path2924 = /*#__PURE__*/React.createElement("path", {
    d: "M103 52v-1h1v1z",
    fill: "#5e382c"
  })), _path2925 || (_path2925 = /*#__PURE__*/React.createElement("path", {
    d: "M105 52h-1v-1h1z",
    fill: "#7a351a"
  })), _path2926 || (_path2926 = /*#__PURE__*/React.createElement("path", {
    d: "M105 51h1v1h-1z",
    fill: "#924221"
  })), _path2927 || (_path2927 = /*#__PURE__*/React.createElement("path", {
    d: "M107 51v1h-1v-1z",
    fill: "#744e39"
  })), _path2928 || (_path2928 = /*#__PURE__*/React.createElement("path", {
    d: "M107 52v-1h1v1z",
    fill: "#46352d"
  })), _path2929 || (_path2929 = /*#__PURE__*/React.createElement("path", {
    d: "M109 52h-1v-1h1z",
    fill: "#4e3c2e"
  })), _path2930 || (_path2930 = /*#__PURE__*/React.createElement("path", {
    d: "M110 52h-1v-1h1z",
    fill: "#9d885b"
  })), _path2931 || (_path2931 = /*#__PURE__*/React.createElement("path", {
    d: "M111 52h-1v-1h1z",
    fill: "#644d2a"
  })), _path2932 || (_path2932 = /*#__PURE__*/React.createElement("path", {
    d: "M112 51v1h-1v-1z",
    fill: "#7b5840"
  })), _path2933 || (_path2933 = /*#__PURE__*/React.createElement("path", {
    d: "M113 52h-1v-1h1z",
    fill: "#824a24"
  })), _path2934 || (_path2934 = /*#__PURE__*/React.createElement("path", {
    d: "M113 51h1v1h-1z",
    fill: "#9d612f"
  })), _path2935 || (_path2935 = /*#__PURE__*/React.createElement("path", {
    d: "M114 51h1v1h-1z",
    fill: "#b5713f"
  })), _path2936 || (_path2936 = /*#__PURE__*/React.createElement("path", {
    d: "M115 51h1v1h-1z",
    fill: "#a25218"
  })), _path2937 || (_path2937 = /*#__PURE__*/React.createElement("path", {
    d: "M116 52v-1h1v1z",
    fill: "#ae570f"
  })), _path2938 || (_path2938 = /*#__PURE__*/React.createElement("path", {
    d: "M117 51h1v1h-1z",
    fill: "#b46011"
  })), _path2939 || (_path2939 = /*#__PURE__*/React.createElement("path", {
    d: "M119 51v1h-1v-1z",
    fill: "#a77020",
    fillOpacity: 0.835
  })), _path2940 || (_path2940 = /*#__PURE__*/React.createElement("path", {
    d: "M119 51h1v1h-1z",
    fill: "#d3c078",
    fillOpacity: 0.482
  })), _path2941 || (_path2941 = /*#__PURE__*/React.createElement("path", {
    d: "M121 52h-1v-1h1z",
    fill: "#dbc682",
    fillOpacity: 0.392
  })), _path2942 || (_path2942 = /*#__PURE__*/React.createElement("path", {
    d: "M121 52v-1h1v1z",
    fill: "#c4b378",
    fillOpacity: 0.29
  })), _path2943 || (_path2943 = /*#__PURE__*/React.createElement("path", {
    d: "M123 51v1h-1v-1z",
    fill: "#a59f79",
    fillOpacity: 0.157
  })), _path2944 || (_path2944 = /*#__PURE__*/React.createElement("path", {
    d: "M123 52v-1h1v1z",
    fill: "#7f7f5a",
    fillOpacity: 0.133
  })), _path2945 || (_path2945 = /*#__PURE__*/React.createElement("path", {
    d: "M124 52v-1h1v1z",
    fill: "#86865c",
    fillOpacity: 0.141
  })), _path2946 || (_path2946 = /*#__PURE__*/React.createElement("path", {
    d: "M126 52h-1v-1h1z",
    fill: "#798555",
    fillOpacity: 0.082
  })), _path2947 || (_path2947 = /*#__PURE__*/React.createElement("path", {
    d: "M127 51v1h-1v-1z",
    fill: "#6d6d6d",
    fillOpacity: 0.027
  })), _path2948 || (_path2948 = /*#__PURE__*/React.createElement("path", {
    d: "M7 52v1H6v-1z",
    fill: "#5f1f00",
    fillOpacity: 0.031
  })), _path2949 || (_path2949 = /*#__PURE__*/React.createElement("path", {
    d: "M8 52v1H7v-1z",
    fill: "#a2722e",
    fillOpacity: 0.761
  })), _path2950 || (_path2950 = /*#__PURE__*/React.createElement("path", {
    d: "M8 52h1v1H8z",
    fill: "#dcad5c"
  })), _path2951 || (_path2951 = /*#__PURE__*/React.createElement("path", {
    d: "M9 52h1v1H9z",
    fill: "#c08b3d"
  })), _path2952 || (_path2952 = /*#__PURE__*/React.createElement("path", {
    d: "M10 52h1v1h-1z",
    fill: "#be7e2f"
  })), _path2953 || (_path2953 = /*#__PURE__*/React.createElement("path", {
    d: "M12 53h-1v-1h1z",
    fill: "#9f6d36"
  })), _path2954 || (_path2954 = /*#__PURE__*/React.createElement("path", {
    d: "M12 53v-1h1v1z",
    fill: "#3c1f13"
  })), _path2955 || (_path2955 = /*#__PURE__*/React.createElement("path", {
    d: "M14 53h-1v-1h1z",
    fill: "#482a24"
  })), _path2956 || (_path2956 = /*#__PURE__*/React.createElement("path", {
    d: "M15 53h-1v-1h1z",
    fill: "#4e2d1a"
  })), _path2957 || (_path2957 = /*#__PURE__*/React.createElement("path", {
    d: "M15 53v-1h1v1z",
    fill: "#401f11"
  })), _path2958 || (_path2958 = /*#__PURE__*/React.createElement("path", {
    d: "M16 52h1v1h-1z",
    fill: "#2a120c"
  })), _path2959 || (_path2959 = /*#__PURE__*/React.createElement("path", {
    d: "M17 53v-1h1v1z",
    fill: "#321c15"
  })), _path2960 || (_path2960 = /*#__PURE__*/React.createElement("path", {
    d: "M19 52v1h-1v-1z",
    fill: "#331e17"
  })), _path2961 || (_path2961 = /*#__PURE__*/React.createElement("path", {
    d: "M19 53v-1h1v1z",
    fill: "#301b11"
  })), _path2962 || (_path2962 = /*#__PURE__*/React.createElement("path", {
    d: "M20 52h1v1h-1z",
    fill: "#361d10"
  })), _path2963 || (_path2963 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52h1v1h-1z",
    fill: "#412316"
  })), _path2964 || (_path2964 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52v1h-1v-1z",
    fill: "#341907"
  })), _path2965 || (_path2965 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h1v1h-1z",
    fill: "#3a1b0a"
  })), _path2966 || (_path2966 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52v1h-1v-1z",
    fill: "#4c2e1f"
  })), _path2967 || (_path2967 = /*#__PURE__*/React.createElement("path", {
    d: "M27 53h-1v-1h1z",
    fill: "#270e08",
    fillOpacity: 0.831
  })), _path2968 || (_path2968 = /*#__PURE__*/React.createElement("path", {
    d: "M27 52h1v1h-1z",
    fill: "#341408",
    fillOpacity: 0.949
  })), _path2969 || (_path2969 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v1h-1v-1z",
    fill: "#452009"
  })), _path2970 || (_path2970 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52h1v1h-1z",
    fill: "#3a1607"
  })), _path2971 || (_path2971 = /*#__PURE__*/React.createElement("path", {
    d: "M31 52v1h-1v-1z",
    fill: "#391906"
  })), _path2972 || (_path2972 = /*#__PURE__*/React.createElement("path", {
    d: "M32 53h-1v-1h1z",
    fill: "#381a03"
  })), _path2973 || (_path2973 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h1v1h-1z",
    fill: "#331405"
  })), _path2974 || (_path2974 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52v1h-1v-1z",
    fill: "#2d0f05"
  })), _path2975 || (_path2975 = /*#__PURE__*/React.createElement("path", {
    d: "M35 53h-1v-1h1z",
    fill: "#2e1407"
  })), _path2976 || (_path2976 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h-1v-1h1z",
    fill: "#271007"
  })), _path2977 || (_path2977 = /*#__PURE__*/React.createElement("path", {
    d: "M36 52h1v1h-1z",
    fill: "#502819"
  })), _path2978 || (_path2978 = /*#__PURE__*/React.createElement("path", {
    d: "M38 52v1h-1v-1z",
    fill: "#9d7629"
  })), _path2979 || (_path2979 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v-1h1v1z",
    fill: "#573517"
  })), _path2980 || (_path2980 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53h-1v-1h1z",
    fill: "#341b12"
  })), _path2981 || (_path2981 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h-1v-1h1z",
    fill: "#49332a"
  })), _path2982 || (_path2982 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h-1v-1h1z",
    fill: "#604640"
  })), _path2983 || (_path2983 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53v-1h1v1z",
    fill: "#6e4f4c"
  })), _path2984 || (_path2984 = /*#__PURE__*/React.createElement("path", {
    d: "M43 52h1v1h-1z",
    fill: "#3b2822"
  })), _path2985 || (_path2985 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52h1v1h-1z",
    fill: "#211812"
  })), _path2986 || (_path2986 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52v1h-1v-1z",
    fill: "#12100d"
  })), _path2987 || (_path2987 = /*#__PURE__*/React.createElement("path", {
    d: "M46 53v-1h1v1z",
    fill: "#15120f"
  })), _path2988 || (_path2988 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52v1h-1v-1z",
    fill: "#211c13"
  })), _path2989 || (_path2989 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h1v1h-1z",
    fill: "#1b160f"
  })), _path2990 || (_path2990 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h1v1h-1z",
    fill: "#100c09"
  })), _path2991 || (_path2991 = /*#__PURE__*/React.createElement("path", {
    d: "M50 52h1v1h-1z",
    fill: "#251714"
  })), _path2992 || (_path2992 = /*#__PURE__*/React.createElement("path", {
    d: "M51 52h1v1h-1z",
    fill: "#764437"
  })), _path2993 || (_path2993 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52v1h-1v-1z",
    fill: "#883d21"
  })), _path2994 || (_path2994 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52h1v1h-1z",
    fill: "#843617"
  })), _path2995 || (_path2995 = /*#__PURE__*/React.createElement("path", {
    d: "M55 52v1h-1v-1z",
    fill: "#65260f"
  })), _path2996 || (_path2996 = /*#__PURE__*/React.createElement("path", {
    d: "M55 53v-1h1v1z",
    fill: "#77391c"
  })), _path2997 || (_path2997 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53h-1v-1h1z",
    fill: "#7a300e"
  })), _path2998 || (_path2998 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h1v1h-1z",
    fill: "#612814"
  })), _path2999 || (_path2999 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52h1v1h-1z",
    fill: "#3e160c"
  })), _path3000 || (_path3000 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v1h-1v-1z",
    fill: "#4d251a"
  })), _path3001 || (_path3001 = /*#__PURE__*/React.createElement("path", {
    d: "M61 53h-1v-1h1z",
    fill: "#5c4435"
  })), _path3002 || (_path3002 = /*#__PURE__*/React.createElement("path", {
    d: "M61 52h1v1h-1z",
    fill: "#675849"
  })), _path3003 || (_path3003 = /*#__PURE__*/React.createElement("path", {
    d: "M63 53h-1v-1h1z",
    fill: "#654b3b"
  })), _path3004 || (_path3004 = /*#__PURE__*/React.createElement("path", {
    d: "M63 52h1v1h-1z",
    fill: "#7a5032"
  })), _path3005 || (_path3005 = /*#__PURE__*/React.createElement("path", {
    d: "M65 52v1h-1v-1z",
    fill: "#52260c"
  })), _path3006 || (_path3006 = /*#__PURE__*/React.createElement("path", {
    d: "M66 53h-1v-1h1z",
    fill: "#4b2310"
  })), _path3007 || (_path3007 = /*#__PURE__*/React.createElement("path", {
    d: "M66 52h1v1h-1z",
    fill: "#59230f"
  })), _path3008 || (_path3008 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v-1h1v1z",
    fill: "#9b5b2c"
  })), _path3009 || (_path3009 = /*#__PURE__*/React.createElement("path", {
    d: "M69 52v1h-1v-1z",
    fill: "#ad6c32"
  })), _path3010 || (_path3010 = /*#__PURE__*/React.createElement("path", {
    d: "M70 52v1h-1v-1z",
    fill: "#733316"
  })), _path3011 || (_path3011 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v-1h1v1z",
    fill: "#411e0e"
  })), _path3012 || (_path3012 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h-1v-1h1z",
    fill: "#5e3827"
  })), _path3013 || (_path3013 = /*#__PURE__*/React.createElement("path", {
    d: "M72 52h1v1h-1z",
    fill: "#926656"
  })), _path3014 || (_path3014 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h1v1h-1z",
    fill: "#603122"
  })), _path3015 || (_path3015 = /*#__PURE__*/React.createElement("path", {
    d: "M75 53v-1h1v1z",
    fill: "#311d18"
  })), _path3016 || (_path3016 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v-1h1v1z",
    fill: "#030001"
  })), _path3017 || (_path3017 = /*#__PURE__*/React.createElement("path", {
    d: "M77 52h1v1h-1z",
    fill: "#231b1a"
  })), _path3018 || (_path3018 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52h1v1h-1z",
    fill: "#0c0807"
  })), _path3019 || (_path3019 = /*#__PURE__*/React.createElement("path", {
    d: "M79 53v-1h1v1z",
    fill: "#0d0c0c"
  })), _path3020 || (_path3020 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h-1v-1h1z",
    fill: "#19110d"
  })), _path3021 || (_path3021 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53v-1h1v1z",
    fill: "#432415"
  })), _path3022 || (_path3022 = /*#__PURE__*/React.createElement("path", {
    d: "M83 52h1v1h-1z",
    fill: "#2c1406"
  })), _path3023 || (_path3023 = /*#__PURE__*/React.createElement("path", {
    d: "M84 53v-1h1v1z",
    fill: "#310f04"
  })), _path3024 || (_path3024 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52h1v1h-1z",
    fill: "#5a2e22"
  })), _path3025 || (_path3025 = /*#__PURE__*/React.createElement("path", {
    d: "M87 52v1h-1v-1z",
    fill: "#513529"
  })), _path3026 || (_path3026 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h-1v-1h1z",
    fill: "#8e6c62"
  })), _path3027 || (_path3027 = /*#__PURE__*/React.createElement("path", {
    d: "M89 52v1h-1v-1z",
    fill: "#967153"
  })), _path3028 || (_path3028 = /*#__PURE__*/React.createElement("path", {
    d: "M90 53h-1v-1h1z",
    fill: "#9c753c"
  })), _path3029 || (_path3029 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52v1h-1v-1z",
    fill: "#704b29"
  })), _path3030 || (_path3030 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52h1v1h-1z",
    fill: "#3f2310"
  })), _path3031 || (_path3031 = /*#__PURE__*/React.createElement("path", {
    d: "M92 53v-1h1v1z",
    fill: "#764b2c"
  })), _path3032 || (_path3032 = /*#__PURE__*/React.createElement("path", {
    d: "M94 52v1h-1v-1z",
    fill: "#a56b3b"
  })), _path3033 || (_path3033 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53h-1v-1h1z",
    fill: "#79452b"
  })), _path3034 || (_path3034 = /*#__PURE__*/React.createElement("path", {
    d: "M95 52h1v1h-1z",
    fill: "#795349"
  })), _path3035 || (_path3035 = /*#__PURE__*/React.createElement("path", {
    d: "M96 53v-1h1v1z",
    fill: "#8e7470"
  })), _path3036 || (_path3036 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52v1h-1v-1z",
    fill: "#987f79"
  })), _path3037 || (_path3037 = /*#__PURE__*/React.createElement("path", {
    d: "M99 52v1h-1v-1z",
    fill: "#83635e"
  })), _path3038 || (_path3038 = /*#__PURE__*/React.createElement("path", {
    d: "M100 53h-1v-1h1z",
    fill: "#50342f"
  })), _path3039 || (_path3039 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52v1h-1v-1z",
    fill: "#3a1b11"
  })), _path3040 || (_path3040 = /*#__PURE__*/React.createElement("path", {
    d: "M102 53h-1v-1h1z",
    fill: "#563429"
  })), _path3041 || (_path3041 = /*#__PURE__*/React.createElement("path", {
    d: "M102 52h1v1h-1z",
    fill: "#4a3026"
  })), _path3042 || (_path3042 = /*#__PURE__*/React.createElement("path", {
    d: "M103 53v-1h1v1z",
    fill: "#522e21"
  })), _path3043 || (_path3043 = /*#__PURE__*/React.createElement("path", {
    d: "M105 53h-1v-1h1z",
    fill: "#834127"
  })), _path3044 || (_path3044 = /*#__PURE__*/React.createElement("path", {
    d: "M106 52v1h-1v-1z",
    fill: "#8c3a13"
  })), _path3045 || (_path3045 = /*#__PURE__*/React.createElement("path", {
    d: "M106 53v-1h1v1z",
    fill: "#c78c5f"
  })), _path3046 || (_path3046 = /*#__PURE__*/React.createElement("path", {
    d: "M108 53h-1v-1h1z",
    fill: "#af9263"
  })), _path3047 || (_path3047 = /*#__PURE__*/React.createElement("path", {
    d: "M109 52v1h-1v-1z",
    fill: "#c0a563"
  })), _path3048 || (_path3048 = /*#__PURE__*/React.createElement("path", {
    d: "M109 53v-1h1v1z",
    fill: "#e9c081"
  })), _path3049 || (_path3049 = /*#__PURE__*/React.createElement("path", {
    d: "M110 53v-1h1v1z",
    fill: "#a78350"
  })), _path3050 || (_path3050 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53h-1v-1h1z",
    fill: "#50260e"
  })), _path3051 || (_path3051 = /*#__PURE__*/React.createElement("path", {
    d: "M112 52h1v1h-1z",
    fill: "#7c3d18"
  })), _path3052 || (_path3052 = /*#__PURE__*/React.createElement("path", {
    d: "M113 52h1v1h-1z",
    fill: "#7f3405"
  })), _path3053 || (_path3053 = /*#__PURE__*/React.createElement("path", {
    d: "M114 52h1v1h-1z",
    fill: "#72330e"
  })), _path3054 || (_path3054 = /*#__PURE__*/React.createElement("path", {
    d: "M116 52v1h-1v-1z",
    fill: "#6b3111"
  })), _path3055 || (_path3055 = /*#__PURE__*/React.createElement("path", {
    d: "M117 53h-1v-1h1z",
    fill: "#78370f"
  })), _path3056 || (_path3056 = /*#__PURE__*/React.createElement("path", {
    d: "M118 52v1h-1v-1z",
    fill: "#ab7336"
  })), _path3057 || (_path3057 = /*#__PURE__*/React.createElement("path", {
    d: "M119 53h-1v-1h1z",
    fill: "#b99958",
    fillOpacity: 0.475
  })), _path3058 || (_path3058 = /*#__PURE__*/React.createElement("path", {
    d: "M8 54H7v-1h1z",
    fill: "#77512b",
    fillOpacity: 0.184
  })), _path3059 || (_path3059 = /*#__PURE__*/React.createElement("path", {
    d: "M9 54H8v-1h1z",
    fill: "#9e774a",
    fillOpacity: 0.796
  })), _path3060 || (_path3060 = /*#__PURE__*/React.createElement("path", {
    d: "M9 54v-1h1v1z",
    fill: "#c38c51"
  })), _path3061 || (_path3061 = /*#__PURE__*/React.createElement("path", {
    d: "M11 54h-1v-1h1z",
    fill: "#bc7e40"
  })), _path3062 || (_path3062 = /*#__PURE__*/React.createElement("path", {
    d: "M11 54v-1h1v1z",
    fill: "#775128",
    fillOpacity: 0.98
  })), _path3063 || (_path3063 = /*#__PURE__*/React.createElement("path", {
    d: "M13 54h-1v-1h1z",
    fill: "#6c573c",
    fillOpacity: 0.961
  })), _path3064 || (_path3064 = /*#__PURE__*/React.createElement("path", {
    d: "M13 54v-1h1v1z",
    fill: "#695230",
    fillOpacity: 0.914
  })), _path3065 || (_path3065 = /*#__PURE__*/React.createElement("path", {
    d: "M15 54h-1v-1h1z",
    fill: "#512f19",
    fillOpacity: 0.973
  })), _path3066 || (_path3066 = /*#__PURE__*/React.createElement("path", {
    d: "M15 54v-1h1v1z",
    fill: "#502c20"
  })), _path3067 || (_path3067 = /*#__PURE__*/React.createElement("path", {
    d: "M17 54h-1v-1h1z",
    fill: "#30160c"
  })), _path3068 || (_path3068 = /*#__PURE__*/React.createElement("path", {
    d: "M17 53h1v1h-1z",
    fill: "#33190f"
  })), _path3069 || (_path3069 = /*#__PURE__*/React.createElement("path", {
    d: "M19 54h-1v-1h1z",
    fill: "#49291d"
  })), _path3070 || (_path3070 = /*#__PURE__*/React.createElement("path", {
    d: "M19 53h1v1h-1z",
    fill: "#4d2a1a"
  })), _path3071 || (_path3071 = /*#__PURE__*/React.createElement("path", {
    d: "M21 53v1h-1v-1z",
    fill: "#56361c"
  })), _path3072 || (_path3072 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53v1h-1v-1z",
    fill: "#694834",
    fillOpacity: 0.988
  })), _path3073 || (_path3073 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53h1v1h-1z",
    fill: "#3e2515",
    fillOpacity: 0.929
  })), _path3074 || (_path3074 = /*#__PURE__*/React.createElement("path", {
    d: "M23 54v-1h1v1z",
    fill: "#5a4222",
    fillOpacity: 0.839
  })), _path3075 || (_path3075 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54h-1v-1h1z",
    fill: "#492e0e",
    fillOpacity: 0.737
  })), _path3076 || (_path3076 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54v-1h1v1z",
    fill: "#3d2912",
    fillOpacity: 0.549
  })), _path3077 || (_path3077 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54h-1v-1h1z",
    fill: "#1c0e0e",
    fillOpacity: 0.071
  })), _path3078 || (_path3078 = /*#__PURE__*/React.createElement("path", {
    d: "M28 53v1h-1v-1z",
    fill: "#241207",
    fillOpacity: 0.271
  })), _path3079 || (_path3079 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54h-1v-1h1z",
    fill: "#231405",
    fillOpacity: 0.529
  })), _path3080 || (_path3080 = /*#__PURE__*/React.createElement("path", {
    d: "M30 53v1h-1v-1z",
    fill: "#1c0c05",
    fillOpacity: 0.733
  })), _path3081 || (_path3081 = /*#__PURE__*/React.createElement("path", {
    d: "M30 54v-1h1v1z",
    fill: "#2f1607",
    fillOpacity: 0.988
  })), _path3082 || (_path3082 = /*#__PURE__*/React.createElement("path", {
    d: "M31 53h1v1h-1z",
    fill: "#422408"
  })), _path3083 || (_path3083 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v-1h1v1z",
    fill: "#442310"
  })), _path3084 || (_path3084 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54v-1h1v1z",
    fill: "#36140a"
  })), _path3085 || (_path3085 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h-1v-1h1z",
    fill: "#2f140b"
  })), _path3086 || (_path3086 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53v1h-1v-1z",
    fill: "#2d160b"
  })), _path3087 || (_path3087 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h1v1h-1z",
    fill: "#835220"
  })), _path3088 || (_path3088 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v1h-1v-1z",
    fill: "#c08629"
  })), _path3089 || (_path3089 = /*#__PURE__*/React.createElement("path", {
    d: "M38 54v-1h1v1z",
    fill: "#784b1f"
  })), _path3090 || (_path3090 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53v1h-1v-1z",
    fill: "#3a231c"
  })), _path3091 || (_path3091 = /*#__PURE__*/React.createElement("path", {
    d: "M41 54h-1v-1h1z",
    fill: "#39241f"
  })), _path3092 || (_path3092 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h1v1h-1z",
    fill: "#382422"
  })), _path3093 || (_path3093 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h1v1h-1z",
    fill: "#392423"
  })), _path3094 || (_path3094 = /*#__PURE__*/React.createElement("path", {
    d: "M44 53v1h-1v-1z",
    fill: "#33231d"
  })), _path3095 || (_path3095 = /*#__PURE__*/React.createElement("path", {
    d: "M45 53v1h-1v-1z",
    fill: "#201712"
  })), _path3096 || (_path3096 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54h-1v-1h1z",
    fill: "#1c1513"
  })), _path3097 || (_path3097 = /*#__PURE__*/React.createElement("path", {
    d: "M47 53v1h-1v-1z",
    fill: "#150e0e"
  })), _path3098 || (_path3098 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h-1v-1h1z",
    fill: "#161510"
  })), _path3099 || (_path3099 = /*#__PURE__*/React.createElement("path", {
    d: "M49 54h-1v-1h1z",
    fill: "#150c06"
  })), _path3100 || (_path3100 = /*#__PURE__*/React.createElement("path", {
    d: "M50 53v1h-1v-1z",
    fill: "#261209"
  })), _path3101 || (_path3101 = /*#__PURE__*/React.createElement("path", {
    d: "M51 53v1h-1v-1z",
    fill: "#36170d"
  })), _path3102 || (_path3102 = /*#__PURE__*/React.createElement("path", {
    d: "M51 54v-1h1v1z",
    fill: "#59281c"
  })), _path3103 || (_path3103 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h-1v-1h1z",
    fill: "#5a1e0f"
  })), _path3104 || (_path3104 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54h-1v-1h1z",
    fill: "#441307"
  })), _path3105 || (_path3105 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54v-1h1v1z",
    fill: "#3e190f"
  })), _path3106 || (_path3106 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54h-1v-1h1z",
    fill: "#572817"
  })), _path3107 || (_path3107 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53v1h-1v-1z",
    fill: "#672b13"
  })), _path3108 || (_path3108 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54h-1v-1h1z",
    fill: "#884325"
  })), _path3109 || (_path3109 = /*#__PURE__*/React.createElement("path", {
    d: "M58 53h1v1h-1z",
    fill: "#804122"
  })), _path3110 || (_path3110 = /*#__PURE__*/React.createElement("path", {
    d: "M59 53h1v1h-1z",
    fill: "#804c2a"
  })), _path3111 || (_path3111 = /*#__PURE__*/React.createElement("path", {
    d: "M60 53h1v1h-1z",
    fill: "#cdaf86"
  })), _path3112 || (_path3112 = /*#__PURE__*/React.createElement("path", {
    d: "M62 53v1h-1v-1z",
    fill: "#ebd7ac"
  })), _path3113 || (_path3113 = /*#__PURE__*/React.createElement("path", {
    d: "M62 54v-1h1v1z",
    fill: "#e2c297"
  })), _path3114 || (_path3114 = /*#__PURE__*/React.createElement("path", {
    d: "M64 53v1h-1v-1z",
    fill: "#b88d56"
  })), _path3115 || (_path3115 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54h-1v-1h1z",
    fill: "#764a1c"
  })), _path3116 || (_path3116 = /*#__PURE__*/React.createElement("path", {
    d: "M65 53h1v1h-1z",
    fill: "#693c1e"
  })), _path3117 || (_path3117 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v1h-1v-1z",
    fill: "#622e16"
  })), _path3118 || (_path3118 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53h1v1h-1z",
    fill: "#64300e"
  })), _path3119 || (_path3119 = /*#__PURE__*/React.createElement("path", {
    d: "M69 53v1h-1v-1z",
    fill: "#7a3b18"
  })), _path3120 || (_path3120 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v1h-1v-1z",
    fill: "#622c1b"
  })), _path3121 || (_path3121 = /*#__PURE__*/React.createElement("path", {
    d: "M71 54h-1v-1h1z",
    fill: "#130703"
  })), _path3122 || (_path3122 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54h-1v-1h1z",
    fill: "#250f0b"
  })), _path3123 || (_path3123 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h1v1h-1z",
    fill: "#462217"
  })), _path3124 || (_path3124 = /*#__PURE__*/React.createElement("path", {
    d: "M73 53h1v1h-1z",
    fill: "#6d3f2f"
  })), _path3125 || (_path3125 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53h1v1h-1z",
    fill: "#583025"
  })), _path3126 || (_path3126 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v1h-1v-1z",
    fill: "#341d19"
  })), _path3127 || (_path3127 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53h1v1h-1z",
    fill: "#100504"
  })), _path3128 || (_path3128 = /*#__PURE__*/React.createElement("path", {
    d: "M78 53v1h-1v-1z",
    fill: "#140807"
  })), _path3129 || (_path3129 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v-1h1v1z",
    fill: "#140804"
  })), _path3130 || (_path3130 = /*#__PURE__*/React.createElement("path", {
    d: "M80 54h-1v-1h1z",
    fill: "#180e0d"
  })), _path3131 || (_path3131 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53v1h-1v-1z",
    fill: "#1b0d0b"
  })), _path3132 || (_path3132 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h1v1h-1z",
    fill: "#29130b"
  })), _path3133 || (_path3133 = /*#__PURE__*/React.createElement("path", {
    d: "M83 53v1h-1v-1z",
    fill: "#2c1206"
  })), _path3134 || (_path3134 = /*#__PURE__*/React.createElement("path", {
    d: "M85 53v1h-1v-1z",
    fill: "#512f25"
  })), _path3135 || (_path3135 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v-1h1v1z",
    fill: "#3b211a"
  })), _path3136 || (_path3136 = /*#__PURE__*/React.createElement("path", {
    d: "M86 53h1v1h-1z",
    fill: "#412d29"
  })), _path3137 || (_path3137 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53v1h-1v-1z",
    fill: "#5c433e"
  })), _path3138 || (_path3138 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h1v1h-1z",
    fill: "#45291e"
  })), _path3139 || (_path3139 = /*#__PURE__*/React.createElement("path", {
    d: "M89 53h1v1h-1z",
    fill: "#513216"
  })), _path3140 || (_path3140 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53v1h-1v-1z",
    fill: "#56331f"
  })), _path3141 || (_path3141 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53h1v1h-1z",
    fill: "#55371f"
  })), _path3142 || (_path3142 = /*#__PURE__*/React.createElement("path", {
    d: "M93 53v1h-1v-1z",
    fill: "#603e24"
  })), _path3143 || (_path3143 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54h-1v-1h1z",
    fill: "#66432d"
  })), _path3144 || (_path3144 = /*#__PURE__*/React.createElement("path", {
    d: "M94 53h1v1h-1z",
    fill: "#4c2f22"
  })), _path3145 || (_path3145 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53h1v1h-1z",
    fill: "#a58781"
  })), _path3146 || (_path3146 = /*#__PURE__*/React.createElement("path", {
    d: "M96 53h1v1h-1z",
    fill: "#a38681"
  })), _path3147 || (_path3147 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v-1h1v1z",
    fill: "#866962"
  })), _path3148 || (_path3148 = /*#__PURE__*/React.createElement("path", {
    d: "M99 53v1h-1v-1z",
    fill: "#674542"
  })), _path3149 || (_path3149 = /*#__PURE__*/React.createElement("path", {
    d: "M99 53h1v1h-1z",
    fill: "#361912"
  })), _path3150 || (_path3150 = /*#__PURE__*/React.createElement("path", {
    d: "M100 54v-1h1v1z",
    fill: "#391a0c"
  })), _path3151 || (_path3151 = /*#__PURE__*/React.createElement("path", {
    d: "M102 53v1h-1v-1z",
    fill: "#703f2e"
  })), _path3152 || (_path3152 = /*#__PURE__*/React.createElement("path", {
    d: "M102 54v-1h1v1z",
    fill: "#74473a"
  })), _path3153 || (_path3153 = /*#__PURE__*/React.createElement("path", {
    d: "M104 54h-1v-1h1z",
    fill: "#623a31"
  })), _path3154 || (_path3154 = /*#__PURE__*/React.createElement("path", {
    d: "M105 53v1h-1v-1z",
    fill: "#834c3a"
  })), _path3155 || (_path3155 = /*#__PURE__*/React.createElement("path", {
    d: "M105 54v-1h1v1z",
    fill: "#823f1e"
  })), _path3156 || (_path3156 = /*#__PURE__*/React.createElement("path", {
    d: "M107 54h-1v-1h1z",
    fill: "#ad6f41"
  })), _path3157 || (_path3157 = /*#__PURE__*/React.createElement("path", {
    d: "M108 53v1h-1v-1z",
    fill: "#efc77b"
  })), _path3158 || (_path3158 = /*#__PURE__*/React.createElement("path", {
    d: "M109 54h-1v-1h1z",
    fill: "#d6a240"
  })), _path3159 || (_path3159 = /*#__PURE__*/React.createElement("path", {
    d: "M110 54h-1v-1h1z",
    fill: "#cd963a"
  })), _path3160 || (_path3160 = /*#__PURE__*/React.createElement("path", {
    d: "M110 54v-1h1v1z",
    fill: "#e6c388"
  })), _path3161 || (_path3161 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53v1h-1v-1z",
    fill: "#d4b86e"
  })), _path3162 || (_path3162 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53h1v1h-1z",
    fill: "#d2a155"
  })), _path3163 || (_path3163 = /*#__PURE__*/React.createElement("path", {
    d: "M114 53v1h-1v-1z",
    fill: "#bf873b"
  })), _path3164 || (_path3164 = /*#__PURE__*/React.createElement("path", {
    d: "M114 53h1v1h-1z",
    fill: "#a47325"
  })), _path3165 || (_path3165 = /*#__PURE__*/React.createElement("path", {
    d: "M116 54h-1v-1h1z",
    fill: "#9c7636"
  })), _path3166 || (_path3166 = /*#__PURE__*/React.createElement("path", {
    d: "M117 53v1h-1v-1z",
    fill: "#72532a"
  })), _path3167 || (_path3167 = /*#__PURE__*/React.createElement("path", {
    d: "M117 53h1v1h-1z",
    fill: "#66522a",
    fillOpacity: 0.992
  })), _path3168 || (_path3168 = /*#__PURE__*/React.createElement("path", {
    d: "M119 53v1h-1v-1z",
    fill: "#9b925a",
    fillOpacity: 0.322
  })), _path3169 || (_path3169 = /*#__PURE__*/React.createElement("path", {
    d: "M8 55v-1h1v1z",
    fillOpacity: 0.086
  })), _path3170 || (_path3170 = /*#__PURE__*/React.createElement("path", {
    d: "M10 54v1H9v-1z",
    fill: "#6b371b",
    fillOpacity: 0.435
  })), _path3171 || (_path3171 = /*#__PURE__*/React.createElement("path", {
    d: "M10 55v-1h1v1z",
    fill: "#56220e",
    fillOpacity: 0.486
  })), _path3172 || (_path3172 = /*#__PURE__*/React.createElement("path", {
    d: "M11 54h1v1h-1z",
    fill: "#684b3e",
    fillOpacity: 0.239
  })), _path3173 || (_path3173 = /*#__PURE__*/React.createElement("path", {
    d: "M13 54v1h-1v-1z",
    fill: "#c5a879",
    fillOpacity: 0.173
  })), _path3174 || (_path3174 = /*#__PURE__*/React.createElement("path", {
    d: "M13 54h1v1h-1z",
    fill: "#482d12",
    fillOpacity: 0.11
  })), _path3175 || (_path3175 = /*#__PURE__*/React.createElement("path", {
    d: "M14 54h1v1h-1z",
    fill: "#5d442c",
    fillOpacity: 0.204
  })), _path3176 || (_path3176 = /*#__PURE__*/React.createElement("path", {
    d: "M16 54v1h-1v-1z",
    fill: "#6f533b",
    fillOpacity: 0.322
  })), _path3177 || (_path3177 = /*#__PURE__*/React.createElement("path", {
    d: "M16 54h1v1h-1z",
    fill: "#3c2413",
    fillOpacity: 0.361
  })), _path3178 || (_path3178 = /*#__PURE__*/React.createElement("path", {
    d: "M18 54v1h-1v-1z",
    fill: "#3f2214",
    fillOpacity: 0.349
  })), _path3179 || (_path3179 = /*#__PURE__*/React.createElement("path", {
    d: "M19 54v1h-1v-1z",
    fill: "#6c3f2f",
    fillOpacity: 0.314
  })), _path3180 || (_path3180 = /*#__PURE__*/React.createElement("path", {
    d: "M20 55h-1v-1h1z",
    fill: "#6c412b",
    fillOpacity: 0.322
  })), _path3181 || (_path3181 = /*#__PURE__*/React.createElement("path", {
    d: "M20 54h1v1h-1z",
    fill: "#8c6844",
    fillOpacity: 0.278
  })), _path3182 || (_path3182 = /*#__PURE__*/React.createElement("path", {
    d: "M21 54h1v1h-1z",
    fill: "#8f6f53",
    fillOpacity: 0.251
  })), _path3183 || (_path3183 = /*#__PURE__*/React.createElement("path", {
    d: "M22 55v-1h1v1z",
    fill: "#2d0f00",
    fillOpacity: 0.133
  })), _path3184 || (_path3184 = /*#__PURE__*/React.createElement("path", {
    d: "M24 54v1h-1v-1z",
    fill: "#272700",
    fillOpacity: 0.051
  })), _path3185 || (_path3185 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55v-1h1v1z",
    fill: "#382f25",
    fillOpacity: 0.106
  })), _path3186 || (_path3186 = /*#__PURE__*/React.createElement("path", {
    d: "M31 54v1h-1v-1z",
    fill: "#4e2918",
    fillOpacity: 0.91
  })), _path3187 || (_path3187 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v1h-1v-1z",
    fill: "#502a13"
  })), _path3188 || (_path3188 = /*#__PURE__*/React.createElement("path", {
    d: "M32 55v-1h1v1z",
    fill: "#532b15"
  })), _path3189 || (_path3189 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54h1v1h-1z",
    fill: "#3e1e11"
  })), _path3190 || (_path3190 = /*#__PURE__*/React.createElement("path", {
    d: "M35 55h-1v-1h1z",
    fill: "#2a1108"
  })), _path3191 || (_path3191 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h1v1h-1z",
    fill: "#382113"
  })), _path3192 || (_path3192 = /*#__PURE__*/React.createElement("path", {
    d: "M37 55h-1v-1h1z",
    fill: "#a17332"
  })), _path3193 || (_path3193 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55h-1v-1h1z",
    fill: "#9b5f1b"
  })), _path3194 || (_path3194 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54v1h-1v-1z",
    fill: "#6b3f11"
  })), _path3195 || (_path3195 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54h1v1h-1z",
    fill: "#1e1006"
  })), _path3196 || (_path3196 = /*#__PURE__*/React.createElement("path", {
    d: "M40 54h1v1h-1z",
    fill: "#0d0803"
  })), _path3197 || (_path3197 = /*#__PURE__*/React.createElement("path", {
    d: "M42 55v-1h1v1z",
    fill: "#120a07"
  })), _path3198 || (_path3198 = /*#__PURE__*/React.createElement("path", {
    d: "M44 54v1h-1v-1z",
    fill: "#1b0d07"
  })), _path3199 || (_path3199 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55v-1h1v1z",
    fill: "#1e130c"
  })), _path3200 || (_path3200 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54v1h-1v-1z",
    fill: "#302520"
  })), _path3201 || (_path3201 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55h-1v-1h1z",
    fill: "#271f1b"
  })), _path3202 || (_path3202 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54h1v1h-1z",
    fill: "#100e0a"
  })), _path3203 || (_path3203 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h1v1h-1z",
    fill: "#371f11"
  })), _path3204 || (_path3204 = /*#__PURE__*/React.createElement("path", {
    d: "M49 55v-1h1v1z",
    fill: "#613621"
  })), _path3205 || (_path3205 = /*#__PURE__*/React.createElement("path", {
    d: "M50 54h1v1h-1z",
    fill: "#603625"
  })), _path3206 || (_path3206 = /*#__PURE__*/React.createElement("path", {
    d: "M52 55h-1v-1h1z",
    fill: "#391409"
  })), _path3207 || (_path3207 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54v1h-1v-1z",
    fill: "#673118"
  })), _path3208 || (_path3208 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h1v1h-1z",
    fill: "#431a0c"
  })), _path3209 || (_path3209 = /*#__PURE__*/React.createElement("path", {
    d: "M55 54v1h-1v-1z",
    fill: "#290c05"
  })), _path3210 || (_path3210 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54v1h-1v-1z",
    fill: "#3f1509"
  })), _path3211 || (_path3211 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55v-1h1v1z",
    fill: "#622d19"
  })), _path3212 || (_path3212 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54v1h-1v-1z",
    fill: "#914a2b"
  })), _path3213 || (_path3213 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55v-1h1v1z",
    fill: "#8a4522"
  })), _path3214 || (_path3214 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54v1h-1v-1z",
    fill: "#a77551"
  })), _path3215 || (_path3215 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54h1v1h-1z",
    fill: "#eccea0"
  })), _path3216 || (_path3216 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55h-1v-1h1z",
    fill: "#edd099"
  })), _path3217 || (_path3217 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54v1h-1v-1z",
    fill: "#d7b271"
  })), _path3218 || (_path3218 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54h1v1h-1z",
    fill: "#cda763"
  })), _path3219 || (_path3219 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54v1h-1v-1z",
    fill: "#9d7a46"
  })), _path3220 || (_path3220 = /*#__PURE__*/React.createElement("path", {
    d: "M66 55h-1v-1h1z",
    fill: "#6f4522"
  })), _path3221 || (_path3221 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55h-1v-1h1z",
    fill: "#7a4d2d"
  })), _path3222 || (_path3222 = /*#__PURE__*/React.createElement("path", {
    d: "M68 54v1h-1v-1z",
    fill: "#472209"
  })), _path3223 || (_path3223 = /*#__PURE__*/React.createElement("path", {
    d: "M69 55h-1v-1h1z",
    fill: "#5b1f0e"
  })), _path3224 || (_path3224 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55h-1v-1h1z",
    fill: "#5a311e"
  })), _path3225 || (_path3225 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55v-1h1v1z",
    fill: "#0f0a07"
  })), _path3226 || (_path3226 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54v1h-1v-1z",
    fill: "#0f0603"
  })), _path3227 || (_path3227 = /*#__PURE__*/React.createElement("path", {
    d: "M73 54v1h-1v-1z",
    fill: "#4f3020"
  })), _path3228 || (_path3228 = /*#__PURE__*/React.createElement("path", {
    d: "M73 55v-1h1v1z",
    fill: "#5a3223"
  })), _path3229 || (_path3229 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54v1h-1v-1z",
    fill: "#260907"
  })), _path3230 || (_path3230 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54h1v1h-1z",
    fill: "#1e0806"
  })), _path3231 || (_path3231 = /*#__PURE__*/React.createElement("path", {
    d: "M76 54h1v1h-1z",
    fill: "#21100c"
  })), _path3232 || (_path3232 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v1h-1v-1z",
    fill: "#1a0b05"
  })), _path3233 || (_path3233 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54h1v1h-1z",
    fill: "#1e0c06"
  })), _path3234 || (_path3234 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h-1v-1h1z",
    fill: "#21100d"
  })), _path3235 || (_path3235 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55v-1h1v1z",
    fill: "#200e09"
  })), _path3236 || (_path3236 = /*#__PURE__*/React.createElement("path", {
    d: "M81 55v-1h1v1z",
    fill: "#260b07"
  })), _path3237 || (_path3237 = /*#__PURE__*/React.createElement("path", {
    d: "M82 54h1v1h-1z",
    fill: "#36170a"
  })), _path3238 || (_path3238 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54h1v1h-1z",
    fill: "#451c0c"
  })), _path3239 || (_path3239 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v1h-1v-1z",
    fill: "#7c5642"
  })), _path3240 || (_path3240 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54h1v1h-1z",
    fill: "#463227"
  })), _path3241 || (_path3241 = /*#__PURE__*/React.createElement("path", {
    d: "M87 54v1h-1v-1z",
    fill: "#30211c"
  })), _path3242 || (_path3242 = /*#__PURE__*/React.createElement("path", {
    d: "M88 54v1h-1v-1z",
    fill: "#210f04"
  })), _path3243 || (_path3243 = /*#__PURE__*/React.createElement("path", {
    d: "M88 54h1v1h-1z",
    fill: "#361f10"
  })), _path3244 || (_path3244 = /*#__PURE__*/React.createElement("path", {
    d: "M90 55h-1v-1h1z",
    fill: "#39281e"
  })), _path3245 || (_path3245 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55h-1v-1h1z",
    fill: "#2f1c19"
  })), _path3246 || (_path3246 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54v1h-1v-1z",
    fill: "#210c06"
  })), _path3247 || (_path3247 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54v1h-1v-1z",
    fill: "#45322f"
  })), _path3248 || (_path3248 = /*#__PURE__*/React.createElement("path", {
    d: "M94 55v-1h1v1z",
    fill: "#2d1c15"
  })), _path3249 || (_path3249 = /*#__PURE__*/React.createElement("path", {
    d: "M95 54h1v1h-1z",
    fill: "#4c322f"
  })), _path3250 || (_path3250 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v1h-1v-1z",
    fill: "#5f413a"
  })), _path3251 || (_path3251 = /*#__PURE__*/React.createElement("path", {
    d: "M97 55v-1h1v1z",
    fill: "#342014"
  })), _path3252 || (_path3252 = /*#__PURE__*/React.createElement("path", {
    d: "M99 55h-1v-1h1z",
    fill: "#452a1b"
  })), _path3253 || (_path3253 = /*#__PURE__*/React.createElement("path", {
    d: "M100 54v1h-1v-1z",
    fill: "#2f1305"
  })), _path3254 || (_path3254 = /*#__PURE__*/React.createElement("path", {
    d: "M101 55h-1v-1h1z",
    fill: "#270f09"
  })), _path3255 || (_path3255 = /*#__PURE__*/React.createElement("path", {
    d: "M101 55v-1h1v1z",
    fill: "#57271a"
  })), _path3256 || (_path3256 = /*#__PURE__*/React.createElement("path", {
    d: "M103 55h-1v-1h1z",
    fill: "#945c45"
  })), _path3257 || (_path3257 = /*#__PURE__*/React.createElement("path", {
    d: "M104 54v1h-1v-1z",
    fill: "#88544f"
  })), _path3258 || (_path3258 = /*#__PURE__*/React.createElement("path", {
    d: "M104 54h1v1h-1z",
    fill: "#734041"
  })), _path3259 || (_path3259 = /*#__PURE__*/React.createElement("path", {
    d: "M105 54h1v1h-1z",
    fill: "#743921"
  })), _path3260 || (_path3260 = /*#__PURE__*/React.createElement("path", {
    d: "M107 54v1h-1v-1z",
    fill: "#7c401c"
  })), _path3261 || (_path3261 = /*#__PURE__*/React.createElement("path", {
    d: "M108 54v1h-1v-1z",
    fill: "#856330"
  })), _path3262 || (_path3262 = /*#__PURE__*/React.createElement("path", {
    d: "M108 54h1v1h-1z",
    fill: "#b08b4f"
  })), _path3263 || (_path3263 = /*#__PURE__*/React.createElement("path", {
    d: "M109 55v-1h1v1z",
    fill: "#835620"
  })), _path3264 || (_path3264 = /*#__PURE__*/React.createElement("path", {
    d: "M110 55v-1h1v1z",
    fill: "#ae895f"
  })), _path3265 || (_path3265 = /*#__PURE__*/React.createElement("path", {
    d: "M111 55v-1h1v1z",
    fill: "#f4dba9"
  })), _path3266 || (_path3266 = /*#__PURE__*/React.createElement("path", {
    d: "M113 54v1h-1v-1z",
    fill: "#efdc9b"
  })), _path3267 || (_path3267 = /*#__PURE__*/React.createElement("path", {
    d: "M114 55h-1v-1h1z",
    fill: "#f5db99"
  })), _path3268 || (_path3268 = /*#__PURE__*/React.createElement("path", {
    d: "M114 54h1v1h-1z",
    fill: "#e6c76e"
  })), _path3269 || (_path3269 = /*#__PURE__*/React.createElement("path", {
    d: "M116 54v1h-1v-1z",
    fill: "#e2c377"
  })), _path3270 || (_path3270 = /*#__PURE__*/React.createElement("path", {
    d: "M117 55h-1v-1h1z",
    fill: "#d4bd86"
  })), _path3271 || (_path3271 = /*#__PURE__*/React.createElement("path", {
    d: "M118 54v1h-1v-1z",
    fill: "#c2af80",
    fillOpacity: 0.996
  })), _path3272 || (_path3272 = /*#__PURE__*/React.createElement("path", {
    d: "M119 54v1h-1v-1z",
    fill: "#beaa7a",
    fillOpacity: 0.4
  })), _path3273 || (_path3273 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55h1v1h-1z",
    fill: "#745943",
    fillOpacity: 0.224
  })), _path3274 || (_path3274 = /*#__PURE__*/React.createElement("path", {
    d: "M31 55v1h-1v-1z",
    fill: "#764c31",
    fillOpacity: 0.984
  })), _path3275 || (_path3275 = /*#__PURE__*/React.createElement("path", {
    d: "M32 56h-1v-1h1z",
    fill: "#673920"
  })), _path3276 || (_path3276 = /*#__PURE__*/React.createElement("path", {
    d: "M33 55v1h-1v-1z",
    fill: "#64371e"
  })), _path3277 || (_path3277 = /*#__PURE__*/React.createElement("path", {
    d: "M34 56h-1v-1h1z",
    fill: "#462718"
  })), _path3278 || (_path3278 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56h-1v-1h1z",
    fill: "#2e1607"
  })), _path3279 || (_path3279 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56v-1h1v1z",
    fill: "#391306"
  })), _path3280 || (_path3280 = /*#__PURE__*/React.createElement("path", {
    d: "M37 56h-1v-1h1z",
    fill: "#976324"
  })), _path3281 || (_path3281 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55v1h-1v-1z",
    fill: "#8e5618"
  })), _path3282 || (_path3282 = /*#__PURE__*/React.createElement("path", {
    d: "M38 56v-1h1v1z",
    fill: "#653c0f"
  })), _path3283 || (_path3283 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h-1v-1h1z",
    fill: "#1e1005"
  })), _path3284 || (_path3284 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56v-1h1v1z",
    fill: "#0e0f0e"
  })), _path3285 || (_path3285 = /*#__PURE__*/React.createElement("path", {
    d: "M41 55h1v1h-1z",
    fill: "#120c0a"
  })), _path3286 || (_path3286 = /*#__PURE__*/React.createElement("path", {
    d: "M43 56h-1v-1h1z",
    fill: "#160f0f"
  })), _path3287 || (_path3287 = /*#__PURE__*/React.createElement("path", {
    d: "M43 55h1v1h-1z",
    fill: "#1c0f0a"
  })), _path3288 || (_path3288 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55h1v1h-1z",
    fill: "#170c07"
  })), _path3289 || (_path3289 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56v-1h1v1z",
    fill: "#130e0d"
  })), _path3290 || (_path3290 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h-1v-1h1z",
    fill: "#141211"
  })), _path3291 || (_path3291 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55v1h-1v-1z",
    fill: "#1f1107"
  })), _path3292 || (_path3292 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55h1v1h-1z",
    fill: "#462411"
  })), _path3293 || (_path3293 = /*#__PURE__*/React.createElement("path", {
    d: "M50 56h-1v-1h1z",
    fill: "#754733"
  })), _path3294 || (_path3294 = /*#__PURE__*/React.createElement("path", {
    d: "M51 55v1h-1v-1z",
    fill: "#6d4133"
  })), _path3295 || (_path3295 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v-1h1v1z",
    fill: "#512814"
  })), _path3296 || (_path3296 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55v1h-1v-1z",
    fill: "#65310a"
  })), _path3297 || (_path3297 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55h1v1h-1z",
    fill: "#6a3c1f"
  })), _path3298 || (_path3298 = /*#__PURE__*/React.createElement("path", {
    d: "M55 56h-1v-1h1z",
    fill: "#552a1d"
  })), _path3299 || (_path3299 = /*#__PURE__*/React.createElement("path", {
    d: "M55 55h1v1h-1z",
    fill: "#683122"
  })), _path3300 || (_path3300 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55h1v1h-1z",
    fill: "#894a33"
  })), _path3301 || (_path3301 = /*#__PURE__*/React.createElement("path", {
    d: "M57 56v-1h1v1z",
    fill: "#924d35"
  })), _path3302 || (_path3302 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55h1v1h-1z",
    fill: "#4f170b"
  })), _path3303 || (_path3303 = /*#__PURE__*/React.createElement("path", {
    d: "M60 56h-1v-1h1z",
    fill: "#5a3726"
  })), _path3304 || (_path3304 = /*#__PURE__*/React.createElement("path", {
    d: "M61 55v1h-1v-1z",
    fill: "#ab8463"
  })), _path3305 || (_path3305 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55v1h-1v-1z",
    fill: "#c68f5c"
  })), _path3306 || (_path3306 = /*#__PURE__*/React.createElement("path", {
    d: "M63 55v1h-1v-1z",
    fill: "#cb9859"
  })), _path3307 || (_path3307 = /*#__PURE__*/React.createElement("path", {
    d: "M64 55v1h-1v-1z",
    fill: "#d8b378"
  })), _path3308 || (_path3308 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56h-1v-1h1z",
    fill: "#d3ad79"
  })), _path3309 || (_path3309 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55h1v1h-1z",
    fill: "#a06c3e"
  })), _path3310 || (_path3310 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55v1h-1v-1z",
    fill: "#5a2b15"
  })), _path3311 || (_path3311 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56v-1h1v1z",
    fill: "#472911"
  })), _path3312 || (_path3312 = /*#__PURE__*/React.createElement("path", {
    d: "M68 55h1v1h-1z",
    fill: "#61311b"
  })), _path3313 || (_path3313 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56v-1h1v1z",
    fill: "#472317"
  })), _path3314 || (_path3314 = /*#__PURE__*/React.createElement("path", {
    d: "M71 56h-1v-1h1z",
    fill: "#10020b"
  })), _path3315 || (_path3315 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56h-1v-1h1z",
    fill: "#2d2012"
  })), _path3316 || (_path3316 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56v-1h1v1z",
    fill: "#92773f"
  })), _path3317 || (_path3317 = /*#__PURE__*/React.createElement("path", {
    d: "M74 55v1h-1v-1z",
    fill: "#a28c63"
  })), _path3318 || (_path3318 = /*#__PURE__*/React.createElement("path", {
    d: "M74 56v-1h1v1z",
    fill: "#554a37"
  })), _path3319 || (_path3319 = /*#__PURE__*/React.createElement("path", {
    d: "M76 55v1h-1v-1z",
    fill: "#3a2c1c"
  })), _path3320 || (_path3320 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56v-1h1v1z",
    fill: "#301e0e"
  })), _path3321 || (_path3321 = /*#__PURE__*/React.createElement("path", {
    d: "M78 55v1h-1v-1z",
    fill: "#4e3920"
  })), _path3322 || (_path3322 = /*#__PURE__*/React.createElement("path", {
    d: "M79 55v1h-1v-1z",
    fill: "#3e2d17"
  })), _path3323 || (_path3323 = /*#__PURE__*/React.createElement("path", {
    d: "M79 56v-1h1v1z",
    fill: "#261513"
  })), _path3324 || (_path3324 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h1v1h-1z",
    fill: "#2c1613"
  })), _path3325 || (_path3325 = /*#__PURE__*/React.createElement("path", {
    d: "M82 55v1h-1v-1z",
    fill: "#37150d"
  })), _path3326 || (_path3326 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56h-1v-1h1z",
    fill: "#4b2207"
  })), _path3327 || (_path3327 = /*#__PURE__*/React.createElement("path", {
    d: "M84 55v1h-1v-1z",
    fill: "#421d09"
  })), _path3328 || (_path3328 = /*#__PURE__*/React.createElement("path", {
    d: "M85 55v1h-1v-1z",
    fill: "#5a3429"
  })), _path3329 || (_path3329 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55v1h-1v-1z",
    fill: "#432015"
  })), _path3330 || (_path3330 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55h1v1h-1z",
    fill: "#29170a"
  })), _path3331 || (_path3331 = /*#__PURE__*/React.createElement("path", {
    d: "M87 55h1v1h-1z",
    fill: "#1a0f0d"
  })), _path3332 || (_path3332 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56v-1h1v1z",
    fill: "#241112"
  })), _path3333 || (_path3333 = /*#__PURE__*/React.createElement("path", {
    d: "M90 56h-1v-1h1z",
    fill: "#1f0f15"
  })), _path3334 || (_path3334 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55v1h-1v-1z",
    fill: "#1b0c09"
  })), _path3335 || (_path3335 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55h1v1h-1z",
    fill: "#2a1008"
  })), _path3336 || (_path3336 = /*#__PURE__*/React.createElement("path", {
    d: "M92 55h1v1h-1z",
    fill: "#4a271c"
  })), _path3337 || (_path3337 = /*#__PURE__*/React.createElement("path", {
    d: "M93 55h1v1h-1z",
    fill: "#572f24"
  })), _path3338 || (_path3338 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56h-1v-1h1z",
    fill: "#4e3228"
  })), _path3339 || (_path3339 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55v1h-1v-1z",
    fill: "#26120e"
  })), _path3340 || (_path3340 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55h1v1h-1z",
    fill: "#2e140f"
  })), _path3341 || (_path3341 = /*#__PURE__*/React.createElement("path", {
    d: "M97 56v-1h1v1z",
    fill: "#260f03"
  })), _path3342 || (_path3342 = /*#__PURE__*/React.createElement("path", {
    d: "M98 56v-1h1v1z",
    fill: "#75491a"
  })), _path3343 || (_path3343 = /*#__PURE__*/React.createElement("path", {
    d: "M100 55v1h-1v-1z",
    fill: "#986217"
  })), _path3344 || (_path3344 = /*#__PURE__*/React.createElement("path", {
    d: "M100 55h1v1h-1z",
    fill: "#865d22"
  })), _path3345 || (_path3345 = /*#__PURE__*/React.createElement("path", {
    d: "M101 55h1v1h-1z",
    fill: "#5c3313"
  })), _path3346 || (_path3346 = /*#__PURE__*/React.createElement("path", {
    d: "M103 55v1h-1v-1z",
    fill: "#885742"
  })), _path3347 || (_path3347 = /*#__PURE__*/React.createElement("path", {
    d: "M103 55h1v1h-1z",
    fill: "#a06a67"
  })), _path3348 || (_path3348 = /*#__PURE__*/React.createElement("path", {
    d: "M105 56h-1v-1h1z",
    fill: "#8f6054"
  })), _path3349 || (_path3349 = /*#__PURE__*/React.createElement("path", {
    d: "M105 56v-1h1v1z",
    fill: "#8f5741"
  })), _path3350 || (_path3350 = /*#__PURE__*/React.createElement("path", {
    d: "M107 56h-1v-1h1z",
    fill: "#78422b"
  })), _path3351 || (_path3351 = /*#__PURE__*/React.createElement("path", {
    d: "M108 55v1h-1v-1z",
    fill: "#472e13"
  })), _path3352 || (_path3352 = /*#__PURE__*/React.createElement("path", {
    d: "M108 56v-1h1v1z",
    fill: "#48391d"
  })), _path3353 || (_path3353 = /*#__PURE__*/React.createElement("path", {
    d: "M109 55h1v1h-1z",
    fill: "#5f3519"
  })), _path3354 || (_path3354 = /*#__PURE__*/React.createElement("path", {
    d: "M111 56h-1v-1h1z",
    fill: "#965b0e"
  })), _path3355 || (_path3355 = /*#__PURE__*/React.createElement("path", {
    d: "M112 55v1h-1v-1z",
    fill: "#c9871d"
  })), _path3356 || (_path3356 = /*#__PURE__*/React.createElement("path", {
    d: "M112 55h1v1h-1z",
    fill: "#c2842c"
  })), _path3357 || (_path3357 = /*#__PURE__*/React.createElement("path", {
    d: "M114 55v1h-1v-1z",
    fill: "#cfad64"
  })), _path3358 || (_path3358 = /*#__PURE__*/React.createElement("path", {
    d: "M114 56v-1h1v1z",
    fill: "#e0c779"
  })), _path3359 || (_path3359 = /*#__PURE__*/React.createElement("path", {
    d: "M115 56v-1h1v1z",
    fill: "#ead3a1"
  })), _path3360 || (_path3360 = /*#__PURE__*/React.createElement("path", {
    d: "M117 55v1h-1v-1z",
    fill: "#f0e0ba"
  })), _path3361 || (_path3361 = /*#__PURE__*/React.createElement("path", {
    d: "M117 56v-1h1v1z",
    fill: "#fae6bd"
  })), _path3362 || (_path3362 = /*#__PURE__*/React.createElement("path", {
    d: "M119 55v1h-1v-1z",
    fill: "#e5d2b1",
    fillOpacity: 0.745
  })), _path3363 || (_path3363 = /*#__PURE__*/React.createElement("path", {
    d: "M119 56v-1h1v1z",
    fill: "#d7c4b0",
    fillOpacity: 0.051
  })), _path3364 || (_path3364 = /*#__PURE__*/React.createElement("path", {
    d: "M30 56v1h-1v-1z",
    fill: "#79634d",
    fillOpacity: 0.09
  })), _path3365 || (_path3365 = /*#__PURE__*/React.createElement("path", {
    d: "M30 57v-1h1v1z",
    fill: "#7f5435",
    fillOpacity: 0.784
  })), _path3366 || (_path3366 = /*#__PURE__*/React.createElement("path", {
    d: "M31 56h1v1h-1z",
    fill: "#512a11",
    fillOpacity: 0.824
  })), _path3367 || (_path3367 = /*#__PURE__*/React.createElement("path", {
    d: "M32 57v-1h1v1z",
    fill: "#5f3920",
    fillOpacity: 0.894
  })), _path3368 || (_path3368 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56h1v1h-1z",
    fill: "#542f14",
    fillOpacity: 0.863
  })), _path3369 || (_path3369 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v-1h1v1z",
    fill: "#855626",
    fillOpacity: 0.996
  })), _path3370 || (_path3370 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56v1h-1v-1z",
    fill: "#96631d"
  })), _path3371 || (_path3371 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56h1v1h-1z",
    fill: "#b88214"
  })), _path3372 || (_path3372 = /*#__PURE__*/React.createElement("path", {
    d: "M38 57h-1v-1h1z",
    fill: "#a06911"
  })), _path3373 || (_path3373 = /*#__PURE__*/React.createElement("path", {
    d: "M39 56v1h-1v-1z",
    fill: "#744816"
  })), _path3374 || (_path3374 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57v-1h1v1z",
    fill: "#38230f"
  })), _path3375 || (_path3375 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h1v1h-1z",
    fill: "#181719"
  })), _path3376 || (_path3376 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57h-1v-1h1z",
    fill: "#161519"
  })), _path3377 || (_path3377 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57v-1h1v1z",
    fill: "#141415"
  })), _path3378 || (_path3378 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57h-1v-1h1z",
    fill: "#100f15"
  })), _path3379 || (_path3379 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57v-1h1v1z",
    fill: "#150906"
  })), _path3380 || (_path3380 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56h1v1h-1z",
    fill: "#1c0803"
  })), _path3381 || (_path3381 = /*#__PURE__*/React.createElement("path", {
    d: "M46 56h1v1h-1z",
    fill: "#2a130a"
  })), _path3382 || (_path3382 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h1v1h-1z",
    fill: "#4a2a1a"
  })), _path3383 || (_path3383 = /*#__PURE__*/React.createElement("path", {
    d: "M49 56v1h-1v-1z",
    fill: "#492310"
  })), _path3384 || (_path3384 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57v-1h1v1z",
    fill: "#683d2e"
  })), _path3385 || (_path3385 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v1h-1v-1z",
    fill: "#72473a"
  })), _path3386 || (_path3386 = /*#__PURE__*/React.createElement("path", {
    d: "M52 57h-1v-1h1z",
    fill: "#5f341d"
  })), _path3387 || (_path3387 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h-1v-1h1z",
    fill: "#5a3007"
  })), _path3388 || (_path3388 = /*#__PURE__*/React.createElement("path", {
    d: "M54 56v1h-1v-1z",
    fill: "#65330c"
  })), _path3389 || (_path3389 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h-1v-1h1z",
    fill: "#5a240a"
  })), _path3390 || (_path3390 = /*#__PURE__*/React.createElement("path", {
    d: "M56 56v1h-1v-1z",
    fill: "#69361a"
  })), _path3391 || (_path3391 = /*#__PURE__*/React.createElement("path", {
    d: "M56 57v-1h1v1z",
    fill: "#7a442a"
  })), _path3392 || (_path3392 = /*#__PURE__*/React.createElement("path", {
    d: "M58 56v1h-1v-1z",
    fill: "#7a4a3a"
  })), _path3393 || (_path3393 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57v-1h1v1z",
    fill: "#4f2d27"
  })), _path3394 || (_path3394 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h-1v-1h1z",
    fill: "#300c08"
  })), _path3395 || (_path3395 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57h-1v-1h1z",
    fill: "#511f0f"
  })), _path3396 || (_path3396 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57v-1h1v1z",
    fill: "#7a4426"
  })), _path3397 || (_path3397 = /*#__PURE__*/React.createElement("path", {
    d: "M63 57h-1v-1h1z",
    fill: "#deb17c"
  })), _path3398 || (_path3398 = /*#__PURE__*/React.createElement("path", {
    d: "M63 56h1v1h-1z",
    fill: "#dcb87c"
  })), _path3399 || (_path3399 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56v1h-1v-1z",
    fill: "#d2aa72"
  })), _path3400 || (_path3400 = /*#__PURE__*/React.createElement("path", {
    d: "M66 56v1h-1v-1z",
    fill: "#b57d45"
  })), _path3401 || (_path3401 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v-1h1v1z",
    fill: "#9a5826"
  })), _path3402 || (_path3402 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56h1v1h-1z",
    fill: "#905b31"
  })), _path3403 || (_path3403 = /*#__PURE__*/React.createElement("path", {
    d: "M68 56h1v1h-1z",
    fill: "#a5785c"
  })), _path3404 || (_path3404 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56h1v1h-1z",
    fill: "#80652a"
  })), _path3405 || (_path3405 = /*#__PURE__*/React.createElement("path", {
    d: "M71 57h-1v-1h1z",
    fill: "#614719"
  })), _path3406 || (_path3406 = /*#__PURE__*/React.createElement("path", {
    d: "M71 57v-1h1v1z",
    fill: "#987328"
  })), _path3407 || (_path3407 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56h1v1h-1z",
    fill: "#6b3d1b"
  })), _path3408 || (_path3408 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57h-1v-1h1z",
    fill: "#967751"
  })), _path3409 || (_path3409 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57h-1v-1h1z",
    fill: "#eede9c"
  })), _path3410 || (_path3410 = /*#__PURE__*/React.createElement("path", {
    d: "M76 57h-1v-1h1z",
    fill: "#e5da9a"
  })), _path3411 || (_path3411 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56h1v1h-1z",
    fill: "#d0c084"
  })), _path3412 || (_path3412 = /*#__PURE__*/React.createElement("path", {
    d: "M78 56v1h-1v-1z",
    fill: "#c1ac6e"
  })), _path3413 || (_path3413 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57v-1h1v1z",
    fill: "#675136"
  })), _path3414 || (_path3414 = /*#__PURE__*/React.createElement("path", {
    d: "M80 56v1h-1v-1z",
    fill: "#23100a"
  })), _path3415 || (_path3415 = /*#__PURE__*/React.createElement("path", {
    d: "M81 57h-1v-1h1z",
    fill: "#4c2f19"
  })), _path3416 || (_path3416 = /*#__PURE__*/React.createElement("path", {
    d: "M81 56h1v1h-1z",
    fill: "#6c3e17"
  })), _path3417 || (_path3417 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56v1h-1v-1z",
    fill: "#753816"
  })), _path3418 || (_path3418 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57v-1h1v1z",
    fill: "#612d12"
  })), _path3419 || (_path3419 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57v-1h1v1z",
    fill: "#633b25"
  })), _path3420 || (_path3420 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57h-1v-1h1z",
    fill: "#482417"
  })), _path3421 || (_path3421 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56v1h-1v-1z",
    fill: "#2b100f"
  })), _path3422 || (_path3422 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56h1v1h-1z",
    fill: "#3e1a12"
  })), _path3423 || (_path3423 = /*#__PURE__*/React.createElement("path", {
    d: "M89 56h1v1h-1z",
    fill: "#4f210f"
  })), _path3424 || (_path3424 = /*#__PURE__*/React.createElement("path", {
    d: "M90 57v-1h1v1z",
    fill: "#753717"
  })), _path3425 || (_path3425 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57h-1v-1h1z",
    fill: "#763614"
  })), _path3426 || (_path3426 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v-1h1v1z",
    fill: "#895335"
  })), _path3427 || (_path3427 = /*#__PURE__*/React.createElement("path", {
    d: "M93 56h1v1h-1z",
    fill: "#a5725f"
  })), _path3428 || (_path3428 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56v1h-1v-1z",
    fill: "#613f33"
  })), _path3429 || (_path3429 = /*#__PURE__*/React.createElement("path", {
    d: "M96 57h-1v-1h1z",
    fill: "#1a0a03"
  })), _path3430 || (_path3430 = /*#__PURE__*/React.createElement("path", {
    d: "M97 57v-1h1v1z",
    fill: "#663e14"
  })), _path3431 || (_path3431 = /*#__PURE__*/React.createElement("path", {
    d: "M99 57h-1v-1h1z",
    fill: "#985611"
  })), _path3432 || (_path3432 = /*#__PURE__*/React.createElement("path", {
    d: "M100 56v1h-1v-1z",
    fill: "#bc6a13"
  })), _path3433 || (_path3433 = /*#__PURE__*/React.createElement("path", {
    d: "M100 56h1v1h-1z",
    fill: "#d2951f"
  })), _path3434 || (_path3434 = /*#__PURE__*/React.createElement("path", {
    d: "M102 57h-1v-1h1z",
    fill: "#cfa431"
  })), _path3435 || (_path3435 = /*#__PURE__*/React.createElement("path", {
    d: "M103 57h-1v-1h1z",
    fill: "#a4763e"
  })), _path3436 || (_path3436 = /*#__PURE__*/React.createElement("path", {
    d: "M103 56h1v1h-1z",
    fill: "#965f54"
  })), _path3437 || (_path3437 = /*#__PURE__*/React.createElement("path", {
    d: "M104 57v-1h1v1z",
    fill: "#b0776d"
  })), _path3438 || (_path3438 = /*#__PURE__*/React.createElement("path", {
    d: "M106 57h-1v-1h1z",
    fill: "#a77560"
  })), _path3439 || (_path3439 = /*#__PURE__*/React.createElement("path", {
    d: "M106 57v-1h1v1z",
    fill: "#a2714d"
  })), _path3440 || (_path3440 = /*#__PURE__*/React.createElement("path", {
    d: "M107 57v-1h1v1z",
    fill: "#8f6d34"
  })), _path3441 || (_path3441 = /*#__PURE__*/React.createElement("path", {
    d: "M108 56h1v1h-1z",
    fill: "#9d8042"
  })), _path3442 || (_path3442 = /*#__PURE__*/React.createElement("path", {
    d: "M109 56h1v1h-1z",
    fill: "#956c30"
  })), _path3443 || (_path3443 = /*#__PURE__*/React.createElement("path", {
    d: "M110 56h1v1h-1z",
    fill: "#ba8033"
  })), _path3444 || (_path3444 = /*#__PURE__*/React.createElement("path", {
    d: "M112 56v1h-1v-1z",
    fill: "#9c5914"
  })), _path3445 || (_path3445 = /*#__PURE__*/React.createElement("path", {
    d: "M112 57v-1h1v1z",
    fill: "#612602"
  })), _path3446 || (_path3446 = /*#__PURE__*/React.createElement("path", {
    d: "M114 56v1h-1v-1z",
    fill: "#8f6a3a"
  })), _path3447 || (_path3447 = /*#__PURE__*/React.createElement("path", {
    d: "M114 57v-1h1v1z",
    fill: "#f5d9b1"
  })), _path3448 || (_path3448 = /*#__PURE__*/React.createElement("path", {
    d: "M116 57h-1v-1h1z",
    fill: "#ecd9b7"
  })), _path3449 || (_path3449 = /*#__PURE__*/React.createElement("path", {
    d: "M116 56h1v1h-1z",
    fill: "#e2d5ae"
  })), _path3450 || (_path3450 = /*#__PURE__*/React.createElement("path", {
    d: "M117 56h1v1h-1z",
    fill: "#e2cfad",
    fillOpacity: 0.941
  })), _path3451 || (_path3451 = /*#__PURE__*/React.createElement("path", {
    d: "M119 56v1h-1v-1z",
    fill: "#dbcbac",
    fillOpacity: 0.965
  })), _path3452 || (_path3452 = /*#__PURE__*/React.createElement("path", {
    d: "M119 57v-1h1v1z",
    fill: "#c1b498",
    fillOpacity: 0.243
  })), _path3453 || (_path3453 = /*#__PURE__*/React.createElement("path", {
    d: "M30 58v-1h1v1z",
    fill: "#9c7739",
    fillOpacity: 0.192
  })), _path3454 || (_path3454 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58v-1h1v1z",
    fill: "#74572d",
    fillOpacity: 0.376
  })), _path3455 || (_path3455 = /*#__PURE__*/React.createElement("path", {
    d: "M33 57v1h-1v-1z",
    fill: "#53371b",
    fillOpacity: 0.251
  })), _path3456 || (_path3456 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v1h-1v-1z",
    fill: "#552a0e",
    fillOpacity: 0.071
  })), _path3457 || (_path3457 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58h-1v-1h1z",
    fill: "#9d712c",
    fillOpacity: 0.361
  })), _path3458 || (_path3458 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58v-1h1v1z",
    fill: "#b58a25",
    fillOpacity: 0.949
  })), _path3459 || (_path3459 = /*#__PURE__*/React.createElement("path", {
    d: "M36 57h1v1h-1z",
    fill: "#b7830f"
  })), _path3460 || (_path3460 = /*#__PURE__*/React.createElement("path", {
    d: "M38 58h-1v-1h1z",
    fill: "#a06612"
  })), _path3461 || (_path3461 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h-1v-1h1z",
    fill: "#895616"
  })), _path3462 || (_path3462 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57h1v1h-1z",
    fill: "#563713"
  })), _path3463 || (_path3463 = /*#__PURE__*/React.createElement("path", {
    d: "M40 57h1v1h-1z",
    fill: "#1a1513"
  })), _path3464 || (_path3464 = /*#__PURE__*/React.createElement("path", {
    d: "M41 57h1v1h-1z",
    fill: "#18171a"
  })), _path3465 || (_path3465 = /*#__PURE__*/React.createElement("path", {
    d: "M43 58h-1v-1h1z",
    fill: "#1c1810"
  })), _path3466 || (_path3466 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58h-1v-1h1z",
    fill: "#352016"
  })), _path3467 || (_path3467 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58h-1v-1h1z",
    fill: "#613d2d"
  })), _path3468 || (_path3468 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v-1h1v1z",
    fill: "#522b19"
  })), _path3469 || (_path3469 = /*#__PURE__*/React.createElement("path", {
    d: "M48 57h1v1h-1z",
    fill: "#532919"
  })), _path3470 || (_path3470 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57h1v1h-1z",
    fill: "#471b0c"
  })), _path3471 || (_path3471 = /*#__PURE__*/React.createElement("path", {
    d: "M50 57h1v1h-1z",
    fill: "#481a09"
  })), _path3472 || (_path3472 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h-1v-1h1z",
    fill: "#552607"
  })), _path3473 || (_path3473 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58v-1h1v1z",
    fill: "#633109"
  })), _path3474 || (_path3474 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h1v1h-1z",
    fill: "#6a350a"
  })), _path3475 || (_path3475 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h-1v-1h1z",
    fill: "#592906"
  })), _path3476 || (_path3476 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h1v1h-1z",
    fill: "#4c2102"
  })), _path3477 || (_path3477 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h-1v-1h1z",
    fill: "#73462a"
  })), _path3478 || (_path3478 = /*#__PURE__*/React.createElement("path", {
    d: "M58 58h-1v-1h1z",
    fill: "#543628"
  })), _path3479 || (_path3479 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57h1v1h-1z",
    fill: "#301f19"
  })), _path3480 || (_path3480 = /*#__PURE__*/React.createElement("path", {
    d: "M59 58v-1h1v1z",
    fill: "#3f1b10"
  })), _path3481 || (_path3481 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h1v1h-1z",
    fill: "#723614"
  })), _path3482 || (_path3482 = /*#__PURE__*/React.createElement("path", {
    d: "M62 58h-1v-1h1z",
    fill: "#b38145"
  })), _path3483 || (_path3483 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58h-1v-1h1z",
    fill: "#d0a45a"
  })), _path3484 || (_path3484 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v-1h1v1z",
    fill: "#d0a862"
  })), _path3485 || (_path3485 = /*#__PURE__*/React.createElement("path", {
    d: "M65 57v1h-1v-1z",
    fill: "#d9b67f"
  })), _path3486 || (_path3486 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v1h-1v-1z",
    fill: "#b0845b"
  })), _path3487 || (_path3487 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58h-1v-1h1z",
    fill: "#b98f6c"
  })), _path3488 || (_path3488 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v-1h1v1z",
    fill: "#d1aa8a"
  })), _path3489 || (_path3489 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58h-1v-1h1z",
    fill: "#dab399"
  })), _path3490 || (_path3490 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58v-1h1v1z",
    fill: "#cf9f42"
  })), _path3491 || (_path3491 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58v-1h1v1z",
    fill: "#e0b34c"
  })), _path3492 || (_path3492 = /*#__PURE__*/React.createElement("path", {
    d: "M72 58h-1v-1h1z",
    fill: "#c99650"
  })), _path3493 || (_path3493 = /*#__PURE__*/React.createElement("path", {
    d: "M72 57h1v1h-1z",
    fill: "#926549"
  })), _path3494 || (_path3494 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57v1h-1v-1z",
    fill: "#c7975b"
  })), _path3495 || (_path3495 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57v1h-1v-1z",
    fill: "#c6924b"
  })), _path3496 || (_path3496 = /*#__PURE__*/React.createElement("path", {
    d: "M75 58v-1h1v1z",
    fill: "#eccb8e"
  })), _path3497 || (_path3497 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v-1h1v1z",
    fill: "#f9e6ae"
  })), _path3498 || (_path3498 = /*#__PURE__*/React.createElement("path", {
    d: "M77 58v-1h1v1z",
    fill: "#f9e7af"
  })), _path3499 || (_path3499 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57h1v1h-1z",
    fill: "#dac698"
  })), _path3500 || (_path3500 = /*#__PURE__*/React.createElement("path", {
    d: "M79 58v-1h1v1z",
    fill: "#897850"
  })), _path3501 || (_path3501 = /*#__PURE__*/React.createElement("path", {
    d: "M80 57h1v1h-1z",
    fill: "#a88a4e"
  })), _path3502 || (_path3502 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58v-1h1v1z",
    fill: "#ab7338"
  })), _path3503 || (_path3503 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58h-1v-1h1z",
    fill: "#9d511e"
  })), _path3504 || (_path3504 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57h1v1h-1z",
    fill: "#a3561f"
  })), _path3505 || (_path3505 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58v-1h1v1z",
    fill: "#3f1f0e"
  })), _path3506 || (_path3506 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h1v1h-1z",
    fill: "#332013"
  })), _path3507 || (_path3507 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57v1h-1v-1z",
    fill: "#40321d"
  })), _path3508 || (_path3508 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58h-1v-1h1z",
    fill: "#4d2411"
  })), _path3509 || (_path3509 = /*#__PURE__*/React.createElement("path", {
    d: "M89 57v1h-1v-1z",
    fill: "#864123"
  })), _path3510 || (_path3510 = /*#__PURE__*/React.createElement("path", {
    d: "M89 58v-1h1v1z",
    fill: "#8d482a"
  })), _path3511 || (_path3511 = /*#__PURE__*/React.createElement("path", {
    d: "M91 57v1h-1v-1z",
    fill: "#7f3815"
  })), _path3512 || (_path3512 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v1h-1v-1z",
    fill: "#813c17"
  })), _path3513 || (_path3513 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58v-1h1v1z",
    fill: "#754228"
  })), _path3514 || (_path3514 = /*#__PURE__*/React.createElement("path", {
    d: "M94 57v1h-1v-1z",
    fill: "#4b2919"
  })), _path3515 || (_path3515 = /*#__PURE__*/React.createElement("path", {
    d: "M95 58h-1v-1h1z",
    fill: "#382318"
  })), _path3516 || (_path3516 = /*#__PURE__*/React.createElement("path", {
    d: "M96 58v-1h1v1z",
    fill: "#713d13"
  })), _path3517 || (_path3517 = /*#__PURE__*/React.createElement("path", {
    d: "M97 57h1v1h-1z",
    fill: "#aa732a"
  })), _path3518 || (_path3518 = /*#__PURE__*/React.createElement("path", {
    d: "M99 58h-1v-1h1z",
    fill: "#b06f1f"
  })), _path3519 || (_path3519 = /*#__PURE__*/React.createElement("path", {
    d: "M100 58h-1v-1h1z",
    fill: "#b57220"
  })), _path3520 || (_path3520 = /*#__PURE__*/React.createElement("path", {
    d: "M101 57v1h-1v-1z",
    fill: "#c38c20"
  })), _path3521 || (_path3521 = /*#__PURE__*/React.createElement("path", {
    d: "M101 58v-1h1v1z",
    fill: "#a97424"
  })), _path3522 || (_path3522 = /*#__PURE__*/React.createElement("path", {
    d: "M103 57v1h-1v-1z",
    fill: "#67352a"
  })), _path3523 || (_path3523 = /*#__PURE__*/React.createElement("path", {
    d: "M103 57h1v1h-1z",
    fill: "#6b3d3a"
  })), _path3524 || (_path3524 = /*#__PURE__*/React.createElement("path", {
    d: "M105 58h-1v-1h1z",
    fill: "#794c3d"
  })), _path3525 || (_path3525 = /*#__PURE__*/React.createElement("path", {
    d: "M106 57v1h-1v-1z",
    fill: "#8f6356"
  })), _path3526 || (_path3526 = /*#__PURE__*/React.createElement("path", {
    d: "M107 58h-1v-1h1z",
    fill: "#97664f"
  })), _path3527 || (_path3527 = /*#__PURE__*/React.createElement("path", {
    d: "M108 58h-1v-1h1z",
    fill: "#6d4827"
  })), _path3528 || (_path3528 = /*#__PURE__*/React.createElement("path", {
    d: "M108 58v-1h1v1z",
    fill: "#4e3420"
  })), _path3529 || (_path3529 = /*#__PURE__*/React.createElement("path", {
    d: "M110 57v1h-1v-1z",
    fill: "#5a3d23"
  })), _path3530 || (_path3530 = /*#__PURE__*/React.createElement("path", {
    d: "M110 58v-1h1v1z",
    fill: "#7f4d28"
  })), _path3531 || (_path3531 = /*#__PURE__*/React.createElement("path", {
    d: "M112 58h-1v-1h1z",
    fill: "#824820"
  })), _path3532 || (_path3532 = /*#__PURE__*/React.createElement("path", {
    d: "M113 58h-1v-1h1z",
    fill: "#542a07"
  })), _path3533 || (_path3533 = /*#__PURE__*/React.createElement("path", {
    d: "M113 58v-1h1v1z",
    fill: "#9d7757"
  })), _path3534 || (_path3534 = /*#__PURE__*/React.createElement("path", {
    d: "M115 57v1h-1v-1z",
    fill: "#c0a088"
  })), _path3535 || (_path3535 = /*#__PURE__*/React.createElement("path", {
    d: "M116 58h-1v-1h1z",
    fill: "#edd7aa"
  })), _path3536 || (_path3536 = /*#__PURE__*/React.createElement("path", {
    d: "M117 58h-1v-1h1z",
    fill: "#d5c194",
    fillOpacity: 0.925
  })), _path3537 || (_path3537 = /*#__PURE__*/React.createElement("path", {
    d: "M118 57v1h-1v-1z",
    fill: "#a59678",
    fillOpacity: 0.2
  })), _path3538 || (_path3538 = /*#__PURE__*/React.createElement("path", {
    d: "M119 57v1h-1v-1z",
    fill: "#cabc91",
    fillOpacity: 0.302
  })), _path3539 || (_path3539 = /*#__PURE__*/React.createElement("path", {
    d: "M120 58h-1v-1h1z",
    fill: "#b9a678",
    fillOpacity: 0.373
  })), _path3540 || (_path3540 = /*#__PURE__*/React.createElement("path", {
    d: "M121 58v-1h1v1z",
    fill: "#b69563",
    fillOpacity: 0.18
  })), _path3541 || (_path3541 = /*#__PURE__*/React.createElement("path", {
    d: "M123 57v1h-1v-1z",
    fill: "#bf996c",
    fillOpacity: 0.157
  })), _path3542 || (_path3542 = /*#__PURE__*/React.createElement("path", {
    d: "M123 58v-1h1v1z",
    fill: "#aa7155",
    fillOpacity: 0.035
  })), _path3543 || (_path3543 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h-1v-1h1z",
    fill: "#96732b",
    fillOpacity: 0.345
  })), _path3544 || (_path3544 = /*#__PURE__*/React.createElement("path", {
    d: "M36 58h1v1h-1z",
    fill: "#ad7a22",
    fillOpacity: 0.992
  })), _path3545 || (_path3545 = /*#__PURE__*/React.createElement("path", {
    d: "M37 58h1v1h-1z",
    fill: "#a76f16"
  })), _path3546 || (_path3546 = /*#__PURE__*/React.createElement("path", {
    d: "M38 59v-1h1v1z",
    fill: "#936217"
  })), _path3547 || (_path3547 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h1v1h-1z",
    fill: "#6c4a1b"
  })), _path3548 || (_path3548 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h-1v-1h1z",
    fill: "#1f170c"
  })), _path3549 || (_path3549 = /*#__PURE__*/React.createElement("path", {
    d: "M42 59h-1v-1h1z",
    fill: "#201913"
  })), _path3550 || (_path3550 = /*#__PURE__*/React.createElement("path", {
    d: "M42 58h1v1h-1z",
    fill: "#463321"
  })), _path3551 || (_path3551 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v1h-1v-1z",
    fill: "#855534"
  })), _path3552 || (_path3552 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v1h-1v-1z",
    fill: "#814e32"
  })), _path3553 || (_path3553 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58h1v1h-1z",
    fill: "#3b1508"
  })), _path3554 || (_path3554 = /*#__PURE__*/React.createElement("path", {
    d: "M47 59v-1h1v1z",
    fill: "#4b1b09"
  })), _path3555 || (_path3555 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58v1h-1v-1z",
    fill: "#532209"
  })), _path3556 || (_path3556 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58h1v1h-1z",
    fill: "#5a2c1a"
  })), _path3557 || (_path3557 = /*#__PURE__*/React.createElement("path", {
    d: "M51 58v1h-1v-1z",
    fill: "#441a0b"
  })), _path3558 || (_path3558 = /*#__PURE__*/React.createElement("path", {
    d: "M51 59v-1h1v1z",
    fill: "#5c2f08"
  })), _path3559 || (_path3559 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h1v1h-1z",
    fill: "#77400c"
  })), _path3560 || (_path3560 = /*#__PURE__*/React.createElement("path", {
    d: "M53 58h1v1h-1z",
    fill: "#773e0a"
  })), _path3561 || (_path3561 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58v1h-1v-1z",
    fill: "#703909"
  })), _path3562 || (_path3562 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h1v1h-1z",
    fill: "#663109"
  })), _path3563 || (_path3563 = /*#__PURE__*/React.createElement("path", {
    d: "M57 59h-1v-1h1z",
    fill: "#65361b"
  })), _path3564 || (_path3564 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h1v1h-1z",
    fill: "#3b1a0b"
  })), _path3565 || (_path3565 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59h-1v-1h1z",
    fill: "#220e05"
  })), _path3566 || (_path3566 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59v-1h1v1z",
    fill: "#4a250a"
  })), _path3567 || (_path3567 = /*#__PURE__*/React.createElement("path", {
    d: "M61 58v1h-1v-1z",
    fill: "#9d5a15"
  })), _path3568 || (_path3568 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v-1h1v1z",
    fill: "#cc8b35"
  })), _path3569 || (_path3569 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v1h-1v-1z",
    fill: "#af7626"
  })), _path3570 || (_path3570 = /*#__PURE__*/React.createElement("path", {
    d: "M64 58v1h-1v-1z",
    fill: "#c7934f"
  })), _path3571 || (_path3571 = /*#__PURE__*/React.createElement("path", {
    d: "M65 59h-1v-1h1z",
    fill: "#c59864"
  })), _path3572 || (_path3572 = /*#__PURE__*/React.createElement("path", {
    d: "M65 58h1v1h-1z",
    fill: "#b38765"
  })), _path3573 || (_path3573 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v1h-1v-1z",
    fill: "#ab7f5e"
  })), _path3574 || (_path3574 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59h-1v-1h1z",
    fill: "#c39f79"
  })), _path3575 || (_path3575 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59v-1h1v1z",
    fill: "#dab79c"
  })), _path3576 || (_path3576 = /*#__PURE__*/React.createElement("path", {
    d: "M69 59v-1h1v1z",
    fill: "#b9865b"
  })), _path3577 || (_path3577 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58h1v1h-1z",
    fill: "#c99974"
  })), _path3578 || (_path3578 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h-1v-1h1z",
    fill: "#e4b7a4"
  })), _path3579 || (_path3579 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h-1v-1h1z",
    fill: "#d8b698"
  })), _path3580 || (_path3580 = /*#__PURE__*/React.createElement("path", {
    d: "M74 59h-1v-1h1z",
    fill: "#dbb494"
  })), _path3581 || (_path3581 = /*#__PURE__*/React.createElement("path", {
    d: "M74 58h1v1h-1z",
    fill: "#cc9a60"
  })), _path3582 || (_path3582 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v1h-1v-1z",
    fill: "#ac7a32"
  })), _path3583 || (_path3583 = /*#__PURE__*/React.createElement("path", {
    d: "M76 59v-1h1v1z",
    fill: "#ddbf79"
  })), _path3584 || (_path3584 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59h-1v-1h1z",
    fill: "#f1e6af"
  })), _path3585 || (_path3585 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v-1h1v1z",
    fill: "#e4d69c"
  })), _path3586 || (_path3586 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h-1v-1h1z",
    fill: "#f6e8ad"
  })), _path3587 || (_path3587 = /*#__PURE__*/React.createElement("path", {
    d: "M80 58h1v1h-1z",
    fill: "#fbe3a3"
  })), _path3588 || (_path3588 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58h1v1h-1z",
    fill: "#d5a867"
  })), _path3589 || (_path3589 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58v1h-1v-1z",
    fill: "#b56015"
  })), _path3590 || (_path3590 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v-1h1v1z",
    fill: "#bb6119"
  })), _path3591 || (_path3591 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58h1v1h-1z",
    fill: "#683421"
  })), _path3592 || (_path3592 = /*#__PURE__*/React.createElement("path", {
    d: "M86 59h-1v-1h1z",
    fill: "#271611"
  })), _path3593 || (_path3593 = /*#__PURE__*/React.createElement("path", {
    d: "M86 58h1v1h-1z",
    fill: "#301e0c"
  })), _path3594 || (_path3594 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58v1h-1v-1z",
    fill: "#492e13"
  })), _path3595 || (_path3595 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58h1v1h-1z",
    fill: "#482717"
  })), _path3596 || (_path3596 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59h-1v-1h1z",
    fill: "#412212"
  })), _path3597 || (_path3597 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59v-1h1v1z",
    fill: "#582e20"
  })), _path3598 || (_path3598 = /*#__PURE__*/React.createElement("path", {
    d: "M92 59h-1v-1h1z",
    fill: "#835441"
  })), _path3599 || (_path3599 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58h1v1h-1z",
    fill: "#6e4739"
  })), _path3600 || (_path3600 = /*#__PURE__*/React.createElement("path", {
    d: "M93 59v-1h1v1z",
    fill: "#39241d"
  })), _path3601 || (_path3601 = /*#__PURE__*/React.createElement("path", {
    d: "M94 58h1v1h-1z",
    fill: "#25170f"
  })), _path3602 || (_path3602 = /*#__PURE__*/React.createElement("path", {
    d: "M95 59v-1h1v1z",
    fill: "#724d33"
  })), _path3603 || (_path3603 = /*#__PURE__*/React.createElement("path", {
    d: "M97 58v1h-1v-1z",
    fill: "#b27434"
  })), _path3604 || (_path3604 = /*#__PURE__*/React.createElement("path", {
    d: "M97 59v-1h1v1z",
    fill: "#b77929"
  })), _path3605 || (_path3605 = /*#__PURE__*/React.createElement("path", {
    d: "M98 58h1v1h-1z",
    fill: "#d19f4e"
  })), _path3606 || (_path3606 = /*#__PURE__*/React.createElement("path", {
    d: "M100 58v1h-1v-1z",
    fill: "#c79d43"
  })), _path3607 || (_path3607 = /*#__PURE__*/React.createElement("path", {
    d: "M100 59v-1h1v1z",
    fill: "#cea54f"
  })), _path3608 || (_path3608 = /*#__PURE__*/React.createElement("path", {
    d: "M101 58h1v1h-1z",
    fill: "#cfa350"
  })), _path3609 || (_path3609 = /*#__PURE__*/React.createElement("path", {
    d: "M102 58h1v1h-1z",
    fill: "#9a6e38"
  })), _path3610 || (_path3610 = /*#__PURE__*/React.createElement("path", {
    d: "M103 58h1v1h-1z",
    fill: "#5b371f"
  })), _path3611 || (_path3611 = /*#__PURE__*/React.createElement("path", {
    d: "M105 59h-1v-1h1z",
    fill: "#3f1b0a"
  })), _path3612 || (_path3612 = /*#__PURE__*/React.createElement("path", {
    d: "M106 59h-1v-1h1z",
    fill: "#51260d"
  })), _path3613 || (_path3613 = /*#__PURE__*/React.createElement("path", {
    d: "M107 58v1h-1v-1z",
    fill: "#613319"
  })), _path3614 || (_path3614 = /*#__PURE__*/React.createElement("path", {
    d: "M107 59v-1h1v1z",
    fill: "#59331f"
  })), _path3615 || (_path3615 = /*#__PURE__*/React.createElement("path", {
    d: "M108 59v-1h1v1z",
    fill: "#442c25"
  })), _path3616 || (_path3616 = /*#__PURE__*/React.createElement("path", {
    d: "M110 59h-1v-1h1z",
    fill: "#382c20"
  })), _path3617 || (_path3617 = /*#__PURE__*/React.createElement("path", {
    d: "M111 58v1h-1v-1z",
    fill: "#77593d"
  })), _path3618 || (_path3618 = /*#__PURE__*/React.createElement("path", {
    d: "M112 59h-1v-1h1z",
    fill: "#86613d"
  })), _path3619 || (_path3619 = /*#__PURE__*/React.createElement("path", {
    d: "M112 59v-1h1v1z",
    fill: "#432b15"
  })), _path3620 || (_path3620 = /*#__PURE__*/React.createElement("path", {
    d: "M113 58h1v1h-1z",
    fill: "#5d3523"
  })), _path3621 || (_path3621 = /*#__PURE__*/React.createElement("path", {
    d: "M114 58h1v1h-1z",
    fill: "#774933"
  })), _path3622 || (_path3622 = /*#__PURE__*/React.createElement("path", {
    d: "M116 59h-1v-1h1z",
    fill: "#9d7a5f"
  })), _path3623 || (_path3623 = /*#__PURE__*/React.createElement("path", {
    d: "M117 58v1h-1v-1z",
    fill: "#77614a",
    fillOpacity: 0.737
  })), _path3624 || (_path3624 = /*#__PURE__*/React.createElement("path", {
    d: "M119 59v-1h1v1z",
    fill: "#993",
    fillOpacity: 0.02
  })), _path3625 || (_path3625 = /*#__PURE__*/React.createElement("path", {
    d: "M121 58h1v1h-1z",
    fill: "#ad8b51",
    fillOpacity: 0.086
  })), _path3626 || (_path3626 = /*#__PURE__*/React.createElement("path", {
    d: "M122 59v-1h1v1z",
    fill: "#c39669",
    fillOpacity: 0.067
  })), _path3627 || (_path3627 = /*#__PURE__*/React.createElement("path", {
    d: "M123 58h1v1h-1z",
    fill: "#b6916d",
    fillOpacity: 0.027
  })), _path3628 || (_path3628 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59v1h-1v-1z",
    fill: "#00007f",
    fillOpacity: 0.008
  })), _path3629 || (_path3629 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h1v1h-1z",
    fill: "#a5762b",
    fillOpacity: 0.573
  })), _path3630 || (_path3630 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60h-1v-1h1z",
    fill: "#9a6a20",
    fillOpacity: 0.835
  })), _path3631 || (_path3631 = /*#__PURE__*/React.createElement("path", {
    d: "M39 60h-1v-1h1z",
    fill: "#7f5216",
    fillOpacity: 0.925
  })), _path3632 || (_path3632 = /*#__PURE__*/React.createElement("path", {
    d: "M39 59h1v1h-1z",
    fill: "#80501a"
  })), _path3633 || (_path3633 = /*#__PURE__*/React.createElement("path", {
    d: "M40 59h1v1h-1z",
    fill: "#543c13"
  })), _path3634 || (_path3634 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h1v1h-1z",
    fill: "#57441e"
  })), _path3635 || (_path3635 = /*#__PURE__*/React.createElement("path", {
    d: "M42 60v-1h1v1z",
    fill: "#3e2a11"
  })), _path3636 || (_path3636 = /*#__PURE__*/React.createElement("path", {
    d: "M43 60v-1h1v1z",
    fill: "#7e533a"
  })), _path3637 || (_path3637 = /*#__PURE__*/React.createElement("path", {
    d: "M45 60h-1v-1h1z",
    fill: "#8d5533"
  })), _path3638 || (_path3638 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h-1v-1h1z",
    fill: "#743b19"
  })), _path3639 || (_path3639 = /*#__PURE__*/React.createElement("path", {
    d: "M46 59h1v1h-1z",
    fill: "#834213"
  })), _path3640 || (_path3640 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h-1v-1h1z",
    fill: "#94531b"
  })), _path3641 || (_path3641 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h-1v-1h1z",
    fill: "#884e27"
  })), _path3642 || (_path3642 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60v-1h1v1z",
    fill: "#5b301b"
  })), _path3643 || (_path3643 = /*#__PURE__*/React.createElement("path", {
    d: "M50 59h1v1h-1z",
    fill: "#512b18"
  })), _path3644 || (_path3644 = /*#__PURE__*/React.createElement("path", {
    d: "M52 60h-1v-1h1z",
    fill: "#79451b"
  })), _path3645 || (_path3645 = /*#__PURE__*/React.createElement("path", {
    d: "M52 59h1v1h-1z",
    fill: "#915719"
  })), _path3646 || (_path3646 = /*#__PURE__*/React.createElement("path", {
    d: "M54 59v1h-1v-1z",
    fill: "#935316"
  })), _path3647 || (_path3647 = /*#__PURE__*/React.createElement("path", {
    d: "M54 60v-1h1v1z",
    fill: "#864611"
  })), _path3648 || (_path3648 = /*#__PURE__*/React.createElement("path", {
    d: "M55 59h1v1h-1z",
    fill: "#6b3107"
  })), _path3649 || (_path3649 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60v-1h1v1z",
    fill: "#57260b"
  })), _path3650 || (_path3650 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59v1h-1v-1z",
    fill: "#451e0d"
  })), _path3651 || (_path3651 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59h1v1h-1z",
    fill: "#421f0d"
  })), _path3652 || (_path3652 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60h-1v-1h1z",
    fill: "#804c22"
  })), _path3653 || (_path3653 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v1h-1v-1z",
    fill: "#a85e16"
  })), _path3654 || (_path3654 = /*#__PURE__*/React.createElement("path", {
    d: "M62 60h-1v-1h1z",
    fill: "#c97f2e"
  })), _path3655 || (_path3655 = /*#__PURE__*/React.createElement("path", {
    d: "M63 60h-1v-1h1z",
    fill: "#9f5814"
  })), _path3656 || (_path3656 = /*#__PURE__*/React.createElement("path", {
    d: "M64 59v1h-1v-1z",
    fill: "#8f5425"
  })), _path3657 || (_path3657 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v-1h1v1z",
    fill: "#633615"
  })), _path3658 || (_path3658 = /*#__PURE__*/React.createElement("path", {
    d: "M65 60v-1h1v1z",
    fill: "#8c5732"
  })), _path3659 || (_path3659 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h-1v-1h1z",
    fill: "#a36f49"
  })), _path3660 || (_path3660 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60v-1h1v1z",
    fill: "#b38064"
  })), _path3661 || (_path3661 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60h-1v-1h1z",
    fill: "#ac6d4b"
  })), _path3662 || (_path3662 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v-1h1v1z",
    fill: "#9b6546"
  })), _path3663 || (_path3663 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59v1h-1v-1z",
    fill: "#dfb19c"
  })), _path3664 || (_path3664 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h1v1h-1z",
    fill: "#d8b29f"
  })), _path3665 || (_path3665 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h1v1h-1z",
    fill: "#dfc1a8"
  })), _path3666 || (_path3666 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60h-1v-1h1z",
    fill: "#e8caa5"
  })), _path3667 || (_path3667 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60v-1h1v1z",
    fill: "#dab178"
  })), _path3668 || (_path3668 = /*#__PURE__*/React.createElement("path", {
    d: "M77 59v1h-1v-1z",
    fill: "#c29d5d"
  })), _path3669 || (_path3669 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v1h-1v-1z",
    fill: "#f4e0aa"
  })), _path3670 || (_path3670 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60h-1v-1h1z",
    fill: "#eee0ae"
  })), _path3671 || (_path3671 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59v1h-1v-1z",
    fill: "#e1d3a5"
  })), _path3672 || (_path3672 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h1v1h-1z",
    fill: "#f5e0a2"
  })), _path3673 || (_path3673 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v-1h1v1z",
    fill: "#edcb72"
  })), _path3674 || (_path3674 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v1h-1v-1z",
    fill: "#bb7a29"
  })), _path3675 || (_path3675 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59h1v1h-1z",
    fill: "#8c471b"
  })), _path3676 || (_path3676 = /*#__PURE__*/React.createElement("path", {
    d: "M85 59v1h-1v-1z",
    fill: "#5c2513"
  })), _path3677 || (_path3677 = /*#__PURE__*/React.createElement("path", {
    d: "M85 60v-1h1v1z",
    fill: "#745137"
  })), _path3678 || (_path3678 = /*#__PURE__*/React.createElement("path", {
    d: "M87 60h-1v-1h1z",
    fill: "#482d1c"
  })), _path3679 || (_path3679 = /*#__PURE__*/React.createElement("path", {
    d: "M87 60v-1h1v1z",
    fill: "#674e38"
  })), _path3680 || (_path3680 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60h-1v-1h1z",
    fill: "#5a3e34"
  })), _path3681 || (_path3681 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60v-1h1v1z",
    fill: "#6e4e3f"
  })), _path3682 || (_path3682 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59h1v1h-1z",
    fill: "#8c6354"
  })), _path3683 || (_path3683 = /*#__PURE__*/React.createElement("path", {
    d: "M92 59v1h-1v-1z",
    fill: "#5e372b"
  })), _path3684 || (_path3684 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60v-1h1v1z",
    fill: "#361a12"
  })), _path3685 || (_path3685 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h-1v-1h1z",
    fill: "#311e1b"
  })), _path3686 || (_path3686 = /*#__PURE__*/React.createElement("path", {
    d: "M95 60h-1v-1h1z",
    fill: "#2f170a"
  })), _path3687 || (_path3687 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h-1v-1h1z",
    fill: "#8d6734"
  })), _path3688 || (_path3688 = /*#__PURE__*/React.createElement("path", {
    d: "M97 60h-1v-1h1z",
    fill: "#d19a50"
  })), _path3689 || (_path3689 = /*#__PURE__*/React.createElement("path", {
    d: "M98 59v1h-1v-1z",
    fill: "#b7812d"
  })), _path3690 || (_path3690 = /*#__PURE__*/React.createElement("path", {
    d: "M99 59v1h-1v-1z",
    fill: "#d4a85c"
  })), _path3691 || (_path3691 = /*#__PURE__*/React.createElement("path", {
    d: "M100 60h-1v-1h1z",
    fill: "#e2b678"
  })), _path3692 || (_path3692 = /*#__PURE__*/React.createElement("path", {
    d: "M101 59v1h-1v-1z",
    fill: "#e5b670"
  })), _path3693 || (_path3693 = /*#__PURE__*/React.createElement("path", {
    d: "M102 60h-1v-1h1z",
    fill: "#e7b65f"
  })), _path3694 || (_path3694 = /*#__PURE__*/React.createElement("path", {
    d: "M103 60h-1v-1h1z",
    fill: "#e3b16a"
  })), _path3695 || (_path3695 = /*#__PURE__*/React.createElement("path", {
    d: "M103 60v-1h1v1z",
    fill: "#4e2d1b"
  })), _path3696 || (_path3696 = /*#__PURE__*/React.createElement("path", {
    d: "M104 60v-1h1v1z",
    fill: "#291310"
  })), _path3697 || (_path3697 = /*#__PURE__*/React.createElement("path", {
    d: "M106 59v1h-1v-1z",
    fill: "#482516"
  })), _path3698 || (_path3698 = /*#__PURE__*/React.createElement("path", {
    d: "M107 60h-1v-1h1z",
    fill: "#653e2d"
  })), _path3699 || (_path3699 = /*#__PURE__*/React.createElement("path", {
    d: "M107 59h1v1h-1z",
    fill: "#5c382d"
  })), _path3700 || (_path3700 = /*#__PURE__*/React.createElement("path", {
    d: "M109 59v1h-1v-1z",
    fill: "#452924"
  })), _path3701 || (_path3701 = /*#__PURE__*/React.createElement("path", {
    d: "M109 60v-1h1v1z",
    fill: "#5a3c3a"
  })), _path3702 || (_path3702 = /*#__PURE__*/React.createElement("path", {
    d: "M110 60v-1h1v1z",
    fill: "#a7875d"
  })), _path3703 || (_path3703 = /*#__PURE__*/React.createElement("path", {
    d: "M111 60v-1h1v1z",
    fill: "#d3b06b"
  })), _path3704 || (_path3704 = /*#__PURE__*/React.createElement("path", {
    d: "M112 59h1v1h-1z",
    fill: "#9e754c"
  })), _path3705 || (_path3705 = /*#__PURE__*/React.createElement("path", {
    d: "M113 59h1v1h-1z",
    fill: "#91584d"
  })), _path3706 || (_path3706 = /*#__PURE__*/React.createElement("path", {
    d: "M114 59h1v1h-1z",
    fill: "#8c4f40"
  })), _path3707 || (_path3707 = /*#__PURE__*/React.createElement("path", {
    d: "M115 59h1v1h-1z",
    fill: "#703c2f"
  })), _path3708 || (_path3708 = /*#__PURE__*/React.createElement("path", {
    d: "M117 60h-1v-1h1z",
    fill: "#48271a",
    fillOpacity: 0.816
  })), _path3709 || (_path3709 = /*#__PURE__*/React.createElement("path", {
    d: "M118 59v1h-1v-1z",
    fill: "#4f3f2f",
    fillOpacity: 0.063
  })), _path3710 || (_path3710 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60v1h-1v-1z",
    fill: "#4c4c33",
    fillOpacity: 0.039
  })), _path3711 || (_path3711 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h-1v-1h1z",
    fill: "#75552d",
    fillOpacity: 0.153
  })), _path3712 || (_path3712 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61h-1v-1h1z",
    fill: "#81592d",
    fillOpacity: 0.416
  })), _path3713 || (_path3713 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61v-1h1v1z",
    fill: "#6f5023",
    fillOpacity: 0.447
  })), _path3714 || (_path3714 = /*#__PURE__*/React.createElement("path", {
    d: "M41 60h1v1h-1z",
    fill: "#613b1a",
    fillOpacity: 0.608
  })), _path3715 || (_path3715 = /*#__PURE__*/React.createElement("path", {
    d: "M43 61h-1v-1h1z",
    fill: "#4a2217",
    fillOpacity: 0.976
  })), _path3716 || (_path3716 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60v1h-1v-1z",
    fill: "#6d391b"
  })), _path3717 || (_path3717 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60h1v1h-1z",
    fill: "#975527"
  })), _path3718 || (_path3718 = /*#__PURE__*/React.createElement("path", {
    d: "M46 61h-1v-1h1z",
    fill: "#9b5c2c"
  })), _path3719 || (_path3719 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h1v1h-1z",
    fill: "#ab6a2f"
  })), _path3720 || (_path3720 = /*#__PURE__*/React.createElement("path", {
    d: "M48 61h-1v-1h1z",
    fill: "#a4652d"
  })), _path3721 || (_path3721 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h1v1h-1z",
    fill: "#522510"
  })), _path3722 || (_path3722 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h1v1h-1z",
    fill: "#32140f"
  })), _path3723 || (_path3723 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61v-1h1v1z",
    fill: "#411c10"
  })), _path3724 || (_path3724 = /*#__PURE__*/React.createElement("path", {
    d: "M52 61h-1v-1h1z",
    fill: "#804318"
  })), _path3725 || (_path3725 = /*#__PURE__*/React.createElement("path", {
    d: "M53 61h-1v-1h1z",
    fill: "#985718"
  })), _path3726 || (_path3726 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61h-1v-1h1z",
    fill: "#924e0f"
  })), _path3727 || (_path3727 = /*#__PURE__*/React.createElement("path", {
    d: "M55 60v1h-1v-1z",
    fill: "#8f4d19"
  })), _path3728 || (_path3728 = /*#__PURE__*/React.createElement("path", {
    d: "M55 61v-1h1v1z",
    fill: "#773c14"
  })), _path3729 || (_path3729 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60h1v1h-1z",
    fill: "#5f290d"
  })), _path3730 || (_path3730 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h-1v-1h1z",
    fill: "#542511"
  })), _path3731 || (_path3731 = /*#__PURE__*/React.createElement("path", {
    d: "M58 60h1v1h-1z",
    fill: "#4c220d"
  })), _path3732 || (_path3732 = /*#__PURE__*/React.createElement("path", {
    d: "M59 60h1v1h-1z",
    fill: "#602f0d"
  })), _path3733 || (_path3733 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61h-1v-1h1z",
    fill: "#7e3e11"
  })), _path3734 || (_path3734 = /*#__PURE__*/React.createElement("path", {
    d: "M61 60h1v1h-1z",
    fill: "#b56e2f"
  })), _path3735 || (_path3735 = /*#__PURE__*/React.createElement("path", {
    d: "M62 61v-1h1v1z",
    fill: "#9c541c"
  })), _path3736 || (_path3736 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v1h-1v-1z",
    fill: "#5d280d"
  })), _path3737 || (_path3737 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61v-1h1v1z",
    fill: "#3b1808"
  })), _path3738 || (_path3738 = /*#__PURE__*/React.createElement("path", {
    d: "M66 61h-1v-1h1z",
    fill: "#693316"
  })), _path3739 || (_path3739 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60v1h-1v-1z",
    fill: "#823d1b"
  })), _path3740 || (_path3740 = /*#__PURE__*/React.createElement("path", {
    d: "M67 61v-1h1v1z",
    fill: "#ab6f4e"
  })), _path3741 || (_path3741 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h1v1h-1z",
    fill: "#c28e77"
  })), _path3742 || (_path3742 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v1h-1v-1z",
    fill: "#b78166"
  })), _path3743 || (_path3743 = /*#__PURE__*/React.createElement("path", {
    d: "M71 61h-1v-1h1z",
    fill: "#b7825e"
  })), _path3744 || (_path3744 = /*#__PURE__*/React.createElement("path", {
    d: "M71 60h1v1h-1z",
    fill: "#c19075"
  })), _path3745 || (_path3745 = /*#__PURE__*/React.createElement("path", {
    d: "M72 60h1v1h-1z",
    fill: "#d5ae98"
  })), _path3746 || (_path3746 = /*#__PURE__*/React.createElement("path", {
    d: "M74 60v1h-1v-1z",
    fill: "#dfc2a8"
  })), _path3747 || (_path3747 = /*#__PURE__*/React.createElement("path", {
    d: "M75 61h-1v-1h1z",
    fill: "#ecd7bd"
  })), _path3748 || (_path3748 = /*#__PURE__*/React.createElement("path", {
    d: "M76 60v1h-1v-1z",
    fill: "#f1d7b2"
  })), _path3749 || (_path3749 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61v-1h1v1z",
    fill: "#cfaa79"
  })), _path3750 || (_path3750 = /*#__PURE__*/React.createElement("path", {
    d: "M78 61h-1v-1h1z",
    fill: "#986e39"
  })), _path3751 || (_path3751 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60v1h-1v-1z",
    fill: "#e9cf8b"
  })), _path3752 || (_path3752 = /*#__PURE__*/React.createElement("path", {
    d: "M80 60v1h-1v-1z",
    fill: "#e8d394"
  })), _path3753 || (_path3753 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v1h-1v-1z",
    fill: "#dfc584"
  })), _path3754 || (_path3754 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v-1h1v1z",
    fill: "#debb6a"
  })), _path3755 || (_path3755 = /*#__PURE__*/React.createElement("path", {
    d: "M83 61h-1v-1h1z",
    fill: "#ba8d43"
  })), _path3756 || (_path3756 = /*#__PURE__*/React.createElement("path", {
    d: "M83 60h1v1h-1z",
    fill: "#63341d"
  })), _path3757 || (_path3757 = /*#__PURE__*/React.createElement("path", {
    d: "M84 61v-1h1v1z",
    fill: "#6b3926"
  })), _path3758 || (_path3758 = /*#__PURE__*/React.createElement("path", {
    d: "M86 61h-1v-1h1z",
    fill: "#895631"
  })), _path3759 || (_path3759 = /*#__PURE__*/React.createElement("path", {
    d: "M86 60h1v1h-1z",
    fill: "#6f4531"
  })), _path3760 || (_path3760 = /*#__PURE__*/React.createElement("path", {
    d: "M88 61h-1v-1h1z",
    fill: "#7c5c50"
  })), _path3761 || (_path3761 = /*#__PURE__*/React.createElement("path", {
    d: "M88 60h1v1h-1z",
    fill: "#51352a"
  })), _path3762 || (_path3762 = /*#__PURE__*/React.createElement("path", {
    d: "M90 61h-1v-1h1z",
    fill: "#53352e"
  })), _path3763 || (_path3763 = /*#__PURE__*/React.createElement("path", {
    d: "M91 61h-1v-1h1z",
    fill: "#331a17"
  })), _path3764 || (_path3764 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60v1h-1v-1z",
    fill: "#210e0e"
  })), _path3765 || (_path3765 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60h1v1h-1z",
    fill: "#26191a"
  })), _path3766 || (_path3766 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61v-1h1v1z",
    fill: "#2c1d21"
  })), _path3767 || (_path3767 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h1v1h-1z",
    fill: "#3a2218"
  })), _path3768 || (_path3768 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v-1h1v1z",
    fill: "#a8875a"
  })), _path3769 || (_path3769 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h1v1h-1z",
    fill: "#d0ac6e"
  })), _path3770 || (_path3770 = /*#__PURE__*/React.createElement("path", {
    d: "M98 61h-1v-1h1z",
    fill: "#d3a867"
  })), _path3771 || (_path3771 = /*#__PURE__*/React.createElement("path", {
    d: "M98 60h1v1h-1z",
    fill: "#a37548"
  })), _path3772 || (_path3772 = /*#__PURE__*/React.createElement("path", {
    d: "M99 60h1v1h-1z",
    fill: "#653c26"
  })), _path3773 || (_path3773 = /*#__PURE__*/React.createElement("path", {
    d: "M101 61h-1v-1h1z",
    fill: "#a47a40"
  })), _path3774 || (_path3774 = /*#__PURE__*/React.createElement("path", {
    d: "M102 61h-1v-1h1z",
    fill: "#af7d34"
  })), _path3775 || (_path3775 = /*#__PURE__*/React.createElement("path", {
    d: "M102 61v-1h1v1z",
    fill: "#a67037"
  })), _path3776 || (_path3776 = /*#__PURE__*/React.createElement("path", {
    d: "M103 61v-1h1v1z",
    fill: "#57321b"
  })), _path3777 || (_path3777 = /*#__PURE__*/React.createElement("path", {
    d: "M104 60h1v1h-1z",
    fill: "#250f0a"
  })), _path3778 || (_path3778 = /*#__PURE__*/React.createElement("path", {
    d: "M105 60h1v1h-1z",
    fill: "#3a1c12"
  })), _path3779 || (_path3779 = /*#__PURE__*/React.createElement("path", {
    d: "M107 61h-1v-1h1z",
    fill: "#4b2c22"
  })), _path3780 || (_path3780 = /*#__PURE__*/React.createElement("path", {
    d: "M107 61v-1h1v1z",
    fill: "#482f27"
  })), _path3781 || (_path3781 = /*#__PURE__*/React.createElement("path", {
    d: "M109 60v1h-1v-1z",
    fill: "#37211c"
  })), _path3782 || (_path3782 = /*#__PURE__*/React.createElement("path", {
    d: "M110 60v1h-1v-1z",
    fill: "#482c2a"
  })), _path3783 || (_path3783 = /*#__PURE__*/React.createElement("path", {
    d: "M110 61v-1h1v1z",
    fill: "#482a1d"
  })), _path3784 || (_path3784 = /*#__PURE__*/React.createElement("path", {
    d: "M112 60v1h-1v-1z",
    fill: "#a17c57"
  })), _path3785 || (_path3785 = /*#__PURE__*/React.createElement("path", {
    d: "M112 61v-1h1v1z",
    fill: "#c99262"
  })), _path3786 || (_path3786 = /*#__PURE__*/React.createElement("path", {
    d: "M114 61h-1v-1h1z",
    fill: "#c4856d"
  })), _path3787 || (_path3787 = /*#__PURE__*/React.createElement("path", {
    d: "M114 60h1v1h-1z",
    fill: "#95573d"
  })), _path3788 || (_path3788 = /*#__PURE__*/React.createElement("path", {
    d: "M116 61h-1v-1h1z",
    fill: "#79432a"
  })), _path3789 || (_path3789 = /*#__PURE__*/React.createElement("path", {
    d: "M117 61h-1v-1h1z",
    fill: "#926952"
  })), _path3790 || (_path3790 = /*#__PURE__*/React.createElement("path", {
    d: "M117 61v-1h1v1z",
    fill: "#bba188",
    fillOpacity: 0.639
  })), _path3791 || (_path3791 = /*#__PURE__*/React.createElement("path", {
    d: "M42 62v-1h1v1z",
    fill: "#381411",
    fillOpacity: 0.337
  })), _path3792 || (_path3792 = /*#__PURE__*/React.createElement("path", {
    d: "M44 62h-1v-1h1z",
    fill: "#572b13",
    fillOpacity: 0.867
  })), _path3793 || (_path3793 = /*#__PURE__*/React.createElement("path", {
    d: "M44 61h1v1h-1z",
    fill: "#93562c"
  })), _path3794 || (_path3794 = /*#__PURE__*/React.createElement("path", {
    d: "M45 61h1v1h-1z",
    fill: "#a56a39"
  })), _path3795 || (_path3795 = /*#__PURE__*/React.createElement("path", {
    d: "M47 61h1v1h-1z",
    fill: "#804b16"
  })), _path3796 || (_path3796 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62h-1v-1h1z",
    fill: "#674418"
  })), _path3797 || (_path3797 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62v-1h1v1z",
    fill: "#5a391b"
  })), _path3798 || (_path3798 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61h1v1h-1z",
    fill: "#5f2e17"
  })), _path3799 || (_path3799 = /*#__PURE__*/React.createElement("path", {
    d: "M52 62h-1v-1h1z",
    fill: "#7e3f19"
  })), _path3800 || (_path3800 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h-1v-1h1z",
    fill: "#96561b"
  })), _path3801 || (_path3801 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61v1h-1v-1z",
    fill: "#a05f20"
  })), _path3802 || (_path3802 = /*#__PURE__*/React.createElement("path", {
    d: "M54 62v-1h1v1z",
    fill: "#8f4f1d"
  })), _path3803 || (_path3803 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h-1v-1h1z",
    fill: "#793b15"
  })), _path3804 || (_path3804 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62v-1h1v1z",
    fill: "#72381b"
  })), _path3805 || (_path3805 = /*#__PURE__*/React.createElement("path", {
    d: "M57 61h1v1h-1z",
    fill: "#58230d"
  })), _path3806 || (_path3806 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h1v1h-1z",
    fill: "#4c1f07"
  })), _path3807 || (_path3807 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h-1v-1h1z",
    fill: "#4e210a"
  })), _path3808 || (_path3808 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61v1h-1v-1z",
    fill: "#6f3515"
  })), _path3809 || (_path3809 = /*#__PURE__*/React.createElement("path", {
    d: "M61 62v-1h1v1z",
    fill: "#994d1a"
  })), _path3810 || (_path3810 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v-1h1v1z",
    fill: "#a05216"
  })), _path3811 || (_path3811 = /*#__PURE__*/React.createElement("path", {
    d: "M63 61h1v1h-1z",
    fill: "#7b3b0e"
  })), _path3812 || (_path3812 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61h1v1h-1z",
    fill: "#6a3111"
  })), _path3813 || (_path3813 = /*#__PURE__*/React.createElement("path", {
    d: "M65 61h1v1h-1z",
    fill: "#7a3413"
  })), _path3814 || (_path3814 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62v-1h1v1z",
    fill: "#85370c"
  })), _path3815 || (_path3815 = /*#__PURE__*/React.createElement("path", {
    d: "M68 62h-1v-1h1z",
    fill: "#9c5827"
  })), _path3816 || (_path3816 = /*#__PURE__*/React.createElement("path", {
    d: "M69 61v1h-1v-1z",
    fill: "#a56e4a"
  })), _path3817 || (_path3817 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62h-1v-1h1z",
    fill: "#9c6b46"
  })), _path3818 || (_path3818 = /*#__PURE__*/React.createElement("path", {
    d: "M71 61v1h-1v-1z",
    fill: "#b28758"
  })), _path3819 || (_path3819 = /*#__PURE__*/React.createElement("path", {
    d: "M71 62v-1h1v1z",
    fill: "#d1a984"
  })), _path3820 || (_path3820 = /*#__PURE__*/React.createElement("path", {
    d: "M73 61v1h-1v-1z",
    fill: "#dcb89d"
  })), _path3821 || (_path3821 = /*#__PURE__*/React.createElement("path", {
    d: "M74 62h-1v-1h1z",
    fill: "#e4c5a8"
  })), _path3822 || (_path3822 = /*#__PURE__*/React.createElement("path", {
    d: "M74 61h1v1h-1z",
    fill: "#edd5b2"
  })), _path3823 || (_path3823 = /*#__PURE__*/React.createElement("path", {
    d: "M76 62h-1v-1h1z",
    fill: "#eed7b5"
  })), _path3824 || (_path3824 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61h1v1h-1z",
    fill: "#dcb791"
  })), _path3825 || (_path3825 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62v-1h1v1z",
    fill: "#a47031"
  })), _path3826 || (_path3826 = /*#__PURE__*/React.createElement("path", {
    d: "M80 62h-1v-1h1z",
    fill: "#e1bc64"
  })), _path3827 || (_path3827 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v1h-1v-1z",
    fill: "#d9bb5e"
  })), _path3828 || (_path3828 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62h-1v-1h1z",
    fill: "#eecc7a"
  })), _path3829 || (_path3829 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62v-1h1v1z",
    fill: "#ba8b4c"
  })), _path3830 || (_path3830 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62v-1h1v1z",
    fill: "#7d4524"
  })), _path3831 || (_path3831 = /*#__PURE__*/React.createElement("path", {
    d: "M85 61v1h-1v-1z",
    fill: "#703c1c"
  })), _path3832 || (_path3832 = /*#__PURE__*/React.createElement("path", {
    d: "M86 62h-1v-1h1z",
    fill: "#69391d"
  })), _path3833 || (_path3833 = /*#__PURE__*/React.createElement("path", {
    d: "M86 61h1v1h-1z",
    fill: "#522713"
  })), _path3834 || (_path3834 = /*#__PURE__*/React.createElement("path", {
    d: "M88 61v1h-1v-1z",
    fill: "#3d2220"
  })), _path3835 || (_path3835 = /*#__PURE__*/React.createElement("path", {
    d: "M88 62v-1h1v1z",
    fill: "#3c2922"
  })), _path3836 || (_path3836 = /*#__PURE__*/React.createElement("path", {
    d: "M89 61h1v1h-1z",
    fill: "#24100e"
  })), _path3837 || (_path3837 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62v-1h1v1z",
    fill: "#211210"
  })), _path3838 || (_path3838 = /*#__PURE__*/React.createElement("path", {
    d: "M91 61h1v1h-1z",
    fill: "#261816"
  })), _path3839 || (_path3839 = /*#__PURE__*/React.createElement("path", {
    d: "M92 61h1v1h-1z",
    fill: "#4d3330"
  })), _path3840 || (_path3840 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61h1v1h-1z",
    fill: "#664844"
  })), _path3841 || (_path3841 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v1h-1v-1z",
    fill: "#492921"
  })), _path3842 || (_path3842 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61h1v1h-1z",
    fill: "#9d725b"
  })), _path3843 || (_path3843 = /*#__PURE__*/React.createElement("path", {
    d: "M97 61v1h-1v-1z",
    fill: "#cda577"
  })), _path3844 || (_path3844 = /*#__PURE__*/React.createElement("path", {
    d: "M97 62v-1h1v1z",
    fill: "#ddb275"
  })), _path3845 || (_path3845 = /*#__PURE__*/React.createElement("path", {
    d: "M98 61h1v1h-1z",
    fill: "#a77f56"
  })), _path3846 || (_path3846 = /*#__PURE__*/React.createElement("path", {
    d: "M100 61v1h-1v-1z",
    fill: "#290f06"
  })), _path3847 || (_path3847 = /*#__PURE__*/React.createElement("path", {
    d: "M100 61h1v1h-1z",
    fill: "#3d2312"
  })), _path3848 || (_path3848 = /*#__PURE__*/React.createElement("path", {
    d: "M102 61v1h-1v-1z",
    fill: "#3c2312"
  })), _path3849 || (_path3849 = /*#__PURE__*/React.createElement("path", {
    d: "M103 62h-1v-1h1z",
    fill: "#38180c"
  })), _path3850 || (_path3850 = /*#__PURE__*/React.createElement("path", {
    d: "M104 62h-1v-1h1z",
    fill: "#4e2d20"
  })), _path3851 || (_path3851 = /*#__PURE__*/React.createElement("path", {
    d: "M104 62v-1h1v1z",
    fill: "#3f211c"
  })), _path3852 || (_path3852 = /*#__PURE__*/React.createElement("path", {
    d: "M106 62h-1v-1h1z",
    fill: "#3b1811"
  })), _path3853 || (_path3853 = /*#__PURE__*/React.createElement("path", {
    d: "M107 62h-1v-1h1z",
    fill: "#2b0f09"
  })), _path3854 || (_path3854 = /*#__PURE__*/React.createElement("path", {
    d: "M107 62v-1h1v1z",
    fill: "#2d1812"
  })), _path3855 || (_path3855 = /*#__PURE__*/React.createElement("path", {
    d: "M108 61h1v1h-1z",
    fill: "#28110a"
  })), _path3856 || (_path3856 = /*#__PURE__*/React.createElement("path", {
    d: "M109 62v-1h1v1z",
    fill: "#33150c"
  })), _path3857 || (_path3857 = /*#__PURE__*/React.createElement("path", {
    d: "M111 62h-1v-1h1z",
    fill: "#4a1e14"
  })), _path3858 || (_path3858 = /*#__PURE__*/React.createElement("path", {
    d: "M111 62v-1h1v1z",
    fill: "#773d29"
  })), _path3859 || (_path3859 = /*#__PURE__*/React.createElement("path", {
    d: "M112 62v-1h1v1z",
    fill: "#b87a5a"
  })), _path3860 || (_path3860 = /*#__PURE__*/React.createElement("path", {
    d: "M113 61h1v1h-1z",
    fill: "#a66d58"
  })), _path3861 || (_path3861 = /*#__PURE__*/React.createElement("path", {
    d: "M115 62h-1v-1h1z",
    fill: "#8c5a40"
  })), _path3862 || (_path3862 = /*#__PURE__*/React.createElement("path", {
    d: "M115 61h1v1h-1z",
    fill: "#90644b"
  })), _path3863 || (_path3863 = /*#__PURE__*/React.createElement("path", {
    d: "M117 61v1h-1v-1z",
    fill: "#78523f",
    fillOpacity: 0.976
  })), _path3864 || (_path3864 = /*#__PURE__*/React.createElement("path", {
    d: "M118 62h-1v-1h1z",
    fill: "#9f7f6c",
    fillOpacity: 0.471
  })), _path3865 || (_path3865 = /*#__PURE__*/React.createElement("path", {
    d: "M118 62v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.012
  })), _path3866 || (_path3866 = /*#__PURE__*/React.createElement("path", {
    d: "M43 63v-1h1v1z",
    fill: "#64412f",
    fillOpacity: 0.169
  })), _path3867 || (_path3867 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63h-1v-1h1z",
    fill: "#8a5a2c",
    fillOpacity: 0.859
  })), _path3868 || (_path3868 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63v-1h1v1z",
    fill: "#b98d3d"
  })), _path3869 || (_path3869 = /*#__PURE__*/React.createElement("path", {
    d: "M46 62h1v1h-1z",
    fill: "#ca9b55"
  })), _path3870 || (_path3870 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62v1h-1v-1z",
    fill: "#b98c44"
  })), _path3871 || (_path3871 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62h1v1h-1z",
    fill: "#c3a055"
  })), _path3872 || (_path3872 = /*#__PURE__*/React.createElement("path", {
    d: "M49 63v-1h1v1z",
    fill: "#906a39"
  })), _path3873 || (_path3873 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v-1h1v1z",
    fill: "#6b3716"
  })), _path3874 || (_path3874 = /*#__PURE__*/React.createElement("path", {
    d: "M51 62h1v1h-1z",
    fill: "#955f2d"
  })), _path3875 || (_path3875 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62v1h-1v-1z",
    fill: "#b38148"
  })), _path3876 || (_path3876 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h1v1h-1z",
    fill: "#bf8a4a"
  })), _path3877 || (_path3877 = /*#__PURE__*/React.createElement("path", {
    d: "M55 62v1h-1v-1z",
    fill: "#ad7749"
  })), _path3878 || (_path3878 = /*#__PURE__*/React.createElement("path", {
    d: "M56 63h-1v-1h1z",
    fill: "#905531"
  })), _path3879 || (_path3879 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h1v1h-1z",
    fill: "#71381e"
  })), _path3880 || (_path3880 = /*#__PURE__*/React.createElement("path", {
    d: "M58 63h-1v-1h1z",
    fill: "#5d2911"
  })), _path3881 || (_path3881 = /*#__PURE__*/React.createElement("path", {
    d: "M58 62h1v1h-1z",
    fill: "#592912"
  })), _path3882 || (_path3882 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h1v1h-1z",
    fill: "#7b3b14"
  })), _path3883 || (_path3883 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v1h-1v-1z",
    fill: "#873809"
  })), _path3884 || (_path3884 = /*#__PURE__*/React.createElement("path", {
    d: "M63 62v1h-1v-1z",
    fill: "#a14f18"
  })), _path3885 || (_path3885 = /*#__PURE__*/React.createElement("path", {
    d: "M63 63v-1h1v1z",
    fill: "#8a3d0d"
  })), _path3886 || (_path3886 = /*#__PURE__*/React.createElement("path", {
    d: "M64 62h1v1h-1z",
    fill: "#883c14"
  })), _path3887 || (_path3887 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62h1v1h-1z",
    fill: "#7e320d"
  })), _path3888 || (_path3888 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62h1v1h-1z",
    fill: "#843a10"
  })), _path3889 || (_path3889 = /*#__PURE__*/React.createElement("path", {
    d: "M67 63v-1h1v1z",
    fill: "#6c2e0c"
  })), _path3890 || (_path3890 = /*#__PURE__*/React.createElement("path", {
    d: "M69 63h-1v-1h1z",
    fill: "#572508"
  })), _path3891 || (_path3891 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62v1h-1v-1z",
    fill: "#a06a3a"
  })), _path3892 || (_path3892 = /*#__PURE__*/React.createElement("path", {
    d: "M71 63h-1v-1h1z",
    fill: "#c3915f"
  })), _path3893 || (_path3893 = /*#__PURE__*/React.createElement("path", {
    d: "M72 62v1h-1v-1z",
    fill: "#be9576"
  })), _path3894 || (_path3894 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62v1h-1v-1z",
    fill: "#95715f"
  })), _path3895 || (_path3895 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62h1v1h-1z",
    fill: "#b39076"
  })), _path3896 || (_path3896 = /*#__PURE__*/React.createElement("path", {
    d: "M75 62v1h-1v-1z",
    fill: "#f6d9b3"
  })), _path3897 || (_path3897 = /*#__PURE__*/React.createElement("path", {
    d: "M75 63v-1h1v1z",
    fill: "#f2d8b6"
  })), _path3898 || (_path3898 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63v-1h1v1z",
    fill: "#cea47c"
  })), _path3899 || (_path3899 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63h-1v-1h1z",
    fill: "#aa734b"
  })), _path3900 || (_path3900 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62h1v1h-1z",
    fill: "#894718"
  })), _path3901 || (_path3901 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v-1h1v1z",
    fill: "#ca9136"
  })), _path3902 || (_path3902 = /*#__PURE__*/React.createElement("path", {
    d: "M80 63v-1h1v1z",
    fill: "#ddb639"
  })), _path3903 || (_path3903 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v-1h1v1z",
    fill: "#e7be4a"
  })), _path3904 || (_path3904 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63h-1v-1h1z",
    fill: "#ae7937"
  })), _path3905 || (_path3905 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62h1v1h-1z",
    fill: "#713219"
  })), _path3906 || (_path3906 = /*#__PURE__*/React.createElement("path", {
    d: "M84 63v-1h1v1z",
    fill: "#955e41"
  })), _path3907 || (_path3907 = /*#__PURE__*/React.createElement("path", {
    d: "M85 62h1v1h-1z",
    fill: "#8f5f48"
  })), _path3908 || (_path3908 = /*#__PURE__*/React.createElement("path", {
    d: "M87 63h-1v-1h1z",
    fill: "#6d3f21"
  })), _path3909 || (_path3909 = /*#__PURE__*/React.createElement("path", {
    d: "M88 63h-1v-1h1z",
    fill: "#3b1e18"
  })), _path3910 || (_path3910 = /*#__PURE__*/React.createElement("path", {
    d: "M89 62v1h-1v-1z",
    fill: "#422c24"
  })), _path3911 || (_path3911 = /*#__PURE__*/React.createElement("path", {
    d: "M90 63h-1v-1h1z",
    fill: "#462b27"
  })), _path3912 || (_path3912 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62h1v1h-1z",
    fill: "#472c25"
  })), _path3913 || (_path3913 = /*#__PURE__*/React.createElement("path", {
    d: "M92 62v1h-1v-1z",
    fill: "#452719"
  })), _path3914 || (_path3914 = /*#__PURE__*/React.createElement("path", {
    d: "M93 63v-1h1v1z",
    fill: "#a77d76"
  })), _path3915 || (_path3915 = /*#__PURE__*/React.createElement("path", {
    d: "M94 63v-1h1v1z",
    fill: "#6c463e"
  })), _path3916 || (_path3916 = /*#__PURE__*/React.createElement("path", {
    d: "M96 63v-1h1v1z",
    fill: "#a7794d"
  })), _path3917 || (_path3917 = /*#__PURE__*/React.createElement("path", {
    d: "M98 62v1h-1v-1z",
    fill: "#e8bb77"
  })), _path3918 || (_path3918 = /*#__PURE__*/React.createElement("path", {
    d: "M99 62v1h-1v-1z",
    fill: "#b88e60"
  })), _path3919 || (_path3919 = /*#__PURE__*/React.createElement("path", {
    d: "M100 63h-1v-1h1z",
    fill: "#432c1a"
  })), _path3920 || (_path3920 = /*#__PURE__*/React.createElement("path", {
    d: "M101 62v1h-1v-1z",
    fill: "#352b25"
  })), _path3921 || (_path3921 = /*#__PURE__*/React.createElement("path", {
    d: "M102 63h-1v-1h1z",
    fill: "#3f3c31"
  })), _path3922 || (_path3922 = /*#__PURE__*/React.createElement("path", {
    d: "M102 62h1v1h-1z",
    fill: "#463928"
  })), _path3923 || (_path3923 = /*#__PURE__*/React.createElement("path", {
    d: "M104 62v1h-1v-1z",
    fill: "#33170b"
  })), _path3924 || (_path3924 = /*#__PURE__*/React.createElement("path", {
    d: "M105 63h-1v-1h1z",
    fill: "#392614"
  })), _path3925 || (_path3925 = /*#__PURE__*/React.createElement("path", {
    d: "M106 62v1h-1v-1z",
    fill: "#3a1e0c"
  })), _path3926 || (_path3926 = /*#__PURE__*/React.createElement("path", {
    d: "M106 63v-1h1v1z",
    fill: "#270d09"
  })), _path3927 || (_path3927 = /*#__PURE__*/React.createElement("path", {
    d: "M108 63h-1v-1h1z",
    fill: "#1f0d09"
  })), _path3928 || (_path3928 = /*#__PURE__*/React.createElement("path", {
    d: "M108 62h1v1h-1z",
    fill: "#1f0801"
  })), _path3929 || (_path3929 = /*#__PURE__*/React.createElement("path", {
    d: "M110 62v1h-1v-1z",
    fill: "#35190b"
  })), _path3930 || (_path3930 = /*#__PURE__*/React.createElement("path", {
    d: "M110 62h1v1h-1z",
    fill: "#693c2a"
  })), _path3931 || (_path3931 = /*#__PURE__*/React.createElement("path", {
    d: "M112 63h-1v-1h1z",
    fill: "#a56a52"
  })), _path3932 || (_path3932 = /*#__PURE__*/React.createElement("path", {
    d: "M113 63h-1v-1h1z",
    fill: "#cf957c"
  })), _path3933 || (_path3933 = /*#__PURE__*/React.createElement("path", {
    d: "M114 62v1h-1v-1z",
    fill: "#9b6554"
  })), _path3934 || (_path3934 = /*#__PURE__*/React.createElement("path", {
    d: "M114 62h1v1h-1z",
    fill: "#5f321e"
  })), _path3935 || (_path3935 = /*#__PURE__*/React.createElement("path", {
    d: "M116 62v1h-1v-1z",
    fill: "#573825",
    fillOpacity: 0.945
  })), _path3936 || (_path3936 = /*#__PURE__*/React.createElement("path", {
    d: "M117 63h-1v-1h1z",
    fill: "#442b20",
    fillOpacity: 0.365
  })), _path3937 || (_path3937 = /*#__PURE__*/React.createElement("path", {
    d: "M44 64v-1h1v1z",
    fill: "#e3c386",
    fillOpacity: 0.439
  })), _path3938 || (_path3938 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h-1v-1h1z",
    fill: "#dfc370",
    fillOpacity: 0.976
  })), _path3939 || (_path3939 = /*#__PURE__*/React.createElement("path", {
    d: "M47 63v1h-1v-1z",
    fill: "#d3b379",
    fillOpacity: 0.922
  })), _path3940 || (_path3940 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h-1v-1h1z",
    fill: "#946a33",
    fillOpacity: 0.898
  })), _path3941 || (_path3941 = /*#__PURE__*/React.createElement("path", {
    d: "M48 63h1v1h-1z",
    fill: "#caa75c"
  })), _path3942 || (_path3942 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v1h-1v-1z",
    fill: "#cca95c"
  })), _path3943 || (_path3943 = /*#__PURE__*/React.createElement("path", {
    d: "M51 63v1h-1v-1z",
    fill: "#a67d3d"
  })), _path3944 || (_path3944 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64v-1h1v1z",
    fill: "#a37f3c"
  })), _path3945 || (_path3945 = /*#__PURE__*/React.createElement("path", {
    d: "M52 64v-1h1v1z",
    fill: "#c19b5b"
  })), _path3946 || (_path3946 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64h-1v-1h1z",
    fill: "#c29b5d",
    fillOpacity: 0.996
  })), _path3947 || (_path3947 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64v-1h1v1z",
    fill: "#9b724b",
    fillOpacity: 0.953
  })), _path3948 || (_path3948 = /*#__PURE__*/React.createElement("path", {
    d: "M56 64h-1v-1h1z",
    fill: "#a77d4b"
  })), _path3949 || (_path3949 = /*#__PURE__*/React.createElement("path", {
    d: "M57 64h-1v-1h1z",
    fill: "#583622"
  })), _path3950 || (_path3950 = /*#__PURE__*/React.createElement("path", {
    d: "M57 63h1v1h-1z",
    fill: "#441611"
  })), _path3951 || (_path3951 = /*#__PURE__*/React.createElement("path", {
    d: "M59 63v1h-1v-1z",
    fill: "#5c2b16"
  })), _path3952 || (_path3952 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64v-1h1v1z",
    fill: "#592914"
  })), _path3953 || (_path3953 = /*#__PURE__*/React.createElement("path", {
    d: "M61 64h-1v-1h1z",
    fill: "#6c3816"
  })), _path3954 || (_path3954 = /*#__PURE__*/React.createElement("path", {
    d: "M62 63v1h-1v-1z",
    fill: "#7f4923"
  })), _path3955 || (_path3955 = /*#__PURE__*/React.createElement("path", {
    d: "M62 64v-1h1v1z",
    fill: "#884d25"
  })), _path3956 || (_path3956 = /*#__PURE__*/React.createElement("path", {
    d: "M64 64h-1v-1h1z",
    fill: "#6c2d0b"
  })), _path3957 || (_path3957 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64h-1v-1h1z",
    fill: "#6a3113"
  })), _path3958 || (_path3958 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64h-1v-1h1z",
    fill: "#612e10"
  })), _path3959 || (_path3959 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v-1h1v1z",
    fill: "#411e08"
  })), _path3960 || (_path3960 = /*#__PURE__*/React.createElement("path", {
    d: "M68 63v1h-1v-1z",
    fill: "#260c02"
  })), _path3961 || (_path3961 = /*#__PURE__*/React.createElement("path", {
    d: "M68 64v-1h1v1z",
    fill: "#472414"
  })), _path3962 || (_path3962 = /*#__PURE__*/React.createElement("path", {
    d: "M70 64h-1v-1h1z",
    fill: "#945f37"
  })), _path3963 || (_path3963 = /*#__PURE__*/React.createElement("path", {
    d: "M70 63h1v1h-1z",
    fill: "#5f381b"
  })), _path3964 || (_path3964 = /*#__PURE__*/React.createElement("path", {
    d: "M71 64v-1h1v1z",
    fill: "#2d1307"
  })), _path3965 || (_path3965 = /*#__PURE__*/React.createElement("path", {
    d: "M73 63v1h-1v-1z",
    fill: "#553c35"
  })), _path3966 || (_path3966 = /*#__PURE__*/React.createElement("path", {
    d: "M73 64v-1h1v1z",
    fill: "#907161"
  })), _path3967 || (_path3967 = /*#__PURE__*/React.createElement("path", {
    d: "M74 63h1v1h-1z",
    fill: "#e6caad"
  })), _path3968 || (_path3968 = /*#__PURE__*/React.createElement("path", {
    d: "M76 64h-1v-1h1z",
    fill: "#e3c5a6"
  })), _path3969 || (_path3969 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63h1v1h-1z",
    fill: "#c4936a"
  })), _path3970 || (_path3970 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v1h-1v-1z",
    fill: "#8a5129"
  })), _path3971 || (_path3971 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63h1v1h-1z",
    fill: "#c18a2e"
  })), _path3972 || (_path3972 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v1h-1v-1z",
    fill: "#ddb235"
  })), _path3973 || (_path3973 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v-1h1v1z",
    fill: "#deaf36"
  })), _path3974 || (_path3974 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63v1h-1v-1z",
    fill: "#ae8037"
  })), _path3975 || (_path3975 = /*#__PURE__*/React.createElement("path", {
    d: "M83 64v-1h1v1z",
    fill: "#7c482e"
  })), _path3976 || (_path3976 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h-1v-1h1z",
    fill: "#ae7d66"
  })), _path3977 || (_path3977 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64v-1h1v1z",
    fill: "#b78974"
  })), _path3978 || (_path3978 = /*#__PURE__*/React.createElement("path", {
    d: "M86 64v-1h1v1z",
    fill: "#8a5e4a"
  })), _path3979 || (_path3979 = /*#__PURE__*/React.createElement("path", {
    d: "M88 63v1h-1v-1z",
    fill: "#442423"
  })), _path3980 || (_path3980 = /*#__PURE__*/React.createElement("path", {
    d: "M88 64v-1h1v1z",
    fill: "#240e0b"
  })), _path3981 || (_path3981 = /*#__PURE__*/React.createElement("path", {
    d: "M89 63h1v1h-1z",
    fill: "#331d1b"
  })), _path3982 || (_path3982 = /*#__PURE__*/React.createElement("path", {
    d: "M91 64h-1v-1h1z",
    fill: "#311d1a"
  })), _path3983 || (_path3983 = /*#__PURE__*/React.createElement("path", {
    d: "M91 63h1v1h-1z",
    fill: "#220c09"
  })), _path3984 || (_path3984 = /*#__PURE__*/React.createElement("path", {
    d: "M93 64h-1v-1h1z",
    fill: "#270f05"
  })), _path3985 || (_path3985 = /*#__PURE__*/React.createElement("path", {
    d: "M94 64h-1v-1h1z",
    fill: "#3e2517"
  })), _path3986 || (_path3986 = /*#__PURE__*/React.createElement("path", {
    d: "M95 63v1h-1v-1z",
    fill: "#6b5043"
  })), _path3987 || (_path3987 = /*#__PURE__*/React.createElement("path", {
    d: "M95 64v-1h1v1z",
    fill: "#6d473a"
  })), _path3988 || (_path3988 = /*#__PURE__*/React.createElement("path", {
    d: "M97 63v1h-1v-1z",
    fill: "#86522e"
  })), _path3989 || (_path3989 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64v-1h1v1z",
    fill: "#8f6127"
  })), _path3990 || (_path3990 = /*#__PURE__*/React.createElement("path", {
    d: "M98 64v-1h1v1z",
    fill: "#91724b"
  })), _path3991 || (_path3991 = /*#__PURE__*/React.createElement("path", {
    d: "M99 63h1v1h-1z",
    fill: "#917f64"
  })), _path3992 || (_path3992 = /*#__PURE__*/React.createElement("path", {
    d: "M100 64v-1h1v1z",
    fill: "#5b5d34"
  })), _path3993 || (_path3993 = /*#__PURE__*/React.createElement("path", {
    d: "M101 63h1v1h-1z",
    fill: "#52592e"
  })), _path3994 || (_path3994 = /*#__PURE__*/React.createElement("path", {
    d: "M102 64v-1h1v1z",
    fill: "#67613d"
  })), _path3995 || (_path3995 = /*#__PURE__*/React.createElement("path", {
    d: "M104 64h-1v-1h1z",
    fill: "#624e37"
  })), _path3996 || (_path3996 = /*#__PURE__*/React.createElement("path", {
    d: "M105 63v1h-1v-1z",
    fill: "#5d4e37"
  })), _path3997 || (_path3997 = /*#__PURE__*/React.createElement("path", {
    d: "M105 63h1v1h-1z",
    fill: "#6f643c"
  })), _path3998 || (_path3998 = /*#__PURE__*/React.createElement("path", {
    d: "M107 63v1h-1v-1z",
    fill: "#7b6744"
  })), _path3999 || (_path3999 = /*#__PURE__*/React.createElement("path", {
    d: "M107 64v-1h1v1z",
    fill: "#90785e"
  })), _path4000 || (_path4000 = /*#__PURE__*/React.createElement("path", {
    d: "M108 63h1v1h-1z",
    fill: "#a28f81"
  })), _path4001 || (_path4001 = /*#__PURE__*/React.createElement("path", {
    d: "M110 63v1h-1v-1z",
    fill: "#b49e8a"
  })), _path4002 || (_path4002 = /*#__PURE__*/React.createElement("path", {
    d: "M110 63h1v1h-1z",
    fill: "#8a634f"
  })), _path4003 || (_path4003 = /*#__PURE__*/React.createElement("path", {
    d: "M112 63v1h-1v-1z",
    fill: "#a67062"
  })), _path4004 || (_path4004 = /*#__PURE__*/React.createElement("path", {
    d: "M112 63h1v1h-1z",
    fill: "#c59284"
  })), _path4005 || (_path4005 = /*#__PURE__*/React.createElement("path", {
    d: "M114 64h-1v-1h1z",
    fill: "#a6715e"
  })), _path4006 || (_path4006 = /*#__PURE__*/React.createElement("path", {
    d: "M115 63v1h-1v-1z",
    fill: "#4e2719"
  })), _path4007 || (_path4007 = /*#__PURE__*/React.createElement("path", {
    d: "M116 64h-1v-1h1z",
    fill: "#301d0d",
    fillOpacity: 0.435
  })), _path4008 || (_path4008 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v-1h1v1z",
    fill: "#ffff7f",
    fillOpacity: 0.016
  })), _path4009 || (_path4009 = /*#__PURE__*/React.createElement("path", {
    d: "M45 64h1v1h-1z",
    fill: "#d3b26e",
    fillOpacity: 0.208
  })), _path4010 || (_path4010 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h1v1h-1z",
    fill: "#bda074",
    fillOpacity: 0.137
  })), _path4011 || (_path4011 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64v1h-1v-1z",
    fill: "#59300d",
    fillOpacity: 0.145
  })), _path4012 || (_path4012 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h1v1h-1z",
    fill: "#9e8446",
    fillOpacity: 0.58
  })), _path4013 || (_path4013 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65h-1v-1h1z",
    fill: "#b69e4b",
    fillOpacity: 0.98
  })), _path4014 || (_path4014 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h-1v-1h1z",
    fill: "#a68641"
  })), _path4015 || (_path4015 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64h1v1h-1z",
    fill: "#9e7837"
  })), _path4016 || (_path4016 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64v1h-1v-1z",
    fill: "#9d6931"
  })), _path4017 || (_path4017 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64h1v1h-1z",
    fill: "#b2834f",
    fillOpacity: 0.929
  })), _path4018 || (_path4018 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v-1h1v1z",
    fill: "#5c412b",
    fillOpacity: 0.227
  })), _path4019 || (_path4019 = /*#__PURE__*/React.createElement("path", {
    d: "M55 65v-1h1v1z",
    fill: "#9c794a",
    fillOpacity: 0.631
  })), _path4020 || (_path4020 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65h-1v-1h1z",
    fill: "#8c5f37"
  })), _path4021 || (_path4021 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64v1h-1v-1z",
    fill: "#2e160e"
  })), _path4022 || (_path4022 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64h1v1h-1z",
    fill: "#251e12"
  })), _path4023 || (_path4023 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64h1v1h-1z",
    fill: "#40281a"
  })), _path4024 || (_path4024 = /*#__PURE__*/React.createElement("path", {
    d: "M60 64h1v1h-1z",
    fill: "#6d462e"
  })), _path4025 || (_path4025 = /*#__PURE__*/React.createElement("path", {
    d: "M61 65v-1h1v1z",
    fill: "#8a5a46"
  })), _path4026 || (_path4026 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65h-1v-1h1z",
    fill: "#704331"
  })), _path4027 || (_path4027 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65h-1v-1h1z",
    fill: "#572d1e"
  })), _path4028 || (_path4028 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64v1h-1v-1z",
    fill: "#4a2218"
  })), _path4029 || (_path4029 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v1h-1v-1z",
    fill: "#441d10"
  })), _path4030 || (_path4030 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v-1h1v1z",
    fill: "#2f1307"
  })), _path4031 || (_path4031 = /*#__PURE__*/React.createElement("path", {
    d: "M68 65h-1v-1h1z",
    fill: "#170805"
  })), _path4032 || (_path4032 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65h-1v-1h1z",
    fill: "#150c0c"
  })), _path4033 || (_path4033 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v-1h1v1z",
    fill: "#190d09"
  })), _path4034 || (_path4034 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h-1v-1h1z",
    fill: "#130700"
  })), _path4035 || (_path4035 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64v1h-1v-1z",
    fill: "#0d0502"
  })), _path4036 || (_path4036 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64h1v1h-1z",
    fill: "#090000"
  })), _path4037 || (_path4037 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65h-1v-1h1z",
    fill: "#56433c"
  })), _path4038 || (_path4038 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65h-1v-1h1z",
    fill: "#e0c6a7"
  })), _path4039 || (_path4039 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65v-1h1v1z",
    fill: "#e0c195"
  })), _path4040 || (_path4040 = /*#__PURE__*/React.createElement("path", {
    d: "M77 65h-1v-1h1z",
    fill: "#c99b67"
  })), _path4041 || (_path4041 = /*#__PURE__*/React.createElement("path", {
    d: "M77 64h1v1h-1z",
    fill: "#64381d"
  })), _path4042 || (_path4042 = /*#__PURE__*/React.createElement("path", {
    d: "M79 64v1h-1v-1z",
    fill: "#784b21"
  })), _path4043 || (_path4043 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65h-1v-1h1z",
    fill: "#deaf3e"
  })), _path4044 || (_path4044 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v1h-1v-1z",
    fill: "#eec543"
  })), _path4045 || (_path4045 = /*#__PURE__*/React.createElement("path", {
    d: "M82 64v1h-1v-1z",
    fill: "#daac2c"
  })), _path4046 || (_path4046 = /*#__PURE__*/React.createElement("path", {
    d: "M83 65h-1v-1h1z",
    fill: "#e4be5c"
  })), _path4047 || (_path4047 = /*#__PURE__*/React.createElement("path", {
    d: "M84 64v1h-1v-1z",
    fill: "#b89465"
  })), _path4048 || (_path4048 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65v-1h1v1z",
    fill: "#86644c"
  })), _path4049 || (_path4049 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h1v1h-1z",
    fill: "#ac866b"
  })), _path4050 || (_path4050 = /*#__PURE__*/React.createElement("path", {
    d: "M86 65v-1h1v1z",
    fill: "#aa7a62"
  })), _path4051 || (_path4051 = /*#__PURE__*/React.createElement("path", {
    d: "M87 65v-1h1v1z",
    fill: "#8d5c4c"
  })), _path4052 || (_path4052 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65h-1v-1h1z",
    fill: "#653c2b"
  })), _path4053 || (_path4053 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65v-1h1v1z",
    fill: "#44261e"
  })), _path4054 || (_path4054 = /*#__PURE__*/React.createElement("path", {
    d: "M90 64h1v1h-1z",
    fill: "#2a170e"
  })), _path4055 || (_path4055 = /*#__PURE__*/React.createElement("path", {
    d: "M92 65v-1h1v1z",
    fill: "#391e0a"
  })), _path4056 || (_path4056 = /*#__PURE__*/React.createElement("path", {
    d: "M94 64v1h-1v-1z",
    fill: "#59341e"
  })), _path4057 || (_path4057 = /*#__PURE__*/React.createElement("path", {
    d: "M95 65h-1v-1h1z",
    fill: "#6b3e26"
  })), _path4058 || (_path4058 = /*#__PURE__*/React.createElement("path", {
    d: "M95 64h1v1h-1z",
    fill: "#987250"
  })), _path4059 || (_path4059 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64v1h-1v-1z",
    fill: "#b28c56"
  })), _path4060 || (_path4060 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64h1v1h-1z",
    fill: "#af8833"
  })), _path4061 || (_path4061 = /*#__PURE__*/React.createElement("path", {
    d: "M99 64v1h-1v-1z",
    fill: "#c8a865"
  })), _path4062 || (_path4062 = /*#__PURE__*/React.createElement("path", {
    d: "M100 65h-1v-1h1z",
    fill: "#d5b58b"
  })), _path4063 || (_path4063 = /*#__PURE__*/React.createElement("path", {
    d: "M101 65h-1v-1h1z",
    fill: "#a59469"
  })), _path4064 || (_path4064 = /*#__PURE__*/React.createElement("path", {
    d: "M101 65v-1h1v1z",
    fill: "#4b4f2e"
  })), _path4065 || (_path4065 = /*#__PURE__*/React.createElement("path", {
    d: "M102 64h1v1h-1z",
    fill: "#26290c"
  })), _path4066 || (_path4066 = /*#__PURE__*/React.createElement("path", {
    d: "M104 64v1h-1v-1z",
    fill: "#211b0d"
  })), _path4067 || (_path4067 = /*#__PURE__*/React.createElement("path", {
    d: "M104 64h1v1h-1z",
    fill: "#2e2318"
  })), _path4068 || (_path4068 = /*#__PURE__*/React.createElement("path", {
    d: "M106 64v1h-1v-1z",
    fill: "#3d3b1c"
  })), _path4069 || (_path4069 = /*#__PURE__*/React.createElement("path", {
    d: "M107 65h-1v-1h1z",
    fill: "#5f5326"
  })), _path4070 || (_path4070 = /*#__PURE__*/React.createElement("path", {
    d: "M107 64h1v1h-1z",
    fill: "#9e8555"
  })), _path4071 || (_path4071 = /*#__PURE__*/React.createElement("path", {
    d: "M108 64h1v1h-1z",
    fill: "#cebf90"
  })), _path4072 || (_path4072 = /*#__PURE__*/React.createElement("path", {
    d: "M109 65v-1h1v1z",
    fill: "#e8d7b0"
  })), _path4073 || (_path4073 = /*#__PURE__*/React.createElement("path", {
    d: "M111 64v1h-1v-1z",
    fill: "#c29f83"
  })), _path4074 || (_path4074 = /*#__PURE__*/React.createElement("path", {
    d: "M111 65v-1h1v1z",
    fill: "#8f614f"
  })), _path4075 || (_path4075 = /*#__PURE__*/React.createElement("path", {
    d: "M112 64h1v1h-1z",
    fill: "#a17769"
  })), _path4076 || (_path4076 = /*#__PURE__*/React.createElement("path", {
    d: "M114 65h-1v-1h1z",
    fill: "#865c54"
  })), _path4077 || (_path4077 = /*#__PURE__*/React.createElement("path", {
    d: "M114 64h1v1h-1z",
    fill: "#4d312e",
    fillOpacity: 0.604
  })), _path4078 || (_path4078 = /*#__PURE__*/React.createElement("path", {
    d: "M48 65h1v1h-1z",
    fill: "#2a552a",
    fillOpacity: 0.024
  })), _path4079 || (_path4079 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65v1h-1v-1z",
    fill: "#7d7032",
    fillOpacity: 0.239
  })), _path4080 || (_path4080 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66v-1h1v1z",
    fill: "#907446",
    fillOpacity: 0.325
  })), _path4081 || (_path4081 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h1v1h-1z",
    fill: "#9d7943",
    fillOpacity: 0.698
  })), _path4082 || (_path4082 = /*#__PURE__*/React.createElement("path", {
    d: "M53 66h-1v-1h1z",
    fill: "#844b1e",
    fillOpacity: 0.851
  })), _path4083 || (_path4083 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v1h-1v-1z",
    fill: "#7f4819",
    fillOpacity: 0.51
  })), _path4084 || (_path4084 = /*#__PURE__*/React.createElement("path", {
    d: "M56 66h-1v-1h1z",
    fill: "#633",
    fillOpacity: 0.02
  })), _path4085 || (_path4085 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65v1h-1v-1z",
    fill: "#8c6543",
    fillOpacity: 0.639
  })), _path4086 || (_path4086 = /*#__PURE__*/React.createElement("path", {
    d: "M58 66h-1v-1h1z",
    fill: "#75523b"
  })), _path4087 || (_path4087 = /*#__PURE__*/React.createElement("path", {
    d: "M59 65v1h-1v-1z",
    fill: "#4f3932"
  })), _path4088 || (_path4088 = /*#__PURE__*/React.createElement("path", {
    d: "M60 65v1h-1v-1z",
    fill: "#735b4c"
  })), _path4089 || (_path4089 = /*#__PURE__*/React.createElement("path", {
    d: "M60 66v-1h1v1z",
    fill: "#8c6951"
  })), _path4090 || (_path4090 = /*#__PURE__*/React.createElement("path", {
    d: "M62 65v1h-1v-1z",
    fill: "#442011"
  })), _path4091 || (_path4091 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65v1h-1v-1z",
    fill: "#371b0e"
  })), _path4092 || (_path4092 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65v1h-1v-1z",
    fill: "#432718"
  })), _path4093 || (_path4093 = /*#__PURE__*/React.createElement("path", {
    d: "M64 66v-1h1v1z",
    fill: "#573021"
  })), _path4094 || (_path4094 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v1h-1v-1z",
    fill: "#6c3c26"
  })), _path4095 || (_path4095 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65h1v1h-1z",
    fill: "#78482f"
  })), _path4096 || (_path4096 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v1h-1v-1z",
    fill: "#311d16"
  })), _path4097 || (_path4097 = /*#__PURE__*/React.createElement("path", {
    d: "M70 65v1h-1v-1z",
    fill: "#150b08"
  })), _path4098 || (_path4098 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h1v1h-1z",
    fill: "#0b0903"
  })), _path4099 || (_path4099 = /*#__PURE__*/React.createElement("path", {
    d: "M72 65h1v1h-1z",
    fill: "#070603"
  })), _path4100 || (_path4100 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65v1h-1v-1z",
    fill: "#271d18"
  })), _path4101 || (_path4101 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66h-1v-1h1z",
    fill: "#a99077"
  })), _path4102 || (_path4102 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66v-1h1v1z",
    fill: "#d7b68b"
  })), _path4103 || (_path4103 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h-1v-1h1z",
    fill: "#c79f75"
  })), _path4104 || (_path4104 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66h-1v-1h1z",
    fill: "#381c12"
  })), _path4105 || (_path4105 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66v-1h1v1z",
    fill: "#6c441e"
  })), _path4106 || (_path4106 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65v1h-1v-1z",
    fill: "#dbae3b"
  })), _path4107 || (_path4107 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65v1h-1v-1z",
    fill: "#efc750"
  })), _path4108 || (_path4108 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65h1v1h-1z",
    fill: "#ddb23b"
  })), _path4109 || (_path4109 = /*#__PURE__*/React.createElement("path", {
    d: "M82 65h1v1h-1z",
    fill: "#e1ba51"
  })), _path4110 || (_path4110 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65v1h-1v-1z",
    fill: "#826637"
  })), _path4111 || (_path4111 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65h1v1h-1z",
    fill: "#503b2f"
  })), _path4112 || (_path4112 = /*#__PURE__*/React.createElement("path", {
    d: "M85 65h1v1h-1z",
    fill: "#6b5440"
  })), _path4113 || (_path4113 = /*#__PURE__*/React.createElement("path", {
    d: "M86 66v-1h1v1z",
    fill: "#916d4d"
  })), _path4114 || (_path4114 = /*#__PURE__*/React.createElement("path", {
    d: "M87 65h1v1h-1z",
    fill: "#aa765a"
  })), _path4115 || (_path4115 = /*#__PURE__*/React.createElement("path", {
    d: "M89 66h-1v-1h1z",
    fill: "#956349"
  })), _path4116 || (_path4116 = /*#__PURE__*/React.createElement("path", {
    d: "M91 66h-1v-1h1z",
    fill: "#6a452d"
  })), _path4117 || (_path4117 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h-1v-1h1z",
    fill: "#81562b"
  })), _path4118 || (_path4118 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65v1h-1v-1z",
    fill: "#9c653e"
  })), _path4119 || (_path4119 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65h1v1h-1z",
    fill: "#733a1e"
  })), _path4120 || (_path4120 = /*#__PURE__*/React.createElement("path", {
    d: "M94 65h1v1h-1z",
    fill: "#815123"
  })), _path4121 || (_path4121 = /*#__PURE__*/React.createElement("path", {
    d: "M96 65v1h-1v-1z",
    fill: "#bf9154"
  })), _path4122 || (_path4122 = /*#__PURE__*/React.createElement("path", {
    d: "M96 65h1v1h-1z",
    fill: "#cd9c4c"
  })), _path4123 || (_path4123 = /*#__PURE__*/React.createElement("path", {
    d: "M97 65h1v1h-1z",
    fill: "#c19231"
  })), _path4124 || (_path4124 = /*#__PURE__*/React.createElement("path", {
    d: "M98 65h1v1h-1z",
    fill: "#c3a455"
  })), _path4125 || (_path4125 = /*#__PURE__*/React.createElement("path", {
    d: "M100 65v1h-1v-1z",
    fill: "#bc9a54"
  })), _path4126 || (_path4126 = /*#__PURE__*/React.createElement("path", {
    d: "M100 66v-1h1v1z",
    fill: "#866c39",
    fillOpacity: 0.996
  })), _path4127 || (_path4127 = /*#__PURE__*/React.createElement("path", {
    d: "M102 65v1h-1v-1z",
    fill: "#2c301d",
    fillOpacity: 0.655
  })), _path4128 || (_path4128 = /*#__PURE__*/React.createElement("path", {
    d: "M102 66v-1h1v1z",
    fill: "#101d09",
    fillOpacity: 0.616
  })), _path4129 || (_path4129 = /*#__PURE__*/React.createElement("path", {
    d: "M104 66h-1v-1h1z",
    fill: "#10180d",
    fillOpacity: 0.871
  })), _path4130 || (_path4130 = /*#__PURE__*/React.createElement("path", {
    d: "M104 65h1v1h-1z",
    fill: "#0e0c04"
  })), _path4131 || (_path4131 = /*#__PURE__*/React.createElement("path", {
    d: "M105 65h1v1h-1z",
    fill: "#1a1604"
  })), _path4132 || (_path4132 = /*#__PURE__*/React.createElement("path", {
    d: "M107 65v1h-1v-1z",
    fill: "#251a0a"
  })), _path4133 || (_path4133 = /*#__PURE__*/React.createElement("path", {
    d: "M107 66v-1h1v1z",
    fill: "#483223"
  })), _path4134 || (_path4134 = /*#__PURE__*/React.createElement("path", {
    d: "M109 66h-1v-1h1z",
    fill: "#7b6146"
  })), _path4135 || (_path4135 = /*#__PURE__*/React.createElement("path", {
    d: "M109 65h1v1h-1z",
    fill: "#8f775e"
  })), _path4136 || (_path4136 = /*#__PURE__*/React.createElement("path", {
    d: "M110 66v-1h1v1z",
    fill: "#947163"
  })), _path4137 || (_path4137 = /*#__PURE__*/React.createElement("path", {
    d: "M111 65h1v1h-1z",
    fill: "#7f544d"
  })), _path4138 || (_path4138 = /*#__PURE__*/React.createElement("path", {
    d: "M112 65h1v1h-1z",
    fill: "#76514c"
  })), _path4139 || (_path4139 = /*#__PURE__*/React.createElement("path", {
    d: "M113 66v-1h1v1z",
    fill: "#482c28",
    fillOpacity: 0.694
  })), _path4140 || (_path4140 = /*#__PURE__*/React.createElement("path", {
    d: "M115 65v1h-1v-1z",
    fill: "#0f0000",
    fillOpacity: 0.067
  })), _path4141 || (_path4141 = /*#__PURE__*/React.createElement("path", {
    d: "M52 66h1v1h-1z",
    fill: "#521",
    fillOpacity: 0.059
  })), _path4142 || (_path4142 = /*#__PURE__*/React.createElement("path", {
    d: "M57 67h-1v-1h1z",
    fill: "#453939",
    fillOpacity: 0.086
  })), _path4143 || (_path4143 = /*#__PURE__*/React.createElement("path", {
    d: "M57 66h1v1h-1z",
    fill: "#54311e",
    fillOpacity: 0.816
  })), _path4144 || (_path4144 = /*#__PURE__*/React.createElement("path", {
    d: "M59 66v1h-1v-1z",
    fill: "#906442"
  })), _path4145 || (_path4145 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67v-1h1v1z",
    fill: "#b38867"
  })), _path4146 || (_path4146 = /*#__PURE__*/React.createElement("path", {
    d: "M60 67v-1h1v1z",
    fill: "#ae8669"
  })), _path4147 || (_path4147 = /*#__PURE__*/React.createElement("path", {
    d: "M62 67h-1v-1h1z",
    fill: "#906749"
  })), _path4148 || (_path4148 = /*#__PURE__*/React.createElement("path", {
    d: "M62 66h1v1h-1z",
    fill: "#5f3f26"
  })), _path4149 || (_path4149 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67h-1v-1h1z",
    fill: "#33190c"
  })), _path4150 || (_path4150 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67v-1h1v1z",
    fill: "#371a13"
  })), _path4151 || (_path4151 = /*#__PURE__*/React.createElement("path", {
    d: "M65 67v-1h1v1z",
    fill: "#3c1d14"
  })), _path4152 || (_path4152 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67v-1h1v1z",
    fill: "#3a1a0c"
  })), _path4153 || (_path4153 = /*#__PURE__*/React.createElement("path", {
    d: "M68 66v1h-1v-1z",
    fill: "#3f1e0f"
  })), _path4154 || (_path4154 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v-1h1v1z",
    fill: "#664536"
  })), _path4155 || (_path4155 = /*#__PURE__*/React.createElement("path", {
    d: "M69 66h1v1h-1z",
    fill: "#6b4b3b"
  })), _path4156 || (_path4156 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67h-1v-1h1z",
    fill: "#1e0c05"
  })), _path4157 || (_path4157 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67v-1h1v1z",
    fill: "#130b09"
  })), _path4158 || (_path4158 = /*#__PURE__*/React.createElement("path", {
    d: "M73 66v1h-1v-1z",
    fill: "#130c0a"
  })), _path4159 || (_path4159 = /*#__PURE__*/React.createElement("path", {
    d: "M74 67h-1v-1h1z",
    fill: "#0f0302"
  })), _path4160 || (_path4160 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67h-1v-1h1z",
    fill: "#543d2c"
  })), _path4161 || (_path4161 = /*#__PURE__*/React.createElement("path", {
    d: "M76 67h-1v-1h1z",
    fill: "#cca678"
  })), _path4162 || (_path4162 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66v1h-1v-1z",
    fill: "#e3bb9c"
  })), _path4163 || (_path4163 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h1v1h-1z",
    fill: "#412d26"
  })), _path4164 || (_path4164 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v-1h1v1z",
    fill: "#200f07"
  })), _path4165 || (_path4165 = /*#__PURE__*/React.createElement("path", {
    d: "M80 66v1h-1v-1z",
    fill: "#93672b"
  })), _path4166 || (_path4166 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h-1v-1h1z",
    fill: "#d8aa4f"
  })), _path4167 || (_path4167 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v-1h1v1z",
    fill: "#deb157"
  })), _path4168 || (_path4168 = /*#__PURE__*/React.createElement("path", {
    d: "M83 66v1h-1v-1z",
    fill: "#ae7b35"
  })), _path4169 || (_path4169 = /*#__PURE__*/React.createElement("path", {
    d: "M84 67h-1v-1h1z",
    fill: "#825525"
  })), _path4170 || (_path4170 = /*#__PURE__*/React.createElement("path", {
    d: "M85 66v1h-1v-1z",
    fill: "#7c6124"
  })), _path4171 || (_path4171 = /*#__PURE__*/React.createElement("path", {
    d: "M86 67h-1v-1h1z",
    fill: "#827348"
  })), _path4172 || (_path4172 = /*#__PURE__*/React.createElement("path", {
    d: "M87 67h-1v-1h1z",
    fill: "#9b915e"
  })), _path4173 || (_path4173 = /*#__PURE__*/React.createElement("path", {
    d: "M88 66v1h-1v-1z",
    fill: "#b69271"
  })), _path4174 || (_path4174 = /*#__PURE__*/React.createElement("path", {
    d: "M88 66h1v1h-1z",
    fill: "#a77966"
  })), _path4175 || (_path4175 = /*#__PURE__*/React.createElement("path", {
    d: "M89 66h1v1h-1z",
    fill: "#724831"
  })), _path4176 || (_path4176 = /*#__PURE__*/React.createElement("path", {
    d: "M91 67h-1v-1h1z",
    fill: "#87572d"
  })), _path4177 || (_path4177 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66v1h-1v-1z",
    fill: "#a27248"
  })), _path4178 || (_path4178 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h1v1h-1z",
    fill: "#804c32"
  })), _path4179 || (_path4179 = /*#__PURE__*/React.createElement("path", {
    d: "M94 66v1h-1v-1z",
    fill: "#60321d"
  })), _path4180 || (_path4180 = /*#__PURE__*/React.createElement("path", {
    d: "M95 66v1h-1v-1z",
    fill: "#7b5627"
  })), _path4181 || (_path4181 = /*#__PURE__*/React.createElement("path", {
    d: "M96 67h-1v-1h1z",
    fill: "#aa7532"
  })), _path4182 || (_path4182 = /*#__PURE__*/React.createElement("path", {
    d: "M97 66v1h-1v-1z",
    fill: "#c58d3e"
  })), _path4183 || (_path4183 = /*#__PURE__*/React.createElement("path", {
    d: "M98 67h-1v-1h1z",
    fill: "#ca9c3f"
  })), _path4184 || (_path4184 = /*#__PURE__*/React.createElement("path", {
    d: "M99 67h-1v-1h1z",
    fill: "#bb9033"
  })), _path4185 || (_path4185 = /*#__PURE__*/React.createElement("path", {
    d: "M100 66v1h-1v-1z",
    fill: "#b5932d"
  })), _path4186 || (_path4186 = /*#__PURE__*/React.createElement("path", {
    d: "M101 67h-1v-1h1z",
    fill: "#b49830"
  })), _path4187 || (_path4187 = /*#__PURE__*/React.createElement("path", {
    d: "M102 66v1h-1v-1z",
    fill: "#968424",
    fillOpacity: 0.49
  })), _path4188 || (_path4188 = /*#__PURE__*/React.createElement("path", {
    d: "M103 67h-1v-1h1z",
    fill: "#171717",
    fillOpacity: 0.043
  })), _path4189 || (_path4189 = /*#__PURE__*/React.createElement("path", {
    d: "M104 67h-1v-1h1z",
    fill: "#14170d",
    fillOpacity: 0.588
  })), _path4190 || (_path4190 = /*#__PURE__*/React.createElement("path", {
    d: "M105 67h-1v-1h1z",
    fill: "#18160b"
  })), _path4191 || (_path4191 = /*#__PURE__*/React.createElement("path", {
    d: "M105 66h1v1h-1z",
    fill: "#302615"
  })), _path4192 || (_path4192 = /*#__PURE__*/React.createElement("path", {
    d: "M107 67h-1v-1h1z",
    fill: "#22170d"
  })), _path4193 || (_path4193 = /*#__PURE__*/React.createElement("path", {
    d: "M108 66v1h-1v-1z",
    fill: "#2f1f1d"
  })), _path4194 || (_path4194 = /*#__PURE__*/React.createElement("path", {
    d: "M108 66h1v1h-1z",
    fill: "#593c36"
  })), _path4195 || (_path4195 = /*#__PURE__*/React.createElement("path", {
    d: "M109 67v-1h1v1z",
    fill: "#5b3f38"
  })), _path4196 || (_path4196 = /*#__PURE__*/React.createElement("path", {
    d: "M110 67v-1h1v1z",
    fill: "#815d57"
  })), _path4197 || (_path4197 = /*#__PURE__*/React.createElement("path", {
    d: "M111 67v-1h1v1z",
    fill: "#8a645e"
  })), _path4198 || (_path4198 = /*#__PURE__*/React.createElement("path", {
    d: "M112 66h1v1h-1z",
    fill: "#4e3330",
    fillOpacity: 0.659
  })), _path4199 || (_path4199 = /*#__PURE__*/React.createElement("path", {
    d: "M113 66h1v1h-1z",
    fill: "#0f0f00",
    fillOpacity: 0.063
  })), _path4200 || (_path4200 = /*#__PURE__*/React.createElement("path", {
    d: "M56 68v-1h1v1z",
    fill: "#280d0d",
    fillOpacity: 0.075
  })), _path4201 || (_path4201 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h-1v-1h1z",
    fill: "#3b2110",
    fillOpacity: 0.784
  })), _path4202 || (_path4202 = /*#__PURE__*/React.createElement("path", {
    d: "M58 67h1v1h-1z",
    fill: "#63401b"
  })), _path4203 || (_path4203 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67h1v1h-1z",
    fill: "#6a4324"
  })), _path4204 || (_path4204 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67v1h-1v-1z",
    fill: "#422519"
  })), _path4205 || (_path4205 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67h1v1h-1z",
    fill: "#371f14"
  })), _path4206 || (_path4206 = /*#__PURE__*/React.createElement("path", {
    d: "M63 67v1h-1v-1z",
    fill: "#5f3f2d"
  })), _path4207 || (_path4207 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h-1v-1h1z",
    fill: "#442419"
  })), _path4208 || (_path4208 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v-1h1v1z",
    fill: "#250c0a"
  })), _path4209 || (_path4209 = /*#__PURE__*/React.createElement("path", {
    d: "M65 68v-1h1v1z",
    fill: "#3d2523"
  })), _path4210 || (_path4210 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67h1v1h-1z",
    fill: "#35211b"
  })), _path4211 || (_path4211 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v1h-1v-1z",
    fill: "#200e07"
  })), _path4212 || (_path4212 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67h1v1h-1z",
    fill: "#251006"
  })), _path4213 || (_path4213 = /*#__PURE__*/React.createElement("path", {
    d: "M69 68v-1h1v1z",
    fill: "#3b2010"
  })), _path4214 || (_path4214 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68h-1v-1h1z",
    fill: "#2c1909"
  })), _path4215 || (_path4215 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67v1h-1v-1z",
    fill: "#170c02"
  })), _path4216 || (_path4216 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67h1v1h-1z",
    fill: "#1b0e0c"
  })), _path4217 || (_path4217 = /*#__PURE__*/React.createElement("path", {
    d: "M73 67h1v1h-1z",
    fill: "#210c0c"
  })), _path4218 || (_path4218 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67v1h-1v-1z",
    fill: "#4c2d1d"
  })), _path4219 || (_path4219 = /*#__PURE__*/React.createElement("path", {
    d: "M75 68v-1h1v1z",
    fill: "#bb8f69"
  })), _path4220 || (_path4220 = /*#__PURE__*/React.createElement("path", {
    d: "M77 67v1h-1v-1z",
    fill: "#ab7a5d"
  })), _path4221 || (_path4221 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v1h-1v-1z",
    fill: "#4c2a1b"
  })), _path4222 || (_path4222 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67h1v1h-1z",
    fill: "#1a0d06"
  })), _path4223 || (_path4223 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68h-1v-1h1z",
    fill: "#3b170c"
  })), _path4224 || (_path4224 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v1h-1v-1z",
    fill: "#8e6343"
  })), _path4225 || (_path4225 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h1v1h-1z",
    fill: "#7f4f2a"
  })), _path4226 || (_path4226 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68v-1h1v1z",
    fill: "#5b321c"
  })), _path4227 || (_path4227 = /*#__PURE__*/React.createElement("path", {
    d: "M83 67h1v1h-1z",
    fill: "#7d4823"
  })), _path4228 || (_path4228 = /*#__PURE__*/React.createElement("path", {
    d: "M84 68v-1h1v1z",
    fill: "#865b2e"
  })), _path4229 || (_path4229 = /*#__PURE__*/React.createElement("path", {
    d: "M86 68h-1v-1h1z",
    fill: "#887734"
  })), _path4230 || (_path4230 = /*#__PURE__*/React.createElement("path", {
    d: "M87 67v1h-1v-1z",
    fill: "#938040"
  })), _path4231 || (_path4231 = /*#__PURE__*/React.createElement("path", {
    d: "M88 68h-1v-1h1z",
    fill: "#a27a51"
  })), _path4232 || (_path4232 = /*#__PURE__*/React.createElement("path", {
    d: "M88 67h1v1h-1z",
    fill: "#885d43"
  })), _path4233 || (_path4233 = /*#__PURE__*/React.createElement("path", {
    d: "M90 67v1h-1v-1z",
    fill: "#7b5536"
  })), _path4234 || (_path4234 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68h-1v-1h1z",
    fill: "#9a7248"
  })), _path4235 || (_path4235 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68v-1h1v1z",
    fill: "#a07f5a"
  })), _path4236 || (_path4236 = /*#__PURE__*/React.createElement("path", {
    d: "M93 67v1h-1v-1z",
    fill: "#a58870"
  })), _path4237 || (_path4237 = /*#__PURE__*/React.createElement("path", {
    d: "M93 68v-1h1v1z",
    fill: "#876e57"
  })), _path4238 || (_path4238 = /*#__PURE__*/React.createElement("path", {
    d: "M95 68h-1v-1h1z",
    fill: "#6a5037"
  })), _path4239 || (_path4239 = /*#__PURE__*/React.createElement("path", {
    d: "M95 67h1v1h-1z",
    fill: "#845a2a"
  })), _path4240 || (_path4240 = /*#__PURE__*/React.createElement("path", {
    d: "M97 68h-1v-1h1z",
    fill: "#ac8039"
  })), _path4241 || (_path4241 = /*#__PURE__*/React.createElement("path", {
    d: "M98 67v1h-1v-1z",
    fill: "#b2903e"
  })), _path4242 || (_path4242 = /*#__PURE__*/React.createElement("path", {
    d: "M98 68v-1h1v1z",
    fill: "#bd9125"
  })), _path4243 || (_path4243 = /*#__PURE__*/React.createElement("path", {
    d: "M100 68h-1v-1h1z",
    fill: "#c39325"
  })), _path4244 || (_path4244 = /*#__PURE__*/React.createElement("path", {
    d: "M101 67v1h-1v-1z",
    fill: "#b49a22"
  })), _path4245 || (_path4245 = /*#__PURE__*/React.createElement("path", {
    d: "M102 68h-1v-1h1z",
    fill: "#a99e38",
    fillOpacity: 0.984
  })), _path4246 || (_path4246 = /*#__PURE__*/React.createElement("path", {
    d: "M103 67v1h-1v-1z",
    fill: "#766a44",
    fillOpacity: 0.808
  })), _path4247 || (_path4247 = /*#__PURE__*/React.createElement("path", {
    d: "M104 67v1h-1v-1z",
    fill: "#45402f",
    fillOpacity: 0.733
  })), _path4248 || (_path4248 = /*#__PURE__*/React.createElement("path", {
    d: "M105 68h-1v-1h1z",
    fill: "#4c4533",
    fillOpacity: 0.816
  })), _path4249 || (_path4249 = /*#__PURE__*/React.createElement("path", {
    d: "M106 68h-1v-1h1z",
    fill: "#43362a",
    fillOpacity: 0.973
  })), _path4250 || (_path4250 = /*#__PURE__*/React.createElement("path", {
    d: "M106 67h1v1h-1z",
    fill: "#1f160e"
  })), _path4251 || (_path4251 = /*#__PURE__*/React.createElement("path", {
    d: "M107 67h1v1h-1z",
    fill: "#18120e"
  })), _path4252 || (_path4252 = /*#__PURE__*/React.createElement("path", {
    d: "M109 67v1h-1v-1z",
    fill: "#372724"
  })), _path4253 || (_path4253 = /*#__PURE__*/React.createElement("path", {
    d: "M109 68v-1h1v1z",
    fill: "#3f2520"
  })), _path4254 || (_path4254 = /*#__PURE__*/React.createElement("path", {
    d: "M110 67h1v1h-1z",
    fill: "#593c35",
    fillOpacity: 0.749
  })), _path4255 || (_path4255 = /*#__PURE__*/React.createElement("path", {
    d: "M111 67h1v1h-1z",
    fill: "#785c54",
    fillOpacity: 0.357
  })), _path4256 || (_path4256 = /*#__PURE__*/React.createElement("path", {
    d: "M57 68v1h-1v-1z",
    fill: "#a88539",
    fillOpacity: 0.173
  })), _path4257 || (_path4257 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69h-1v-1h1z",
    fill: "#926b35",
    fillOpacity: 0.918
  })), _path4258 || (_path4258 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h1v1h-1z",
    fill: "#8b5c28"
  })), _path4259 || (_path4259 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v-1h1v1z",
    fill: "#723f19"
  })), _path4260 || (_path4260 = /*#__PURE__*/React.createElement("path", {
    d: "M60 68h1v1h-1z",
    fill: "#451d0d"
  })), _path4261 || (_path4261 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68h1v1h-1z",
    fill: "#472110"
  })), _path4262 || (_path4262 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v1h-1v-1z",
    fill: "#4c291b"
  })), _path4263 || (_path4263 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h1v1h-1z",
    fill: "#493129"
  })), _path4264 || (_path4264 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69h-1v-1h1z",
    fill: "#4f342a"
  })), _path4265 || (_path4265 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v-1h1v1z",
    fill: "#3c281e"
  })), _path4266 || (_path4266 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69h-1v-1h1z",
    fill: "#25160f"
  })), _path4267 || (_path4267 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69v-1h1v1z",
    fill: "#2b180c"
  })), _path4268 || (_path4268 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69v-1h1v1z",
    fill: "#4d2e18"
  })), _path4269 || (_path4269 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68v1h-1v-1z",
    fill: "#4f3215"
  })), _path4270 || (_path4270 = /*#__PURE__*/React.createElement("path", {
    d: "M71 69v-1h1v1z",
    fill: "#301c07"
  })), _path4271 || (_path4271 = /*#__PURE__*/React.createElement("path", {
    d: "M73 68v1h-1v-1z",
    fill: "#22100a"
  })), _path4272 || (_path4272 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v-1h1v1z",
    fill: "#1f080a"
  })), _path4273 || (_path4273 = /*#__PURE__*/React.createElement("path", {
    d: "M74 69v-1h1v1z",
    fill: "#44271b"
  })), _path4274 || (_path4274 = /*#__PURE__*/React.createElement("path", {
    d: "M76 69h-1v-1h1z",
    fill: "#59321c"
  })), _path4275 || (_path4275 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h-1v-1h1z",
    fill: "#5f330d"
  })), _path4276 || (_path4276 = /*#__PURE__*/React.createElement("path", {
    d: "M78 68v1h-1v-1z",
    fill: "#653c1c"
  })), _path4277 || (_path4277 = /*#__PURE__*/React.createElement("path", {
    d: "M79 69h-1v-1h1z",
    fill: "#2a1808"
  })), _path4278 || (_path4278 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68v1h-1v-1z",
    fill: "#432c27"
  })), _path4279 || (_path4279 = /*#__PURE__*/React.createElement("path", {
    d: "M81 68v1h-1v-1z",
    fill: "#43281f"
  })), _path4280 || (_path4280 = /*#__PURE__*/React.createElement("path", {
    d: "M81 69v-1h1v1z",
    fill: "#744837"
  })), _path4281 || (_path4281 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68h1v1h-1z",
    fill: "#54301f"
  })), _path4282 || (_path4282 = /*#__PURE__*/React.createElement("path", {
    d: "M84 69h-1v-1h1z",
    fill: "#9b6442"
  })), _path4283 || (_path4283 = /*#__PURE__*/React.createElement("path", {
    d: "M85 69h-1v-1h1z",
    fill: "#652b18"
  })), _path4284 || (_path4284 = /*#__PURE__*/React.createElement("path", {
    d: "M86 68v1h-1v-1z",
    fill: "#80572e"
  })), _path4285 || (_path4285 = /*#__PURE__*/React.createElement("path", {
    d: "M87 69h-1v-1h1z",
    fill: "#8b5d2f"
  })), _path4286 || (_path4286 = /*#__PURE__*/React.createElement("path", {
    d: "M88 68v1h-1v-1z",
    fill: "#7c4927"
  })), _path4287 || (_path4287 = /*#__PURE__*/React.createElement("path", {
    d: "M88 69v-1h1v1z",
    fill: "#885e3f"
  })), _path4288 || (_path4288 = /*#__PURE__*/React.createElement("path", {
    d: "M90 69h-1v-1h1z",
    fill: "#b89974"
  })), _path4289 || (_path4289 = /*#__PURE__*/React.createElement("path", {
    d: "M91 69h-1v-1h1z",
    fill: "#b99f73"
  })), _path4290 || (_path4290 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68h1v1h-1z",
    fill: "#ddc69b"
  })), _path4291 || (_path4291 = /*#__PURE__*/React.createElement("path", {
    d: "M93 69h-1v-1h1z",
    fill: "#efdbba"
  })), _path4292 || (_path4292 = /*#__PURE__*/React.createElement("path", {
    d: "M94 69h-1v-1h1z",
    fill: "#f1dfbe"
  })), _path4293 || (_path4293 = /*#__PURE__*/React.createElement("path", {
    d: "M95 68v1h-1v-1z",
    fill: "#cdbba4"
  })), _path4294 || (_path4294 = /*#__PURE__*/React.createElement("path", {
    d: "M96 69h-1v-1h1z",
    fill: "#775b3e"
  })), _path4295 || (_path4295 = /*#__PURE__*/React.createElement("path", {
    d: "M97 69h-1v-1h1z",
    fill: "#78582d",
    fillOpacity: 0.8
  })), _path4296 || (_path4296 = /*#__PURE__*/React.createElement("path", {
    d: "M98 69h-1v-1h1z",
    fill: "#90784e",
    fillOpacity: 0.408
  })), _path4297 || (_path4297 = /*#__PURE__*/React.createElement("path", {
    d: "M98 68h1v1h-1z",
    fill: "#aa8538",
    fillOpacity: 0.51
  })), _path4298 || (_path4298 = /*#__PURE__*/React.createElement("path", {
    d: "M100 68v1h-1v-1z",
    fill: "#bb9237",
    fillOpacity: 0.698
  })), _path4299 || (_path4299 = /*#__PURE__*/React.createElement("path", {
    d: "M100 69v-1h1v1z",
    fill: "#896f2b",
    fillOpacity: 0.573
  })), _path4300 || (_path4300 = /*#__PURE__*/React.createElement("path", {
    d: "M102 68v1h-1v-1z",
    fill: "#6f6930",
    fillOpacity: 0.333
  })), _path4301 || (_path4301 = /*#__PURE__*/React.createElement("path", {
    d: "M103 68v1h-1v-1z",
    fill: "#71713b",
    fillOpacity: 0.475
  })), _path4302 || (_path4302 = /*#__PURE__*/React.createElement("path", {
    d: "M103 68h1v1h-1z",
    fill: "#696049",
    fillOpacity: 0.655
  })), _path4303 || (_path4303 = /*#__PURE__*/React.createElement("path", {
    d: "M104 68h1v1h-1z",
    fill: "#7d6949",
    fillOpacity: 0.765
  })), _path4304 || (_path4304 = /*#__PURE__*/React.createElement("path", {
    d: "M105 69v-1h1v1z",
    fill: "#625631",
    fillOpacity: 0.51
  })), _path4305 || (_path4305 = /*#__PURE__*/React.createElement("path", {
    d: "M107 68v1h-1v-1z",
    fill: "#363423",
    fillOpacity: 0.51
  })), _path4306 || (_path4306 = /*#__PURE__*/React.createElement("path", {
    d: "M107 69v-1h1v1z",
    fill: "#3e3124",
    fillOpacity: 0.765
  })), _path4307 || (_path4307 = /*#__PURE__*/React.createElement("path", {
    d: "M109 69h-1v-1h1z",
    fill: "#84655e",
    fillOpacity: 0.914
  })), _path4308 || (_path4308 = /*#__PURE__*/React.createElement("path", {
    d: "M109 68h1v1h-1z",
    fill: "#5f433b",
    fillOpacity: 0.502
  })), _path4309 || (_path4309 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70h-1v-1h1z",
    fill: "#bfbf3f",
    fillOpacity: 0.016
  })), _path4310 || (_path4310 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69v1h-1v-1z",
    fill: "#e9bf65",
    fillOpacity: 0.365
  })), _path4311 || (_path4311 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v1h-1v-1z",
    fill: "#d4a346",
    fillOpacity: 0.569
  })), _path4312 || (_path4312 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70v-1h1v1z",
    fill: "#966220",
    fillOpacity: 0.62
  })), _path4313 || (_path4313 = /*#__PURE__*/React.createElement("path", {
    d: "M60 70v-1h1v1z",
    fill: "#764b20",
    fillOpacity: 0.675
  })), _path4314 || (_path4314 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70h-1v-1h1z",
    fill: "#694522",
    fillOpacity: 0.843
  })), _path4315 || (_path4315 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69v1h-1v-1z",
    fill: "#412817"
  })), _path4316 || (_path4316 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69h1v1h-1z",
    fill: "#130805"
  })), _path4317 || (_path4317 = /*#__PURE__*/React.createElement("path", {
    d: "M64 69h1v1h-1z",
    fill: "#080200"
  })), _path4318 || (_path4318 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v1h-1v-1z",
    fill: "#3c271f"
  })), _path4319 || (_path4319 = /*#__PURE__*/React.createElement("path", {
    d: "M67 69v1h-1v-1z",
    fill: "#462a1c"
  })), _path4320 || (_path4320 = /*#__PURE__*/React.createElement("path", {
    d: "M67 70v-1h1v1z",
    fill: "#2a1405"
  })), _path4321 || (_path4321 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70h-1v-1h1z",
    fill: "#422614"
  })), _path4322 || (_path4322 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69h1v1h-1z",
    fill: "#683b1e"
  })), _path4323 || (_path4323 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h-1v-1h1z",
    fill: "#6b3c18"
  })), _path4324 || (_path4324 = /*#__PURE__*/React.createElement("path", {
    d: "M72 69v1h-1v-1z",
    fill: "#58371c"
  })), _path4325 || (_path4325 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v1h-1v-1z",
    fill: "#311e15"
  })), _path4326 || (_path4326 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69h1v1h-1z",
    fill: "#1f100f"
  })), _path4327 || (_path4327 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70h-1v-1h1z",
    fill: "#2d1b15"
  })), _path4328 || (_path4328 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70v-1h1v1z",
    fill: "#4f3429"
  })), _path4329 || (_path4329 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v-1h1v1z",
    fill: "#8a693b"
  })), _path4330 || (_path4330 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h1v1h-1z",
    fill: "#8f6932"
  })), _path4331 || (_path4331 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70h-1v-1h1z",
    fill: "#533521"
  })), _path4332 || (_path4332 = /*#__PURE__*/React.createElement("path", {
    d: "M80 69v1h-1v-1z",
    fill: "#321f18"
  })), _path4333 || (_path4333 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70h-1v-1h1z",
    fill: "#201006"
  })), _path4334 || (_path4334 = /*#__PURE__*/React.createElement("path", {
    d: "M83 70h-1v-1h1z",
    fill: "#663223"
  })), _path4335 || (_path4335 = /*#__PURE__*/React.createElement("path", {
    d: "M83 69h1v1h-1z",
    fill: "#71391e"
  })), _path4336 || (_path4336 = /*#__PURE__*/React.createElement("path", {
    d: "M84 70v-1h1v1z",
    fill: "#773c24"
  })), _path4337 || (_path4337 = /*#__PURE__*/React.createElement("path", {
    d: "M85 69h1v1h-1z",
    fill: "#8e5337"
  })), _path4338 || (_path4338 = /*#__PURE__*/React.createElement("path", {
    d: "M87 70h-1v-1h1z",
    fill: "#a1653d"
  })), _path4339 || (_path4339 = /*#__PURE__*/React.createElement("path", {
    d: "M87 70v-1h1v1z",
    fill: "#8d5930"
  })), _path4340 || (_path4340 = /*#__PURE__*/React.createElement("path", {
    d: "M88 69h1v1h-1z",
    fill: "#ac8854"
  })), _path4341 || (_path4341 = /*#__PURE__*/React.createElement("path", {
    d: "M90 69v1h-1v-1z",
    fill: "#dac48d"
  })), _path4342 || (_path4342 = /*#__PURE__*/React.createElement("path", {
    d: "M90 70v-1h1v1z",
    fill: "#948252"
  })), _path4343 || (_path4343 = /*#__PURE__*/React.createElement("path", {
    d: "M91 70v-1h1v1z",
    fill: "#b69e6d"
  })), _path4344 || (_path4344 = /*#__PURE__*/React.createElement("path", {
    d: "M92 70v-1h1v1z",
    fill: "#dcc093"
  })), _path4345 || (_path4345 = /*#__PURE__*/React.createElement("path", {
    d: "M93 70v-1h1v1z",
    fill: "#a78a64"
  })), _path4346 || (_path4346 = /*#__PURE__*/React.createElement("path", {
    d: "M94 70v-1h1v1z",
    fill: "#9d8761"
  })), _path4347 || (_path4347 = /*#__PURE__*/React.createElement("path", {
    d: "M95 69h1v1h-1z",
    fill: "#7b664e",
    fillOpacity: 0.824
  })), _path4348 || (_path4348 = /*#__PURE__*/React.createElement("path", {
    d: "M96 70v-1h1v1z",
    fill: "#4f2f2f",
    fillOpacity: 0.125
  })), _path4349 || (_path4349 = /*#__PURE__*/React.createElement("path", {
    d: "M104 70v-1h1v1z",
    fill: "#493c14",
    fillOpacity: 0.149
  })), _path4350 || (_path4350 = /*#__PURE__*/React.createElement("path", {
    d: "M105 69h1v1h-1z",
    fill: "#61552e",
    fillOpacity: 0.235
  })), _path4351 || (_path4351 = /*#__PURE__*/React.createElement("path", {
    d: "M106 70v-1h1v1z",
    fill: "#372c16",
    fillOpacity: 0.09
  })), _path4352 || (_path4352 = /*#__PURE__*/React.createElement("path", {
    d: "M108 70h-1v-1h1z",
    fill: "#c6b89b",
    fillOpacity: 0.071
  })), _path4353 || (_path4353 = /*#__PURE__*/React.createElement("path", {
    d: "M108 70v-1h1v1z",
    fill: "#9d8770",
    fillOpacity: 0.133
  })), _path4354 || (_path4354 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70v1h-1v-1z",
    fillOpacity: 0.204
  })), _path4355 || (_path4355 = /*#__PURE__*/React.createElement("path", {
    d: "M62 71v-1h1v1z",
    fill: "#0e0c09",
    fillOpacity: 0.965
  })), _path4356 || (_path4356 = /*#__PURE__*/React.createElement("path", {
    d: "M64 70v1h-1v-1z",
    fill: "#392515"
  })), _path4357 || (_path4357 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71v-1h1v1z",
    fill: "#62402b"
  })), _path4358 || (_path4358 = /*#__PURE__*/React.createElement("path", {
    d: "M66 71h-1v-1h1z",
    fill: "#8a5c47"
  })), _path4359 || (_path4359 = /*#__PURE__*/React.createElement("path", {
    d: "M67 71h-1v-1h1z",
    fill: "#744625"
  })), _path4360 || (_path4360 = /*#__PURE__*/React.createElement("path", {
    d: "M67 71v-1h1v1z",
    fill: "#785630"
  })), _path4361 || (_path4361 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70v1h-1v-1z",
    fill: "#634322"
  })), _path4362 || (_path4362 = /*#__PURE__*/React.createElement("path", {
    d: "M69 71v-1h1v1z",
    fill: "#5b3614"
  })), _path4363 || (_path4363 = /*#__PURE__*/React.createElement("path", {
    d: "M70 70h1v1h-1z",
    fill: "#643d15"
  })), _path4364 || (_path4364 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h1v1h-1z",
    fill: "#6e4c23"
  })), _path4365 || (_path4365 = /*#__PURE__*/React.createElement("path", {
    d: "M73 71h-1v-1h1z",
    fill: "#361c0d"
  })), _path4366 || (_path4366 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70v1h-1v-1z",
    fill: "#211310"
  })), _path4367 || (_path4367 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70h1v1h-1z",
    fill: "#393130"
  })), _path4368 || (_path4368 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v1h-1v-1z",
    fill: "#5e515c"
  })), _path4369 || (_path4369 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70h1v1h-1z",
    fill: "#88715f"
  })), _path4370 || (_path4370 = /*#__PURE__*/React.createElement("path", {
    d: "M78 70v1h-1v-1z",
    fill: "#c7a45d"
  })), _path4371 || (_path4371 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70v1h-1v-1z",
    fill: "#a27b3e"
  })), _path4372 || (_path4372 = /*#__PURE__*/React.createElement("path", {
    d: "M79 71v-1h1v1z",
    fill: "#7a5e43"
  })), _path4373 || (_path4373 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70v1h-1v-1z",
    fill: "#856a4e"
  })), _path4374 || (_path4374 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70h1v1h-1z",
    fill: "#74452d"
  })), _path4375 || (_path4375 = /*#__PURE__*/React.createElement("path", {
    d: "M83 70v1h-1v-1z",
    fill: "#9a5735"
  })), _path4376 || (_path4376 = /*#__PURE__*/React.createElement("path", {
    d: "M83 71v-1h1v1z",
    fill: "#813b23"
  })), _path4377 || (_path4377 = /*#__PURE__*/React.createElement("path", {
    d: "M85 70v1h-1v-1z",
    fill: "#75392b"
  })), _path4378 || (_path4378 = /*#__PURE__*/React.createElement("path", {
    d: "M86 70v1h-1v-1z",
    fill: "#a27752"
  })), _path4379 || (_path4379 = /*#__PURE__*/React.createElement("path", {
    d: "M87 71h-1v-1h1z",
    fill: "#bd9664"
  })), _path4380 || (_path4380 = /*#__PURE__*/React.createElement("path", {
    d: "M88 70v1h-1v-1z",
    fill: "#caac7f"
  })), _path4381 || (_path4381 = /*#__PURE__*/React.createElement("path", {
    d: "M89 71h-1v-1h1z",
    fill: "#e7d69b"
  })), _path4382 || (_path4382 = /*#__PURE__*/React.createElement("path", {
    d: "M89 70h1v1h-1z",
    fill: "#dad09d"
  })), _path4383 || (_path4383 = /*#__PURE__*/React.createElement("path", {
    d: "M91 70v1h-1v-1z",
    fill: "#d5c79e"
  })), _path4384 || (_path4384 = /*#__PURE__*/React.createElement("path", {
    d: "M91 71v-1h1v1z",
    fill: "#c3a582"
  })), _path4385 || (_path4385 = /*#__PURE__*/React.createElement("path", {
    d: "M93 70v1h-1v-1z",
    fill: "#947153"
  })), _path4386 || (_path4386 = /*#__PURE__*/React.createElement("path", {
    d: "M93 71v-1h1v1z",
    fill: "#593723"
  })), _path4387 || (_path4387 = /*#__PURE__*/React.createElement("path", {
    d: "M94 70h1v1h-1z",
    fill: "#51351c",
    fillOpacity: 0.863
  })), _path4388 || (_path4388 = /*#__PURE__*/React.createElement("path", {
    d: "M95 70h1v1h-1z",
    fill: "#5e4231",
    fillOpacity: 0.18
  })), _path4389 || (_path4389 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72h-1v-1h1z",
    fill: "#43302b",
    fillOpacity: 0.208
  })), _path4390 || (_path4390 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71v1h-1v-1z",
    fill: "#634830",
    fillOpacity: 0.961
  })), _path4391 || (_path4391 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71h1v1h-1z",
    fill: "#ae764c"
  })), _path4392 || (_path4392 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71h1v1h-1z",
    fill: "#b47956"
  })), _path4393 || (_path4393 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72v-1h1v1z",
    fill: "#6e4f36"
  })), _path4394 || (_path4394 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72v-1h1v1z",
    fill: "#7e593e"
  })), _path4395 || (_path4395 = /*#__PURE__*/React.createElement("path", {
    d: "M68 72h-1v-1h1z",
    fill: "#a97863"
  })), _path4396 || (_path4396 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72h-1v-1h1z",
    fill: "#6f4637"
  })), _path4397 || (_path4397 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72h-1v-1h1z",
    fill: "#3c2916"
  })), _path4398 || (_path4398 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72h-1v-1h1z",
    fill: "#4a3a1d"
  })), _path4399 || (_path4399 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72v-1h1v1z",
    fill: "#71542c"
  })), _path4400 || (_path4400 = /*#__PURE__*/React.createElement("path", {
    d: "M72 71h1v1h-1z",
    fill: "#55341d"
  })), _path4401 || (_path4401 = /*#__PURE__*/React.createElement("path", {
    d: "M74 71h1v1h-1z",
    fill: "#3a2e2d"
  })), _path4402 || (_path4402 = /*#__PURE__*/React.createElement("path", {
    d: "M75 71h1v1h-1z",
    fill: "#504551"
  })), _path4403 || (_path4403 = /*#__PURE__*/React.createElement("path", {
    d: "M76 71h1v1h-1z",
    fill: "#6d5e54"
  })), _path4404 || (_path4404 = /*#__PURE__*/React.createElement("path", {
    d: "M77 71h1v1h-1z",
    fill: "#b59d65"
  })), _path4405 || (_path4405 = /*#__PURE__*/React.createElement("path", {
    d: "M78 72v-1h1v1z",
    fill: "#9e814a"
  })), _path4406 || (_path4406 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v-1h1v1z",
    fill: "#6d5333",
    fillOpacity: 0.953
  })), _path4407 || (_path4407 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72v-1h1v1z",
    fill: "#debb75"
  })), _path4408 || (_path4408 = /*#__PURE__*/React.createElement("path", {
    d: "M81 71h1v1h-1z",
    fill: "#b5764d"
  })), _path4409 || (_path4409 = /*#__PURE__*/React.createElement("path", {
    d: "M82 71h1v1h-1z",
    fill: "#a25a3e"
  })), _path4410 || (_path4410 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72h-1v-1h1z",
    fill: "#a55a47"
  })), _path4411 || (_path4411 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72v-1h1v1z",
    fill: "#a36143"
  })), _path4412 || (_path4412 = /*#__PURE__*/React.createElement("path", {
    d: "M85 71h1v1h-1z",
    fill: "#d5a55e"
  })), _path4413 || (_path4413 = /*#__PURE__*/React.createElement("path", {
    d: "M87 71v1h-1v-1z",
    fill: "#c9a564"
  })), _path4414 || (_path4414 = /*#__PURE__*/React.createElement("path", {
    d: "M88 71v1h-1v-1z",
    fill: "#cab88d"
  })), _path4415 || (_path4415 = /*#__PURE__*/React.createElement("path", {
    d: "M89 72h-1v-1h1z",
    fill: "#e8ddb4"
  })), _path4416 || (_path4416 = /*#__PURE__*/React.createElement("path", {
    d: "M89 72v-1h1v1z",
    fill: "#eedcb2"
  })), _path4417 || (_path4417 = /*#__PURE__*/React.createElement("path", {
    d: "M91 72h-1v-1h1z",
    fill: "#cebc96"
  })), _path4418 || (_path4418 = /*#__PURE__*/React.createElement("path", {
    d: "M92 71v1h-1v-1z",
    fill: "#b5b189"
  })), _path4419 || (_path4419 = /*#__PURE__*/React.createElement("path", {
    d: "M93 72h-1v-1h1z",
    fill: "#9c926c"
  })), _path4420 || (_path4420 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72h-1v-1h1z",
    fill: "#7a6453",
    fillOpacity: 0.8
  })), _path4421 || (_path4421 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72v-1h1v1z",
    fill: "#7d6b66",
    fillOpacity: 0.224
  })), _path4422 || (_path4422 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72h1v1h-1z",
    fill: "#9d6f53",
    fillOpacity: 0.286
  })), _path4423 || (_path4423 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72v1h-1v-1z",
    fill: "#bd8a65",
    fillOpacity: 0.835
  })), _path4424 || (_path4424 = /*#__PURE__*/React.createElement("path", {
    d: "M63 72v1h-1v-1z",
    fill: "#d09a71"
  })), _path4425 || (_path4425 = /*#__PURE__*/React.createElement("path", {
    d: "M64 72v1h-1v-1z",
    fill: "#b2856d"
  })), _path4426 || (_path4426 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v-1h1v1z",
    fill: "#5c4850"
  })), _path4427 || (_path4427 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72h1v1h-1z",
    fill: "#534040"
  })), _path4428 || (_path4428 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72h1v1h-1z",
    fill: "#a07660"
  })), _path4429 || (_path4429 = /*#__PURE__*/React.createElement("path", {
    d: "M67 73v-1h1v1z",
    fill: "#c1907e"
  })), _path4430 || (_path4430 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72v1h-1v-1z",
    fill: "#a47a6e"
  })), _path4431 || (_path4431 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72v1h-1v-1z",
    fill: "#765d4b"
  })), _path4432 || (_path4432 = /*#__PURE__*/React.createElement("path", {
    d: "M71 73h-1v-1h1z",
    fill: "#614937"
  })), _path4433 || (_path4433 = /*#__PURE__*/React.createElement("path", {
    d: "M72 72v1h-1v-1z",
    fill: "#563c21",
    fillOpacity: 0.773
  })), _path4434 || (_path4434 = /*#__PURE__*/React.createElement("path", {
    d: "M72 73v-1h1v1z",
    fill: "#664932",
    fillOpacity: 0.816
  })), _path4435 || (_path4435 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72v1h-1v-1z",
    fill: "#573b20"
  })), _path4436 || (_path4436 = /*#__PURE__*/React.createElement("path", {
    d: "M74 73v-1h1v1z",
    fill: "#4d341e",
    fillOpacity: 0.882
  })), _path4437 || (_path4437 = /*#__PURE__*/React.createElement("path", {
    d: "M76 72v1h-1v-1z",
    fill: "#4e3b34",
    fillOpacity: 0.588
  })), _path4438 || (_path4438 = /*#__PURE__*/React.createElement("path", {
    d: "M77 72v1h-1v-1z",
    fill: "#6a584a",
    fillOpacity: 0.565
  })), _path4439 || (_path4439 = /*#__PURE__*/React.createElement("path", {
    d: "M77 73v-1h1v1z",
    fill: "#9c8760",
    fillOpacity: 0.843
  })), _path4440 || (_path4440 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v1h-1v-1z",
    fill: "#735f37",
    fillOpacity: 0.6
  })), _path4441 || (_path4441 = /*#__PURE__*/React.createElement("path", {
    d: "M79 73v-1h1v1z",
    fill: "#3e2c1f",
    fillOpacity: 0.224
  })), _path4442 || (_path4442 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72h1v1h-1z",
    fill: "#987943",
    fillOpacity: 0.773
  })), _path4443 || (_path4443 = /*#__PURE__*/React.createElement("path", {
    d: "M82 72v1h-1v-1z",
    fill: "#dba85d"
  })), _path4444 || (_path4444 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73h-1v-1h1z",
    fill: "#ae7c43"
  })), _path4445 || (_path4445 = /*#__PURE__*/React.createElement("path", {
    d: "M84 73h-1v-1h1z",
    fill: "#875635"
  })), _path4446 || (_path4446 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72h1v1h-1z",
    fill: "#6c412a"
  })), _path4447 || (_path4447 = /*#__PURE__*/React.createElement("path", {
    d: "M86 72v1h-1v-1z",
    fill: "#b59354"
  })), _path4448 || (_path4448 = /*#__PURE__*/React.createElement("path", {
    d: "M86 72h1v1h-1z",
    fill: "#d4b14d"
  })), _path4449 || (_path4449 = /*#__PURE__*/React.createElement("path", {
    d: "M87 73v-1h1v1z",
    fill: "#dec279"
  })), _path4450 || (_path4450 = /*#__PURE__*/React.createElement("path", {
    d: "M88 73v-1h1v1z",
    fill: "#f2dcb4"
  })), _path4451 || (_path4451 = /*#__PURE__*/React.createElement("path", {
    d: "M89 73v-1h1v1z",
    fill: "#dac59a"
  })), _path4452 || (_path4452 = /*#__PURE__*/React.createElement("path", {
    d: "M91 72v1h-1v-1z",
    fill: "#5f5622"
  })), _path4453 || (_path4453 = /*#__PURE__*/React.createElement("path", {
    d: "M92 72v1h-1v-1z",
    fill: "#4d6326"
  })), _path4454 || (_path4454 = /*#__PURE__*/React.createElement("path", {
    d: "M93 72v1h-1v-1z",
    fill: "#7b984c",
    fillOpacity: 0.69
  })), _path4455 || (_path4455 = /*#__PURE__*/React.createElement("path", {
    d: "M93 72h1v1h-1z",
    fill: "#acbd7b",
    fillOpacity: 0.122
  })), _path4456 || (_path4456 = /*#__PURE__*/React.createElement("path", {
    d: "M60 74h-1v-1h1z",
    fill: "#7f6666",
    fillOpacity: 0.039
  })), _path4457 || (_path4457 = /*#__PURE__*/React.createElement("path", {
    d: "M61 74h-1v-1h1z",
    fill: "#aa7a5f",
    fillOpacity: 0.831
  })), _path4458 || (_path4458 = /*#__PURE__*/React.createElement("path", {
    d: "M62 73v1h-1v-1z",
    fill: "#cb9465"
  })), _path4459 || (_path4459 = /*#__PURE__*/React.createElement("path", {
    d: "M63 74h-1v-1h1z",
    fill: "#cea275"
  })), _path4460 || (_path4460 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v1h-1v-1z",
    fill: "#b99272"
  })), _path4461 || (_path4461 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h-1v-1h1z",
    fill: "#5e4236"
  })), _path4462 || (_path4462 = /*#__PURE__*/React.createElement("path", {
    d: "M66 73v1h-1v-1z",
    fill: "#664342"
  })), _path4463 || (_path4463 = /*#__PURE__*/React.createElement("path", {
    d: "M67 74h-1v-1h1z",
    fill: "#8e5d4e"
  })), _path4464 || (_path4464 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74h-1v-1h1z",
    fill: "#986a54"
  })), _path4465 || (_path4465 = /*#__PURE__*/React.createElement("path", {
    d: "M68 73h1v1h-1z",
    fill: "#b68b78"
  })), _path4466 || (_path4466 = /*#__PURE__*/React.createElement("path", {
    d: "M69 73h1v1h-1z",
    fill: "#b68475"
  })), _path4467 || (_path4467 = /*#__PURE__*/React.createElement("path", {
    d: "M70 73h1v1h-1z",
    fill: "#9e6e62",
    fillOpacity: 0.671
  })), _path4468 || (_path4468 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v-1h1v1z",
    fillOpacity: 0.027
  })), _path4469 || (_path4469 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74h-1v-1h1z",
    fill: "#aa8d7f",
    fillOpacity: 0.071
  })), _path4470 || (_path4470 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74v-1h1v1z",
    fill: "#b28d66",
    fillOpacity: 0.663
  })), _path4471 || (_path4471 = /*#__PURE__*/React.createElement("path", {
    d: "M75 74h-1v-1h1z",
    fill: "#96764c",
    fillOpacity: 0.286
  })), _path4472 || (_path4472 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v-1h1v1z",
    fill: "#3c3c2d",
    fillOpacity: 0.067
  })), _path4473 || (_path4473 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74v-1h1v1z",
    fillOpacity: 0.012
  })), _path4474 || (_path4474 = /*#__PURE__*/React.createElement("path", {
    d: "M80 74v-1h1v1z",
    fill: "#220d06",
    fillOpacity: 0.145
  })), _path4475 || (_path4475 = /*#__PURE__*/React.createElement("path", {
    d: "M82 73v1h-1v-1z",
    fill: "#714825",
    fillOpacity: 0.663
  })), _path4476 || (_path4476 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73v1h-1v-1z",
    fill: "#92562a"
  })), _path4477 || (_path4477 = /*#__PURE__*/React.createElement("path", {
    d: "M84 73v1h-1v-1z",
    fill: "#9b6339"
  })), _path4478 || (_path4478 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74h-1v-1h1z",
    fill: "#b38557"
  })), _path4479 || (_path4479 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74v-1h1v1z",
    fill: "#c49e5e"
  })), _path4480 || (_path4480 = /*#__PURE__*/React.createElement("path", {
    d: "M86 74v-1h1v1z",
    fill: "#e1ba54"
  })), _path4481 || (_path4481 = /*#__PURE__*/React.createElement("path", {
    d: "M88 74h-1v-1h1z",
    fill: "#c79930"
  })), _path4482 || (_path4482 = /*#__PURE__*/React.createElement("path", {
    d: "M88 74v-1h1v1z",
    fill: "#cead5c"
  })), _path4483 || (_path4483 = /*#__PURE__*/React.createElement("path", {
    d: "M89 73h1v1h-1z",
    fill: "#93983e",
    fillOpacity: 0.992
  })), _path4484 || (_path4484 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74h-1v-1h1z",
    fill: "#486b11",
    fillOpacity: 0.784
  })), _path4485 || (_path4485 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74v-1h1v1z",
    fill: "#466922",
    fillOpacity: 0.494
  })), _path4486 || (_path4486 = /*#__PURE__*/React.createElement("path", {
    d: "M93 74h-1v-1h1z",
    fill: "#1e4b00",
    fillOpacity: 0.067
  })), _path4487 || (_path4487 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h-1v-1h1z",
    fill: "#bb9678",
    fillOpacity: 0.133
  })), _path4488 || (_path4488 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75v-1h1v1z",
    fill: "#bb906e",
    fillOpacity: 0.937
  })), _path4489 || (_path4489 = /*#__PURE__*/React.createElement("path", {
    d: "M62 75h-1v-1h1z",
    fill: "#c3956e"
  })), _path4490 || (_path4490 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75h-1v-1h1z",
    fill: "#c69768"
  })), _path4491 || (_path4491 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75v-1h1v1z",
    fill: "#c69869"
  })), _path4492 || (_path4492 = /*#__PURE__*/React.createElement("path", {
    d: "M64 74h1v1h-1z",
    fill: "#bc8f67"
  })), _path4493 || (_path4493 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h1v1h-1z",
    fill: "#b89276"
  })), _path4494 || (_path4494 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75h-1v-1h1z",
    fill: "#b58c76"
  })), _path4495 || (_path4495 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74v1h-1v-1z",
    fill: "#9f6c54"
  })), _path4496 || (_path4496 = /*#__PURE__*/React.createElement("path", {
    d: "M69 75h-1v-1h1z",
    fill: "#ab7861"
  })), _path4497 || (_path4497 = /*#__PURE__*/React.createElement("path", {
    d: "M70 74v1h-1v-1z",
    fill: "#966d5e",
    fillOpacity: 0.906
  })), _path4498 || (_path4498 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v1h-1v-1z",
    fill: "#69433c",
    fillOpacity: 0.133
  })), _path4499 || (_path4499 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75v-1h1v1z",
    fill: "#ffd0b9",
    fillOpacity: 0.043
  })), _path4500 || (_path4500 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74h1v1h-1z",
    fill: "#336",
    fillOpacity: 0.02
  })), _path4501 || (_path4501 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v-1h1v1z",
    fill: "#6c3a26",
    fillOpacity: 0.361
  })), _path4502 || (_path4502 = /*#__PURE__*/React.createElement("path", {
    d: "M84 75h-1v-1h1z",
    fill: "#66361d",
    fillOpacity: 0.714
  })), _path4503 || (_path4503 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74v1h-1v-1z",
    fill: "#946742",
    fillOpacity: 0.933
  })), _path4504 || (_path4504 = /*#__PURE__*/React.createElement("path", {
    d: "M86 75h-1v-1h1z",
    fill: "#bf975a"
  })), _path4505 || (_path4505 = /*#__PURE__*/React.createElement("path", {
    d: "M87 74v1h-1v-1z",
    fill: "#e8ca61"
  })), _path4506 || (_path4506 = /*#__PURE__*/React.createElement("path", {
    d: "M88 75h-1v-1h1z",
    fill: "#f6d661"
  })), _path4507 || (_path4507 = /*#__PURE__*/React.createElement("path", {
    d: "M88 74h1v1h-1z",
    fill: "#c0af49",
    fillOpacity: 0.996
  })), _path4508 || (_path4508 = /*#__PURE__*/React.createElement("path", {
    d: "M89 75v-1h1v1z",
    fill: "#5e770d",
    fillOpacity: 0.529
  })), _path4509 || (_path4509 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74v1h-1v-1z",
    fill: "#3f9400",
    fillOpacity: 0.047
  })), _path4510 || (_path4510 = /*#__PURE__*/React.createElement("path", {
    d: "M60 76h-1v-1h1z",
    fill: "#ca966c",
    fillOpacity: 0.286
  })), _path4511 || (_path4511 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h1v1h-1z",
    fill: "#c6936b",
    fillOpacity: 0.996
  })), _path4512 || (_path4512 = /*#__PURE__*/React.createElement("path", {
    d: "M61 75h1v1h-1z",
    fill: "#c39573"
  })), _path4513 || (_path4513 = /*#__PURE__*/React.createElement("path", {
    d: "M62 76v-1h1v1z",
    fill: "#c29266"
  })), _path4514 || (_path4514 = /*#__PURE__*/React.createElement("path", {
    d: "M64 75v1h-1v-1z",
    fill: "#bf8c5b"
  })), _path4515 || (_path4515 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76v-1h1v1z",
    fill: "#9c673d"
  })), _path4516 || (_path4516 = /*#__PURE__*/React.createElement("path", {
    d: "M66 76h-1v-1h1z",
    fill: "#7c492b",
    fillOpacity: 0.965
  })), _path4517 || (_path4517 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75v1h-1v-1z",
    fill: "#97694a",
    fillOpacity: 0.847
  })), _path4518 || (_path4518 = /*#__PURE__*/React.createElement("path", {
    d: "M67 76v-1h1v1z",
    fill: "#9f6d55",
    fillOpacity: 0.761
  })), _path4519 || (_path4519 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v-1h1v1z",
    fill: "#966555",
    fillOpacity: 0.643
  })), _path4520 || (_path4520 = /*#__PURE__*/React.createElement("path", {
    d: "M70 76h-1v-1h1z",
    fill: "#8e6853",
    fillOpacity: 0.373
  })), _path4521 || (_path4521 = /*#__PURE__*/React.createElement("path", {
    d: "M85 76h-1v-1h1z",
    fill: "#523729",
    fillOpacity: 0.145
  })), _path4522 || (_path4522 = /*#__PURE__*/React.createElement("path", {
    d: "M86 76h-1v-1h1z",
    fill: "#6c552c",
    fillOpacity: 0.565
  })), _path4523 || (_path4523 = /*#__PURE__*/React.createElement("path", {
    d: "M87 76h-1v-1h1z",
    fill: "#cab65b",
    fillOpacity: 0.996
  })), _path4524 || (_path4524 = /*#__PURE__*/React.createElement("path", {
    d: "M88 75v1h-1v-1z",
    fill: "#dcc365"
  })), _path4525 || (_path4525 = /*#__PURE__*/React.createElement("path", {
    d: "M88 76v-1h1v1z",
    fill: "#a7a650",
    fillOpacity: 0.827
  })), _path4526 || (_path4526 = /*#__PURE__*/React.createElement("path", {
    d: "M90 75v1h-1v-1z",
    fill: "#003600",
    fillOpacity: 0.055
  })), _path4527 || (_path4527 = /*#__PURE__*/React.createElement("path", {
    d: "M59 77v-1h1v1z",
    fill: "#c29062",
    fillOpacity: 0.416
  })), _path4528 || (_path4528 = /*#__PURE__*/React.createElement("path", {
    d: "M61 76v1h-1v-1z",
    fill: "#d2a272"
  })), _path4529 || (_path4529 = /*#__PURE__*/React.createElement("path", {
    d: "M62 77h-1v-1h1z",
    fill: "#cba37f"
  })), _path4530 || (_path4530 = /*#__PURE__*/React.createElement("path", {
    d: "M63 77h-1v-1h1z",
    fill: "#c29376"
  })), _path4531 || (_path4531 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77h-1v-1h1z",
    fill: "#d09e82"
  })), _path4532 || (_path4532 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76h1v1h-1z",
    fill: "#c39279"
  })), _path4533 || (_path4533 = /*#__PURE__*/React.createElement("path", {
    d: "M65 77v-1h1v1z",
    fill: "#86594c",
    fillOpacity: 0.773
  })), _path4534 || (_path4534 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77h-1v-1h1z",
    fill: "#5c3f31",
    fillOpacity: 0.38
  })), _path4535 || (_path4535 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v1h-1v-1z",
    fill: "#8a6954",
    fillOpacity: 0.333
  })), _path4536 || (_path4536 = /*#__PURE__*/React.createElement("path", {
    d: "M69 77h-1v-1h1z",
    fill: "#855f40",
    fillOpacity: 0.263
  })), _path4537 || (_path4537 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h-1v-1h1z",
    fill: "#552a15",
    fillOpacity: 0.047
  })), _path4538 || (_path4538 = /*#__PURE__*/React.createElement("path", {
    d: "M85 77v-1h1v1z",
    fill: "#afa",
    fillOpacity: 0.024
  })), _path4539 || (_path4539 = /*#__PURE__*/React.createElement("path", {
    d: "M86 77v-1h1v1z",
    fill: "#b4a960",
    fillOpacity: 0.737
  })), _path4540 || (_path4540 = /*#__PURE__*/React.createElement("path", {
    d: "M88 77h-1v-1h1z",
    fill: "#d1b05b"
  })), _path4541 || (_path4541 = /*#__PURE__*/React.createElement("path", {
    d: "M88 76h1v1h-1z",
    fill: "#bcad62",
    fillOpacity: 0.702
  })), _path4542 || (_path4542 = /*#__PURE__*/React.createElement("path", {
    d: "M90 76v1h-1v-1z",
    fill: "#f0f",
    fillOpacity: 0.004
  })), _path4543 || (_path4543 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78v-1h1v1z",
    fill: "#b48253",
    fillOpacity: 0.443
  })), _path4544 || (_path4544 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78h-1v-1h1z",
    fill: "#d9ab74"
  })), _path4545 || (_path4545 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78h-1v-1h1z",
    fill: "#d8b586"
  })), _path4546 || (_path4546 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78v-1h1v1z",
    fill: "#d7ad8c",
    fillOpacity: 0.941
  })), _path4547 || (_path4547 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77v1h-1v-1z",
    fill: "#a87b66",
    fillOpacity: 0.38
  })), _path4548 || (_path4548 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78v-1h1v1z",
    fill: "#c38b7d",
    fillOpacity: 0.286
  })), _path4549 || (_path4549 = /*#__PURE__*/React.createElement("path", {
    d: "M66 78h-1v-1h1z",
    fill: "#c38782",
    fillOpacity: 0.184
  })), _path4550 || (_path4550 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77v1h-1v-1z",
    fill: "#74554a",
    fillOpacity: 0.094
  })), _path4551 || (_path4551 = /*#__PURE__*/React.createElement("path", {
    d: "M67 78v-1h1v1z",
    fill: "#a07b5a",
    fillOpacity: 0.243
  })), _path4552 || (_path4552 = /*#__PURE__*/React.createElement("path", {
    d: "M68 77h1v1h-1z",
    fill: "#9e7857",
    fillOpacity: 0.58
  })), _path4553 || (_path4553 = /*#__PURE__*/React.createElement("path", {
    d: "M69 78v-1h1v1z",
    fill: "#926c4e",
    fillOpacity: 0.267
  })), _path4554 || (_path4554 = /*#__PURE__*/React.createElement("path", {
    d: "M86 78v-1h1v1z",
    fill: "#cdb473",
    fillOpacity: 0.122
  })), _path4555 || (_path4555 = /*#__PURE__*/React.createElement("path", {
    d: "M87 78v-1h1v1z",
    fill: "#d3ad5d",
    fillOpacity: 0.502
  })), _path4556 || (_path4556 = /*#__PURE__*/React.createElement("path", {
    d: "M89 77v1h-1v-1z",
    fill: "#bd9e4f",
    fillOpacity: 0.227
  })), _path4557 || (_path4557 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h1v1h-1z",
    fill: "#c7a068",
    fillOpacity: 0.737
  })), _path4558 || (_path4558 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78v1h-1v-1z",
    fill: "#e4b071"
  })), _path4559 || (_path4559 = /*#__PURE__*/React.createElement("path", {
    d: "M61 79v-1h1v1z",
    fill: "#dbab79"
  })), _path4560 || (_path4560 = /*#__PURE__*/React.createElement("path", {
    d: "M62 79v-1h1v1z",
    fill: "#c89673",
    fillOpacity: 0.875
  })), _path4561 || (_path4561 = /*#__PURE__*/React.createElement("path", {
    d: "M63 78h1v1h-1z",
    fill: "#d2b4a5",
    fillOpacity: 0.067
  })), _path4562 || (_path4562 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h1v1h-1z",
    fill: "#c89d6d",
    fillOpacity: 0.165
  })), _path4563 || (_path4563 = /*#__PURE__*/React.createElement("path", {
    d: "M60 79v1h-1v-1z",
    fill: "#d1a56d",
    fillOpacity: 0.965
  })), _path4564 || (_path4564 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80v-1h1v1z",
    fill: "#daa66b"
  })), _path4565 || (_path4565 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80h-1v-1h1z",
    fill: "#c38c67",
    fillOpacity: 0.784
  })), _path4566 || (_path4566 = /*#__PURE__*/React.createElement("path", {
    d: "M63 79v1h-1v-1z",
    fill: "#c28d74",
    fillOpacity: 0.282
  })), _path4567 || (_path4567 = /*#__PURE__*/React.createElement("path", {
    d: "M58 80h1v1h-1z",
    fill: "#aa6a3f",
    fillOpacity: 0.047
  })), _path4568 || (_path4568 = /*#__PURE__*/React.createElement("path", {
    d: "M60 81h-1v-1h1z",
    fill: "#b38355",
    fillOpacity: 0.396
  })), _path4569 || (_path4569 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80h1v1h-1z",
    fill: "#b98b60",
    fillOpacity: 0.604
  })), _path4570 || (_path4570 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80v1h-1v-1z",
    fill: "#936b43",
    fillOpacity: 0.149
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaves);
export default __webpack_public_path__ + "static/media/leaves.fcc09841d472944f7a77ff468b5cff2d.svg";
export { ForwardRef as ReactComponent };